/**
 * wt-query-builder
 * @version v0.1.0 - 2019-06-11
 */

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     AccountContainer.$inject = ['Monads', 'logicalCubeUtils', 'segmentService', 'filterUtils'];function AccountContainer(Monads, logicalCubeUtils, segmentService, filterUtils) {
          _classCallCheck(this, AccountContainer);this.Monads = Monads;this.logicalCubeUtils = logicalCubeUtils;this.segmentService = segmentService;this.filterUtils = filterUtils;
     } /**
       * Determines if a given accountContainer is valid to be used in a live query. Is considered
       * usable if only a NONE container exists or no the list of containers is empty
       * @param   {Object}  accountContainer
       * @returns {boolean}
       * @private
       */_createClass(AccountContainer, [{ key: 'hasNonAutoContainers_', value: function hasNonAutoContainers_(accountContainer) {
               var containers = _.get(accountContainer, 'containers', []); // No containers; still valid
               if (_.isEmpty(containers)) {
                    return true;
               }return _.chain(containers).map(function (container) {
                    return _.get(container, 'context');
               }).without('NONE').size().eq(0).value();
          } /**
            * Determines if a given account container's NONE container has ANY filter rules that
            * have a non-AND connector
            * @param   {Object}  accountContainer
            * @returns {boolean}
            * @private
            */ }, { key: 'hasNonAndConnectors_', value: function hasNonAndConnectors_(accountContainer) {
               var filters = _.get(accountContainer, 'filters', []);return _.chain(accountContainer).get('containers', []).map(function (container) {
                    return _.get(container, 'filters');
               }).flatten().concat(filters).map(function (filter) {
                    return _.get(filter, 'connector', '');
               }).without('AND').size().eq(0).value();
          } /**
            * Determines if a given account container contains dimension filter rules that do not exist
            * in the REAL_TIME context
            * @param   {Object}  accountContainer
            * @returns {boolean}
            * @private
            */ }, { key: 'hasRawFilters_', value: function hasRawFilters_(accountContainer) {
               var Monads = this.Monads.layer(this.Monads.REAL_TIME);var filters = _.get(accountContainer, 'filters', []);return _.chain(accountContainer).get('containers', []).map(function (container) {
                    return _.get(container, 'filters');
               }).flatten().concat(filters).map(function (filter) {
                    return _.get(filter, 'arrangeType');
               }).uniq().map(function (arrangeType) {
                    var liveMonad = Monads.monad(arrangeType);return _.isNil(liveMonad);
               }).includes(true).value();
          } /**
            * Determines if a given account container contains NO metric filter rules
            * @param   {Object}  accountContainer
            * @returns {boolean}
            * @private
            */ }, { key: 'hasMetricFilters_', value: function hasMetricFilters_(accountContainer) {
               var Monads = this.Monads.layer(this.Monads.REAL_TIME);var filters = _.get(accountContainer, 'filters', []);return _.chain(accountContainer).get('containers', []).map(function (container) {
                    return _.get(container, 'filters');
               }).flatten().concat(filters).map(function (filter) {
                    return _.get(filter, 'arrangeType');
               }).uniq().map(function (arrangeType) {
                    var monad = Monads.monad(arrangeType);return _.get(monad, 'metric', false);
               }).compact().size().gt(0).value();
          } /**
            * Determines if a given account container is suitable to be injected to a 'real time' query
            * @param   {Object}  accountContainer
            * @returns {boolean}
            */ }, { key: 'isValidForRealTime', value: function isValidForRealTime(accountContainer) {
               if (!this.hasNonAutoContainers_(accountContainer)) {
                    return false;
               }if (!this.hasNonAndConnectors_(accountContainer)) {
                    return false;
               }if (this.hasRawFilters_(accountContainer)) {
                    return false;
               }if (this.hasMetricFilters_(accountContainer)) {
                    return false;
               }return true;
          } /**
            * Will validate an injected container's filter rules against a raw query
            * @param  {Object} query - The calculation object
            * @param  {Object} accountContainer - A hash of filters and containers
            * @param  {Object} meta - A plain meta object on which to 'record' meta info
            * @private
            */ }, { key: 'validateQuery_', value: function validateQuery_(query, accountContainer, meta) {
               // Validate filter rules from injected container and populate ERRORS
               var validContainerLC_ = this.logicalCubeUtils.validateFiltersFromQuery(query, accountContainer);if (validContainerLC_.isValid) {
                    return this;
               }if (!_.hasIn(meta, 'errors')) {
                    meta.errors = [];
               }meta.errors.push({ name: 'InjectedContainerLogicalCubeMismatch', parameters: { arrangeTypes: validContainerLC_.arrangeTypes } });return this;
          } /**
            * Will validate if a container can be injected to a real time query.
            * @param  {Object} query - The calculation object
            * @param  {Object} accountContainer - A hash of filters and containers
            * @param  {Object} meta - A plain meta object on which to 'record' meta info
            * @chainable
            * @private
            */ }, { key: 'validateAccountContainerForLive_', value: function validateAccountContainerForLive_(query, accountContainer, meta) {
               if (!this.Monads.isRealTimeQuery(query)) {
                    return this;
               }if (this.isValidForRealTime(accountContainer)) {
                    return this;
               }if (!_.hasIn(meta, 'errors')) {
                    meta.errors = [];
               }meta.errors.push({ name: 'InjectedContainerNotSuitableForRealTime', parameters: {} });return this;
          } /**
            * Will validate an injected container's filter rules against query.
            * @param  {Object} query - The calculation object
            * @param  {Object} accountContainer - A hash of filters and containers
            * @param  {Object} meta - A plain meta object on which to 'record' meta info
            */ }, { key: 'validateQuery', value: function validateQuery(query, accountContainer, meta) {
               this.validateAccountContainerForLive_(query, accountContainer, meta).validateQuery_(query, accountContainer, meta);
          } }]);return AccountContainer;
}();

},{}],2:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/function AccountService() {
          _classCallCheck(this, AccountService);this.standardWeekStart = true; // default for account
          this.account = { timezone: 'Europe/Berlin', possibleCalculationLayers: ['RAW_DATA'], config: {} }; // default for accountContainer
          this.accountContainer = { name: '', description: '', specification: { filters: [], containers: [] } };
     } /**
       * Initialize the service with account data
       * Any logic of account data reinitialization/cleanup belongs to this method
       * @param {Object} iAccount
       * @returns {AccountService}
       */_createClass(AccountService, [{ key: 'init', value: function init(iAccount) {
               if (!this.isValid_(iAccount)) {
                    throw new Error('Invalid account configuration');
               }this.account = _.cloneDeep(iAccount);return this;
          } /**
            * Returns the account logo
            * @returns {string|null} Base64 encoded image
            */ }, { key: 'getLogo', value: function getLogo() {
               if (_.isUndefined(this.account.logo)) {
                    return null;
               }return this.account.logo;
          } /**
            * Returns the account timezone
            * @returns {string|null}
            */ }, { key: 'getTimezone', value: function getTimezone() {
               if (_.isUndefined(this.account.timezone)) {
                    return null;
               }return this.account.timezone;
          } /**
            * Returns the possible calculation layers for the current account
            * @returns {Array}
            */ }, { key: 'getPossibleCalculationLayers', value: function getPossibleCalculationLayers() {
               if (_.isUndefined(this.account.possibleCalculationLayers)) {
                    return ['RAW_DATA'];
               }return this.account.possibleCalculationLayers;
          } /**
            * Get account configuration or a specific account configuration value
            * @param {string=} iPropertyName Optional config property name
            * @returns {*} Complete configuration is returned if config property is not provided
            */ }, { key: 'getConfig', value: function getConfig(iPropertyName) {
               var config = this.account.config;if (iPropertyName && _.isUndefined(config[iPropertyName])) {
                    return null;
               }return iPropertyName ? config[iPropertyName] : config;
          } /**
            * Validates the input account information
            * @param {Object} iAccount
            * @returns {boolean}
            * @private
            */ }, { key: 'isValid_', value: function isValid_(iAccount) {
               return _.isObject(iAccount) && _.isObject(iAccount.config) && _.isArray(iAccount.possibleCalculationLayers) && _.includes(iAccount.possibleCalculationLayers, 'RAW_DATA') && !_.isUndefined(iAccount.timezone);
          } /**
            * Setter for account container
            * @param {Object} iAccountContainer
            * @returns {boolean}
            */ }, { key: 'setAccountContainer', value: function setAccountContainer(iAccountContainer) {
               this.accountContainer = _.cloneDeep(iAccountContainer);return this;
          } /**
            * Getter for account container
            * @returns {*}
            */ }, { key: 'getAccountContainer', value: function getAccountContainer() {
               return this.accountContainer;
          } /**
            * Getter for account container.name
            * @returns {*}
            */ }, { key: 'getAccountContainerName', value: function getAccountContainerName() {
               return this.accountContainer.name;
          } /**
            * Getter for account container.description
            * @returns {*}
            */ }, { key: 'getAccountContainerDescription', value: function getAccountContainerDescription() {
               return this.accountContainer.description;
          } /**
            * Indicates that the account is configured to follow ISO 8601 in regards of week start day (Monday)
            * @todo: This property should be dropped and proper configuration should be delivered by the backend
            * @returns {boolean}
            */ }, { key: 'hasStandardWeekStart', value: function hasStandardWeekStart() {
               return Boolean(this.standardWeekStart);
          } /**
            * Will return limits for known export types that correspond to an account. Will return undefined if an
            * unrecognized export type is requested or if no limit is defined.
            * @param  {string} iResultType
            * @returns {number|undefined}
            */ }, { key: 'getExportLimit', value: function getExportLimit(iResultType) {
               if (iResultType === 'CSV') {
                    return Number(this.getConfig('max_csv_export_limit'));
               }if (_.includes(['EXCEL_XLS', 'EXCEL_XLSX'], iResultType)) {
                    return Number(this.getConfig('max_excel_export_limit'));
               }return; // eslint-disable-line consistent-return
          } /**
                * @ngdoc method
                * @name AccountService#getCustomMonadLimit
                * @description Will return limit for custom elements
                * @returns {number}
                */ }, { key: 'getCustomMonadLimit', value: function getCustomMonadLimit() {
               return Number(this.getConfig('max_customer_scores'));
          } /**
            * Returns the account configured limit for how many dimensions in total can be stacked in a pivot analysis.
            * In case of account misconfiguration the limit fallback to the max 5 dimensions (similar to Q3)
            * @returns {number}
            */ }, { key: 'getAnalysisPivotDimensionsQuota', value: function getAnalysisPivotDimensionsQuota() {
               var dimensionsQuota = this.getConfig('max_dimensions_pivot');return _.isNumber(dimensionsQuota) && dimensionsQuota > 0 ? dimensionsQuota : 10;
          } /**
            * Returns the account configured limit for how many categories of dimensions (based on categoryOf property of the dimension) can be stacked in a pivot analysis.
            * In case of account misconfiguration the limit fallback to the max 3 categories (similar to Q3)
            * @returns {number}
            */ }, { key: 'getAnalysisDistinctPivotDimensionsQuota', value: function getAnalysisDistinctPivotDimensionsQuota() {
               var dimensionsQuota = this.getConfig('max_different_dimensions_pivot');return _.isNumber(dimensionsQuota) && dimensionsQuota > 0 ? dimensionsQuota : 3;
          } /**
            * Returns the account configured limit for how many metrics in total can be used in an analysis.
            * In case of account misconfiguration the limit fallback to the max 15 metrics (similar to Q3)
            * @returns {number}
            */ }, { key: 'getAnalysisMetricsQuota', value: function getAnalysisMetricsQuota() {
               var metricsQuota = this.getConfig('max_analysis_cols');return _.isNumber(metricsQuota) && metricsQuota > 0 ? metricsQuota : 15;
          } /**
            * Returns the account configured limit for how many metrics in total can be used in a comparison analysis.
            * @returns {number}
            */ }, { key: 'getMaxComparisonMetrics', value: function getMaxComparisonMetrics() {
               return this.getConfig('suite_max_comparison_metrics');
          } /**
            * Returns the account configured limit for the time series elements.
            * @returns {number}
            */ }, { key: 'getMaxTimeSeriesElements', value: function getMaxTimeSeriesElements() {
               return this.getConfig('maxTimeSeriesElements');
          } }]);return AccountService;
}();

},{}],3:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     Analyses.$inject = ['$q', 'Filters', 'Columns', 'reportElementUtils', 'dateService', 'DSCONST', 'Monads', 'viewModeComparison'];function Analyses($q, Filters, Columns, reportElementUtils, dateService, DSCONST, Monads, viewModeComparison) {
          _classCallCheck(this, Analyses);this.$q = $q;this.Filters = Filters;this.Columns = Columns;this.reportElementUtils = reportElementUtils;this.dateService = dateService;this.DSCONST = DSCONST;this.Monads = Monads;this.viewModeComparison = viewModeComparison;
     } /**
       * Will fix the conector - explictly set it to AND - of the first filter rule after the time filter in
       * all types of analyses apart from KPIs and Spraklines
       * @param  {Object} config - Analysis config
       * @param  {Object} query - The query so far
       * @chainable
       */_createClass(Analyses, [{ key: 'afterTime', value: function afterTime(config, query) {
               if (this.reportElementUtils.isSparkline(config) || this.reportElementUtils.isKPI(config)) {
                    return this;
               }this.Filters.applyAndRule(_.get(query, 'filters'));return this;
          } /**
            * Sets columns based on metric and dimension, plus standardChart for SPARKLINE analysis type of reports.
            * @param {string} reportElementType The report element type
            * @param {Object} analysisConfig
            * @private
            */ }, { key: 'configureCustomAnalysisTypes_', value: function configureCustomAnalysisTypes_(reportElementType, analysisConfig) {
               if (reportElementType === 'ANALYSIS') {
                    return;
               }if (analysisConfig && !_.isEmpty(analysisConfig.columns)) {
                    return;
               }analysisConfig.columns = []; // Set the standardChart for both SPARKLINE and KPI (in case of KPI it is needed so as be able to switch without
               // errors to SPARKLINE)
               switch (reportElementType) {case 'SPARKLINE':case 'SPARKLINE_LIVE':case 'KPI':case 'KPI_LIVE':
                         analysisConfig.standardChart = 'AREA';analysisConfig.columns = this.getKpiOrSparklineColumns(analysisConfig, reportElementType) || [];break;default:
                         // no special handling required so leave the method
                         break;}
          } /**
            * Returns the KPI or Sparkline metric as a column; taking special care of the context in case of
            * campaign attributions.
            * @param   {Object} analysisConfig
            * @returns {Object}
            */ }, { key: 'getKpiSparklineMetricColumn_', value: function getKpiSparklineMetricColumn_(analysisConfig) {
               var metricMonad = this.getKpiSparklineMetric(analysisConfig);var layer = this.Monads.getConfigLayer(analysisConfig);var arrangeType = _.get(metricMonad, 'arrangeType');var isCampaignsAttribution = this.Monads.layer(layer).isCampaignsAttribution(arrangeType);var visible = true;var context = isCampaignsAttribution ? _.get(metricMonad, 'context', 'NONE') : 'NONE';var predefinedContainer = _.get(metricMonad, 'predefinedContainer', []);return _.extend(metricMonad, { visible: visible, context: context, predefinedContainer: predefinedContainer });
          } /**
            * Retrieves a computed array of KPI|Sparkline columns based on the analysis configuration
            * @param {Object} config The analysis|reportElement configuration
            * @param {string} type The type of the report element the analysis config belongs to
            * @returns {Array} An array containing the metric and optionally dimension columns
            */ }, { key: 'getKpiOrSparklineColumns', value: function getKpiOrSparklineColumns(config, type) {
               var analysisConfig = _.has(config, 'configJson') ? _.get(config, 'configJson') : config;var reportElementType = _.has(config, 'configJson') ? _.get(config, 'type') : type;var dimensionMonad = this.getKpiSparklineDimension(analysisConfig);var dimensionColumn = _.extend(dimensionMonad, { visible: true });var metricColumn = this.getKpiSparklineMetricColumn_(analysisConfig);var columns = []; // required for all custom analysis types (at the time of writing for KPI and SPARKLINE)
               if (analysisConfig && this.Columns.validateColumnElement(dimensionMonad)) {
                    // Sort by date ASC for sparklines
                    if (_.includes(['SPARKLINE', 'SPARKLINE_LIVE'], reportElementType)) {
                         dimensionColumn.sortDirection = 'ASCENDING';
                    }columns.push(dimensionColumn);
               }if (analysisConfig && this.Columns.validateColumnElement(metricColumn)) {
                    // Sort by metric value DESC for metrics
                    if (_.includes(['KPI', 'KPI_LIVE'], reportElementType)) {
                         metricColumn.sortDirection = 'DESCENDING';
                    }columns.push(metricColumn);
               }return columns;
          } /**
            * Will set the possibleCalculationLayers of the analysis query. Calculation layer list of analysis configuration is
            * favoured over calculation layer list passed via external options
            * @param  {Object} analysis - An intermediate analysis helper DTO object
            * @param  {Array<string>} analysisCalculationLayers - List of calculation layers
            * @param  {Array<string>} explicitCalculationLayers - List of calculation layers
            * @private
            */ }, { key: 'configureCalculationLayers_', value: function configureCalculationLayers_(analysis, analysisCalculationLayers, explicitCalculationLayers) {
               // Real time configurations get by default the 'REAL_TIME' layer no matter what
               if (_.get(analysis, 'realTime')) {
                    _.set(analysis, 'possibleCalculationLayers', [this.Monads.REAL_TIME]);return;
               }if (_.isArray(analysisCalculationLayers) && !_.isEmpty(analysisCalculationLayers)) {
                    _.set(analysis, 'possibleCalculationLayers', analysisCalculationLayers);return;
               }if (_.isArray(explicitCalculationLayers) && !_.isEmpty(explicitCalculationLayers)) {
                    _.set(analysis, 'possibleCalculationLayers', explicitCalculationLayers);return;
               }
          } /**
            * Prepares an analysis to form a query. Most importantly sets the analysisType if any and modifies/filters columns
            * @param  {Object} iAnalysisConfig The analysis configuration to adjust
            * @param  {Object} iOptions        Additional options. Used mainly to pass complete report element configurations which also include the analysis config
            */ }, { key: 'prepareAnalysisForQuery', value: function prepareAnalysisForQuery(iAnalysisConfig, iOptions) {
               var analysis_ = _.get(iOptions, 'analysisConfig.configJson') || iAnalysisConfig;if (!analysis_) {
                    return;
               } // Set the analysis type - important for report elements only
               analysis_.analysisType = _.get(iOptions, 'analysisConfig.type') || null; // Add extra columns to mock analysis requests for Sparklines and KPIs
               this.configureCustomAnalysisTypes_(analysis_.analysisType, analysis_); // Trace the layer of the analysis
               var layer = void 0;if (_.has(iOptions, 'analysisConfig.configJson')) {
                    // Obviously a report element, hence pass the entire config - including the outer config
                    layer = this.Monads.getConfigLayer(_.get(iOptions, 'analysisConfig'));
               } else {
                    // Obviously a stand alone analysis
                    layer = this.Monads.getConfigLayer(iAnalysisConfig);
               } // Clean up the columns from unusable columns - mostly for predefined analyses
               analysis_.columns = this.Columns.usableComplete(analysis_.columns, layer); // Get the calculation layers from the element configuration
               var analysisCalculationLayers = _.get(iOptions, 'analysisConfig.calculationLayers'); // Get the explicit calculation layers passed optionally via options
               var explicitCalculationLayers = _.get(iOptions, 'possibleCalculationLayers');this.configureCalculationLayers_(analysis_, analysisCalculationLayers, explicitCalculationLayers);return analysis_; // eslint-disable-line consistent-return
          } /**
                * Will retrieve the time filter that is to be used as main time filter in Sparkline
                * or KPI queries
                * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
                * @param {Object} filterObject - See returned object of dateService.resolveTimeRangeByFilter
                * @returns {Object|undefined}
                */ }, { key: 'getMainFilter', value: function getMainFilter(analysisConfig, filterObject) {
               // The time filter fetched from the predefinedContainer's filter list that is found
               // in the analysisConfig
               var predefinedFilter = this.reportElementUtils.getTimeFilter(analysisConfig);if (predefinedFilter) {
                    return predefinedFilter;
               } // If no time filter is explictly set in analysisConfig, try to locate a time filter
               // in the filterObject's filter list
               return this.Filters.hasTimeFilter(_.get(filterObject, 'filters'));
          } /**
            * Will retrieve a list of time filters from an anlysis configuration. The
            * filter list of the predefined container and all filter lists in predefinedContainers of
            * columns are snooped
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getTimeFiltersFromAnalysis_', value: function getTimeFiltersFromAnalysis_(analysisConfig) {
               var _this = this;var analysisTime = this.reportElementUtils.getTimeFilter(analysisConfig);var columnTimes = _.chain(analysisConfig).get('columns').map(function (column) {
                    return _this.Filters.hasTimeFilter(_.get(column, 'predefinedContainer.filters'));
               }).value();var comparisonTimes = this.viewModeComparison.getActiveTimeComparisonObjects(analysisConfig);var timeFilters = [analysisTime].concat(_toConsumableArray(columnTimes), _toConsumableArray(comparisonTimes));return _.filter(timeFilters, function (timeFilter) {
                    return _this.dateService.validateTimeFilterObject(timeFilter);
               });
          } /**
            * Will retrieve a list of time filters from a sparkline or KPI configuration. Will snoop around in:
            * i. The filter list of the predefined container
            * ii. The comparison period - if any and if set to PERIOD
            * iii. The filter list of the predefined container of the metric
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getTimeFiltersFromReportElement_', value: function getTimeFiltersFromReportElement_(analysisConfig) {
               var _this2 = this;var timeFilters = [];var kpiSparklineMetric = this.reportElementUtils.isAnySparklineOrAnyKPI(analysisConfig) ? this.getKpiSparklineMetric(analysisConfig) : null; // Push the predefined time filter - if defined
               timeFilters.push(this.reportElementUtils.getTimeFilter(analysisConfig)); // Push the comparison time period
               timeFilters.push(this.reportElementUtils.getComparisonTimeFilter(analysisConfig)); // Push any time filters that might be found in the metric configuration
               timeFilters.push(this.Filters.hasTimeFilter(_.get(kpiSparklineMetric, 'filters', []))); // Return only the valid filters
               return _.filter(timeFilters, function (timeFilter) {
                    return _this2.dateService.validateTimeFilterObject(timeFilter);
               });
          } /**
            * Will return a list of time filters found in analyses, sparklines or KPI objects
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Array<Object>}
            */ }, { key: 'getTimeFilters', value: function getTimeFilters(analysisConfig) {
               if (this.reportElementUtils.isAnalysis(analysisConfig)) {
                    return this.getTimeFiltersFromAnalysis_(analysisConfig);
               }if (this.reportElementUtils.isAnySparklineOrAnyKPI(analysisConfig)) {
                    return this.getTimeFiltersFromReportElement_(analysisConfig);
               }return [];
          } /**
            * Will return a list of 'resolved' - meaning dynamic time filters are replaced by regular time period filters
            * - time filters.
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Array<Object>}
            */ }, { key: 'timeResolve', value: function timeResolve(analysisConfig) {
               var _this3 = this;var timeFilters = this.getTimeFilters(analysisConfig);return _.chain(timeFilters).map(function (filter) {
                    return _this3.dateService.toTimeFilter(filter);
               }).compact().value();
          } /**
            * Will collect all time filters and resolve them eventually.
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Promise} - Eventually returns a list of objects returned from dateService.resolveTimeRangeByFilter
            */ }, { key: 'timeResolveAsync', value: function timeResolveAsync(analysisConfig) {
               var _this4 = this; // Collect all time filters from the config
               var timeFilters = this.getTimeFilters(analysisConfig); // Generate a list of promises for all the filters that are to be resolved
               var promises = _.chain(timeFilters).compact().map(function (filter) {
                    return _this4.dateService.resolveTimeRangeByFilter(filter);
               }).value(); // Return the resolved filter list once all promises are done
               return this.$q.all(promises).then(function (resolvedFilters) {
                    return resolvedFilters;
               }).catch(function () {
                    return [];
               });
          } /**
            * Will set the timeShiftBy property on a report element configuration
            * @param {Object} analysisConfig - A report element configuration (See https:// wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @param {Object} filterObject - See returned object of dateService.resolveTimeRangeByFilter
            */ }, { key: 'setTimeShiftBy', value: function setTimeShiftBy(analysisConfig, filterObject) {
               if (!this.reportElementUtils.hasComparison(analysisConfig)) {
                    return this.$q.resolve(analysisConfig);
               }var timeFilter = this.getMainFilter(analysisConfig, filterObject);if (!timeFilter) {
                    return this.$q.resolve(analysisConfig);
               }return this.reportElementUtils.updateComparisonTimeShiftBy(analysisConfig, timeFilter).then(function () {
                    return analysisConfig;
               }).catch(function () {
                    return analysisConfig;
               });
          } /**
            * Should decide on the sampling factor
            * @param  {Object}  analysisConfig Analysis configuration
            * @param  {Boolean} isPartOfReport Is part of report
            * @returns {boolean|number} Sampling factor
            */ }, { key: 'getSamplingFactor', value: function getSamplingFactor(analysisConfig, isPartOfReport) {
               // @todo Should have a more complex logic based on the analysisConfiguration. Pending specs.
               var samplingFactor = false;if (isPartOfReport) {
                    samplingFactor = this.DSCONST.REPORT_ANALYSIS_DEFAULT_SAMPLING_FACTOR_ON_EDIT;
               }return samplingFactor;
          } /**
            * Retrieves the dimension configuration (if applicable) for a KPI or Sparkline
            * @param {Object} config A KPI|Sparkline analysis|reportElement configuration
            * @returns {Object|null}
            */ }, { key: 'getKpiSparklineDimension', value: function getKpiSparklineDimension(config) {
               return this.getKpiSparklineMonadConfig_(config, 'dimension');
          } /**
            * Retrieves the metric configuration for a KPI or Sparkline
            * @param {Object} config A KPI|Sparkline analysis|reportElement configuration
            * @returns {Object|null}
            */ }, { key: 'getKpiSparklineMetric', value: function getKpiSparklineMetric(config) {
               return this.getKpiSparklineMonadConfig_(config, 'metric');
          } /**
            * Computes the monad configuration (metric|dimension) for a KPI|Sparkline.
            * Supports both old and new analysis configurations, meaning the configurations where the metric|dimension was
            * passed by value or by reference (arrangeType only)
            * @param {Object} config A KPI|Sparkline analysis|reportElement configuration
            * @param {string} monadType The monad type to compute. Valid values - metric|dimension
            * @returns {Object|null} Returns the metric|dimension configuration or null in case of abnormal configuration
            * @private
            */ }, { key: 'getKpiSparklineMonadConfig_', value: function getKpiSparklineMonadConfig_(config) {
               var monadType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'metric';if (!_.includes(['metric', 'dimension'], monadType)) {
                    return null;
               }var analysisConfig = _.has(config, 'configJson') ? _.get(config, 'configJson') : config;var layer = _.get(analysisConfig, 'realTime') ? this.Monads.REAL_TIME : this.Monads.RAW_DATA;var monadArrangeTypeProperty = monadType === 'metric' ? 'metricArrangeType' : 'dimensionArrangeType';var mappedByReference = Boolean(_.get(analysisConfig, monadArrangeTypeProperty));var arrangeType = mappedByReference ? _.get(analysisConfig, monadArrangeTypeProperty) : _.get(analysisConfig, monadType + '.arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);var roundConfig = _.get(analysisConfig, 'roundConfig');if (monadType !== 'metric' || _.isEmpty(roundConfig)) {
                    return monad;
               }return _.merge({ roundConfig: roundConfig }, monad);
          } /**
            * Retrieves all custom figures metric|formula from an analysis configuration
            * @param {Object} analysis The analysis configuration
            * @returns {Array}
            */ }, { key: 'getAnalysisCustomFigureMonads', value: function getAnalysisCustomFigureMonads(analysis) {
               var _this5 = this;var figures = [];var columns = _.get(analysis, 'columns', []);var realTime = _.get(analysis, 'realTime', false);if (realTime) {
                    return [];
               }_.forEach(columns, function (column) {
                    var columnMonad = _this5.Monads.monad(column.arrangeType);if (_this5.Monads.isMonadCustomFigure(columnMonad)) {
                         figures.push(columnMonad);
                    }
               });return figures;
          } /**
            * Determines is an analysis configuration can have multiple dimensions or not - i.e. can be a PIVOT or PIVOT_AS_LIST
            * @param   {Object} analysisConfig
            * @returns {boolean}
            */ }, { key: 'canHaveManyDimensions', value: function canHaveManyDimensions(analysisConfig) {
               var _this6 = this; // Real time analyses always have only one dimension
               if (this.Monads.isRealTimeConfig(analysisConfig)) {
                    return false;
               }var layer = this.Monads.getConfigLayer(analysisConfig);var columns = this.Columns.usableComplete(_.get(analysisConfig, 'columns'), layer);return _.chain(columns).filter({ dimension: true }).map(function (dimension) {
                    return _this6.Monads.layer(layer).isPivotUsable(_.get(dimension, 'arrangeType'));
               }).filter(function (value) {
                    return value === false;
               }).size().eq(0).value();
          } }]);return Analyses;
}();

},{}],4:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     AnalysisColumnUtils.$inject = ['Monads', 'filterUtils', 'arrangeTypeUtils', 'metricService', 'ConfigPeriodColumn'];function AnalysisColumnUtils(Monads, filterUtils, arrangeTypeUtils, metricService, ConfigPeriodColumn) {
          _classCallCheck(this, AnalysisColumnUtils);this.Monads = Monads;this.filterUtils = filterUtils;this.arrangeTypeUtils = arrangeTypeUtils;this.metricService = metricService;this.ConfigPeriodColumn = ConfigPeriodColumn; /**
                                                                                                                                                                                                                                   * an array with objects that will be used to match the the metrics and dimensions needed for process analysis
                                                                                                                                                                                                                                   * used in getProcessAliasOrder
                                                                                                                                                                                                                                   */this.PROCESS_ALIAS_MATCHING = [{ match: function match(alias) {
                    return _.startsWith(alias, 'process') && !_.endsWith(alias, '_amount|0');
               }, name: 'pageNme' }, { match: function match(alias) {
                    return _.startsWith(alias, 'process') && _.endsWith(alias, '_amount|0');
               }, name: 'visit' }, { match: function match(alias) {
                    return _.startsWith(alias, 'predefined_formula_process_step_conversion_rate_percent');
               }, name: 'conversion' }, { match: function match(alias) {
                    return _.startsWith(alias, 'predefined_formula_process_step_exit_rate_percent');
               }, name: 'exit' }];
     } /**
       * Will return the list of 'important' column properties
       * https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-AnalysisColumn
       * @returns {Array<string>}
       * @private
       */_createClass(AnalysisColumnUtils, [{ key: 'getRefinedColumnConfiguration', /**
                                                                                    * Will return an object only with properties contained in this.COLUMN_PROPERTY_LIST
                                                                                    * @param  {Object} unrefinedColumn An object
                                                                                    * @returns {Object} A new object containing only properties contained in this.COLUMN_PROPERTY_LIST, if any
                                                                                    */value: function getRefinedColumnConfiguration(unrefinedColumn) {
               var refined_ = _.chain(unrefinedColumn).toPlainObject().pick(this.COLUMN_PROPERTY_LIST).value();if (_.isEmpty(refined_)) {
                    return refined_;
               } // Default the scope to Object if it does not exist and at least one valid property exists
               if (!_.get(refined_, 'scope')) {
                    _.set(refined_, 'scope', 'OBJECT');
               }return refined_;
          } /**
            * Will set inTimeSeries && sumValue properties to a column is not already set
            * @param   {Object} column - Column configuration object
            * @param   {Object} monad - Metric or dimension configuration object
            * @param   {string} layer
            * @returns {Object}
            * @private
            */ }, { key: 'extendColumnConfig_', value: function extendColumnConfig_(column, monad, layer) {
               if (!column) {
                    return column;
               }if (_.get(monad, 'dimension')) {
                    return column;
               }if (!_.get(monad, 'metric')) {
                    return column;
               }if (!_.chain(column).get('predefinedSegmentConnections').isArray().value()) {
                    _.set(column, 'predefinedSegmentConnections', []);
               }this.ConfigPeriodColumn.initPeriod(column, layer);if (!_.has(column, 'inTimeSeries')) {
                    _.set(column, 'inTimeSeries', false);
               }if (!_.has(column, 'sumValue')) {
                    _.set(column, 'sumValue', false);
               }return column;
          } /**
            * Will return a column configuration object based on a given alias. Configuration will include the given alias.
            * @param   {string} columnAlias - A string
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @param   {boolean} useRefine Whether to use a refined version of just return the complete monad config.
            * @returns {Object} An column object that contains custom column configuration properties BUT the essential properties of the original arrangeType of this column.
            */ }, { key: 'getEssentialColumnConfiguration', value: function getEssentialColumnConfiguration(columnAlias, layer) {
               var useRefine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;var arrangeType = this.arrangeTypeUtils.getArrangeTypeFromAlias(columnAlias);var arrangeTypeConfiguration = this.Monads.layer(layer).monad(arrangeType);var column = void 0;if (useRefine) {
                    var refinedColumn = this.getRefinedColumnConfiguration(arrangeTypeConfiguration);column = _.assign({}, refinedColumn, { alias: columnAlias });
               } else {
                    column = _.assign({}, arrangeTypeConfiguration, { alias: columnAlias });
               }return this.extendColumnConfig_(column, arrangeTypeConfiguration, layer);
          } /**
            * Given a list of column configuration objects, will return that first with the given alias
            * @param {string} columnAlias  A string
            * @param {Array<Object>} columnList An array of column configuration objects
            * @returns {Object|undefined} The found column configuration object or undefined
            */ }, { key: 'getColumnConfigurationByAlias', value: function getColumnConfigurationByAlias(columnAlias, columnList) {
               return _.find(columnList, { alias: columnAlias });
          } /**
            * Will strip a list of objects to its essential column object properties and prepare the list for persistance
            * @param  {Array<Object>} unrefinedColumnList List of objects that can potentially be an analysis column configuration
            * @returns {Array<Object>} List of column configuration objects (see https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-AnalysisColumn)
            */ }, { key: 'getEssentialColumnList', value: function getEssentialColumnList(unrefinedColumnList) {
               var _this = this;return _.chain(unrefinedColumnList).map(function (unrefined) {
                    var refinedConfig = _this.getRefinedColumnConfiguration(unrefined);return _.isEmpty(refinedConfig) ? null : _.cloneDeep(refinedConfig);
               }).compact().value();
          } /**
            * Will return a new object which is the result of a column configuration and it's corresponding element configuration (dimension or metric)
            * @param   {string} columnAlias - A string
            * @param   {Array<Object>} columnList  - An array of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Object} Merged object of analysis column configuration and metric|dimension configuration
            */ }, { key: 'getCompleteColumnConfiguration', value: function getCompleteColumnConfiguration(columnAlias, columnList, layer) {
               var arrangeType = this.arrangeTypeUtils.getArrangeTypeFromAlias(columnAlias);var arrangeTypeConfiguration = this.Monads.layer(layer).monad(arrangeType);var unrefinedColumn = this.getColumnConfigurationByAlias(columnAlias, columnList); // @todo: Column configurations coming from service are not to be trusted. Hence use the configuration
               // of the monad to set dimension or metric. Obviously the below line needs to be removed once
               // service returns proper configuration.
               _.assign(unrefinedColumn, _.pick(arrangeTypeConfiguration, ['dimension', 'metric']));var refinedColumnList = this.getRefinedColumnConfiguration(unrefinedColumn);this.extendColumnConfig_(refinedColumnList, arrangeTypeConfiguration, layer);return _.merge({}, arrangeTypeConfiguration, refinedColumnList);
          } /**
            * Will return a list of complete column configurations
            * @param   {Array<Object>} columnList - An array of column configuration objects
            * @param   {boolean} useRefine - Use refine
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<Object>}
            */ }, { key: 'getCompleteColumnConfigurations', value: function getCompleteColumnConfigurations(columnList, useRefine, layer) {
               var _this2 = this;return _.map(columnList, function (column) {
                    var columnConfiguration = _this2.getCompleteColumnConfiguration(column.alias, columnList, layer);return useRefine ? _this2.getRefinedColumnConfiguration(columnConfiguration) : columnConfiguration;
               });
          } /**
            * Returns the list of dimensions from the column list of an analysis.
            * @param   {Object}  analysisConfig The complete analysis configuration object
            * @returns {Array<Object>}
            */ }, { key: 'getDimensions', value: function getDimensions(analysisConfig) {
               var _this3 = this;var layer = this.Monads.getConfigLayer(analysisConfig);var columns = _.get(analysisConfig, 'columns');return _.chain(this.getColumnsByType('dimensions', columns, layer)).compact().map(function (_ref) {
                    var arrangeType = _ref.arrangeType;return _this3.Monads.layer(layer).monad(arrangeType);
               }).valueOf();
          } /**
            * Will split a list of configuration column objects in two grouped arrays of metrics and dimensions
            * @param   {Array<Object>} columnList - An array of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Object} An object with a list of dimension columns and a list metric objects
            */ }, { key: 'splitColumnsByElementType', value: function splitColumnsByElementType(columnList, layer) {
               var _this4 = this;var metrics = [];var dimensions = [];_.forEach(columnList, function (column) {
                    var monad = _this4.Monads.layer(layer).monad(column && column.arrangeType);if (monad && monad.metric) {
                         metrics.push(column);
                    } else if (monad && monad.dimension) {
                         dimensions.push(column);
                    }
               });return { metrics: metrics, dimensions: dimensions };
          } /**
            * Will return the columns that match the given type
            * @param   {string} type The type to look for ('dimensions' or 'metrics')
            * @param   {Array<Object>} columnList An array of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<Object>}           An array of filtered column configuration objects
            */ }, { key: 'getColumnsByType', value: function getColumnsByType(type, columnList, layer) {
               if (!_.includes(['dimensions', 'metrics'], type)) {
                    return [];
               }var splitColumns = this.splitColumnsByElementType(columnList, layer);return splitColumns[type] || [];
          } /**
            * Will return the arrangeType of the first dimension column of a list of columns
            * @param   {Array<Object>} columnList - An array of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {string|false}
            */ }, { key: 'getFirstDimensionArrangeType', value: function getFirstDimensionArrangeType(columnList, layer) {
               var splitColumns = this.splitColumnsByElementType(columnList, layer);if (_.isEmpty(splitColumns.dimensions)) {
                    return false;
               }return _.first(splitColumns.dimensions).arrangeType || false;
          } /**
            * Will detect if the given metrics of a list of columns include the requiredFirstDimensions in the first position of the columns list
            * @param   {Array<Object>} columnsList - An array of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {boolean}
            */ }, { key: 'hasRequiredDimensionLock', value: function hasRequiredDimensionLock(columnsList, layer) {
               var _this5 = this;var splitColumns = this.splitColumnsByElementType(columnsList, layer); // Detected required dimensions based on the metrics of the columnsList provided
               var requiredDimensionList = _.chain(splitColumns.metrics).map(function (metricColumn) {
                    var metricConfig = _this5.Monads.layer(layer).monad(metricColumn.arrangeType);return metricConfig && metricConfig.requiredFirstDimensions || [];
               }).flatten().uniq().value(); // Return false if more than one required dimensions appear in the metric list
               if (!_.isArray(requiredDimensionList) || requiredDimensionList.length !== 1) {
                    return false;
               }var requiredDimension = _.first(requiredDimensionList);var firstDimension = _.first(splitColumns.dimensions);return Boolean(firstDimension && firstDimension.arrangeType === requiredDimension);
          } /**
            * Gets the correct column indexes
            * @param {Array<string>} aliases - list of aliases used in the data set
            * @returns {Object}
            */ }, { key: 'getProcessAliasOrder', value: function getProcessAliasOrder(aliases) {
               var _this6 = this;var aliasOrder = {};_.forEach(aliases, function (alias, i) {
                    _this6.PROCESS_ALIAS_MATCHING.map(function (processAlias) {
                         if (!processAlias.match(alias)) {
                              // if it is not matching do nothing
                              return false;
                         } // if it matches set the alias in aliasOrder
                         aliasOrder[processAlias.name] = i;return true;
                    });
               });return aliasOrder;
          } /**
            * Will determine if the alias is the process analysis alias
            * @param {string} alias - alias name to check against process analysis aliases
            * @returns {boolean}
            */ }, { key: 'isProcessAlias', value: function isProcessAlias(alias) {
               return this.PROCESS_ALIAS_MATCHING.some(function (processAlias) {
                    return processAlias.match(alias);
               });
          } /**
            * Will determine if a list has 0 dimensions but at least one metric
            * @param   {Array<Object>}  iColumns - List of column configurations
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {boolean}
            */ }, { key: 'hasOnlyMetrics', value: function hasOnlyMetrics(iColumns, layer) {
               if (!_.isArray(iColumns)) {
                    return false;
               }var columnsTypes_ = this.splitColumnsByElementType(iColumns, layer);return _.chain(columnsTypes_).get('dimensions').size().value() === 0 && _.chain(columnsTypes_).get('metrics').size().value() > 0;
          } /**
            * Will iterate over a list of column objects and determine if ALL metrics have context set to NONE,
            * based on the configuration of the metric.
            * @param   {Array<Object>}  iColumns - The list of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {boolean}
            */ }, { key: 'hasOnlyNoneContextMetrics', value: function hasOnlyNoneContextMetrics(iColumns, layer) {
               var _this7 = this;if (!_.isArray(iColumns)) {
                    return false;
               }var onlyNone = true;_.forEach(iColumns, function (iColumn) {
                    var monad = _this7.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')); // Skip dimensions
                    if (_.get(monad, 'dimension') === true) {
                         return;
                    }if (_.get(monad, 'metric') === true && !_this7.metricService.ignoresLogicalCubes(monad)) {
                         // If at least one metric is found with a non NONE context (ignoring the Google Adwords metrics) update onlyNone variable
                         // and break iteration
                         onlyNone = false;return false; // eslint-disable-line consistent-return
                    }
               });return onlyNone;
          } }, { key: 'COLUMN_PROPERTY_LIST', get: function get() {
               return [// 'validatedDimension', Internal to service
               // 'validatedMetric' Internal to service
               'alias', 'arrangeType', 'chart', 'columnPeriod', 'dataType', 'sortDirection', 'title', 'metricDisplayType', 'dataVisual', 'dataVisualTarget', 'dataVisualTargetMax', 'dataVisualTargetMin', 'dataVisualNormalized', 'dataVisualShowSparklineHeader', 'scope', 'context', 'variant', 'dimension', 'metric', 'filters', 'predefinedContainer', 'predefinedSegmentConnections', 'lowerLimit', 'upperLimit', 'analyisColumnDirection', 'inTimeSeries', 'sumValue', 'round', 'roundConfig'];
          } }]);return AnalysisColumnUtils;
}();

},{}],5:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     ArrangeTypeUtils.$inject = ['Monads'];function ArrangeTypeUtils(Monads) {
          _classCallCheck(this, ArrangeTypeUtils);this.Monads = Monads;
     } /**
       * Will return the arrangeType of an alias string. Aliases are expected to be of the format arrangeType|number
       * @param  {string} alias Aliases are expected to be of the format arrangeType|number
       * @returns {string} The first part of the given alias
       */_createClass(ArrangeTypeUtils, [{ key: 'getArrangeTypeFromAlias', value: function getArrangeTypeFromAlias(alias) {
               return _.isString(alias) && alias.replace(/\|.*$/, '');
          } /**
            * Given a list of response columns will extract all the detected arrange types based on the defined aliases in them
            * @param  {Array<Object>} responseColumns See https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ResultColumnResultColumn
            * @returns {Array<string|boolean>} List of strings if valid column aliases or false.
            */ }, { key: 'getArrangeTypesFromResponse', value: function getArrangeTypesFromResponse(responseColumns) {
               var _this = this;var arrangeTypes = [];if (!_.isArray(responseColumns)) {
                    return arrangeTypes;
               }arrangeTypes = _.chain(responseColumns).map('alias').map(function (alias) {
                    return _this.getArrangeTypeFromAlias(alias);
               }).value();return arrangeTypes;
          } /**
            * Returns a list of the arrange types from an analysis configuration, based on its columns.
            * Either unique values or simply the list of detected arrangeTypes.
            * @param {Object} analysisConfig Object with analysis configuration
            * @param {boolean} unique Whether to return unique arrangeTypes or just the list
            * @param {boolean} deepFetch Whether to look for arrangeTypes in predefinedContainer of the analysis and columns or not.
            * @returns {Array<string>} The list or undefined for bad input
            */ }, { key: 'getArrangeTypesFromAnalysis', value: function getArrangeTypesFromAnalysis(analysisConfig, unique, deepFetch) {
               var _this2 = this;var arrangeTypes = [];if (_.isEmpty(analysisConfig) || _.isEmpty(analysisConfig.columns)) {
                    return arrangeTypes;
               }arrangeTypes = _.map(analysisConfig.columns, 'arrangeType');if (deepFetch) {
                    // Try to fetch from the predefinedContainer of the analysis
                    arrangeTypes = arrangeTypes.concat(this.getArrangeTypesFromContainer(analysisConfig.predefinedContainer)); // Go for the predefinedContainer of each column
                    _.forEach(analysisConfig.columns, function (column) {
                         arrangeTypes = arrangeTypes.concat(_this2.getArrangeTypesFromContainer(column && column.predefinedContainer));
                    });
               }return unique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Returns the arrangeTypes of a KPI or Sparkline element
            * @param {Object} kpiConfig The configuration object for a KPI or Sparkline
            * @param {boolean} unique Whether to return unique arrangeTypes or just the list
            * @param {boolean} deepFetch Whether to look for arrangeTypes in predefinedContainer of the analysis and columns or not.
            * @param {string=} layer The monad layer
            * @returns {Array<string>} The list of arrangeTypes
            * @deprecated Looks like the method is not used anywhere
            */ }, { key: 'getArrangeTypesFromKpi', value: function getArrangeTypesFromKpi(kpiConfig, unique, deepFetch) {
               var layer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'RAW_DATA';var arrangeTypes = [];if (_.isEmpty(kpiConfig)) {
                    return arrangeTypes;
               }var metricArrangeType = _.has(kpiConfig, 'metricArrangeType') ? kpiConfig.metricArrangeType : _.get(kpiConfig, 'metric.arrangeType');var dimensionArrangeType = _.has(kpiConfig, 'dimensionArrangeType') ? kpiConfig.dimensionArrangeType : _.get(kpiConfig, 'dimension.arrangeType');if (dimensionArrangeType) {
                    arrangeTypes.push(dimensionArrangeType);
               }if (metricArrangeType) {
                    arrangeTypes.push(metricArrangeType);
               }if (deepFetch) {
                    var monad = this.Monads.layer(layer).monad(metricArrangeType);arrangeTypes = arrangeTypes.concat(this.getArrangeTypesFromFilterList(_.get(monad, 'filters', [])));
               }return unique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Returns the arrangeTypes of a list of filters
            * @param {Array<Object>} filterList A list with filter objects
            * @param {boolean} unique Whether to return unique arrangeTypes or just the list
            * @returns {Array<string>} The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromFilterList', value: function getArrangeTypesFromFilterList(filterList, unique) {
               var arrangeTypes = _.map(filterList, 'arrangeType');return unique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Returns a list of strings (arrangeTypes) found in container object, no matter how nested they might be
            * @param {Object} container The container object
            * @param {boolean} unique Whether to return unique arrangeTypes or just the list as found
            * @returns {Array<string>} The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromContainer', value: function getArrangeTypesFromContainer(container, unique) {
               var _this3 = this;var arrangeTypes = [];if (!_.has(container, 'filters')) {
                    return arrangeTypes;
               }arrangeTypes = this.getArrangeTypesFromFilterList(container.filters);_.forEach(container.containers, function (innerContainer) {
                    arrangeTypes = arrangeTypes.concat(_this3.getArrangeTypesFromContainer(innerContainer));
               });return unique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Returns a list of strings (arrangeTypes) found in the filters AND containers of request object. Does not
            * take into account dimensions and metrics of the request. For request object definition see:
            * https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ReportGenerationQuery
            * @param   {Object}        request
            * @param   {boolean}       unique  Whether to return unique arrangeTypes or just the list as found
            * @returns {Array<string>}         The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromRequestQueryFilters', value: function getArrangeTypesFromRequestQueryFilters(request, unique) {
               return this.getArrangeTypesFromContainer(request, unique);
          } /**
            * Will add the arrange type of a metricParameter to the given list of arrangeTypes. In case the metric
            * parameter is a custom formula itself, it will deep fetch arrange types from the configuration as well
            * @param   {Object} metricParameter - A metric parameter object, as found in custom formula configurations
            * @param   {string} layer
            * @param   {Array<string>}  arrangeTypes
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getArrangeTypesFromMetricParam_', value: function getArrangeTypesFromMetricParam_(metricParameter, layer) {
               var arrangeTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : []; // The type of the metric parameter i.e. METRIC, FUNCTION, CONSTANT
               var type = _.get(metricParameter, 'type'); // Nothing to do if a FUNCTION or CONSTANT is encountered
               if (type !== 'METRIC') {
                    return arrangeTypes;
               } // The arrangeType of the metric parameter - if any
               var arrangeType = _.get(metricParameter, 'arrangeType');if (_.isEmpty(arrangeType)) {
                    return arrangeTypes;
               } // Add the found arrange type to the list
               arrangeTypes.push(arrangeType); // Include arrangeTypes from filters and containers of the metricParameter.
               _.forEach(this.getArrangeTypesFromContainer(metricParameter), function (filterArrangeType) {
                    arrangeTypes.push(filterArrangeType);
               }); // In case the metricParameter is itself a custom formula we need to
               // deep fetch the arrangeTypes from its actual configuration
               this.getArrangeTypesFromCustomFormula_(arrangeType, layer, arrangeTypes);return arrangeTypes;
          } /**
            * Will iterate over the child parameters of a parent parameter and collect arrange types
            * @param   {Object} metric - A metric parameter object, as found in custom formula configurations
            * @param   {string} layer
            * @param   {Array<string>}  arrangeTypes
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getArrangeTypesFromCustomFormulaParams_', value: function getArrangeTypesFromCustomFormulaParams_(metric, layer) {
               var _this4 = this;var arrangeTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];this.getArrangeTypesFromMetricParam_(metric, layer, arrangeTypes);var parameters = _.get(metric, 'parameters');if (_.isEmpty(parameters)) {
                    return arrangeTypes;
               }_.forEach(parameters, function (parameter) {
                    _this4.getArrangeTypesFromCustomFormulaParams_(parameter, layer, arrangeTypes);
               });return arrangeTypes;
          } /**
            * Will deeply and recursively fetch all arrange types that might be related with custom formulas
            * and push them to the given list of arrange types
            * @param   {string} arrangeType
            * @param   {string} layer
            * @param   {Array<string>}  arrangeTypes
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getArrangeTypesFromCustomFormula_', value: function getArrangeTypesFromCustomFormula_(arrangeType, layer) {
               var arrangeTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];var customFormula = this.Monads.layer(layer).getCustomFormula(arrangeType);if (!customFormula) {
                    return arrangeTypes;
               }return this.getArrangeTypesFromCustomFormulaParams_(customFormula, layer, arrangeTypes);
          } /**
            * Extracts the arrange types of the dimensions from a query.
            * @param   {Object} query
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getDimensionArrangeTypes_', value: function getDimensionArrangeTypes_(query) {
               return _.chain(query).get('dimensions', []).map('arrangeType').valueOf();
          } /**
            * Will return the arrangeTypes of dimensions and metrics found in a report generation service query. If iDeep flag is set to
            * true will dive deep into metrics to fetch arrangeTypes of filters and containers that may be configured.
            * @param  {Object} iQuery See https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ReportGenerationQuery
            * @param   {boolean} iUnique  Whether to return unique arrangeTypes or just the list as found
            * @returns {Array<string>}         The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromQueryMonads', value: function getArrangeTypesFromQueryMonads(iQuery, iUnique, iDeep) {
               var _this5 = this;var layer = this.Monads.getQueryLayer(iQuery);var arrangeTypes = this.getDimensionArrangeTypes_(iQuery);_.chain(iQuery).get('metrics').forEach(function (iMetric) {
                    if (_.chain(iMetric).get('value').isObject().value()) {
                         var arrangeType = _.get(iMetric, 'value.arrangeType');if (_.isString(arrangeType) && !_.isEmpty(arrangeType)) {
                              arrangeTypes.push(arrangeType);if (iDeep) {
                                   _this5.getArrangeTypesFromCustomFormula_(arrangeType, layer, arrangeTypes);
                              }
                         } // If deep fetching is requested, try to detect arrange types in filters and containers of the metric
                         // if any are defined
                         if (iDeep) {
                              arrangeTypes = arrangeTypes.concat(_this5.getArrangeTypesFromContainer(_.get(iMetric, 'value')));
                         }
                    }
               }).value();return iUnique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Will extract all arrangeTypes found in a custom formula - filters too
            * @param  {Object} iMetric The complete metric configuration property/object of a custom formula or a parameter from it's parameter list
            * @param  {boolean} iUnique Whether to return unique arrangeTypes or just the list as found
            * @returns {Array<string>}         The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromCustomFormula', value: function getArrangeTypesFromCustomFormula(iMetric, iUnique) {
               var _this6 = this;var arrangeTypes = [];_.chain(iMetric).get('parameters').forEach(function (iParameter) {
                    // Get the arrangeType from the parameter if the type is a METRIC and the arrangeType is a string
                    if (_.get(iParameter, 'type') === 'METRIC' && _.chain(iParameter).get('arrangeType').isString().value()) {
                         arrangeTypes.push(_.get(iParameter, 'arrangeType'));
                    } // Get arrangeTypes from any filters or containers (?!?) if any are included in the parameter configuration
                    arrangeTypes = arrangeTypes.concat(_this6.getArrangeTypesFromContainer(iParameter)); // Do some recursion to fetch arrangeTypes if the parameter has nested parameters
                    if (_.chain(iParameter).get('parameters').isArray().value()) {
                         arrangeTypes = arrangeTypes.concat(_this6.getArrangeTypesFromCustomFormula(iParameter));
                    }
               }).value();return iUnique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Will extract all arrangeTypes from a custom metric - filters too
            * @param   {Object} iMetric The complete metric configuration
            * @param   {boolean} iUnique Whether to return unique arrangeTypes or just the list as found
            * @param   {string} layer The layer of given metric
            * @returns {Array<string>}         The list of arrangeTypes
            * @private
            */ }, { key: 'getArrangeTypesFromCustomMetric_', value: function getArrangeTypesFromCustomMetric_(iMetric, iUnique, layer) {
               var arrangeTypes = []; // Get the baseArrangeType string
               var baseArrangeType = _.get(iMetric, 'baseArrangeType');if (_.isString(baseArrangeType) && !_.isEmpty(baseArrangeType)) {
                    arrangeTypes.push(baseArrangeType); // Get any filter or container arrange types - if any - from the nested baseArrangeType object
                    var baseMonad = this.Monads.layer(layer).monad(baseArrangeType);arrangeTypes = arrangeTypes.concat(this.getArrangeTypesFromContainer(baseMonad));
               } // Get any filter or container arrangeTypes from the given metric configuration
               arrangeTypes = arrangeTypes.concat(this.getArrangeTypesFromContainer(iMetric));return iUnique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * @param   {Array<Object>} columns List of column configuration objects
            * @param   {boolean}       unique  Whether to return unique arrangeTypes or just the list as found
            * @returns {Array<string>}         The list of arrangeTypes
            */ }, { key: 'getArrangeTypesFromColumns', value: function getArrangeTypesFromColumns(columns, unique) {
               var arrangeTypes = _.chain(columns).map('arrangeType').compact().value();return unique ? _.uniq(arrangeTypes) : arrangeTypes;
          } /**
            * Will try to fetch the configuration of every arrange type from the list and return the arrange types
            * whose configuration was not found
            * @param   {Array<string>} iArrangeTypes - List of arrange types
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getMissingArrangeTypes_', value: function getMissingArrangeTypes_(iArrangeTypes, layer) {
               var _this7 = this;var missing_ = [];if (!_.isArray(iArrangeTypes)) {
                    return missing_;
               }_.forEach(iArrangeTypes, function (arrangeType) {
                    if (!_this7.Monads.layer(layer).monad(arrangeType)) {
                         missing_.push(arrangeType);
                    }
               });return missing_;
          } /**
            * Will sort a given list of arrangeTypes into resolved and missing based on the fact that their configuration can be found in the
            * cached configuration lists or not. Furhermore will resolve arrangeType dependencies of other arrangeTypes - is the case for custom
            * metrics and formulas - and will enrich the missing and resolved lists based again on whether these configurations can be traced
            * in the cached configurations or not.
            * @param   {Array<string>} iArrangeTypes - List of arrangeTypes to resolve
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Object} Object with resolved and missing arrangeType lists
            */ }, { key: 'resolveArrangeTypesAndDependencies', value: function resolveArrangeTypesAndDependencies(iArrangeTypes, layer) {
               var _this8 = this; // Get the arrangeTypes whose config is missing from the initial list
               var missing_ = this.getMissingArrangeTypes_(iArrangeTypes, layer); // Init the response object
               var res = { resolved: _.difference(iArrangeTypes, missing_), missing: missing_ }; // Struct to hold arrangeTypes retrieved from custom metrics of formulas
               var retrieved_ = [];_.chain(res).get('resolved').forEach(function (arrangeType) {
                    var monad = _this8.Monads.layer(layer).monad(arrangeType); // Get the arrangeTypes from a custom formula
                    retrieved_ = retrieved_.concat(_this8.getArrangeTypesFromCustomFormula(_.get(monad, 'customFormula'), true)); // Get the resolved custom metric
                    retrieved_ = retrieved_.concat(_this8.getArrangeTypesFromCustomMetric_(monad, true, layer));
               }).value(); // Find retrieved arrangeTypes whose configuration is missing
               var missingRetrieved_ = this.getMissingArrangeTypes_(retrieved_, layer);var resolvedRetrieved_ = _.difference(retrieved_, missingRetrieved_); // Collect all missing and resolved arrangeTypes and eliminate duplicates in each list
               res.resolved = _.chain(res.resolved).concat(resolvedRetrieved_).uniq().value();res.missing = _.chain(res.missing).concat(missingRetrieved_).uniq().value();return res;
          } /**
            * Returns all arrangeTypes found in a query.
            * @param   {Object}  query
            * @param   {boolean=} unique
            * @returns {Array<string>}
            */ }, { key: 'getArrangeTypesFromQuery_', value: function getArrangeTypesFromQuery_(query) {
               var unique = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;return _.chain(this.getArrangeTypesFromQueryMonads(query, unique, true)).concat(this.getArrangeTypesFromRequestQueryFilters(query, unique)).uniq().valueOf();
          } /**
            * Find the arrangeTypes that are in dimensions, metrics, filters and containers of the calculation but not defined
            * in available monads. This is done by first of all selecting all the arrange types of the mentioned properties,
            * second of all iterating of the found arrangeTypes and adding those that are not available to the rejected list.
            * @param {Object} iQuery A proper request object that contains containers, filters, metrics and dimensions.
            * @returns {Object} An object that looks similar to this {arrangeTypes: [], isValid: Boolean}. isValid will be set
            * to true if arrangeTypes is empty, false otherwise.
            */ }, { key: 'validateArrangeTypesFromQuery', value: function validateArrangeTypesFromQuery(iQuery) {
               var arrangeTypes = this.getArrangeTypesFromQuery_(iQuery);var layer = this.Monads.getQueryLayer(iQuery);var resolved = this.resolveArrangeTypesAndDependencies(arrangeTypes, layer);return { arrangeTypes: resolved, isValid: _.chain(resolved).get('missing').isEmpty().value() };
          } /**
            * Will fetch the arrange types from a container object - an object with lists of filters and containers -
            * and try to locate their configurations
            * @param  {Object} iContainer A container object
            * @returns {Object} An object that looks similar to this {arrangeTypes: [], isValid: Boolean}. isValid will be set
            * to true if arrangeTypes is empty, false otherwise.
            */ }, { key: 'validateArrangeTypesFromContainer', value: function validateArrangeTypesFromContainer(iContainer) {
               var arrangeTypes = this.getArrangeTypesFromContainer(iContainer, true); // Injected containers are expected to refer to metrics and dimensions of the RAW_DATA layer ONLY.
               // Future requests for injected layers on other layers will need further work.
               var resolved = this.resolveArrangeTypesAndDependencies(arrangeTypes, this.Monads.RAW_DATA);return { arrangeTypes: resolved, isValid: _.chain(resolved).get('missing').isEmpty().value() };
          } /**
            * Returns the list of monad properties whose arrangeTypes are found in a query and narrowed down by one or more callbacks.
            * By default returns only the arrangeTypes of the traced monads.
            * @param   {Object} query
            * @param   {Array<Function>=} filterCallbacks_
            * @param   {Function=} mapCallback
            * @returns {Array<*>}
            */ }, { key: 'filterQueryArrangeTypes', value: function filterQueryArrangeTypes(query) {
               var _this9 = this;var filterCallbacks_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var mapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (monad) {
                    return _.get(monad, 'arrangeType');
               };var filterCallbacks = _.isArray(filterCallbacks_) ? filterCallbacks_ : [filterCallbacks_];var layer = this.Monads.getQueryLayer(query);var monads = _.map(this.getArrangeTypesFromQuery_(query), function (arrangeType) {
                    return _this9.Monads.layer(layer).monad(arrangeType);
               });return _.chain(filterCallbacks).reduce(function (filteredMonads, callback) {
                    return _.isFunction(callback) ? _.filter(filteredMonads, callback) : filteredMonads;
               }, monads).map(mapCallback).valueOf();
          } }]);return ArrangeTypeUtils;
}();

},{}],6:[function(require,module,exports){
'use strict'; /**
              * Contains calulation layer logic.
              * @type {CalculationLayer}
              */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     CalculationLayer.$inject = ['DSCONST', 'arrangeTypeUtils', 'accountService', 'Monads'];function CalculationLayer(DSCONST, arrangeTypeUtils, accountService, Monads) {
          _classCallCheck(this, CalculationLayer);this.DSCONST = DSCONST;this.arrangeTypeUtils = arrangeTypeUtils;this.accountService = accountService;this.Monads = Monads;
     } /**
       * Explicit list of calculation layers needed for queries with google parameters
       */_createClass(CalculationLayer, [{ key: 'isValid_', /**
                                                            * Will validate a calculation layer list
                                                            * @param   {Array<string>} calculationLayers
                                                            * @returns {boolean}
                                                            * @private
                                                            */value: function isValid_(calculationLayers) {
               if (!_.isArray(calculationLayers)) {
                    return false;
               }if (_.isEmpty(calculationLayers)) {
                    return false;
               }return _.chain(calculationLayers).map(function (calculationLayer) {
                    return _.isString(calculationLayer) && !_.isEmpty(calculationLayer);
               }).uniq().includes(false).eq(false).value();
          } /**
            * Will detect if a query has any google parameter related arrangeType in it's dimensions or metrics
            * @param   {Object} query - Calculation object for a RGS job
            * @returns {boolean}
            * @private
            */ }, { key: 'hasGoogleParameters_', value: function hasGoogleParameters_(query) {
               var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromQueryMonads(query, true, false);return _.chain(arrangeTypes).intersection(this.DSCONST.GOOGLE_PARAMETERS).size().gt(0).value();
          } /**
            * Will set the possibleCalculationLayers list in a query under certain conditions
            * @param {Object} query - Calculation object for a RGS job
            * @param {Object} analysisConfig - The analysis configuration of the query
            */ }, { key: 'injectLayers', value: function injectLayers(query, analysisConfig) {
               var _this = this; // Make sure google parameter queries get the proper layer at all costs - but not for REAL_TIME queries
               if (!this.Monads.isRealTimeConfig(analysisConfig) && this.hasGoogleParameters_(query)) {
                    _.set(query, 'possibleCalculationLayers', this.GOOGLE_QUERY_LAYERS);return;
               } // Has explicit possibleCalculationLayers in config - most
               // REAL_TIME analyses should have it.
               var presetCalculationLayers = _.chain(analysisConfig).get('possibleCalculationLayers').cloneDeep().value();if (this.isValid_(presetCalculationLayers)) {
                    _.set(query, 'possibleCalculationLayers', presetCalculationLayers);return;
               } // The possible calculation layers from the account config
               var accountCalculationLayers = _.cloneDeep(this.accountService.getPossibleCalculationLayers());if (!this.Monads.isRealTimeConfig(analysisConfig)) {
                    // Remove the REAL_TIME layer from the list of possible calculation layers
                    // when the query is not referring to live element
                    _.remove(accountCalculationLayers, function (layer) {
                         return layer === _this.Monads.REAL_TIME;
                    });
               }if (this.isValid_(accountCalculationLayers)) {
                    _.set(query, 'possibleCalculationLayers', accountCalculationLayers);return;
               }
          } /**
            * Will validate a google parameter query by simply checking if the GOOGLE_QUERY_LAYERS
            * and the possible calculation layers configured for the account intersect at all.
            * @param   {Object} query - Calculation object for a RGS job
            * @returns {boolean}
            */ }, { key: 'validateGoogleParameterQuery', value: function validateGoogleParameterQuery(query) {
               var layer = this.Monads.getQueryLayer(query); // No google parameter validation for live queries - i.e. time_id
               if (layer === this.Monads.REAL_TIME) {
                    return true;
               } // Nothing to validate against if no google parameters exist in the query.
               if (!this.hasGoogleParameters_(query)) {
                    return true;
               } // Collect the possible calculation layers from the account config...
               var accountCalculationLayers = this.accountService.getPossibleCalculationLayers(); // ...and look for 'any' of the expected GOOGLE_QUERY_LAYERS
               return _.chain(accountCalculationLayers).intersection(this.GOOGLE_QUERY_LAYERS).size().gte(1).value();
          } }, { key: 'GOOGLE_QUERY_LAYERS', get: function get() {
               return ['AGGREGATION_LAYER'];
          } }]);return CalculationLayer;
}();

},{}],7:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     CampaignsAttribution.$inject = ['Monads', 'CustomFormulas'];function CampaignsAttribution(Monads, CustomFormulas) {
          _classCallCheck(this, CampaignsAttribution);this.Monads = Monads;this.CustomFormulas = CustomFormulas;
     } /**
       * Will check if any dimensions of element type 'CAMPAIGNS_ATTRIBUTION' exist in a query and determine its validity.
       * @param   {Object} query Report generation service query object
       * @returns {Object}
       */_createClass(CampaignsAttribution, [{ key: 'validateDimensionsFromQuery', value: function validateDimensionsFromQuery(query) {
               var layer = this.Monads.getQueryLayer(query);var Monads_ = this.Monads.layer(layer);var arrangeTypes = _.chain(query).get('dimensions', []).map('arrangeType').filter(function (arrangeType) {
                    return Monads_.isCampaignsAttribution(arrangeType);
               }).value();var isValid = _.isEmpty(arrangeTypes);return { arrangeTypes: arrangeTypes, isValid: isValid };
          } /**
            * Will trace all CAMPAIGNS_ATTRIBUTION related filters in the original metric configuration and then
            * try to trace these filters in the list of filters of the query metric object.
            * @param   {Object}  queryMetricValue A query metric object's value object - i.e. as its posted to t-rex
            * @param   {string}  layer
            * @returns {boolean}
            * @private
            */ }, { key: 'isMissingCampaignsAttributionFilter_', value: function isMissingCampaignsAttributionFilter_(queryMetricValue, layer) {
               var _this = this;var arrangeType = _.get(queryMetricValue, 'arrangeType');var metric = this.Monads.layer(layer).monad(arrangeType);var sourceCampaignsAttributionFilters = _.chain(metric).get('filters', []).filter(function (filter) {
                    return _this.Monads.layer(layer).isCampaignsAttribution(filter.arrangeType);
               }).value();if (_.isEmpty(sourceCampaignsAttributionFilters)) {
                    return false;
               }var queryCampaignsAttributionFilters = _.reject(sourceCampaignsAttributionFilters, function (filter) {
                    return _.chain(queryMetricValue).get('filters').find(filter).isNil().value();
               });return queryCampaignsAttributionFilters.length !== sourceCampaignsAttributionFilters.length;
          } /**
            * Will check if query metrics of element type 'CAMPAIGNS_ATTRIBUTION' are acompanied by the necessary
            * CAMPAIGNS_ATTRIBUTION dimension filters.
            * @param   {Object} query Report generation service query object
            * @returns {Object}
            */ }, { key: 'validateMetricsFromQuery', value: function validateMetricsFromQuery(query) {
               var _this2 = this;var layer = this.Monads.getQueryLayer(query);var arrangeTypes = _.chain(this.CustomFormulas.getListOfResolvedMetrics(query)).filter(function (queryMetricValue) {
                    return _this2.isMissingCampaignsAttributionFilter_(queryMetricValue, layer);
               }).map('arrangeType').value();var isValid = _.isEmpty(arrangeTypes);return { arrangeTypes: arrangeTypes, isValid: isValid };
          } }]);return CampaignsAttribution;
}();

},{}],8:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     CohortUtils.$inject = ['Monads', 'arrangeTypeUtils'];function CohortUtils(Monads, arrangeTypeUtils) {
          _classCallCheck(this, CohortUtils);this.Monads = Monads;this.arrangeTypeUtils = arrangeTypeUtils;
     } /**
       * Will define if a list of arrange types lives up to build a cohort analysis
       * @param   {Array<string>} arrangeTypes List of arrange types
       * @returns {boolean}
       */_createClass(CohortUtils, [{ key: 'isCohortList', value: function isCohortList(arrangeTypes) {
               var _this = this;if (_.isEmpty(arrangeTypes)) {
                    return false;
               }var dimensions = _.chain(arrangeTypes).map(function (arrangeType) {
                    return _this.Monads.monad(arrangeType);
               }).filter({ dimension: true }).value();return _.isArray(dimensions) && dimensions.length === 1 && dimensions[0].cohort;
          } /**
            * Will define is a list of columns as returned from the report generation service corresponds to a cohort
            * response (needs to have only one dimension and this dimension has to be one of the cohort ones). Documentation:
            * https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ResultColumnResultColumn
            * @param   {Array<Object>} responseColumns
            * @returns {boolean}
            */ }, { key: 'isCohortResponse', value: function isCohortResponse(responseColumns) {
               var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromResponse(responseColumns);return this.isCohortList(arrangeTypes);
          } /**
            * Determines if a list of columns belongs to a cohort analysis
            * @param   {Array<Object>} analysisColumns Columns of an analysis
            * @returns {boolean}
            */ }, { key: 'isCohortAnalysis', value: function isCohortAnalysis(analysisColumns) {
               return this.isCohortList(_.map(analysisColumns, 'arrangeType'));
          } }]);return CohortUtils;
}();

},{}],9:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     Columns.$inject = ['Monads'];function Columns(Monads) {
          _classCallCheck(this, Columns);this.Monads = Monads;
     } /**
       * Will return the 'default' special character that separates the arrangeType from the it's index
       * when building an alias - i.e. 'page_impressions|1'
       * @returns {string}
       */_createClass(Columns, [{ key: 'hasHealthyAliases', /**
                                                            * Will determine if a list of columns contains at least one 'unhealthy' column alias or not
                                                            * @param  {Array<Object>}  columnList - List of column configuration objects
                                                            * @returns {boolean}
                                                            */value: function hasHealthyAliases(columnList) {
               var _this = this;return !_.chain(columnList).map(function (column) {
                    return _this.hasHealthyAlias(column);
               }).uniq().includes(false).value();
          } /**
            * Will check if a column has a 'healthy' alias or not
            * @param  {Object}  column - Column configuation object
            * @returns {boolean}
            */ }, { key: 'hasHealthyAlias', value: function hasHealthyAlias(column) {
               var alias = _.get(column, 'alias');if (_.isEmpty(alias) || !_.isString(alias)) {
                    return false;
               }var arrangeType = _.get(column, 'arrangeType');if (_.isEmpty(arrangeType) || !_.isString(arrangeType)) {
                    return false;
               } // Must have the expected separator
               if (!_.includes(alias, this.ALIAS_SEPARATOR)) {
                    return false;
               }if (!_.includes(alias, arrangeType)) {
                    return false;
               }return true;
          } /**
            * Will go through an array of columns objects, group them by arrangeTypes and attach incremental arrays
            * of equal length to the number of columns with the same arrangeType (i.e. if the collection of columns
            * contains 2 columns with arrangeType visits, the returned object will look like
            * {'visits': [0,1], 'other_arrange_type_with_3_columns': [0,1,2]})
            * @param {Array} columns An array of columns (objects) as defined in an analysis configuration
            * @returns {Object}
            */ }, { key: 'incrementMap', value: function incrementMap(iColumns) {
               var groupedByArrangeType_ = {};if (_.isUndefined(iColumns) || !_.isArray(iColumns)) {
                    return {};
               }groupedByArrangeType_ = _.groupBy(iColumns, function (column) {
                    return column.arrangeType;
               });_.forEach(groupedByArrangeType_, function (columnArray, arrangeType) {
                    groupedByArrangeType_[arrangeType] = _.range(columnArray.length);
               });return groupedByArrangeType_;
          } /**
            * Will determine if a column is usable to build queries, display etc
            * @param  {Object}  column - Column configuration object
            * @returns {boolean}        [description]
            * @private
            */ }, { key: 'isUsable_', value: function isUsable_(column) {
               if (!_.has(column, 'arrangeType')) {
                    return false;
               }if (_.get(column, 'arrangeType') === 'nr') {
                    return false;
               } // Considered usable if no variant is defined or is null
               if (!_.get(column, 'variant')) {
                    return true;
               }if (_.get(column, 'variant') !== 'NORMAL') {
                    return false;
               }return true;
          } /**
            * Will dump columns configurations with specific properties. Will act as a replacement for
            * getFilteredColumnsOfAnalysis???
            * @columns {Array}
            * @returns {Array}
            */ }, { key: 'usable', value: function usable(columns) {
               var _this2 = this;return _.filter(columns, function (column) {
                    return _this2.isUsable_(column);
               });
          } /**
            * Will return a filtered an object with filtered columns AND a collection of their indexes based on their arrangeType
            * @analysis: {Object} analysis The complete configuration of an analysis
            * @returns {Object} An array of filtered columns (excludes nr + non normal variants) and key value struct with arrangeType as key and array with incremental indexes as value
            */ }, { key: 'usableIncrementMap', value: function usableIncrementMap(iColumns) {
               return { filteredColumns: this.usable(iColumns), arrangeTypeColumnIndex: this.incrementMap(iColumns) };
          } /**
            * Will return a list of extended column configurations - the result of merged standard column configuration and metric/dimension configuration.
            * @param   {Array<Object>} columns - List of column configuration objects - https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-AnalysisColumn
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<Object>} List of merged configurations with complete metric/dimension definitions
            */ }, { key: 'complete', value: function complete(iColumns, layer) {
               var _this3 = this;return _.chain(iColumns).map(function (column) {
                    return _.assign({}, _this3.Monads.layer(layer).monad(column.arrangeType), column);
               }).compact().value();
          } }, { key: 'usableComplete', value: function usableComplete(columns_, layer) {
               var columns = _.isArray(columns_) ? columns_ : [columns_];var usable_ = this.usable(columns);var complete_ = this.complete(usable_, layer);var columnsWithAliases = this.getAnalysisConfigurationColumnsWithAliases(complete_);return _.isArray(columns_) ? columnsWithAliases : _.first(columnsWithAliases);
          } /**
            * Will construct an alias string for a column
            * @param  {string} iArrangeType The arrangeType from which to construct an alias string
            * @param  {number} iIndex Should include the index of the column inside the column set based on it's arrangeType
            * @returns {string}
            */ }, { key: 'alias', value: function alias(iArrangeType, iIndex) {
               return [iArrangeType, this.ALIAS_SEPARATOR, iIndex || 0].join('');
          } /**
            * Will return the variant based on the number of dimensions in a list of columns
            * @param   {Array<Object>} iColumns - List of column configuration objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {string}
            */ }, { key: 'variant', value: function variant(iColumns, layer) {
               var _this4 = this;var dimensions_ = 0;_.forEach(iColumns, function (column) {
                    var element = _this4.Monads.layer(layer).monad(column && column.arrangeType);if (element && element.dimension) {
                         dimensions_++;
                    }
               });return dimensions_ === 1 ? 'list' : 'pivot';
          } /**
            * Gets analysis sorting column
            * @param {Array<Object>} iColumns  List of column configuration objects
            * @returns {Object}
            */ }, { key: 'sorting', value: function sorting(iColumns) {
               var sorting_ = void 0;_.forEach(iColumns, function (iColumn) {
                    // First column that has the sortDirection defined is returned.
                    if (iColumn && iColumn.sortDirection) {
                         sorting_ = _.cloneDeep(iColumn);return;
                    } // BE-376780: Let the core decide how to sort stuff if no column is set as sorting column.
                    // First column that has defaultSortDimension defined is set as sortinColumn and will be returned if a column without a sortDirection is found
                    // if (!sorting_ && iColumn && iColumn.sortable && iColumn.defaultSortDirection) {
                    //     sorting_ = _.cloneDeep(iColumn);
                    //     sorting_.sortDirection = iColumn.defaultSortDirection;
                    //     return;
                    // }
               });return sorting_;
          } /**
            * Returns true if an element (dimension or metric) have arrangeType, dataType and title defined
            * @param  {Object} el Column element
            * @returns {boolean}
            */ }, { key: 'validateColumnElement', value: function validateColumnElement(el) {
               return Boolean(el && el.arrangeType && el.dataType && el.title);
          } /**
            * Will add aliases to a list of columns.
            * @param {Array<Object>} columns - List of column configuration objects
            * @chainable
            */ }, { key: 'addAliases', value: function addAliases(columns) {
               var _this5 = this;var groupedArrangeTypeIndexes = this.incrementMap(columns); // @todo: Initial thoughts on how to generate column aliases. Todo: should fill the gaps.
               _.forEach(columns, function (column) {
                    if (_.get(column, 'arrangeType')) {
                         var arrangeTypeIndexes = groupedArrangeTypeIndexes[column.arrangeType]; // Get the first index from the array of indexes
                         var temporaryIndex = _.first(arrangeTypeIndexes); // Now remove it
                         _.remove(arrangeTypeIndexes, function (e) {
                              return e === temporaryIndex;
                         }); // Set the alias and the colId for the column
                         var newAlias = column.arrangeType + _this5.ALIAS_SEPARATOR + temporaryIndex;column.alias = newAlias;
                    }
               });return this;
          } /**
            * Adds alias to the non-modified columns for consistency (https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-AnalysisColumn)
            * @param {Array<Object>} configColumns List of analysis configuration column objects
            * @returns {Array<Object>} An updated clone of the list of analysis configuration column objects
            */ }, { key: 'getAnalysisConfigurationColumnsWithAliases', value: function getAnalysisConfigurationColumnsWithAliases(configColumns) {
               var analysisConfigurationColumns = _.cloneDeep(configColumns);if (!_.isArray(configColumns)) {
                    return analysisConfigurationColumns;
               }var oldAliasesList = _.chain(configColumns).map(function (col) {
                    return col && col.alias;
               }).compact().value(); // If column list has set aliases ain't nothing to do
               if (oldAliasesList.length === configColumns.length) {
                    return analysisConfigurationColumns;
               }this.addAliases(analysisConfigurationColumns);return analysisConfigurationColumns;
          } /**
            * Will iterate over a list of columns and return a key value map of each aliases corresponding
            * list of sub aliases based on the replicationFactor.
            * @param   {Array<Object>} columns
            * @param   {number=} replicationFactor
            * @returns {Object}
            */ }, { key: 'getAliasGroups', value: function getAliasGroups(columns) {
               var replicationFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;var toReturn = _.chain(columns).map('alias').uniq().map(function (alias) {
                    return [alias, []];
               }).fromPairs().value();var arrangeTypeIndex = _.chain(columns).map('arrangeType').uniq().map(function (arrangeType) {
                    return [arrangeType, 0];
               }).fromPairs().value();_.forEach(columns, function (column) {
                    for (var i = 0; i < replicationFactor; i++) {
                         var arrangeType = _.get(column, 'arrangeType');var alias = arrangeType + '|' + _.get(arrangeTypeIndex, arrangeType); // Push the sub alias
                         toReturn[_.get(column, 'alias')].push(alias); // Increase the index for the next alias of the same arrangeType
                         _.set(arrangeTypeIndex, arrangeType, _.get(arrangeTypeIndex, arrangeType) + 1);
                    }
               });return toReturn;
          } /**
            * Will reset the upper and lower limit of the first dimension column keeping the diff steady.
            * @param  {Array<Object>} columns
            * @param  {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            */ }, { key: 'resetLimit', value: function resetLimit(columns, layer) {
               var _this6 = this;var first_ = _.chain(columns).find(function (iColumn) {
                    return _.get(_this6.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')), 'dimension');
               }).value();if (_.chain(first_).get('lowerLimit').isNumber().value() && _.chain(first_).get('upperLimit').isNumber().value()) {
                    first_.upperLimit = 1 + first_.upperLimit - first_.lowerLimit;first_.lowerLimit = 1;
               }return this;
          } /**
            * Will remove 'useless' columns from a list of columns
            * @param  {Array<Object>} columns
            * @chainable
            */ }, { key: 'removeUseless', value: function removeUseless(columns) {
               var _this7 = this;_.remove(columns, function (column) {
                    return !_this7.isUsable_(column);
               });return this;
          } }, { key: 'ALIAS_SEPARATOR', get: function get() {
               return '|';
          } }]);return Columns;
}();

},{}],10:[function(require,module,exports){
'use strict'; /* eslint no-useless-constructor:0 */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     _createClass(Comparison, [{ key: 'TYPES', /**
                                               * List of valid comparison types.
                                               * @returns {Array<String>}
                                               */get: function get() {
               return ['NONE', 'PERIOD', 'SLIDING_WINDOW'];
          } }, { key: 'NONE', get: function get() {
               return this.TYPES[0];
          } }, { key: 'PERIOD', get: function get() {
               return this.TYPES[1];
          } }, { key: 'SLIDING_WINDOW', get: function get() {
               return this.TYPES[2];
          } /**
            * List of valid sliding window time shifts.
            * @returns {Object}
            */ }, { key: 'SLIDING_WINDOW_TIME_SHIFTS', get: function get() {
               return { PRECEDING: 'PRECEDING', PREVIOUS_YEAR: 'PREVIOUS_YEAR', PREVIOUS_QUARTER: 'PREVIOUS_QUARTER', PREVIOUS_MONTH: 'PREVIOUS_MONTH' };
          } }, { key: 'SLIDING_WINDOW_TIME_SHIFTS_TO_MOMENT', get: function get() {
               return { PREVIOUS_YEAR: 'years', PREVIOUS_QUARTER: 'quarters', PREVIOUS_MONTH: 'months' };
          } /**
            * An object used instead of a filter when no comparison type is set.
            * @returns {Object}
            */ }, { key: 'NONE_FILTER', get: function get() {
               return { caseSensitive: false, intern: false, numberOfDays: 0 };
          } /* @ngInject*/ }]);function Comparison() {
          _classCallCheck(this, Comparison);
     } /**
       * Will detect if a given comparison type is any of the valid ones - apart from none
       * @param   {string}  type
       * @returns {boolean}
       */_createClass(Comparison, [{ key: 'isNotNone', value: function isNotNone(type) {
               return _.chain(this.TYPES).without(this.NONE).includes(type).value();
          } /**
            * Determines if a given sliding window time shift value is the PRECEDING.
            * @param   {string} slidingWindowTimeShift
            * @returns {boolean}
            */ }, { key: 'isPreceding', value: function isPreceding(slidingWindowTimeShift) {
               return this.SLIDING_WINDOW_TIME_SHIFTS.PRECEDING === slidingWindowTimeShift;
          } /**
            * Returns an always valid sliding window time shift value.
            * @param   {string} slidingWindowTimeShift
            * @returns {string}
            */ }, { key: 'resolveSlidingWindowTimeShift', value: function resolveSlidingWindowTimeShift(slidingWindowTimeShift) {
               return _.get(this.SLIDING_WINDOW_TIME_SHIFTS, '' + slidingWindowTimeShift, this.SLIDING_WINDOW_TIME_SHIFTS.PRECEDING);
          } }]);return Comparison;
}();

},{}],11:[function(require,module,exports){
'use strict'; /* eslint no-useless-constructor:0 */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}function _possibleConstructorReturn(self, call) {
     if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
     }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
     if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
     }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var Comparison = require('./Comparison');module.exports = function (_Comparison) {
     ComparisonRealTime.$inject = ['Filters', 'TimesDynamic'];_inherits(ComparisonRealTime, _Comparison); /* @ngInject*/function ComparisonRealTime(Filters, TimesDynamic) {
          _classCallCheck(this, ComparisonRealTime);var _this = _possibleConstructorReturn(this, (ComparisonRealTime.__proto__ || Object.getPrototypeOf(ComparisonRealTime)).call(this));_this.Filters = Filters;_this.TimesDynamic = TimesDynamic;return _this;
     } /**
       * List of comparison types for real time elements
       */_createClass(ComparisonRealTime, [{ key: 'findComparison', /**
                                                                    * Will return the corresponding comparison dynamic time filter based on multiple options
                                                                    * @param   {Object} options
                                                                    * @param   {string} options.comparisonType Etheir NONE or PERIOD
                                                                    * @param   {string} options.language The language for which to fetch dynamic time filters
                                                                    * @param   {string} options.elementType Either SPARKLINE_LIVE or KPI_LIVE are expected
                                                                    * @param   {Object} options.timeFilter Time filter object for which we are going to look for a comparison id
                                                                    * @param   {string} options.comparisonId The dynamic time filter comparison id to validate
                                                                    * @returns {null|object}
                                                                    */value: function findComparison(options) {
               var comparisons = this.TimesDynamic.getRealTimeComparisons(_.get(options, 'language'), _.get(options, 'elementType'));return _.chain(comparisons).filter({ compares: _.get(options, 'timeFilter.value1') }).find({ id: _.get(options, 'comparisonId') }).value() || null;
          } /**
            * Will return the 'filter' object to set when a certain type and a certain time filter are set
            * @param   {Object} options
            * @param   {string} options.comparisonType Etheir NONE or PERIOD
            * @param   {string} options.language The language for which to fetch dynamic time filters
            * @param   {string} options.elementType Either SPARKLINE_LIVE or KPI_LIVE are expected
            * @param   {Object} options.timeFilter Time filter object for which we are going to look for a comparison id
            * @param   {string} options.comparisonId The dynamic time filter comparison id to validate
            * @returns {Object}
            */ }, { key: 'evalFilter', value: function evalFilter(options) {
               if (!this.isNotNone(_.get(options, 'comparisonType'))) {
                    return this.NONE_FILTER;
               }var comparisonId = _.get(this.findComparison(options), 'id');if (!comparisonId) {
                    return this.NONE_FILTER;
               }return this.Filters.timeDynamic(comparisonId);
          } /**
            * Will evaluate and return the proper comparison type for a report real time element
            * @param   {Object} options
            * @param   {string} options.comparisonType Etheir NONE or PERIOD
            * @param   {string} options.language The language for which to fetch dynamic time filters
            * @param   {string} options.elementType Either SPARKLINE_LIVE or KPI_LIVE are expected
            * @param   {Object} options.timeFilter Time filter object for which we are going to look for a comparison id
            * @param   {string} options.comparisonId The dynamic time filter comparison id to validate
            * @returns {string}
            */ }, { key: 'evalType', value: function evalType(options) {
               if (this.isNotNone(_.get(options, 'comparisonType'))) {
                    return this.findComparison(options) ? this.PERIOD : this.NONE;
               }return this.NONE;
          } }, { key: 'TYPES', get: function get() {
               return ['NONE', 'PERIOD'];
          } }]);return ComparisonRealTime;
}(Comparison);

},{"./Comparison":10}],12:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     ConfigPeriod.$inject = ['Monads', 'Filters'];function ConfigPeriod(Monads, Filters) {
          _classCallCheck(this, ConfigPeriod);this.Monads = Monads;this.Filters = Filters;
     } /**
       * Returns a list of all valid values of the config period property
       * @returns {Array<string>}
       */_createClass(ConfigPeriod, [{ key: 'getConfigTime_', /**
                                                              * Will try to fetch the time filter from the list of filters of the predefinedContainer hash
                                                              * from the config hash. Will return null if nothing is found.
                                                              * @param   {Object}  config - A config hash
                                                              * @returns {Object|null}
                                                              * @private
                                                              */value: function getConfigTime_(config) {
               var filters = _.get(config, 'predefinedContainer.filters', []); // Will try to fish all known time arrangeTypes, including Q3's times_internal
               var configTime = _.cloneDeep(this.Filters.hasTimeFilter(filters, true));return configTime || null;
          } /**
            * Will try to fetch the monad configuration of the config object passed.
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @returns {Object|undefined}
            * @private
            */ }, { key: 'getMonad_', value: function getMonad_(config, layer) {
               var arrangeType = _.get(config, 'arrangeType');return this.Monads.layer(layer).monad(arrangeType);
          } /**
            * Will try to fetch the time filter from the list of filters from the metric configuration.
            * Will return null if nothing is found.
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @param   {boolean} q3Comp - Flag to replace with times_internal with times_internal_day
            * @returns {Object|null}
            * @private
            */ }, { key: 'getMonadTime_', value: function getMonadTime_(config, layer) {
               var q3Comp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var monad = this.getMonad_(config, layer);if (!monad) {
                    return null;
               }var monadFilters = _.get(monad, 'filters', []);var monadTime = _.cloneDeep(this.Filters.hasTimeFilter(monadFilters, true));if (q3Comp) {
                    this.Filters.correctTime(monadTime);
               }return monadTime || null;
          } /**
            * Will determine the period type for a given config ignoring the actual value
            * of the 'columnPeriod' property - i.e. will detect the proper columnPeriod
            * value based on configurations (of both config and source metric config)
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @returns {string}
            * @private
            */ }, { key: 'detectPeriod_', value: function detectPeriod_(config, layer) {
               var configTime = this.getConfigTime_(config);if (configTime) {
                    return this.CONFIG_PERIOD;
               }var monadTime = this.getMonadTime_(config, layer);if (monadTime) {
                    return this.MONAD_PERIOD;
               }return this.PARENT_PERIOD;
          } /**
            * Will return the proper time filter fished from configurations and based solely
            * on the value of the columnPeriod property.
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @param   {boolean} q3Comp - Flag to replace with times_internal with times_internal_day
            * @returns {Object|null}
            */ }, { key: 'getConfigTimeFilter', value: function getConfigTimeFilter(config, layer) {
               var q3Comp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var configPeriod = _.get(config, this.PERIOD_PROPERTY);switch (configPeriod) {case this.MONAD_PERIOD:
                         return this.getMonadTime_(config, layer, q3Comp);case this.CONFIG_PERIOD:
                         return this.getConfigTime_(config);case this.PARENT_PERIOD:default:
                         return null;}
          } /**
            * Will validate the period property of a config hash, checking for
            * the existence of their corresponding filters in the approriate configurations
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @returns {boolean}
            * @private
            */ }, { key: 'isPeriodValid_', value: function isPeriodValid_(config, layer) {
               var configPeriod = _.get(config, this.PERIOD_PROPERTY);switch (configPeriod) {case this.PARENT_PERIOD:
                         // Parent period needs no further validation
                         return true;case this.MONAD_PERIOD:case this.CONFIG_PERIOD:
                         // True if a proper time filter is found
                         return Boolean(this.getConfigTimeFilter(config, layer));default:
                         return false;}
          } /**
            * Will set the period property if that is found necessary - whether its undefined
            * or simply not in sync with the associated configurations.
            * @param   {Object}  config - A config hash
            * @param   {string} layer - The layer from which to fish configurations from
            * @chainable
            */ }, { key: 'initPeriod', value: function initPeriod(config, layer) {
               // Set the property only if it is found invalid
               if (!this.isPeriodValid_(config, layer)) {
                    _.set(config, this.PERIOD_PROPERTY, this.detectPeriod_(config, layer));
               }return this;
          } }, { key: 'PERIODS', get: function get() {
               return ['COLUMN', 'MONAD', 'ANALYSIS'];
          } }, { key: 'PARENT_PERIOD', get: function get() {
               return this.PERIODS[2];
          } }, { key: 'MONAD_PERIOD', get: function get() {
               return this.PERIODS[1];
          } }, { key: 'CONFIG_PERIOD', get: function get() {
               return this.PERIODS[0];
          } /**
            * Returns the property name of the period value is persisted in. 'columnPeriod' refers to
            * columns
            * @returns {string}
            */ }, { key: 'PERIOD_PROPERTY', get: function get() {
               return 'columnPeriod';
          } }]);return ConfigPeriod;
}();

},{}],13:[function(require,module,exports){
'use strict'; /* eslint no-useless-constructor:0 */
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var ConfigPeriod = require('./ConfigPeriod');module.exports = function (_ConfigPeriod) {
  ConfigPeriodColumn.$inject = ['Monads', 'Filters'];_inherits(ConfigPeriodColumn, _ConfigPeriod); /* @ngInject*/function ConfigPeriodColumn(Monads, Filters) {
    _classCallCheck(this, ConfigPeriodColumn);return _possibleConstructorReturn(this, (ConfigPeriodColumn.__proto__ || Object.getPrototypeOf(ConfigPeriodColumn)).call(this, Monads, Filters));
  }return ConfigPeriodColumn;
}(ConfigPeriod);

},{"./ConfigPeriod":12}],14:[function(require,module,exports){
'use strict'; /* eslint no-useless-constructor:0 */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}function _possibleConstructorReturn(self, call) {
     if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
     }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
     if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
     }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var ConfigPeriod = require('./ConfigPeriod');module.exports = function (_ConfigPeriod) {
     ConfigPeriodElement.$inject = ['Monads', 'Filters'];_inherits(ConfigPeriodElement, _ConfigPeriod); /* @ngInject*/function ConfigPeriodElement(Monads, Filters) {
          _classCallCheck(this, ConfigPeriodElement);return _possibleConstructorReturn(this, (ConfigPeriodElement.__proto__ || Object.getPrototypeOf(ConfigPeriodElement)).call(this, Monads, Filters));
     } /**
       * Returns a list of all valid values of the config period property
       * @returns {Array<string>}
       */_createClass(ConfigPeriodElement, [{ key: 'getMonad_', /**
                                                                * Will try to fetch the monad configuration of the config object passed.
                                                                * @param   {Object}  config - The configJson of a KPI/Sparkline
                                                                * @param   {string} layer - The layer from which to fish configurations from
                                                                * @returns {Object|undefined}
                                                                * @private
                                                                */value: function getMonad_(config, layer) {
               // Fetches the metric arrange type providing backward compatibility with the old KPI|Sparkline structure
               var arrangeType = _.has(config, 'metricArrangeType') ? _.get(config, 'metricArrangeType') : _.get(config, 'metric.arrangeType');return this.Monads.layer(layer).monad(arrangeType);
          } }, { key: 'PERIODS', get: function get() {
               return ['ELEMENT', 'MONAD', 'REPORT'];
          } /**
            * Returns the property name of the period value is persisted in. 'elementPeriod' refers to
            * report KPIs and Sparklines
            * @returns {string}
            */ }, { key: 'PERIOD_PROPERTY', get: function get() {
               return 'elementPeriod';
          } }]);return ConfigPeriodElement;
}(ConfigPeriod);

},{"./ConfigPeriod":12}],15:[function(require,module,exports){
'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
} /**
  * @ngdoc service
  * @name CustomFigures
  * @description Containers service used to hold and manipulate the custom formulas and metrics definition
  * (not to be confused with custom formula|metric based monads)
  */var CustomFiguresService = function () {
    /*@ngInject*/function CustomFiguresService() {
        _classCallCheck(this, CustomFiguresService);this.figuresContainer = { metrics: {}, formulas: {} };
    } /**
      * @ngdoc property
      * @name CustomFiguresService#metrics
      * @description Map of figures of type custom metric keyed by arrange type
      * @returns {Object}
      */_createClass(CustomFiguresService, [{ key: 'setMetrics', /**
                                                                 * @ngdoc method
                                                                 * @name CustomFiguresService#setMetrics
                                                                 * @description Sets the list of custom metrics
                                                                 * @param {Array} metrics The list of custom metrics to be stored in the container
                                                                 * @returns {CustomFiguresService}
                                                                 */value: function setMetrics(metrics) {
            if (_.isArray(metrics)) {
                this.figuresContainer.metrics = _.zipObject(_.map(metrics, 'arrangeType'), metrics);
            }return this;
        } /**
          * @ngdoc method
          * @name CustomFiguresService#setFormulas
          * @description Sets the list of custom formulas
          * @param {Array} formulas The list of custom formulas to be stored in the container
          * @returns {CustomFiguresService}
          */ }, { key: 'setFormulas', value: function setFormulas(formulas) {
            if (_.isArray(formulas)) {
                this.figuresContainer.formulas = _.zipObject(_.map(formulas, 'arrangeType'), formulas);
            }return this;
        } }, { key: 'metrics', get: function get() {
            return this.figuresContainer.metrics;
        } /**
          * @ngdoc property
          * @name CustomFiguresService#formulas
          * @description Map of figures of type custom formula keyed by arrange type
          * @returns {Object}
          */ }, { key: 'formulas', get: function get() {
            return this.figuresContainer.formulas;
        } /**
          * @ngdoc property
          * @name CustomFiguresService#figures
          * @description Map of all figures keyed by arrange type
          * @returns {Object}
          */ }, { key: 'figures', get: function get() {
            return _.assign({}, this.metrics, this.formulas);
        } }]);return CustomFiguresService;
}();module.exports = CustomFiguresService;

},{}],16:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     function CustomFormulaTemplates() {
          _classCallCheck(this, CustomFormulaTemplates);
     }_createClass(CustomFormulaTemplates, [{ key: 'getFunction', /**
                                                                  * Retuns the template for a custom formula template.
                                                                  * @param  {string} operation
                                                                  * @returns {Object}
                                                                  * @private
                                                                  */value: function getFunction(operation) {
               return { type: 'FUNCTION', functionName: _.chain(this.OPERATIONS).values().includes(operation).value() ? operation : this.OPERATIONS.ADD, parameters: [] };
          } /**
            * Will return the addition formula
            * @returns {Object}
            */ }, { key: 'getConstant', /**
                                        * Will return the constant object with a given 'stringified' value
                                        * @param  {number} value
                                        * @returns {Object}
                                        */value: function getConstant(value) {
               return { type: 'CONSTANT', value: '' + value };
          } }, { key: 'getParenthesis', value: function getParenthesis(type) {
               return { functionName: type, type: 'PARENTHESIS' };
          } }, { key: 'OPERATIONS', get: function get() {
               return { ADD: 'add', SUB: 'sub', DIV: 'div', DIVNULL: 'divnull', MUL: 'mul' };
          } }, { key: 'ADD', get: function get() {
               return this.getFunction(this.OPERATIONS.ADD);
          } /**
            * Will return the addition formula
            * @returns {Object}
            */ }, { key: 'SUB', get: function get() {
               return this.getFunction(this.OPERATIONS.SUB);
          } /**
            * Will return the division formula
            * @returns {Object}
            */ }, { key: 'DIV', get: function get() {
               return this.getFunction(this.OPERATIONS.DIV);
          } /**
            * Will return the division by zero formula
            * @returns {Object}
            */ }, { key: 'DIVNULL', get: function get() {
               return this.getFunction(this.OPERATIONS.DIVNULL);
          } /**
            * Will return the mutliplication formula
            * @returns {Object}
            */ }, { key: 'MUL', get: function get() {
               return this.getFunction(this.OPERATIONS.MUL);
          } }]);return CustomFormulaTemplates;
}();

},{}],17:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
} /**
  * @ngdoc service
  * @name CustomFormulas
  * @description Service responsible for querying and altering custom formula configurations
  */var CustomFormulas = function () {
     /*@ngInject*/
     CustomFormulas.$inject = ['CustomFormulaTemplates', 'Monads', 'Filters', 'filterUtils', 'segmentService'];function CustomFormulas(CustomFormulaTemplates, Monads, Filters, filterUtils, segmentService) {
          _classCallCheck(this, CustomFormulas);this.CustomFormulaTemplates = CustomFormulaTemplates;this.Monads = Monads;this.Filters = Filters;this.filterUtils = filterUtils;this.segmentService = segmentService;
     } /**
       * Will generate a percentage comparison formula based on a list of query metrics
       * @param   {Array<Object>} metrics List of query metrics to compare
       * @returns {Object}
       */_createClass(CustomFormulas, [{ key: 'getComparisonFormula', value: function getComparisonFormula(metrics) {
               var divisionFormula = this.CustomFormulaTemplates.DIV;divisionFormula.parameters = _.map(metrics, 'value');var formulaMul = this.CustomFormulaTemplates.MUL;formulaMul.parameters = [divisionFormula, this.CustomFormulaTemplates.getConstant(100)];var formulaSub = this.CustomFormulaTemplates.SUB;formulaSub.parameters = [formulaMul, this.CustomFormulaTemplates.getConstant(100)];return formulaSub;
          } /**
            * Asserts a parameter to be of type constant
            * @param {Object} parameter The parameter to be checked
            * @returns {boolean}
            */ }, { key: 'isParameterConstant', value: function isParameterConstant(parameter) {
               return _.get(parameter, 'type') === 'CONSTANT';
          } /**
            * Asserts a parameter to be of type function
            * @param {Object} parameter The parameter to be checked
            * @returns {boolean}
            */ }, { key: 'isParameterFunction', value: function isParameterFunction(parameter) {
               return _.get(parameter, 'type') === 'FUNCTION';
          } /**
            * Asserts a parameter to be of type function and with functionName div
            * @param {Object} parameter The parameter to be checked
            * @returns {boolean}
            * @private
            */ }, { key: 'isDivParameterFunction_', value: function isDivParameterFunction_(parameter) {
               return this.isParameterFunction(parameter) && _.get(parameter, 'functionName') === this.CustomFormulaTemplates.OPERATIONS.DIV;
          } /**
            * Asserts a parameter to be of type metric. These parameters can be based on metrics, custom metrics or custom formulas.
            * @param {Object} parameter The parameter to be checked
            * @returns {boolean}
            */ }, { key: 'isParameterMetric', value: function isParameterMetric(parameter) {
               return _.get(parameter, 'type') === 'METRIC';
          } /**
            * Asserts a metric parameter to be of type metric that is not based on a formula
            * @param {Object} parameter The parameter to be checked
            * @param {string} layer The formula metric layer
            * @returns {boolean}
            */ }, { key: 'isParameterNonFormulaMetric', value: function isParameterNonFormulaMetric(parameter, layer) {
               return this.isMetricPlain_(parameter, layer);
          } /**
            * Asserts a metric parameter to be of type custom formula
            * @param {Object} parameter The parameter to be checked
            * @param {string} layer The formula metric layer
            * @returns {boolean}
            */ }, { key: 'isParameterCustomFormula', value: function isParameterCustomFormula(parameter, layer) {
               return this.isMetricFormula_(parameter, layer);
          } /**
            * Retrieves the list of metrics and dimensions used in a custom formula monad
            * Currently not applicable, but can be extended to extract metrics and dimensions used in the filters of the formula or its dependencies.
            * @param {Object} formulaMonad The custom formula monad
            * @returns {Array}
            * TODO Replace with the traverse mechanism
            */ }, { key: 'getFormulaMonads', value: function getFormulaMonads(formulaMonad) {
               var _this = this;var foundMonads = {};var onParamVisit = function onParamVisit(node) {
                    var arrangeType = _.get(node, 'arrangeType', null);var foundMonad = _this.Monads.layer(_this.Monads.RAW_DATA).monad(arrangeType);if (foundMonad) {
                         foundMonads[foundMonad.arrangeType] = foundMonad;
                    }
               };this.traverseMonad(formulaMonad, onParamVisit, true);return _.values(foundMonads);
          } /**
            * Retrieves the list of on custom figure based metrics used in a custom formula monad
            * @param {Object} formulaMonad The custom formula monad
            * @returns {Array}
            * TODO Replace with the traverse mechanism
            */ }, { key: 'getFormulaCustomMonads', value: function getFormulaCustomMonads(formulaMonad) {
               var _this2 = this;return _.filter(this.getFormulaMonads(formulaMonad), function (monad) {
                    return _this2.Monads.isMonadCustomFigure(monad);
               });
          } /**
            * Replaces a filter in a custom metric or formula
            * @param {Object} metric The custom figure configuration (custom metric|formula monad)
            * @param {Object} originalFilter Old filter configuration
            * @param {Object} modifiedFilter New filter configuration
            * @returns {Object} The updated metric. Note that it mutates the original argument metric.
            */ }, { key: 'replaceCustomFigureFilterValues', value: function replaceCustomFigureFilterValues(metric, originalFilter, modifiedFilter) {
               var uniqueFilterProperties = this.filterUtils.getUniqueFilterProperties();var originalSlimFilter = _.pick(originalFilter, uniqueFilterProperties);var modifiedSlimFilter = _.pick(modifiedFilter, uniqueFilterProperties);var customFigureFilters = this.getCustomFigureFilters(metric, false); // Does not include inherited filters
               _.forEach(customFigureFilters, function (filter) {
                    if (_.isEqual(_.pick(filter, uniqueFilterProperties), originalSlimFilter)) {
                         _.merge(filter, modifiedSlimFilter);
                    }
               });return metric;
          } /**
            * Traverses a metric monad (metrics, formulas, predefined and custom) invoking the provided callback on any node that implements the monad interface
            * @param {Object} metric A metric or formula monad, includes the custom and predefined monads
            * @param {Function} onVisit Callback to be invoked on node traversal
            * @param {boolean=} resolveDeep Should the parameter resolve the monad it is based on
            */ }, { key: 'traverseMonad', value: function traverseMonad(metric, onVisit) {
               var resolveDeep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var formulaDefinition = _.get(metric, 'customFormula', null);if (!_.isPlainObject(metric) || !_.has(metric, 'arrangeType')) {
                    return;
               } // Might also resolve the baseArrangeType for custom metrics if required
               // metric.baseArrangeType
               onVisit(metric);if (formulaDefinition) {
                    this.traverseParameter_(formulaDefinition, onVisit, resolveDeep);
               }
          } /**
            * Retrieves a custom metric or formula filter using deep lookup, i.e. recursively extracts the filters used in any custom figure
            * that constructs the current custom figure (Includes the segments as filters)
            * @param {Object} metric The custom figure configuration (custom metric|formula monad)
            * @param {boolean=} resolveDeep Should the parameter monads be resolved in case of custom formulas.
            * Will extract also the filters of the monads the parameters are based on.
            * @returns {Array}
            */ }, { key: 'getCustomFigureFilters', value: function getCustomFigureFilters(metric) {
               var _this3 = this;var resolveDeep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var metricFilters = [];var onParamVisit = function onParamVisit(node) {
                    metricFilters.push.apply(metricFilters, _toConsumableArray(_this3.filterUtils.getMetricFiltersList(node)));metricFilters.push.apply(metricFilters, _toConsumableArray(_this3.segmentService.getSegmentConnectorsAsFilters(_.get(node, 'predefinedSegmentConnections', []), false)));
               };this.traverseMonad(metric, onParamVisit, resolveDeep);return this.filterUtils.getTimelessFilterList(metricFilters);
          } /**
            * Will generate the comparison formula for KPI comparison (both Period and Sliding window).
            * Formula is as follows: [(metric - comparisonMetric)/comparisonMetricWithCustomScope]*100
            * @param  {Object}  metric_ - The metric query object to compare against
            * @param  {Object}  comparisonMetric_ - The metric query object with the comparative time range
            * @param  {boolean} hasObjectDivisorScope - Flag to differentiate the divisor scope (true for real time elements and sliding window comparisons)
            * @returns {Object}
            */ }, { key: 'getKPIComparisonFormula', value: function getKPIComparisonFormula(metric_, comparisonMetric_) {
               var hasObjectDivisorScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var metric = _.cloneDeep(metric_);var comparisonMetric = _.cloneDeep(comparisonMetric_);var formulaMul = this.CustomFormulaTemplates.MUL; // First formulaMul parameter is a formula too
               var formulaDiv = this.CustomFormulaTemplates.DIV; // Inner first && only parameter of CustomFormulaTemplates is a formula too
               var formulaSub = this.CustomFormulaTemplates.SUB; // Push the first metric and second comparisonMetric unchanged as first and second parameter in the SUB
               // inner formula (will be subtracted)
               formulaSub.parameters.push(_.get(metric, 'value'));formulaSub.parameters.push(_.get(comparisonMetric, 'value')); // Add the sub inner formula as first parameter in the div inner formula
               formulaDiv.parameters.push(formulaSub); // Add the second metric with changed scope NONE as second parameter in the div inner formula
               var divisorScope = hasObjectDivisorScope ? 'OBJECT' : 'NONE';var divisorMetric = _.chain(comparisonMetric).get('value').cloneDeep().set('scope', divisorScope).value();formulaDiv.parameters.push(divisorMetric); // Add the div formula as first parameter in the mul outer formula
               formulaMul.parameters.push(formulaDiv); // Add the 100 value as second parameter in the mul outer formula
               formulaMul.parameters.push(this.CustomFormulaTemplates.getConstant(100));return formulaMul;
          } /**
            * Will resolve a single custom formula - actually convert a plain custom formula parameter
            * object to a 'full-blown' custom formula definition by:
            * i.  Setting the parameters, inherited from the original custom formula definition
            * ii. Extending filters and containers with the filters and containers found in the original config
            * Will leave non-custom formula parameters untouched.
            * @param  {Object} formulaDefinition - A custom formula parameter object
            */ }, { key: 'resolve', value: function resolve(formulaDefinition) {
               var arrangeType = _.get(formulaDefinition, 'arrangeType'); // No arrange type? Nothing to replace
               if (!arrangeType) {
                    return;
               } // Custom formulas are expected to exist only on raw - non-live - elements
               // hence no explicit layer set for Monads retrieval
               var customFormula = _.get(this.Monads.monad(arrangeType), 'customFormula'); // Not a nested formula? Nothing to replace
               if (!customFormula) {
                    return;
               } // Set the parameters with the actual custom formula configuration
               formulaDefinition.parameters = [customFormula]; // Get the complete metric definition as defined in the FE config, so as to grab...
               var monad = this.Monads.monad(arrangeType); // ...the filters
               var metricFilters = _.chain(monad).get('filters', []).cloneDeep().value(); // Extend the filters of the formulaDefinition with the ones fetched form the original metric definition
               formulaDefinition.filters = metricFilters.concat(_.chain(formulaDefinition).get('filters', []).cloneDeep().value()); // ...and the containers including the segments
               var metricContainers = this.getContainersAndResolvedSegments_(monad);var formulaDefinitionContainers = this.getContainersAndResolvedSegments_(formulaDefinition); // Extend the containers of the formulaDefinition with the ones fetched form the original metric definition
               formulaDefinition.containers = [].concat(_toConsumableArray(metricContainers), _toConsumableArray(formulaDefinitionContainers));
          } /**
            * Will deep resolve a custom formula by recursively resolving - not only the main configuration but also -
            * each nested parameter that might be a custom parameter.
            * @param  {Object} formulaDefinition - A custom formula parameter object
            * @returns {Object} - The 'resolved' parameter configuration, where ALL custom formulas are 'resolved'
            */ }, { key: 'resolveDeep', value: function resolveDeep(formulaDefinition) {
               var _this4 = this;this.resolve(formulaDefinition);_.chain(formulaDefinition).get('parameters').forEach(function (param, index, params) {
                    _.set(params, index, _this4.resolveDeep(param));
               }).value();return formulaDefinition;
          } /**
            * Will identify if a metric object of a RGS query is of type 'METRIC' - i.e. no 'FUNCTION', 'CONST' etc.
            * @param   {Object}  metric
            * @returns {boolean}
            * @private
            */ }, { key: 'isMetric', value: function isMetric(metric) {
               return _.chain(metric).get('type').isEqual('METRIC').value();
          } /**
            * Will replace the arrangeType of a single metric of an RGS query with it's baseArrangeType - if any.
            * @param  {Object} metric
            * @param  {string} layer - The layer from which metric configurations are to be fished from (i.e. REAL_TIME vs RAW_DATA)
            * @private
            */ }, { key: 'replaceArrangeTypeWithBase_', value: function replaceArrangeTypeWithBase_(metric, layer) {
               // Do nothing if it ain't a metric
               if (!this.isMetric(metric)) {
                    return;
               } // The arrangeType of the metric inside the query
               var arrangeType = _.get(metric, 'arrangeType'); // Get the base arrangeType configuration based on the fished metric arrangeType
               var baseArrangeType = this.Monads.layer(layer).getBaseArrangeType(arrangeType); // Do nothing if has no base arrangeType is set
               if (!baseArrangeType) {
                    return;
               } // Replace metric custom metric arrange type with the baseArrangeType
               _.set(metric, 'arrangeType', baseArrangeType);
          } /**
            * Will recursively deep replace arrangeTypes with their equivalent 'base' arrangeType
            * @param  {Array<Object>} metricList - List of query metrics
            * @param  {string} layer - The layer from which metric configurations are to be fished from (i.e. REAL_TIME vs RAW_DATA)
            * @private
            */ }, { key: 'replaceBaseArrangeTypes_', value: function replaceBaseArrangeTypes_(metricList, layer) {
               var _this5 = this;_.forEach(metricList, function (metric) {
                    _this5.replaceArrangeTypeWithBase_(metric, layer); // Work with the parameters as well so as to 'deep' replace
                    var parameters = _.get(metric, 'parameters');_this5.replaceBaseArrangeTypes_(parameters, layer);
               });
          } /**
            * Will replace all arrangeTypes with their equivalent 'base' arrangeType - if any - within a query
            * @param  {Object} query - The calculation hash of an RGS query
            */ }, { key: 'injectBaseArrangeTypes', value: function injectBaseArrangeTypes(query) {
               var layer = this.Monads.getQueryLayer(query);var metrics = _.chain(query).get('metrics').map(function (metric) {
                    return _.get(metric, 'value');
               }).compact().value();this.replaceBaseArrangeTypes_(metrics, layer);
          } /**
            * Will collect all filter lists and return a list of filter rules based on:
            * 1. Parameter configuration
            * 2. 'Parent' metric configuration
            * 3. Metric configuration as determined in FE config
            * Time filter priority is as follows:
            * 1. From parameter - if set
            * 2. From 'parent' - if set
            * 3. From  FE config - if set
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {Object} parentMetric - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string} layer
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getParameterFilters_', value: function getParameterFilters_(parameter, parentMetric, layer) {
               var _this6 = this;if (!this.isMetric(parameter) && !this.isMetric(parentMetric)) {
                    return [];
               }var arrangeType = _.get(parameter, 'arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);var filters = []; // Iterate over the list of objects and compile a list of filters. Order is
               // very important and determines which time filter will prevail
               _.forEach([monad, parentMetric, parameter], function (hash) {
                    var filters_ = _.chain(hash).get('filters', []).cloneDeep().value(); // Extract the time filter
                    var time_ = _.chain(_this6.Filters.deleteTimes(filters_, true)).first().value();filters = filters.concat(filters_);_this6.Filters.insertTimes(filters, time_, true);
               });this.filterUtils.uniqFilters(filters);return filters;
          } /**
            * Will collect all segment connectors, resolve them to containers and append them at the end of the container list
            * of a given config - i.e. monad, parameter etc - while making sure duplicates are eliminated.
            * @param   {Object} config
            * @returns {Array<Object>}
            */ }, { key: 'getContainersAndResolvedSegments_', value: function getContainersAndResolvedSegments_(config) {
               var _this7 = this;var containers_ = _.chain(config).get('containers', []).cloneDeep().value();var segmentContainers_ = _.chain(config).get('predefinedSegmentConnections', []).map(function (segmentConnector) {
                    return _this7.segmentService.getSegmentConnectorAsContainer(segmentConnector);
               }).value();var containers = [].concat(_toConsumableArray(containers_), _toConsumableArray(segmentContainers_));this.filterUtils.uniqContainers(containers);return containers;
          } /**
            * Will collect all container lists and return a list of collected containers including converted segments.
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {Object} parentMetric - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string} layer
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getParameterContainersAndResolvedSegments_', value: function getParameterContainersAndResolvedSegments_(parameter, parentMetric, layer) {
               var _this8 = this;if (!this.isMetric(parameter) && !this.isMetric(parentMetric)) {
                    return [];
               }var arrangeType = _.get(parameter, 'arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);var containers = _.chain([monad, parentMetric, parameter]).map(function (config) {
                    return _this8.getContainersAndResolvedSegments_(config);
               }).flatten().value();this.filterUtils.uniqContainers(containers);return containers;
          } /**
            * A list of properties each custom formula parameter will inherit
            * from its parent parameter node.
            */ }, { key: 'mergeParameters_', /**
                                             * Will merge two query metric parameters of type METRIC, abiding following rules:
                                             * 1. rootParameter's context, timeShiftBy, timeShiftUnit and sumValue will be passed on to sourceParameter
                                             * 2. Filters will be collected from both parameters and duplicates will be eliminated
                                             * 3. sourceParameter's time filter - if any - will prevail
                                             * 4. rootParameter's will be passed on sourceParameter - if sourceParameter lacks a time filter
                                             * 5. Containers will be collected from both parameters and duplicates will be eliminated
                                             * @param  {Object} sourceParameter - Metric parameter object of type 'METRIC'
                                             * @param  {Object} rootParameter - Metric parameter object of type 'METRIC'
                                             * @param  {string} layer
                                             * @chainable
                                             * @private
                                             */value: function mergeParameters_(sourceParameter, rootParameter, layer) {
               // Do nothing if both parameters are not METRICs
               if (!this.isMetric(sourceParameter) || !this.isMetric(rootParameter)) {
                    return this;
               } // sourceParameter will inherit context and sumValue from rootParameter
               var inherit_ = _.pick(rootParameter, this.PARENT_PARAMETER_INHERITANCE); // Merge filters
               var filters = this.getParameterFilters_(sourceParameter, rootParameter, layer); // Merge containers including segments
               var containers = this.getParameterContainersAndResolvedSegments_(sourceParameter, rootParameter, layer);_.chain(sourceParameter).merge(inherit_).set('filters', filters).set('containers', containers).value(); // Will inherit additional parent parameters  - timeShiftBy, timeShiftUnit - only if the scope of the parameter
               // is other than NONE
               if (_.get(sourceParameter, 'scope') !== 'NONE') {
                    var inheritOptionally_ = _.pick(rootParameter, this.OPTIONAL_PARENT_PARAMETER_INHERITANCE);_.chain(sourceParameter).merge(inheritOptionally_).value();
               }return this;
          } /**
            * Will return the appropriate 'parent' metric for a metric parameter; ideally of type METRIC, null otherwise.
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {Object} parentMetric_ - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string} layer
            * @returns {Object | null}
            */ }, { key: 'getParentMetric_', value: function getParentMetric_(parameter, parentMetric_, layer) {
               if (!this.isMetric(parameter) && !this.isMetric(parentMetric_)) {
                    return null;
               } // If the parameter if not a METRIC itself simply propagate the parentMetric
               if (!this.isMetric(parameter) && this.isMetric(parentMetric_)) {
                    return _.cloneDeep(parentMetric_);
               }var newParentMetric = _.cloneDeep(parameter);this.mergeParameters_(newParentMetric, parentMetric_, layer);return newParentMetric;
          } /**
            * Will return a list of 'custom formula' parameters given a metric parameter
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string} layer
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getParameterList_', value: function getParameterList_(parameter, layer) {
               if (!this.isMetric(parameter)) {
                    return _.get(parameter, 'parameters', []);
               } // Get the list of parameters already set in the metric parameter object
               var parameters = _.get(parameter, 'parameters');if (_.isArray(parameters) && !_.isEmpty(parameters)) {
                    return parameters;
               }var arrangeType = _.get(parameter, 'arrangeType');var customFormula = this.Monads.layer(layer).getCustomFormula(arrangeType);if (!customFormula) {
                    return [];
               }return [customFormula];
          } /**
            * Will extract the custom formula configuration from a parameter - if applicable
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string}  layer
            * @returns {Object | null}
            */ }, { key: 'getCustomFormula_', value: function getCustomFormula_(parameter, layer) {
               var arrangeType = _.get(parameter, 'arrangeType');return this.Monads.layer(layer).getCustomFormula(arrangeType);
          } /**
            * Will identify 'expandable' parameters. In other words, parameters of type 'METRIC' that are custom
            * formulas and can be further broken down.
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string}  layer
            * @returns {boolean}
            */ }, { key: 'isMetricFormula_', value: function isMetricFormula_(parameter, layer) {
               if (!this.isMetric(parameter)) {
                    return false;
               }return !_.isEmpty(this.getCustomFormula_(parameter, layer));
          } /**
            * Will identify plain parameters. In other words, parameters of type 'METRIC' that are NOT custom
            * formulas.
            * @param   {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string}  layer
            * @returns {boolean}
            */ }, { key: 'isMetricPlain_', value: function isMetricPlain_(parameter, layer) {
               if (!this.isMetric(parameter)) {
                    return false;
               }return _.isEmpty(this.getCustomFormula_(parameter, layer));
          } /**
            * Will replace the parameter with the first and only element of the parameters list i.e. the custom formula configuration
            * @param  {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param  {string} layer
            * @param  {Array<Object>} parameters - List of parameter objects i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @chainable
            * @private
            */ }, { key: 'replaceCustomFormula_', value: function replaceCustomFormula_(parameter, layer, parameters) {
               if (!this.isMetricFormula_(parameter, layer)) {
                    return this;
               } // Custom formulas are expected to have a parameters list with a single element
               // Supposedly the configuration of the entire 'customFormula', which is expected
               // to be of type 'FUNCTION'
               // @todo: Stricter check???
               if (_.size(parameters) !== 1) {
                    return this;
               }var newParameter = _.chain(parameters).first().cloneDeep().value(); // Swap only if there's something to swap with
               if (!newParameter) {
                    return this;
               } // List of properties that the custom formula needs to wrongly inherit
               // from the 'formula' configuration metric. A must for exports to work :/
               // @todo: Please remove once the arrangeTypeToAlias t-rex magic is clarified or
               // completely ditched.
               var INHERIT_THESE_PROPERTIES = ['title', 'arrangeType']; // Empty the object without breaking the reference
               _.forEach(parameter, function (value, key) {
                    // DO not drop the title
                    if (_.includes(INHERIT_THESE_PROPERTIES, key)) {
                         return;
                    }delete parameter[key];
               });_.merge(parameter, newParameter);return this;
          } /**
            * Will pass on specific properties from parentMetric to parameter and extend it's
            * filters and containers following logic of mergeParameters_ method.
            * @param  {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param  {string} layer
            * @param  {Object} parentMetric - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @chainable
            * @private
            */ }, { key: 'inheritParent_', value: function inheritParent_(parameter, layer, parentMetric) {
               if (!this.isMetricPlain_(parameter, layer)) {
                    return this;
               }this.mergeParameters_(parameter, parentMetric, layer);return this;
          } /**
            * Will replace the arrange type of a plain parameter with it's base arrange type
            * of applicable
            * @param  {Object} parameter - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param  {string} layer
            * @chainable
            * @private
            */ }, { key: 'replaceParameterArrangeTypeWithBase_', value: function replaceParameterArrangeTypeWithBase_(parameter, layer) {
               if (!this.isMetricPlain_(parameter, layer)) {
                    return this;
               }this.replaceArrangeTypeWithBase_(parameter, layer);return this;
          } /**
            * Will deep replace custom formulas with their respective configuration(s), propagating and extending certain configurations
            * to deeper nested parameters of the formula and finally return the 'updated' parameter.
            * Propagated: context, timeShiftBy, timeShiftUnit, sumValue
            * Extended: filters, containers
            * @param   {Object} parameter_ - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @param   {string} layer
            * @param   {Object} parentMetric_ - Metric parameter object i.e. can be of type 'METRIC', 'FUNCTION', 'CONSTANT'
            * @returns {Object}
            */ }, { key: 'replaceCustomFormulaDeep_', value: function replaceCustomFormulaDeep_(parameter_, layer, parentMetric_) {
               var _this9 = this;var parentMetric = this.getParentMetric_(parameter_, parentMetric_, layer);var parameters = _.chain(this.getParameterList_(parameter_)).map(function (parameter) {
                    return _this9.replaceCustomFormulaDeep_(parameter, layer, parentMetric);
               }).value();this.inheritParent_(parameter_, layer, parentMetric_).replaceCustomFormula_(parameter_, layer, parameters).replaceParameterArrangeTypeWithBase_(parameter_, layer);return parameter_;
          } /**
            * Will iterate over the metrics of a query and deep replace 'custom formulas' with their respective
            * configuration.
            * @param  {Object} query - A calculation hash of an RGS request
            */ }, { key: 'injectCustomFormulaConfig', value: function injectCustomFormulaConfig(query) {
               var _this10 = this;var layer = this.Monads.getQueryLayer(query);_.chain(query).get('metrics').forEach(function (metric) {
                    _this10.replaceCustomFormulaDeep_(_.get(metric, 'value'), layer);
               }).value();
          } /**
            * Will recursilvely collect all parameters of a query metric object that are of type METRIC
            * @param   {Object} metric The query metric object
            * @param   {Array<Object>=}  metricList The list to populate with metrics
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getMetricsDeep_', value: function getMetricsDeep_(metric) {
               var _this11 = this;var metricList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];if (this.isMetric(metric)) {
                    metricList.push(_.omit(metric, ['parameters']));
               }_.chain(metric).get('parameters', []).forEach(function (parameter) {
                    return _this11.getMetricsDeep_(parameter, metricList);
               }).value();return metricList;
          } /**
            * Will recursilvely replace the functionName of div functions with divnull
            * @param {Object} parameter A formula parameter of any type
            * @private
            */ }, { key: 'replaceDivWithDivnullDeep_', value: function replaceDivWithDivnullDeep_(parameter) {
               var _this12 = this;if (this.isDivParameterFunction_(parameter)) {
                    _.set(parameter, 'functionName', this.CustomFormulaTemplates.OPERATIONS.DIVNULL);
               }_.chain(parameter).get('parameters').forEach(function (childParameter) {
                    return _this12.replaceDivWithDivnullDeep_(childParameter);
               }).value();
          } /**
            * Will iterate over the metrics of a query, deep replace 'custom formulas' with their respective
            * configuration and apply replaceDivWithDivnullDeep_ on the resolved configurations.
            * @param  {Object} query - A calculation object of an RGS request
            */ }, { key: 'injectDivnull', value: function injectDivnull(query) {
               var _this13 = this;this.injectCustomFormulaConfig(query);_.chain(query).get('metrics').forEach(function (queryMetric) {
                    return _this13.replaceDivWithDivnullDeep_(queryMetric.value);
               }).value();
          } /**
            * Will resolve a query metric and then return the list of all elements of type METRIC that
            * it resolved to.
            * @param   {Object} query_ - A calculation hash of an RGS request
            * @returns {Array<Object>}
            */ }, { key: 'getListOfResolvedMetrics', value: function getListOfResolvedMetrics(query_) {
               var _this14 = this;var query = _.cloneDeep(query_);this.injectCustomFormulaConfig(query);return _.chain(query).get('metrics').map(function (queryMetric) {
                    return _this14.getMetricsDeep_(queryMetric.value);
               }).flatten().value();
          } /**
            * Traverses a formula parameter of type metric
            * @param {Object} parameter A formula parameter of type metric|formula
            * @param {Function} onVisit Callback to be invoked on node traversal
            * @param {boolean=} resolveDeep Should the parameter resolve the monad it is based on
            * @private
            */ }, { key: 'traverseMetricParameter_', value: function traverseMetricParameter_(parameter, onVisit) {
               var resolveDeep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;onVisit(parameter);if (resolveDeep) {
                    var paramMonad = this.Monads.monad(parameter.arrangeType);if (this.isParameterCustomFormula(parameter)) {
                         this.traverseMonad(paramMonad, onVisit, resolveDeep);
                    } else {
                         onVisit(paramMonad);
                    }
               }
          } /**
            * Traverses a formula parameter of type function
            * @param {Object} parameter A formula parameter of type function
            * @param {Function} onVisit Callback to be invoked on node traversal
            * @param {boolean=} resolveDeep Should the parameter resolve the monad it is based on
            * @private
            */ }, { key: 'traverseFunctionParameter_', value: function traverseFunctionParameter_(parameter, onVisit, resolveDeep) {
               var _this15 = this;var funcParameters = _.get(parameter, 'parameters', []);_.forEach(funcParameters, function (funcParameter) {
                    _this15.traverseParameter_(funcParameter, onVisit, resolveDeep);
               });
          } /**
            * Traverses a formula parameter of any type
            * @param {Object} parameter A formula parameter of any type
            * @param {Function} onVisit Callback to be invoked on node traversal
            * @param {boolean=} resolveDeep Should the parameter resolve the monad it is based on
            * @private
            */ }, { key: 'traverseParameter_', value: function traverseParameter_(parameter, onVisit) {
               var resolveDeep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // Processes the function parameters
               if (this.isParameterFunction(parameter)) {
                    this.traverseFunctionParameter_(parameter, onVisit, resolveDeep);
               } // Processes the metric parameters (metrics and formulas)
               if (this.isParameterMetric(parameter)) {
                    this.traverseMetricParameter_(parameter, onVisit, resolveDeep);
               } // Ignores constants
          } }, { key: 'PARENT_PARAMETER_INHERITANCE', get: function get() {
               return [// 'scope',
               // 'context',
               'sumValue'];
          } /**
            * A list of properties each custom formula parameter will OPTIONALLY inherit
            * from its parent parameter node.
            */ }, { key: 'OPTIONAL_PARENT_PARAMETER_INHERITANCE', get: function get() {
               return ['timeShiftBy', 'timeShiftUnit'];
          } }]);return CustomFormulas;
}();module.exports = CustomFormulas;

},{}],18:[function(require,module,exports){
'use strict'; /**
              * Contains important contant variablesof all sorts.
              * @type {Dates}
              */
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}module.exports = /* @ngInject*/function DSCONST() {
  _classCallCheck(this, DSCONST);this.MAX_SUITE_REPORT_ANALYSES_RAW = 20;this.MAX_SUITE_REPORT_KPIS_RAW = 20;this.MAX_SUITE_REPORT_ELEMENTS_LIVE = 6;this.NUMBER_COLUMN_ARRANGE_TYPE = 'nr';this.DEFAULT_TIME_FILTER_INDICATOR = 'times_internal_day';this.TIME_DYNAMIC_FILTER_ARRANGE_TYPE = 'times_dynamic';this.TIME_FILTER_ARRANGE_TYPES = ['times_internal_day', 'times_dynamic']; // Includes all possible time arrange types that may be used inside a time filter
  this.ALL_TIME_FILTERS = [].concat(_toConsumableArray(this.TIME_FILTER_ARRANGE_TYPES), ['times_internal']);this.SAMPLING_FACTOR_DEFAULT_VALUE = { visit: 1, visitor: 5 };this.DYNAMIC_SAMPLING_MODE_DEFAULT = 'visit';this.TIME_FILTER_DATE_STRING = 'YYYY-MM-DD HH:mm:ss';this.DATEPICKER_FORMAT = { en: { live: 'YYYY-MM-DD HH:mm:ss', full: 'YYYY-MM-DD HH:mm', date: 'YYYY-MM-DD', angular: 'yyyy-MM-dd', server: 'YYYY-MM-DD HH:mm:ss' }, de: { live: 'DD.MM.YYYY HH:mm:ss', full: 'DD.MM.YYYY HH:mm', date: 'DD.MM.YYYY', angular: 'dd.MM.yyyy', server: 'YYYY-MM-DD HH:mm:ss' }, zh: { live: 'YYYY-MM-DD HH:mm:ss', full: 'YYYY-MM-DD HH:mm', date: 'YYYY-MM-DD', angular: 'yyyy-MM-dd', server: 'YYYY-MM-DD HH:mm:ss' } };this.VIDEO_ENGAGEMENT_ANALYSES = ['video_engagement'];this.HIDE_SUB_FOOTERS_FOR_ANALYSES = ['media_summary'];this.FORCE_LIST_FOR_ANALYSES = ['media_summary', 'video_engagement'];this.SEGMENTS = { TITLE: 'SEGMENTS_TITLE', GROUP: 'SEGMENTS_GROUP', DROPDOWN_DEFAULT: 'SEGMENTS_DROPDOWN_DEFAULT_VALUE' };this.PRINT_ANALYSIS_ID = 'print-analysis-id';this.REPORT_ANALYSIS_DEFAULT_SAMPLING_FACTOR_ON_EDIT = 49; // arrangeTypes of google related metrics and dimensions which dictate the usage of AGGREGATION_LAYER in all queries
  this.GOOGLE_PARAMETERS = ['google_conversions', 'google_estimatedconversions', 'google_first_page_cpc', 'google_top_of_page_cpc', 'google_average_position', 'time_id', 'google_account_id', 'google_account_name', 'google_adid', 'google_adgroup', 'google_campaign', 'google_ad', 'google_campaign_state', 'google_ad_state', 'google_keyword_id', 'google_keyword', 'google_match_type', 'google_keyword_state']; /**
                                                                                                                                                                                                                                                                                                                                                                                                                        * @ngdoc property
                                                                                                                                                                                                                                                                                                                                                                                                                        * @name DSCONST#TRAVERSE_LEVEL
                                                                                                                                                                                                                                                                                                                                                                                                                        * @description Provides level used in traverse logic
                                                                                                                                                                                                                                                                                                                                                                                                                        * LAZY - provides only nodes used in element, but no monads or segments
                                                                                                                                                                                                                                                                                                                                                                                                                        * SHALLOW - provides nodes used in element, but also the monads and segments used in element
                                                                                                                                                                                                                                                                                                                                                                                                                        * DEEP - provides nodes used in element, also the monads and segments used in element, but also all nodes used
                                                                                                                                                                                                                                                                                                                                                                                                                        * deep in monads or segments
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * @example
                                                                                                                                                                                                                                                                                                                                                                                                                        * 1. report use segment with id 15 and segment has filter city = berlin
                                                                                                                                                                                                                                                                                                                                                                                                                        * LAZY level provides only predefinedSegmentConnection used in report
                                                                                                                                                                                                                                                                                                                                                                                                                        * SHALLOW level, provides predefinedSegmentConnection used in report and also active segment object
                                                                                                                                                                                                                                                                                                                                                                                                                        * DEEP level, provides predefinedSegmentConnection used in report, active segment object and also monad city
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * 2. report use category city
                                                                                                                                                                                                                                                                                                                                                                                                                        * LAZY level provides only metric or dimension node used in report
                                                                                                                                                                                                                                                                                                                                                                                                                        * SHALLOW level, provides metric or dimension node used in report and also monad city
                                                                                                                                                                                                                                                                                                                                                                                                                        * DEEP level, there is no DEEP level for categories or parameters
                                                                                                                                                                                                                                                                                                                                                                                                                        *
                                                                                                                                                                                                                                                                                                                                                                                                                        * @returns {Object}
                                                                                                                                                                                                                                                                                                                                                                                                                        */this.TRAVERSE_LEVEL = { LAZY: 'LAZY', SHALLOW: 'SHALLOW', DEEP: 'DEEP' }; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * Map of known contexts.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    * @type {Object}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    */this.CONTEXTS = { NONE: 'NONE', ACTION: 'ACTION', PAGE: 'PAGE', SESSION: 'SESSION', VISITOR: 'VISITOR', ATOMIC: 'ATOMIC' }; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * List of contexts in ascending scope range order; i.e. 'ACTION' is less wide than 'PAGE'.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * NOTE: This is not the complete list of possible contexts.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @type {Array}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  */this.CONTEXT_RANK = ['ACTION', 'PAGE', 'SESSION', 'VISITOR']; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Map of validation errors and warnings.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * @type {Object}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  */this.VALIDATION_META = { ERRORS: { METRIC_LIST_EMPTY: 'MetricListEmpty', DIMENSION_LIST_EMPTY: 'DimensionListEmpty', INVALID_VIEW_MODE_QUERY: 'InvalidViewModeQuery', QUERY_ARRANGE_TYPES_MISSING: 'QueryArrangeTypesMissing', PIVOT_INCOMPATIBLE_DIMENSION: 'PivotIncompatibleDimension', ANALYSIS_LOGICAL_CUBE_MISMATCH: 'AnalysisLogicalCubeMismatch', GOOGLE_PARAMETER_LAYER_MISSING: 'GoogleParameterAggregationLayerMissing', INJECTED_CONTAINER_ARRANGE_TYPES_MISSING: 'InjectedContainerArrangeTypesMissing' }, WARNINGS: { FILTER_LOGICAL_CUBE_MISMATCH: 'FilterLogicalCubeMismatch', CAMPAIGNS_ATTRIBUTION_IN_DIMENSION_LIST: 'CampaignsAttributionInDimensionList', CAMPAIGNS_ATTRIBUTION_METRIC_FILTER_MISSING: 'CampaignsAttributionMetricFilterMissing' } }; /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Map of view mode specific errors.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * @type {Object}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */this.VIEW_MODE_QUERY_VALIDATION = { PATH: { ERRORS: { INVALID_PATH_MODE: 'invalidPathMode', INVALID_PATH_LENGTH: 'invalidPathLength', INVALID_PATH_METRIC_CONTEXT: 'invalidPathMetricContext', METRIC_IS_NOT_PATH_COMPATIBLE: 'metricIsNotPathCompatible', MULTIPLE_METRICS_IN_PATH_QUERY: 'multipleMetricsInPathQuery', DIMENSION_ARRANGE_TYPE_MISSING: 'dimensionArrangeTypeMissing', PATH_METRIC_ARRANGE_TYPE_MISSING: 'pathMetricArrangeTypeMissing', DIMENSION_IS_NOT_PATH_COMPATIBLE: 'dimensionIsNotPathCompatible', MULTIPLE_DIMENSIONS_IN_PATH_QUERY: 'multipleDimensionsInPathQuery', PATH_METRIC_LOGICAL_CUBE_MISMATCH: 'pathMetricLogicalCubeMismatch' } } };
};

},{}],19:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     DateService.$inject = ['$q', 'Dates', 'TimesDynamic', 'TimesDynamicCache'];function DateService($q, Dates, TimesDynamic, TimesDynamicCache) {
          _classCallCheck(this, DateService);Dates.delegate(this);this.$q = $q;this.TimesDynamic = TimesDynamic;this.TimesDynamicCache = TimesDynamicCache;
     } /**
       * Should return an object that contains a complete set of date ranges like so:
       *     - dynamicTimeRange: complete dynamic time filter config
       *     - dynamicTimeRangeFilter: complete dynamic time filter object,
       *     - filter: resolved dynamic time range in date strings
       *     - timeStamps: object with date strings converted to timestamps under start and stop
       *     - numberOfDays: the number of days involved in the time range
       *     - filterOffsetted: the filter object with dates offsetted by number of days
       * @param  {Object} filterObject A filter object
       * @param  {Object} fallBack     A fallback to return in case the filter object fails to resolve to a proper time range filter
       * @returns {Object}
       */_createClass(DateService, [{ key: 'resolveTimeRangeByFilter', value: function resolveTimeRangeByFilter(filterObject, fallBack) {
               var prom = this.$q.defer();var resTemplate = this.getTimeRangeObjectTemplate();if (this.Filters_.isTimeDynamic(filterObject)) {
                    // Fetch the resolved dynamic time range from the cache
                    var resolvedFilter = this.TimesDynamicCache.getCachedKey(filterObject.value1);if (!resolvedFilter) {
                         console.log('FAILED_TO_RESOLVE_DYNAMIC_TIME_RANGE for dynamic time range key ' + filterObject.value1);prom.reject('FAILED_TO_RESOLVE_DYNAMIC_TIME_RANGE');
                    } else {
                         // Fetch and set the cached configuration from the TimesDynamic service
                         resTemplate.dynamicTimeRange = this.TimesDynamic.getDynamicTimeRangeByKey(filterObject.value1);if (!resTemplate.dynamicTimeRange || !this.validateTimeFilterObject(resolvedFilter)) {
                              console.log('RESOLVED_DYNAMIC_TIME_RANGE_IS_INVALID for dynamic time range key ' + filterObject.value1 + ' with ' + JSON.stringify(resolvedFilter) + '.');prom.reject('RESOLVED_DYNAMIC_TIME_RANGE_IS_INVALID');
                         } else {
                              resTemplate.dynamicTimeRangeFilter = _.cloneDeep(filterObject);resTemplate.filter = _.cloneDeep(resolvedFilter);resTemplate.timeStamps.start = this.getTimeStamp(resolvedFilter.value1);resTemplate.timeStamps.stop = this.getTimeStamp(resolvedFilter.value2);this.setTimeRangeMeta(resTemplate);prom.resolve(resTemplate);
                         }
                    }
               } else if (this.validateTimeFilterObject(filterObject)) {
                    resTemplate.filter = _.cloneDeep(filterObject);resTemplate.timeStamps.start = this.getTimeStamp(filterObject.value1);resTemplate.timeStamps.stop = this.getTimeStamp(filterObject.value2);this.setTimeRangeMeta(resTemplate);prom.resolve(resTemplate);
               } else if (this.validateTimeFilterObject(fallBack && fallBack.filter)) {
                    prom.resolve(_.cloneDeep(fallBack));
               } else {
                    prom.reject('FAILED_TO_RESOLVE_TIME_FILTER');
               }return prom.promise;
          } }]);return DateService;
}();

},{}],20:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     Dates.$inject = ['DSCONST', 'Filters', 'TimesDynamicCache'];function Dates(DSCONST, Filters, TimesDynamicCache) {
          _classCallCheck(this, Dates);this.DSCONST_ = DSCONST;this.Filters_ = Filters;this.TimesDynamicCache = TimesDynamicCache;
     } /**
       * Since extends does not play nice with nested require, Class provides this helper method to delegate
       * properties and methods to classes wishing to extend it.
       * @param  {Object} iForeignContext The this of the foreign context
       */_createClass(Dates, [{ key: 'delegate', value: function delegate(iForeignContext) {
               var _this = this;var getOwnPropertyNamesDeep = function getOwnPropertyNamesDeep(obj) {
                    var props = [];var proto = Object.getPrototypeOf(obj);if (!proto) {
                         return props;
                    }props = Object.getOwnPropertyNames(proto);if (_.includes(props, 'delegate')) {
                         return props;
                    }return getOwnPropertyNamesDeep(proto);
               };var methodNames = getOwnPropertyNamesDeep(this); // Delegate properties
               _.forEach(this, function (p, propertyName) {
                    iForeignContext[propertyName] = _this[propertyName];
               }); // Delegate methods
               _.forEach(methodNames, function (methodName) {
                    if (methodName !== 'constructor' && methodName !== 'delegate' && _.isFunction(_this[methodName])) {
                         Object.getPrototypeOf(iForeignContext)[methodName] = _this[methodName];
                    }
               });
          } /**
            * Returns true if a given (filter) object has the proper arrangeType, value1 and when the value2 property is defined.
            * @param  {Object} filterObject A filter object.
            * @returns {boolean}
            */ }, { key: 'validateTimeFilterObject', value: function validateTimeFilterObject(filterObject) {
               if (!this.Filters_.isTime(filterObject, true)) {
                    return false;
               }var value1 = _.get(filterObject, 'value1', null);if (!value1) {
                    return false;
               }return _.has(filterObject, 'value2');
          } /**
            * Should return an array of date strings in the form of YYYYMMDD given a filter object and starting of at filter objects value1
            * @param {Object} filter Filter object with at least a valid time arrangeType and value1
            * @param {string} iUnit Unit to calculate the diff between edge dates - currently only days
            * @param {number} iIterations Number of iterations if other than diff between date edges
            * @returns {Array<string>} A list of date strings between date edges
            */ }, { key: 'getDateStringsByType', value: function getDateStringsByType(filter, iUnit, iIterations) {
               var unit = (iUnit || 'DAY').toLowerCase();var listToReturn = [];var i = void 0;if (!this.validateTimeFilterObject(filter) || unit !== 'day' || filter.arrangeType === this.DSCONST_.TIME_DYNAMIC_FILTER_ARRANGE_TYPE) {
                    return listToReturn;
               }var iterations = iIterations || moment.utc(filter.value2).startOf(unit).diff(moment.utc(filter.value1).startOf(unit), unit + 's');for (i = 0; i <= iterations; i++) {
                    listToReturn.push(moment.utc(filter.value1).startOf(unit).add(i, unit + 's').format('YYYYMMDD'));
               }return listToReturn;
          } /**
            * Will increase the end value of regular time filter object by one day
            * @param  {Object} timeFilter A standard time filter object
            * @returns {boolean}
            */ }, { key: 'addDayToTimeFilter', value: function addDayToTimeFilter(timeFilter) {
               if (this.validateTimeFilterObject(timeFilter) && !this.Filters_.isTimeDynamic(timeFilter) && !_.isEmpty(timeFilter.value2)) {
                    timeFilter.value2 = moment(timeFilter.value2).add(1, 'days').format(this.DSCONST_.TIME_FILTER_DATE_STRING);return true;
               }return false;
          } /**
            * Will decrease the end value of regular time filter object by one day
            * @param {Object} timeFilter A standard time filter object
            * @returns {boolean}
            */ }, { key: 'subtractDayFromTimeFilter', value: function subtractDayFromTimeFilter(timeFilter) {
               if (this.validateTimeFilterObject(timeFilter) && !this.Filters_.isTimeDynamic(timeFilter) && !_.isEmpty(timeFilter.value2)) {
                    timeFilter.value2 = moment(timeFilter.value2).subtract(1, 'days').format(this.DSCONST_.TIME_FILTER_DATE_STRING);return true;
               }return false;
          } /**
            * Will add one day from a timestamp
            * @param {number} ts increased timestamp
            * @returns {number}
            */ }, { key: 'addDayToTimeStamp', value: function addDayToTimeStamp(ts) {
               return moment(ts).add(1, 'days').valueOf();
          } /**
            * Will remove one day from a timestamp
            * @param {number} ts decreased timestamp
            * @returns {number}
            */ }, { key: 'subtractDayFromTimeStamp', value: function subtractDayFromTimeStamp(ts) {
               return moment(ts).subtract(1, 'days').valueOf();
          } /**
            * Will return a time filter given a start and end timestamp
            * @param {number} start Integer value for a timestamp
            * @param {number} end Integer value for a timestamp
            * @returns {Object|null} A filter object with arrangeType times_internal_day
            */ }, { key: 'getTimeFilterFromTimeStamps', value: function getTimeFilterFromTimeStamps(start, end) {
               var timeFilter;if (!_.isNumber(start) || start % 1 !== 0 || !_.isNumber(end) || end % 1 !== 0) {
                    return null;
               }timeFilter = this.Filters_.time();timeFilter.value1 = moment(start).format(this.DSCONST_.TIME_FILTER_DATE_STRING);timeFilter.value2 = moment(end).format(this.DSCONST_.TIME_FILTER_DATE_STRING);return timeFilter;
          } /**
            * Given a date string should return a timestamp
            * @param  {string} dateString A string for a date (i.e. 'YYYYMMDD')
            * @returns {number}
            */ }, { key: 'getTimeStamp', value: function getTimeStamp(dateString) {
               // @todo Timezones should be taken into account. Remove timezones like moment.utc(dateString).valueOf()
               return moment(dateString).valueOf();
          } /**
            * Will calculate the number of days between the edge values of a time filter
            * @param {Object} timeFilter A regular time filter (with arrangeType times_internal_day, so no dynamic time filters)
            * @returns {number|null} The number of days
            */ }, { key: 'getNumberOfDays', value: function getNumberOfDays(timeFilter) {
               if (!this.validateTimeFilterObject(timeFilter) || this.Filters_.isTimeDynamic(timeFilter)) {
                    return null;
               }return moment(timeFilter.value2).diff(moment(timeFilter.value1), 'days');
          } /**
            * Given a date string and an offset will increase the offset so that the weekdays of the dateString and the offset date string match
            * @param   {string} dateString An valid date string (i.e. YYYY-MM-DD)
            * @param   {number} iOriginalOffset Offset
            * @param   {boolean=} negativeOffset Determines whether the weekday is to be searched for in the past or not.
            * @returns {number|null}
            */ }, { key: 'getWeekdayOffset', value: function getWeekdayOffset(dateString) {
               var originalOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var negativeOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;if (!moment(dateString).isValid() || !_.isNumber(originalOffset)) {
                    return null;
               }var weekdayAdjustOffset = 0;var startDate = moment(dateString);var offsetedDate = moment(dateString).subtract(originalOffset, 'days');while (startDate.weekday() !== offsetedDate.weekday()) {
                    weekdayAdjustOffset = negativeOffset ? weekdayAdjustOffset + 1 : weekdayAdjustOffset - 1;offsetedDate = moment(dateString).subtract(originalOffset + weekdayAdjustOffset, 'days');
               }return originalOffset + weekdayAdjustOffset;
          } /**
            * Determines if a list of offsets from a given date string land on the same date unit i.e. the same 'month', 'quarter' or 'year'.
            * @param   {string} dateString
            * @param   {Array<number>} offsets  List of offsets from original dateString
            * @param   {string} dateUnit        i.e. 'month', 'quarter', 'year'
            * @returns {boolean}
            * @private
            */ }, { key: 'areOffsetsInSameDateUnit_', value: function areOffsetsInSameDateUnit_(dateString, offsets, dateUnit) {
               return _.chain(offsets).map(function (offset) {
                    return moment(dateString).subtract(offset, 'days').get(dateUnit);
               }).uniq().size().eq(1).valueOf();
          } /**
            * Returns the offset - in number of days - that is needed to land on the same weekday as the given date string. Method makes ensures that the
            * resulting date is within the same date unit as the original offset - i.e. the same 'month', 'quarter' or 'year' as the
            * offsetted-without-weekday-adjust date.
            * @param   {string} dateString
            * @param   {number} originalOffset Offset in number of days without weekday adjust
            * @param   {string} offsetUnit     i.e. 'month', 'quarter', 'year'
            * @returns {number}
            * @private
            */ }, { key: 'getWeekdayOffsetByUnit_', value: function getWeekdayOffsetByUnit_(dateString) {
               var originalOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var offsetUnit = arguments[2];var negativeOffset = this.getWeekdayOffset(dateString, originalOffset, true);var positiveOffset = this.getWeekdayOffset(dateString, originalOffset, false);if (positiveOffset < negativeOffset && this.areOffsetsInSameDateUnit_(dateString, [originalOffset, positiveOffset], offsetUnit)) {
                    return positiveOffset;
               }return this.areOffsetsInSameDateUnit_(dateString, [originalOffset, negativeOffset], offsetUnit) ? negativeOffset : originalOffset;
          } /**
            * Will return a regular time filter with its values offseted by the passed offset
            * @param {Object} timeFilter A regular time filter object
            * @param {number} offset A number (actually int)
            * @returns {Object|null} The offset regular filter object
            */ }, { key: 'getTimeFilterWithOffset', value: function getTimeFilterWithOffset(timeFilter, offset) {
               if (!this.validateTimeFilterObject(timeFilter) || this.Filters_.isTimeDynamic(timeFilter)) {
                    return null;
               }if (!_.isNumber(offset) || offset % 1 !== 0) {
                    return null;
               }var newFilter = _.cloneDeep(timeFilter);newFilter.value1 = moment(newFilter.value1).subtract(offset, 'days').format(this.DSCONST_.TIME_FILTER_DATE_STRING);newFilter.value2 = moment(newFilter.value2).subtract(offset, 'days').format(this.DSCONST_.TIME_FILTER_DATE_STRING);return newFilter;
          } /**
            * Will return the object pattern for the complete time range object
            * @returns {Object}
            */ }, { key: 'getTimeRangeObjectTemplate', value: function getTimeRangeObjectTemplate() {
               return { dynamicTimeRange: null, dynamicTimeRangeFilter: null, filter: {}, timeStamps: { start: null, stop: null }, numberOfDays: null, weekdayOffset: null, filterOffsetted: null, filterOffsettedWeekday: null };
          } /**
            * Will append additional 'meta' properties to a 'resolved' time filter object
            * @param {Object} dateObject The date object
            */ }, { key: 'setTimeRangeMeta', value: function setTimeRangeMeta(dateObject) {
               if (!dateObject || !dateObject.filter) {
                    return;
               }dateObject.numberOfDays = this.getNumberOfDays(dateObject.filter) || 0;dateObject.weekdayOffset = this.getWeekdayOffset(dateObject.filter.value1, dateObject.numberOfDays);dateObject.filterOffsetted = this.getTimeFilterWithOffset(dateObject.filter, dateObject.numberOfDays);dateObject.filterOffsettedWeekday = this.getTimeFilterWithOffset(dateObject.filter, dateObject.weekdayOffset);
          } /**
            * Will quickly revert any time filter to a regular times_internal_day filter. Regular filters are plainly copied.
            * Dynamic ones are fetched from the cache without trying to resolve them. Will return null if the object passed is invalid OR if a
            * passed dynamic filter is not found in the cache.
            * @param  {Object} timeFilter - A time filter object
            * @returns {Object|null}
            */ }, { key: 'toTimeFilter', value: function toTimeFilter(timeFilter) {
               // Not a time filter, then null
               if (!this.Filters_.isTime(timeFilter)) {
                    return null;
               } // A time filter but not a dynamic one, simply return the same object
               if (!this.Filters_.isTimeDynamic(timeFilter)) {
                    return _.cloneDeep(timeFilter);
               } // Try to fetch the dynamic filter from the cache
               var fromCache = this.TimesDynamicCache.getCachedKey(_.get(timeFilter, 'value1'));return this.Filters_.isTime(fromCache) ? fromCache : null;
          } /**
            * Will generate a regular times_internal_day filter whose time period will be extended so as to include ALL
            * filters in the given timeFilters list.
            * @param  {Array<Object>} timeFilters - List of time filter objects
            * @returns {Object|null}
            */ }, { key: 'getTimeFilterSuperSet', value: function getTimeFilterSuperSet(timeFilters) {
               var _this2 = this;if (_.size(timeFilters) === 0) {
                    return null;
               } // Try to resolve any dynamic time filters if present in the list so as
               // to be able to calculate the superset
               var filters = _.chain(timeFilters).map(function (timeFilter) {
                    return _this2.toTimeFilter(timeFilter);
               }).compact().value();if (filters.length !== timeFilters.length) {
                    return null;
               }var startDates = _.chain(filters).map(function (filter) {
                    return moment(_.get(filter, 'value1'));
               }).compact().value();var value1 = moment.min(startDates).format(this.DSCONST_.TIME_FILTER_DATE_STRING);var endDates = _.chain(filters).map(function (filter) {
                    return moment(_.get(filter, 'value2'));
               }).compact().value();var value2 = moment.max(endDates).format(this.DSCONST_.TIME_FILTER_DATE_STRING);var superSetFilter = this.Filters_.time();return _.chain(superSetFilter).set('value1', value1).set('value2', value2).value();
          } /**
            * Returns the offset from a given time filter when an offset unit is specified.
            * @param   {Object}  filter A time filter object.
            * @param   {string}  offsetUnit The unit to subtract from the start of the given time filter.
            * @param   {boolean=} weekdayAdjust Flag to align starting weekdays.
            * @returns {number}
            */ }, { key: 'getTimeFilterOffsetByUnit', value: function getTimeFilterOffsetByUnit(filter, offsetUnit) {
               var weekdayAdjust = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var format = this.DSCONST_.TIME_FILTER_DATE_STRING;var startDate = _.get(filter, 'value1');var offsetDate = moment(startDate, format).subtract(1, offsetUnit);var offset = moment(startDate, format).diff(offsetDate, 'days');return weekdayAdjust ? this.getWeekdayOffsetByUnit_(startDate, offset, offsetUnit) : offset;
          } }]);return Dates;
}();

},{}],21:[function(require,module,exports){
'use strict';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}module.exports = function () {
  /*@ngInject*/function FeatureFlagService() {
    _classCallCheck(this, FeatureFlagService);this.featuresFlags = { reportModifierVisible: true // By default the report modifier user is visible in reports overview
    };
  }_createClass(FeatureFlagService, [{ key: 'getFeatureFlag', value: function getFeatureFlag(key) {
      return this.featuresFlags[key];
    } }, { key: 'getFeatureFlags', value: function getFeatureFlags() {
      return this.featuresFlags;
    } }, { key: 'getFeaturesFlags', value: function getFeaturesFlags() {
      return this.getFeatureFlags();
    } }, { key: 'setFeatureFlag', value: function setFeatureFlag(key, value) {
      this.featuresFlags[key] = value;return this;
    } }, { key: 'setFeatureFlags', value: function setFeatureFlags(features) {
      var _this = this;_.forEach(features, function (flagValue, flagName) {
        _this.setFeatureFlag(flagName, flagValue);
      });return this;
    } }]);return FeatureFlagService;
}();

},{}],22:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     FilterUtils.$inject = ['utils', 'DSCONST', 'arrangeTypeUtils', 'QueryTemplates', 'Monads', 'HashGen', 'segmentService'];function FilterUtils(utils, DSCONST, arrangeTypeUtils, QueryTemplates, Monads, HashGen, segmentService) {
          _classCallCheck(this, FilterUtils);this.utils = utils;this.DSCONST = DSCONST;this.arrangeTypeUtils = arrangeTypeUtils;this.QueryTemplates = QueryTemplates;this.Monads = Monads;this.HashGen = HashGen;this.segmentService = segmentService;
     } /**
       * Will try to detect a given filter in a list of filters based on it's arrangeType, connector, context, filterPredicate, value1 and value2
       * @param {Object} filter A filter object
       * @param {Array<Object>} filterList A list of filter objects
       * @returns {Object|undefined} Either the found object or undefined
       */_createClass(FilterUtils, [{ key: 'findFilterInList', value: function findFilterInList(filter, filterList) {
               return _.find(filterList, function (filterInList) {
                    if (!filter || !filterInList) {
                         return false;
                    }if (filter.arrangeType !== filterInList.arrangeType) {
                         return false;
                    }if (filter.connector !== filterInList.connector) {
                         return false;
                    }if (filter.context !== filterInList.context) {
                         return false;
                    }if (filter.filterPredicate !== filterInList.filterPredicate) {
                         return false;
                    }if (filter.value1 !== filterInList.value1) {
                         return false;
                    }if (filter.value2 !== filterInList.value2) {
                         return false;
                    }return true;
               });
          } /**
            *
            * @param {Object} filter - the filter to find in a list
            * @param {Array} filterList - list to where to look for the filter
            * @param {Array} propertyList - properties to compare
            */ }, { key: 'findAllFiltersInList', value: function findAllFiltersInList(filter, filterList, propertyList) {
               var filterLite = _.pick(filter, propertyList);return _.filter(filterList, function (filterInList) {
                    return _.chain(filterInList).pick(propertyList).isEqual(filterLite).value();
               });
          } /**
            * Will iterate over a list of filters and look for the ones whose arrangeType is included in the this.DSCONST.TIME_FILTER_ARRANGE_TYPES list
            * @param {Object[]} filterList List of filter objects
            * @returns {Object|undefined} The first filter object that satisfies the criteria or undefined
            */ }, { key: 'getTimeFilterFromList', value: function getTimeFilterFromList(filterList) {
               var _this = this;return _.find(filterList, function (e) {
                    return _.includes(_this.DSCONST.TIME_FILTER_ARRANGE_TYPES, e && e.arrangeType);
               });
          } /**
            * Will remove the time filter object (filter objects for which the arrangeType is in the list of time filter arrangeTypes) and return the list of removed elements
            * @param  {Array[Object]} filterList An array of filter objects (the one to clean...)
            * @returns {Array[Object]} An array of filter objects (the ones that were cleaned)
            */ }, { key: 'removeTimeFilterFromList', value: function removeTimeFilterFromList(filterList) {
               var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var timeArrangeTypes = q3Comp ? this.DSCONST.ALL_TIME_FILTERS : this.DSCONST.TIME_FILTER_ARRANGE_TYPES;return _.remove(filterList, function (filterElement) {
                    return _.includes(timeArrangeTypes, filterElement && filterElement.arrangeType);
               });
          } /**
            * Will return a fliter list without the time filters
            * @param  {Array<Object>} iFilters List of filter rules
            * @returns {Array<Object>}
            */ }, { key: 'getTimelessFilterList', value: function getTimelessFilterList(iFilters) {
               var _this2 = this;return _.filter(iFilters, function (iFilterRule) {
                    return !_.includes(_this2.DSCONST.TIME_FILTER_ARRANGE_TYPES, _.get(iFilterRule, 'arrangeType'));
               });
          } /**
            * Will normalize - implement the normalizeContainer method to - a list of containers.
            * @param  {Array<Object>} iContainers List of container objects
            * @returns {Array<Object>}             [description]
            */ }, { key: 'normalizeContainerList', value: function normalizeContainerList(iContainers) {
               var _this3 = this;return _.forEach(iContainers, function (iContainer) {
                    _this3.normalizeContainer(iContainer);
               });
          } /**
            * Should add some default properties to an array of containers as defined in the QueryTemplates.container() method
            * @param  {Object} iContainer
            * @returns {Array<Object>}            The list of containers
            */ }, { key: 'normalizeContainer', value: function normalizeContainer(iContainer) {
               var _this4 = this;if (!iContainer.containers || !_.isArray(iContainer.containers) || iContainer.containers.length === 0) {
                    iContainer.containers = [];return iContainer.containers;
               }return _.forEach(iContainer.containers, function (container, index) {
                    iContainer.containers[index] = _.assign({}, _this4.QueryTemplates.container(), container);
               });
          } /**
            * Will switch the connectors of the source filter list from AND to OR if at least one filter of the same arrangeType exists in the target filter list.
            * @param  {Array<Object>} targetFilterList A list of filter objects
            * @param  {Array<Object>} sourceFilterList    A list of filter objects
            */ }, { key: 'updateFilterListConnectors', value: function updateFilterListConnectors(targetFilterList, sourceFilterList) {
               var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromFilterList(targetFilterList); // Nothing to do for an empty list of target filters or source filters
               if (_.isEmpty(arrangeTypes) || _.isEmpty(sourceFilterList)) {
                    return;
               }_.forEach(sourceFilterList, function (newFilter) {
                    if (newFilter && _.includes(arrangeTypes, newFilter.arrangeType) && newFilter.connector === 'AND') {
                         newFilter.connector = 'OR';
                    }
               });
          } /**
            * Given an dimension or metric configuration (analysisObject) and optionally a properties collection, will return a filter object
            * @param {Object} analysisObject Dimension or metric configuration object
            * @param {Object} extraProperties Optional additional property list
            * @returns {Object} Filter object
            */ }, { key: 'getFilterTemplateByAnalysisObject', value: function getFilterTemplateByAnalysisObject(analysisObject, extraProperties) {
               var properties = _.merge({ connector: 'AND' }, extraProperties);var filterObject = this.getFilterTemplate();var predicates = this.getInPredicates(analysisObject);filterObject.arrangeType = analysisObject.arrangeType;filterObject.filterPredicate = _.first(predicates).value;_.merge(filterObject, properties);return filterObject;
          } /**
            * Simply returns the filter template
            * @param {Object} properties The properties to extend the template with
            * @returns {Object}
            */ }, { key: 'getFilterTemplate', value: function getFilterTemplate() {
               var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return this.QueryTemplates.filter(properties);
          } /**
            * Simply returns the container template
            * @returns {Object}
            */ }, { key: 'getContainerTemplate', value: function getContainerTemplate() {
               return this.QueryTemplates.container({ connector: 'AND', context: 'NONE', filters: [], containers: [] });
          } /**
            * Will return a list of proper predicates to be used when constructing a filter for an analysis object (dimension or metric) based the objects configuration.
            * @param {Object} analysisObject Dimension or metric configuration object
            * @note Accepted values EQUAL, UNEQUAL, LESS, LESSEQUAL, GREATER, GREATEREQUAL, BETWEEN, LIKE or NOT_LIKE
            * number: EQUAL, BETWEEN, GREATER, LESS
            * string: LIKE, NOT_LIKE
            * use number if (dataType == number && mapping == undefined) || arrangeTypes in (times_internal, times_internal_day, times_dynamic) else use string
            * General case inPredicates. Also apply on undefined analysisObjects
            * @returns {Array} List of predicates
            */ }, { key: 'getInPredicates', value: function getInPredicates(analysisObject) {
               var inPredicates = [{ text: 'ist gleich', value: 'LIKE', i18n: 'LIKE' }, { text: 'nicht gleich', value: 'NOT_LIKE', i18n: 'NOT_LIKE' }];var specialArrangeTypes = ['times_internal', 'times_internal_day', 'times_dynamic'];var specialArrangeTypesTimeFormat = ['day', 'month', 'year'];if (!analysisObject) {
                    return inPredicates;
               }if (analysisObject.dataType && analysisObject.dataType.toLowerCase() === 'number' && (_.isUndefined(analysisObject.mapping) || _.isNull(analysisObject.mapping)) || analysisObject.arrangeType && _.includes(specialArrangeTypes, analysisObject.arrangeType)) {
                    inPredicates = [{ text: 'ist gleich', value: 'EQUAL', i18n: 'EQUAL' }, { text: 'zwischen', value: 'BETWEEN', i18n: 'BETWEEN' }]; // special time related items (i.e. day, month, year)
                    if (!_.isUndefined(analysisObject.timeFormat) && !_.isEmpty(analysisObject.timeFormat) && _.includes(specialArrangeTypesTimeFormat, analysisObject.timeFormat)) {
                         inPredicates.push({ text: 'größer als', value: 'GREATER', i18n: 'GREATER_T' }, { text: 'kleiner als', value: 'LESS', i18n: 'LESS_T' });
                    } else {
                         inPredicates.push({ text: 'größer als', value: 'GREATER', i18n: 'GREATER' }, { text: 'kleiner als', value: 'LESS', i18n: 'LESS' });
                    }
               }return inPredicates;
          } /**
            * Simple method to return the translation key for a predicate
            * @param  {string} inPredicateValue The predicate string
            * @param  {Array} inPredicateArray The list of predicates see getInPredicates method
            * @returns {string}
            */ }, { key: 'getInPredicateTranslationKeyByValue', value: function getInPredicateTranslationKeyByValue(inPredicateValue, inPredicateArray) {
               var whatToReturn = _.find(inPredicateArray, { value: inPredicateValue });return whatToReturn && whatToReturn.i18n || inPredicateValue;
          } /**
            * Will identify if a filter object has a wildcard in ANY of it's value
            * place holders (i.e. value1, value2).
            * @param   {Object} filter - The filter rule object
            * @returns {boolean}
            */ }, { key: 'hasWildCard', value: function hasWildCard(filter) {
               return _.chain(filter).pick(['value1', 'value2']).values().map(function (value) {
                    return _.includes(value, '*');
               }).includes(true).value();
          } /**
            * Clean the empty filters
            * @param {Array} filterList
            */ }, { key: 'cleanEmptyFilters', value: function cleanEmptyFilters(filterList) {
               var _this5 = this;_.remove(filterList, function (filter) {
                    // No filters for live elements yet. TO be tweaked in next iteration
                    var wildCardAllowed = _this5.Monads.canSupportWildcards(filter.arrangeType);if (wildCardAllowed) {
                         return !filter.arrangeType || !filter.value1;
                    }return !filter.arrangeType || !filter.value1 || _this5.hasWildCard(filter);
               });
          } /**
            * Removes empty filters and empty containers from a list of container objects.
            * @param {Array<Object>} containerList A list of filter objects
            */ }, { key: 'cleanEmptyContainers', value: function cleanEmptyContainers(containerList) {
               var _this6 = this;_.remove(containerList, function (container) {
                    _this6.cleanEmptyFilters(container.filters);if (_.isEmpty(container.containers)) {
                         return !_.find(container.filters, function (filter) {
                              return filter.arrangeType && filter.value1 && !filter.internalObject;
                         });
                    }return _this6.cleanEmptyContainers(container.containers);
               });
          } /**
            * Will recursively compare container object lists, comparing filter lists and nested container object lists.
            * @param {Object} containerListA A container object
            * @param {Object} containerListB A container object
            * @param {Array<string>} excludePropertyList Array of strings/properties to exclude when comparing
            * @returns {boolean}
            */ }, { key: 'compareContainers', value: function compareContainers(containerListA_, containerListB_, excludePropertyList) {
               var _this7 = this;var match = true;var containerListA = this.omitFilterProperties(containerListA_, excludePropertyList);var containerListB = this.omitFilterProperties(containerListB_, excludePropertyList);var comparisonResult = this.utils.compareObjectLists(containerListA, containerListB, ['filters'].concat(excludePropertyList));if (!comparisonResult) {
                    return false;
               }_.forEach(containerListA, function (containerA, index) {
                    var containerB = containerListB[index];var filterMatch = _this7.utils.compareObjectLists(_.get(containerA, 'filters', []), _.get(containerB, 'filters', []), excludePropertyList);if (!filterMatch) {
                         match = false; // Break the iteration immediately
                         return match;
                    }match = _this7.compareContainers(_.get(containerA, 'containers', []), _.get(containerB, 'containers', []), excludePropertyList);return match;
               });return match;
          } /**
            * Recursively cleans filter lists from given array of properties. Dives into both container and filter lists.
            * @param {Array<Object>} filterList A list of objects (can be filter objects or container objects)
            * @param {Array<string>} excludePropertyList A list of strings that are the properties to be excluded from the filter objects
            * @returns {Array<Object>}
            */ }, { key: 'omitFilterProperties', value: function omitFilterProperties(filterList, excludePropertyList) {
               var _this8 = this;if (_.isEmpty(excludePropertyList)) {
                    return filterList;
               }_.forEach(filterList, function (filterElement, index) {
                    filterList[index] = _.omit(filterElement, excludePropertyList);if (_.has(filterElement, 'filters')) {
                         _this8.omitFilterProperties(filterElement.filters, excludePropertyList);
                    }if (_.has(filterElement, 'containers')) {
                         _this8.omitFilterProperties(filterElement.containers, excludePropertyList);
                    }
               });return filterList;
          } /**
            * Will return a duplicate filter list based on filter object equality dictated by the comparePropertyList
            * @param  {Array<Object>} filterList A list of filter objects
            * @param  {Array<string>} comparePropertyList A list of strings depicting the properties we need to compare filter objects
            * @returns {Array<string>} A list of filter objects free of duplicates
            */ }, { key: 'getUniqueFilterList', value: function getUniqueFilterList(filterList, comparePropertyList) {
               return _.uniqBy(filterList, function (filterElement) {
                    var filterElementLite = _.pick(filterElement, comparePropertyList);return JSON.stringify(filterElementLite);
               });
          } /**
            * Will remove all duplicate filter objects from a given filter list
            * @param  {Array<>} filterList List of filter objects
            * @param {Array<string>} excludePropertyList A list of strings that are the properties to be excluded from the filter objects
            */ }, { key: 'uniqFilters', value: function uniqFilters(filterList, excludePropertyList) {
               var _this9 = this;var excludePropertyList_ = excludePropertyList || [];_.forEach(filterList, function (filterOuter, indexOuter) {
                    _.forEach(filterList, function (filterInner, indexInner) {
                         if (_this9.utils.compareObjectLists([filterOuter], [filterInner], excludePropertyList_) && indexInner !== indexOuter) {
                              filterList.splice(indexInner, 1);
                         }
                    });
               });return this;
          } /**
            * Will remove all duplicate containers from a given container list
            * @param  {Array<Object>} containerList List of container objects
            * @param {Array<string>} excludePropertyList A list of strings that are the properties to be excluded from the filter objects
            */ }, { key: 'uniqContainers', value: function uniqContainers(containerList, excludePropertyList) {
               var _this10 = this;var excludePropertyList_ = excludePropertyList || [];_.forEach(containerList, function (containerOuter, indexOuter) {
                    _.forEach(containerList, function (containerInner, indexInner) {
                         if (_this10.compareContainers([containerOuter], [containerInner], excludePropertyList_) && indexInner !== indexOuter) {
                              containerList.splice(indexInner, 1);
                         }
                    });
               });return this;
          } /**
            * Will recursively iterate over a list of container objects and remove duplicate filter objects from their respective filter arrays
            * @param {Array<Object>} containers A list of container objects
            * @param {Array<string>} comparePropertyList A list of strings dictating the properties the filter objects are going to be compared against
            */ }, { key: 'cleanContainerListFilterDuplicates', value: function cleanContainerListFilterDuplicates(containers, comparePropertyList) {
               var _this11 = this;_.forEach(containers, function (container) {
                    if (container && container.filters) {
                         container.filters = _this11.getUniqueFilterList(container.filters, comparePropertyList);
                    }if (container && container.containers) {
                         _this11.cleanContainerListFilterDuplicates(container.containers, comparePropertyList);
                    }
               });
          } /**
            * Adds a random generated id to filter elements (it is needed by the filter engine...for whatever reason)
            * @param {Array<Object>} filterList A list of filter objects
            */ }, { key: 'addRandomIdsToFilterList', value: function addRandomIdsToFilterList(filterList) {
               var _this12 = this;if (filterList) {
                    _.forEach(filterList, function (filterElement, index) {
                         filterList[index].id = _this12.HashGen.getHash(JSON.stringify(filterElement));
                    });
               }
          } /**
            * Recursively adds random ids to filter lists in - nested - containers
            * @param {Object[]} containers - A list of container objects
            */ }, { key: 'addRandomIdsToContainerFilterLists', value: function addRandomIdsToContainerFilterLists(containers) {
               var _this13 = this;if (containers) {
                    _.forEach(containers, function (container) {
                         if (container && container.filters) {
                              _this13.addRandomIdsToFilterList(container.filters);
                         }if (container && container.containers) {
                              _this13.addRandomIdsToContainerFilterLists(container.containers);
                         }
                    });
               }
          } /**
            * Will try to detect if a report generation query has used filters or containers
            * @param {Object} query Report generation query object or any other object that has a filters and container property that inluce lists of filters and containers respectively
            * @param {Array} arrangeTypeExcludeList Array of arrangeTypes to exdlude from the search (i.e. time related arrange types)
            * @returns {boolean}
            */ }, { key: 'hasActiveFilters', value: function hasActiveFilters(query, arrangeTypeExcludeList) {
               var foundFilters;if (!query || !_.has(query, 'filters') || !_.has(query, 'containers')) {
                    return false;
               }foundFilters = _.filter(query.filters, function (filterElement) {
                    return !_.includes(arrangeTypeExcludeList, filterElement && filterElement.arrangeType);
               });if (foundFilters.length > 0) {
                    return true;
               }return query.containers.length > 0;
          } /**
            * Will return a copy of a container omitting filter rules that have an arrange type that is included in a given list of arrange types
            * @param  {Object} iContainer              A container object - including a list of filters and nested containers
            * @param  {Array<string>} iArrangeTypes    List of arrange types to eliminate
            * @returns {Object}                        A revised copy of the given container
            */ }, { key: 'omitFiltersByArrangeTypes', value: function omitFiltersByArrangeTypes(iContainer, iArrangeTypes) {
               var _this14 = this;var query = _.chain(iContainer).cloneDeep().pick(['filters', 'containers']).defaults({ filters: [], containers: [] }).value();query.filters = _.chain(query).get('filters').filter(function (filter) {
                    return !_.includes(iArrangeTypes, _.get(filter, 'arrangeType'));
               }).value();query.containers = _.chain(query).get('containers').map(function (container) {
                    return _this14.omitFiltersByArrangeTypes(container, iArrangeTypes);
               }).value();return query;
          } /**
            * Will return a query without time filter related filter rules
            * @param  {Object} iQuery A query object - containing filter and container lists
            * @returns {Object}    The time filter less query
            */ }, { key: 'omitTimeFilters', value: function omitTimeFilters(iQuery) {
               return this.omitFiltersByArrangeTypes(iQuery, this.DSCONST.TIME_FILTER_ARRANGE_TYPES);
          } /**
            * Will iterate over a list of filter rules/objects and set the intern property to true
            * @param {Array<Object>} iFilters List of filter rule objects
            */ }, { key: 'setInternOnFilters', value: function setInternOnFilters(iFilters) {
               _.forEach(iFilters, function (iFilter) {
                    if (_.isPlainObject(iFilter)) {
                         iFilter.intern = true;
                    }
               });
          } /**
            * Will iterate over all filter and container lists recursively and set the intern property to true
            * @param {Array<Object>} iContainer Container object with list of filters and list of nested containers
            */ }, { key: 'setInternOnContainer', value: function setInternOnContainer(iContainer) {
               var _this15 = this;this.setInternOnFilters(_.get(iContainer, 'filters'));_.chain(iContainer).get('containers').forEach(function (iInnerContainer) {
                    _this15.setInternOnContainer(iInnerContainer);
               }).value();
          } /**
            * Will extract containers with context NONE from the list of containers and get their filters and append it to the list of filters
            * of the container. Will also clean up empty containers and filter.
            * @param  {Object} iContainer A container object - should contain a list of filters and a list of containers
            */ }, { key: 'prepareContainerForInjection', value: function prepareContainerForInjection(iContainer) {
               var hasFilters = _.chain(iContainer).get('filters').isArray().value();var hasContainers = _.chain(iContainer).get('containers').isArray().value();if (!hasFilters && !hasContainers) {
                    return;
               }if (!hasFilters) {
                    iContainer.filters = [];
               }if (!hasContainers) {
                    iContainer.containers = [];
               }var noneContainers = _.remove(iContainer.containers, { context: 'NONE' });_.forEach(noneContainers, function (noneContainer) {
                    var filters_ = _.get(noneContainer, 'filters');if (filters_) {
                         iContainer.filters = iContainer.filters.concat(filters_);
                    }
               }); // Remove empty elements
               this.cleanEmptyFilters(iContainer.filters);this.cleanEmptyContainers(iContainer.containers); // Add the intern flag on all filter rules
               this.setInternOnContainer(iContainer);
          } /**
            * Will prepend filters and containers from the given container to the filters and containers of a query, making sure that
            * time filters are always on the top of the list
            * @param  {Object} iQuery
            * @param  {Object} iContainer
            */ }, { key: 'prependContainerToQuery', value: function prependContainerToQuery(iQuery, iContainer) {
               var hasFilters = _.chain(iQuery).get('filters').isArray().value();var hasContainers = _.chain(iQuery).get('containers').isArray().value();if (!hasFilters && !hasContainers) {
                    return;
               }if (!hasFilters) {
                    iQuery.filters = [];
               }if (!hasContainers) {
                    iQuery.containers = [];
               } // Time filters always first
               var timeFilters = this.removeTimeFilterFromList(iQuery.filters, true);iQuery.filters = _.chain(timeFilters).concat(_.get(iContainer, 'filters', [])).concat(iQuery.filters).value();iQuery.containers = _.chain(iContainer).get('containers', []).concat(iQuery.containers).value();
          } /**
            * Collects the filters used in a container
            * @param {Object} container A container object definition
            * @returns {Array}
            */ }, { key: 'getContainerFilters', value: function getContainerFilters(container) {
               var _this16 = this;var filters = _.get(container, 'filters', []);var containers = _.get(container, 'containers', []);return _.reduce(containers, function (acc, element) {
                    return acc.concat(_this16.getContainerFilters(element));
               }, filters);
          } /**
            * Collects the containers used in a container
            * @param {Object} container A container object definition
            * @returns {Array}
            */ }, { key: 'getContainerContainers', value: function getContainerContainers(container) {
               var _this17 = this;var containers = _.get(container, 'containers', []);return _.reduce(containers, function (acc, element) {
                    return acc.concat(_this17.getContainerContainers(element));
               }, containers);
          } /**
            * Retrieves a union of filters used in a metric filters, containers and segments as filters.
            * The filter list contains the references to the filters used in the metric
            * @param {Object} metric The metric or metric based formula parameter configuration
            * @returns {Array}
            */ }, { key: 'getMetricFiltersList', value: function getMetricFiltersList(metric) {
               var _this18 = this;var resultList = [];var filters = _.get(metric, 'filters', []);var containers = _.get(metric, 'containers', []);var segmentsAsFilters = this.segmentService.getSegmentConnectorsAsFilters(_.get(metric, 'predefinedSegmentConnections', []), false);resultList.push.apply(resultList, _toConsumableArray(filters));_.forEach(containers, function (container) {
                    return resultList.push.apply(resultList, _toConsumableArray(_this18.getContainerFilters(container)));
               });resultList.push.apply(resultList, _toConsumableArray(segmentsAsFilters));return resultList;
          } /**
            * Removes all the filters based on the segments from a list of filters. Does not mutate the original list.
            * @param {Array} filterList An array of filters
            * @returns {Array}
            */ }, { key: 'removeSegmentFilters', value: function removeSegmentFilters(filterList) {
               var _this19 = this;return _.filter(filterList, function (filter) {
                    return filter.arrangeType !== _this19.segmentService.SEGMENT_FAKE_ARRANGE_TYPE;
               });
          } /**
            * Replaces the segment filter values
            * @param {Object} segment The segment configuration
            * @param {Object} originalFilter The original filter
            * @param {Object} modifiedFilter The modified filter
            * @returns {Object} The modified segment configuration
            */ }, { key: 'replaceSegmentFilterValues', value: function replaceSegmentFilterValues(segment, originalFilter, modifiedFilter) {
               var uniqueFilterProperties = this.getUniqueFilterProperties();var originalSlimFilter = _.pick(originalFilter, uniqueFilterProperties);var modifiedSlimFilter = _.pick(modifiedFilter, uniqueFilterProperties);var segmentFilters = this.getContainerFilters(_.get(segment, 'filter', {}));_.forEach(segmentFilters, function (filter) {
                    if (_.isEqual(_.pick(filter, uniqueFilterProperties), originalSlimFilter)) {
                         _.merge(filter, modifiedSlimFilter);
                    }
               });return segment;
          } /**
            * Retrieves a list of filter properties that make a filter unique in comparison to other filters
            * @returns {string[]}
            */ }, { key: 'getUniqueFilterProperties', value: function getUniqueFilterProperties() {
               return ['arrangeType', 'filterPredicate', 'value1', 'value2'];
          } /**
            * Retrieves - recursively - all filters that might be present in a query metric.
            * @param   {Object} queryMetric
            * @param   {Array<Object>} filters A list of filters to enrich
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getQueryMetricFilters_', value: function getQueryMetricFilters_(queryMetric) {
               var _this20 = this;var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var firstLevelFilters = _.map(this.getContainerFilters(queryMetric));_.forEach(firstLevelFilters, function (firstLevelFilter) {
                    return filters.push(firstLevelFilter);
               });_.chain(queryMetric).get('parameters').forEach(function (metricParameter) {
                    return _this20.getQueryMetricFilters_(metricParameter, filters);
               }).value();return filters;
          } /**
            * Retrieves all filters that might be present in a query.
            * @param   {Object} query
            * @returns {Array<Object>}
            */ }, { key: 'getQueryFilters', value: function getQueryFilters(query) {
               var _this21 = this;var filters = _.map(this.getContainerFilters(query));_.chain(query).get('metrics').map('value').forEach(function (queryMetric) {
                    return _this21.getQueryMetricFilters_(queryMetric, filters);
               }).value();return filters;
          } /**
            * Returns the list of filters found in a query and narrowed down by one or more callbacks.
            * @param   {Object} query
            * @param   {Array<Function>=} callbacks_
            * @returns {Array<Object>}
            */ }, { key: 'filterQueryFilters', value: function filterQueryFilters(query) {
               var callbacks_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var callbacks = _.isArray(callbacks_) ? callbacks_ : [callbacks_];return _.reduce(callbacks, function (queryFilters, callback) {
                    return _.isFunction(callback) ? _.filter(queryFilters, callback) : queryFilters;
               }, this.getQueryFilters(query));
          } /**
            * Retrieves - recursively - all containers that might be present in a query metric.
            * @param   {Object} queryMetric
            * @param   {Array<Object>} containers A list of containers to enrich
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getQueryMetricContainers_', value: function getQueryMetricContainers_(queryMetric) {
               var _this22 = this;var containers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var firstLevelContainers = _.map(this.getContainerContainers(queryMetric));_.forEach(firstLevelContainers, function (firstLevelContainer) {
                    return containers.push(firstLevelContainer);
               });_.chain(queryMetric).get('parameters').forEach(function (metricParameter) {
                    return _this22.getQueryMetricContainers_(metricParameter, containers);
               }).value();return containers;
          } /**
            * Retrieves all containers that might be present in a query.
            * @param   {Object} query
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getQueryContainers_', value: function getQueryContainers_(query) {
               var _this23 = this;var containers = _.map(this.getContainerContainers(query));_.chain(query).get('metrics').map('value').forEach(function (queryMetric) {
                    return _this23.getQueryMetricContainers_(queryMetric, containers);
               }).value();return containers;
          } /**
            * Returns the list of containers found in a query and narrowed down by one or more callbacks.
            * @param   {Object} query
            * @param   {Array<Function>=} callbacks_
            * @returns {Array<Object>}
            */ }, { key: 'filterQueryContainers', value: function filterQueryContainers(query) {
               var callbacks_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];var callbacks = _.isArray(callbacks_) ? callbacks_ : [callbacks_];return _.reduce(callbacks, function (queryContainers, callback) {
                    return _.isFunction(callback) ? _.filter(queryContainers, callback) : queryContainers;
               }, this.getQueryContainers_(query));
          } }]);return FilterUtils;
}();

},{}],23:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     Filters.$inject = ['DSCONST', 'QueryTemplates', 'TimesDynamic', 'LanguageSettings', 'LastUpdates'];_createClass(Filters, [{ key: 'transformerToday', /**
                                                                                                                                                          * Returns today based on the transformer's last update. Fallback is system time in ms.
                                                                                                                                                          * @returns {*}
                                                                                                                                                          */get: function get() {
               return this.LastUpdates.getTransformerUpdateTime(this.DSCONST.TIME_FILTER_DATE_STRING) || Date.now();
          } /*@ngInject*/ }]);function Filters(DSCONST, QueryTemplates, TimesDynamic, LanguageSettings, LastUpdates) {
          _classCallCheck(this, Filters);this.DSCONST = DSCONST;this.QueryTemplates = QueryTemplates;this.TimesDynamic = TimesDynamic;this.LanguageSettings = LanguageSettings;this.LastUpdates = LastUpdates;
     } /**
       * Will try to detect a given filter in a list of filters based on it's arrangeType, connector, context, filterPredicate, value1 and value2
       * @param {Object} iFilter A filter object
       * @param {Array<Object>} iFilterList A list of filter objects
       * @returns {Object|undefined} Either the found object or undefined
       */_createClass(Filters, [{ key: 'find', value: function find(iFilter, iFilterList) {
               return _.find(iFilterList, function (listItem) {
                    if (!iFilter || !listItem) {
                         return false;
                    }if (iFilter.arrangeType !== listItem.arrangeType) {
                         return false;
                    }if (iFilter.connector !== listItem.connector) {
                         return false;
                    }if (iFilter.context !== listItem.context) {
                         return false;
                    }if (iFilter.filterPredicate !== listItem.filterPredicate) {
                         return false;
                    }if (iFilter.value1 !== listItem.value1) {
                         return false;
                    }if (iFilter.value2 !== listItem.value2) {
                         return false;
                    }return true;
               });
          } /**
            * Will replace the Q3 times_internal arrange type to the times_internal_day
            * filter used in analytics
            * @param   {Object} timeFilter
            * @returns {Object}
            */ }, { key: 'correctTime', value: function correctTime(timeFilter) {
               if (_.get(timeFilter, 'arrangeType') === 'times_internal') {
                    _.set(timeFilter, 'arrangeType', 'times_internal_day');
               }return timeFilter;
          } /**
            * Returns the list of time related arrangeTypes.
            * @param  {boolean} q3Comp - Flag to enable badly converted filter lists that include the arrangeType 'times_internal'
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getTimeArrangeTypes_', value: function getTimeArrangeTypes_(q3Comp) {
               var times = ['times_internal_day', 'times_dynamic'];if (q3Comp) {
                    times.push('times_internal');
               }return times;
          } /**
            * checks whether the list of filters (passed as argument) contains an object with property arrangeType and contains times_internal_day or times_dynamic;
            * @param {Array<Object>} filterSet
            * @param {string} q3Comp - Flag to enable badly converted filter lists that include the arrangeType 'times_internal'
            * @returns {boolean}
            */ }, { key: 'hasTimeFilter', value: function hasTimeFilter(filterSet, q3Comp) {
               var _this = this;return _.find(filterSet, function (filterRule) {
                    return _this.isTime(filterRule, q3Comp);
               });
          } /**
            * Deletes time filters from a given filter list
            * @param {Array<Object>} filterSet
            * @param {string} q3Comp - Flag to enable badly converted filter lists that include the arrangeType 'times_internal'
            * @returns {Array<Object>} List of removed time filters
            */ }, { key: 'deleteTimes', value: function deleteTimes(filterSet) {
               var _this2 = this;var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;return _.remove(filterSet, function (filterRule) {
                    return _this2.isTime(filterRule, q3Comp);
               });
          } /**
            * Gets filters that are not time filters from a given filter list
            * @param {Array<Object>} filterSet
            * @param {boolean} q3Comp - Flag to enable badly converted filter lists that include the arrangeType 'times_internal'
            * @returns {Array<Object>} List of filters without time filters
            */ }, { key: 'getTimelessFilters', value: function getTimelessFilters(filterSet) {
               var _this3 = this;var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;return _.reject(filterSet, function (filterRule) {
                    return _this3.isTime(filterRule, q3Comp);
               });
          } /**
            * Will insert a time filter - only if it's a time filter in a list of filters
            * @param {Array<Object>} filterList
            * @param  {Object} timeFilter
            * @param {string} q3Comp - Flag to enable badly converted filter lists that include the arrangeType 'times_internal'
            * @chainable
            */ }, { key: 'insertTimes', value: function insertTimes(filterList, timeFilter) {
               var q3Comp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;if (!this.isTime(timeFilter, q3Comp)) {
                    return this;
               }this.deleteTimes(filterList, q3Comp);filterList.unshift(timeFilter);return this;
          } /**
            * Sets intern property to false on ALL filter objects
            * @param {Object} iContainer Any object that might have a filter or container list
            */ }, { key: 'addIntern', value: function addIntern(iContainer) {
               if (_.isUndefined(iContainer)) {
                    return;
               } // Workaround: make sure that ANY filter gets the property 'intern', also coming from segments or bookmarks
               // @note: 'intern':true filters are never added by the frontend (rather by service), but property has to be present for bugfix AN-621
               if (_.isArray(iContainer.filters)) {
                    _.forEach(iContainer.filters, function (filter) {
                         filter.intern = false;
                    });
               }if (_.isArray(iContainer.containers)) {
                    _.forEach(iContainer.containers, function (container) {
                         if (_.isArray(container.filters)) {
                              _.forEach(container.filters, function (filter) {
                                   filter.intern = false;
                              });
                         }
                    });
               }
          } /**
            * Sets the connector of a filter rule to AND if it's the first one or the first after a time filter.
            * @param  {Array<Object>}  filterSet List of filters.
            * @param  {boolean=} q3Comp Flag to identity Q3's 'times_internal' as a time filter too.
            */ }, { key: 'applyAndRule', value: function applyAndRule(filterSet) {
               var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;if (this.hasTimeFilter(filterSet, q3Comp)) {
                    this.afterTime(filterSet);
               }var firstFilterRule = _.first(filterSet);if (this.isTime(firstFilterRule, q3Comp)) {
                    return;
               }_.chain(filterSet).find(function (filterRule) {
                    return _.isObject(filterRule);
               }).set('connector', 'AND').value();
          } /**
            * Sets first - or first after time - filter rule connectors to AND for containers.
            * @param  {Object}  container
            * @param  {boolean=} q3Comp Flag to identity Q3's 'times_internal' as a time filter too.
            */ }, { key: 'applyAndRuleToContainer', value: function applyAndRuleToContainer(container) {
               var _this4 = this;var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;this.applyAndRule(_.get(container, 'filters'), q3Comp);_.chain(container).get('containers').compact().forEach(function (nestedContainer) {
                    return _this4.applyAndRuleToContainer(nestedContainer, q3Comp);
               }).value();
          } /**
            * Sets the connector of every filter the follows a time filter to AND
            * @param  {Array<Object>} filterList List of filter rule objects
            */ }, { key: 'afterTime', value: function afterTime(filterList) {
               var _this5 = this;_.forEach(filterList, function (filterRule, index) {
                    var nextFilter = filterList[index + 1];if (_this5.isTime(filterRule, true) && nextFilter) {
                         nextFilter.connector = 'AND';
                    }
               });
          } /**
            * Determines if a filter object is a time filter
            * @param   {Object} filterRule A filter rule object
            * @param   {string} q3Comp - Flag whether to detect badly converted filter lists that include the arrangeType 'times_internal'
            * @returns {boolean}
            */ }, { key: 'isTime', value: function isTime(filterRule) {
               var q3Comp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var arrangeType = _.get(filterRule, 'arrangeType');return _.includes(this.getTimeArrangeTypes_(q3Comp), arrangeType);
          } /**
            * Will identify if a given filter object is a dynamic time filter
            * @param  {Object}  iFilter A filter object
            * @returns {boolean}
            */ }, { key: 'isTimeDynamic', value: function isTimeDynamic(iFilter) {
               if (!this.isTime(iFilter)) {
                    return false;
               }return Boolean(iFilter.arrangeType === 'times_dynamic');
          } /**
            * Returns and empty time filter
            * @returns {Object}
            */ }, { key: 'time', value: function time() {
               return _.defaults({ arrangeType: 'times_internal_day', filterPredicate: 'BETWEEN', connector: 'AND' }, this.QueryTemplates.filter());
          } /**
            * Return a dymamic time filter
            * @param  {String} value1 The dynamic time key
            * @returns {Object}
            */ }, { key: 'timeDynamic', value: function timeDynamic() {
               var value1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return _.defaults({ value1: value1 }, { arrangeType: 'times_dynamic', filterPredicate: 'LIKE', connector: 'AND' }, this.QueryTemplates.filter());
          } /**
            * Returns a time filter with the default time range
            * @return {Object}
            */ }, { key: 'timeDefault', value: function timeDefault() {
               var now = Date.now();return _.merge(this.time(), { value1: moment(now).subtract(28, 'days').format('YYYY-MM-DD'), value2: moment(now).subtract(0, 'days').format('YYYY-MM-DD') });
          } /**
            * @ngdocs method
            * @name Filters#getTimeRange
            * @description Gets a time range string for given time filter
            * @param {Object} timeFilter - time filter object
            * @return {String} - properly formatted date range string or the dynamic date string
            */ }, { key: 'getTimeRange', value: function getTimeRange(timeFilter) {
               if (!timeFilter) {
                    return '';
               }if (this.isTimeDynamic(timeFilter)) {
                    var dynamicTimeFilter = this.TimesDynamic.getDynamicTimeRangeByKey(_.get(timeFilter, 'value1'));return _.get(dynamicTimeFilter, 'title', '');
               }var dateFormat = this.LanguageSettings.dateFormat;return moment(timeFilter.value1).format(dateFormat) + ' - ' + moment(timeFilter.value2).subtract(1, 'days').format(dateFormat);
          } /**
            * Determines if a filter object is already resolved or will eventually resolve to a normal time filter.
            * @param   {Object} timeFilter_
            * @returns {boolean}
            * @private
            */ }, { key: 'resolvesToTime_', value: function resolvesToTime_(timeFilter_) {
               if (!this.isTime(timeFilter_, true)) {
                    return false;
               }var timeFilter = _.cloneDeep(timeFilter_);if (this.isTimeDynamic(timeFilter)) {
                    this.TimesDynamic.setResolvedFilter(timeFilter);
               } // Catches badly or non resolved dynamic time filters or simply bad input time filters.
               if (_.chain(timeFilter).get('value2').isEmpty().value()) {
                    return false;
               }return true;
          } /**
            * Determines if a given time filter includes transformers today day (the day with where last update of raw data happened)
            * @param   {Object} timeFilter_
            * @returns {boolean}
            */ }, { key: 'includesToday', value: function includesToday(timeFilter_) {
               if (!this.resolvesToTime_(timeFilter_)) {
                    return false;
               }var timeFilter = _.cloneDeep(timeFilter_);if (this.isTimeDynamic(timeFilter)) {
                    this.TimesDynamic.setResolvedFilter(timeFilter);
               }var timeFilterEnd = moment(_.get(timeFilter, 'value2')).startOf('day');var tomorrow = moment(this.transformerToday).add(1, 'days').startOf('day');return tomorrow.isSame(timeFilterEnd) || tomorrow.isBefore(timeFilterEnd);
          } /**
            * Mutates a given timeFilter setting its value2 to its previous day, syncing the time part with the provided last update date.
            * The method changes the date interval into a time interval by replacing the interval end with today's transformer last update time.
            * Because of this, the arrange type of the time filter should be switched to times_internal which is time aware.
            * @param {Object} timeFilter A time filter object.
            */ }, { key: 'syncTimeFilterEndTime', value: function syncTimeFilterEndTime(timeFilter) {
               this.TimesDynamic.setResolvedFilter(timeFilter);var arrangeType = 'times_internal';var lastUpdateDate = moment(this.transformerToday);var filterEndDate = moment(timeFilter.value2);var isFutureDate = lastUpdateDate.isBefore(filterEndDate, 'day'); // Shift one day back because the filter end date is the beginning of the next day
               filterEndDate.subtract(1, 'day'); // Syncs the time part
               filterEndDate.hours(lastUpdateDate.hours()).minutes(lastUpdateDate.minutes()).seconds(lastUpdateDate.seconds()); // Syncs the date if the time filter end is in the future
               if (isFutureDate) {
                    filterEndDate.year(lastUpdateDate.year()).month(lastUpdateDate.month()).date(lastUpdateDate.date());
               }var value2 = filterEndDate.format(this.DSCONST.TIME_FILTER_DATE_STRING);_.merge(timeFilter, { arrangeType: arrangeType, value2: value2 });
          } }]);return Filters;
}();

},{}],24:[function(require,module,exports){
'use strict'; /* eslint no-bitwise: ["error", { "allow": ["<<", "&"] }] */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     function HashGen() {
          _classCallCheck(this, HashGen);
     }_createClass(HashGen, [{ key: 'getHash', /**
                                               * Will convert a string to hash number
                                               * @param  {string} aString
                                               * @returns {number}
                                               */value: function getHash(aString) {
               var hash = 0; // Do nothing if it's not a string
               if (!_.isString(aString)) {
                    return hash;
               } // Do nothing if it's an empty string
               if (aString.length === 0) {
                    return hash;
               }_.forEach(aString, function (char_, index) {
                    var char = aString.charCodeAt(index);hash = (hash << 5) - hash + char;hash = hash & hash; // Convert to 32bit integer
               });return hash;
          } /**
            * Generates a cacheId based on a given query.
            * @param   {Object} query
            * @param   {string} accountId
            * @returns {string}
            */ }, { key: 'getCacheId', value: function getCacheId(query, accountId) {
               // Exclude the id of the query
               var queryAsString = JSON.stringify(_.omit(query, ['id', 'cacheId']));var hash = this.getHash(queryAsString);return hash + '_' + accountId;
          } /**
            * Will inject a cacheId hash on a given query
            * @param  {Object} query - The query object
            * @param  {Object} options - Mist options object
            */ }, { key: 'injectCacheId', value: function injectCacheId(query, options) {
               var accountId = _.get(options, 'accountId', '');var cacheId = this.getCacheId(query, accountId);_.set(query, 'cacheId', cacheId);
          } }]);return HashGen;
}();

},{}],25:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     HistorizedCache.$inject = ['HashGen', 'Filters', 'filterUtils', 'arrangeTypeUtils', 'queryUtilityService'];_createClass(HistorizedCache, [{ key: 'INCLUDES_LAST_UPDATE', /**
                                                                                                                                                                              * Historized cache category indicating that time filters that include today exist in
                                                                                                                                                                              * a query.
                                                                                                                                                                              */get: function get() {
               return 'INCLUDES_LAST_UPDATE';
          } /**
            * Historized cache category indicating that a query includes filters that have VISITOR context.
            */ }, { key: 'INCLUDES_VISITOR_CONTEXT_FILTERS', get: function get() {
               return 'INCLUDES_VISITOR_CONTEXT_FILTERS';
          } /**
            * Historized cache category indicating that a query includes containers that have VISITOR context.
            */ }, { key: 'INCLUDES_VISITOR_CONTEXT_CONTAINERS', get: function get() {
               return 'INCLUDES_VISITOR_CONTEXT_CONTAINERS';
          } /**
            * Historized cache category indicating that a query is a pivot query with more than 3 dimensions.
            */ }, { key: 'IS_PIVOT_WITH_MORE_THAN_3_DIMENSIONS', get: function get() {
               return 'IS_PIVOT_WITH_MORE_THAN_3_DIMENSIONS';
          } /**
            * Historized cache category indicating that a query includes arrangeTypes that are not historizable.
            */ }, { key: 'INCLUDES_UNHISTORIZABLE_ARRANGE_TYPE', get: function get() {
               return 'INCLUDES_UNHISTORIZABLE_ARRANGE_TYPE';
          } /**
            * Historized cache category indicating that a query includes arrangeTypes that are categories.
            */ }, { key: 'INCLUDES_CATEGORY_ARRANGE_TYPE', get: function get() {
               return 'INCLUDES_CATEGORY_ARRANGE_TYPE';
          } /* @ngInject*/ }]);function HistorizedCache(HashGen, Filters, filterUtils, arrangeTypeUtils, queryUtilityService) {
          _classCallCheck(this, HistorizedCache);this.HashGen = HashGen;this.Filters = Filters;this.filterUtils = filterUtils;this.arrangeTypeUtils = arrangeTypeUtils;this.queryUtilityService = queryUtilityService;
     } /**
       * Returns the list of "historized cache" categories a query falls into.
       * @param   {Object} query
       * @returns {Array<string>}
       */_createClass(HistorizedCache, [{ key: 'getCategoriesForQuery', value: function getCategoriesForQuery(query) {
               var categories = [];if (this.queryUtilityService.includesToday(query)) {
                    categories.push(this.INCLUDES_LAST_UPDATE);
               }if (this.includesVisitorContextFilters_(query)) {
                    categories.push(this.INCLUDES_VISITOR_CONTEXT_FILTERS);
               }if (this.includesVisitorContextContainers_(query)) {
                    categories.push(this.INCLUDES_VISITOR_CONTEXT_CONTAINERS);
               }if (this.isPivotWithMoreThan3Dimensions_(query)) {
                    categories.push(this.IS_PIVOT_WITH_MORE_THAN_3_DIMENSIONS);
               }if (this.includesUnhistorizableArrangeTypes_(query)) {
                    categories.push(this.INCLUDES_UNHISTORIZABLE_ARRANGE_TYPE);
               }if (this.includesCategoryArrangeTypes_(query)) {
                    categories.push(this.INCLUDES_CATEGORY_ARRANGE_TYPE);
               }return categories;
          } /**
            * Generates an id for the historized cache meta object.
            * @param   {Object} query_
            * @param   {string} accountId
            * @returns {string}
            */ }, { key: 'getHistorizedCacheId', value: function getHistorizedCacheId(query_, accountId) {
               var query = _.cloneDeep(query_);this.emptyTimeFilters_(query);return this.HashGen.getCacheId(query, accountId);
          } /**
            * Determines if a given query has filters with context 'VISITOR'.
            * @param   {Object}  query
            * @returns {boolean}
            * @private
            */ }, { key: 'includesVisitorContextFilters_', value: function includesVisitorContextFilters_(query) {
               var filterWithVisitorContext = function filterWithVisitorContext(filter) {
                    return _.get(filter, 'context') === 'VISITOR';
               };var queryFilters = this.filterUtils.filterQueryFilters(query, filterWithVisitorContext);return _.chain(queryFilters).size().gt(0).valueOf();
          } /**
            * Determines if a given query has containers with context 'VISITOR'.
            * @param   {Object}  query
            * @returns {boolean}
            * @private
            */ }, { key: 'includesVisitorContextContainers_', value: function includesVisitorContextContainers_(query) {
               var containerWithVisitorContext = function containerWithVisitorContext(container) {
                    return _.get(container, 'context') === 'VISITOR';
               };var queryContainers = this.filterUtils.filterQueryContainers(query, containerWithVisitorContext);return _.chain(queryContainers).size().gt(0).valueOf();
          } /**
            * Determines if a given is a pivot query with more than 3 dimensions.
            * @param   {Object}  query
            * @returns {boolean}
            * @private
            */ }, { key: 'isPivotWithMoreThan3Dimensions_', value: function isPivotWithMoreThan3Dimensions_(query) {
               var numberOfDimensions = _.chain(query).get('dimensions', []).size().valueOf();return numberOfDimensions > 3 && !this.queryUtilityService.isPivotAsList(query);
          } /**
            * Determines if a given query includes arrangeTypes that are not historizable.
            * @param   {Object}  query
            * @returns {boolean}
            * @private
            */ }, { key: 'includesUnhistorizableArrangeTypes_', value: function includesUnhistorizableArrangeTypes_(query) {
               var unhistorizableArrangeType = function unhistorizableArrangeType(monad) {
                    return _.get(monad, 'historizable') === false;
               };var arrangeTypes = this.arrangeTypeUtils.filterQueryArrangeTypes(query, unhistorizableArrangeType);return _.chain(arrangeTypes).size().gt(0).valueOf();
          } /**
            * Determines if a given query includes arrangeTypes that are categories.
            * @param   {Object}  query
            * @returns {boolean}
            * @private
            */ }, { key: 'includesCategoryArrangeTypes_', value: function includesCategoryArrangeTypes_(query) {
               var categoryArrangeType = function categoryArrangeType(monad) {
                    var unhistorizable = _.get(monad, 'historizable') === false;var hasCategoryOf = !_.chain(monad).get('categoryOf').isEmpty().valueOf();var hasCategoriesInArrangeType = ('' + _.get(monad, 'arrangeType')).match(/_categories_/g) !== null;return unhistorizable && (hasCategoryOf || hasCategoriesInArrangeType);
               };var arrangeTypes = this.arrangeTypeUtils.filterQueryArrangeTypes(query, categoryArrangeType);return _.chain(arrangeTypes).size().gt(0).valueOf();
          } /**
            * Mutates a given query by removing all keys from all time filter objects - no matter how deeply situated they might be.
            * @param   {Object}  query
            * @returns {HistorizedCache}
            * @private
            */ }, { key: 'emptyTimeFilters_', value: function emptyTimeFilters_(query) {
               var _this = this;var isTimeFilter = function isTimeFilter(filter) {
                    return _this.Filters.isTime(filter, true);
               };var timeFilters = this.filterUtils.filterQueryFilters(query, isTimeFilter);_.forEach(timeFilters, function (timeFilter) {
                    return Object.keys(timeFilter).forEach(function (key) {
                         return delete timeFilter[key];
                    });
               });return this;
          } }]);return HistorizedCache;
}();

},{}],26:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     LanguageSettings.$inject = ['DSCONST'];function LanguageSettings(DSCONST) {
          _classCallCheck(this, LanguageSettings);this.language_ = 'en';this.DSCONST = DSCONST;
     } /**
       * The list of suported languages
       * @returns {Array<string>}
       */_createClass(LanguageSettings, [{ key: 'setLanguage', /**
                                                               * Will set the language in the class instance if it's one of the supported ones
                                                               * @param {string} language
                                                               */value: function setLanguage(language) {
               if (!_.includes(this.languages, language)) {
                    return;
               }this.language_ = language;
          } }, { key: 'languages', get: function get() {
               return ['en', 'de', 'zh'];
          } /**
            * The current language short code
            * @returns {string}
            */ }, { key: 'language', get: function get() {
               return this.language_;
          } /**
            * Returns the date format based on the current language
            * @returns {string}
            */ }, { key: 'dateFormat', get: function get() {
               return _.get(this.DSCONST, 'DATEPICKER_FORMAT.' + this.language + '.date');
          } /**
            * Returns the full date format based on the current language
            * @returns {string}
            */ }, { key: 'fullDateFormat', get: function get() {
               return _.get(this.DSCONST, 'DATEPICKER_FORMAT.' + this.language + '.full');
          } }]);return LanguageSettings;
}();

},{}],27:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     LastUpdates.$inject = ['LanguageSettings'];_createClass(LastUpdates, [{ key: 'UPDATE_TYPES', /**
                                                                                                  * Returns a collection of update types.
                                                                                                  * @returns {Object}
                                                                                                  */get: function get() {
               return { TRANSFORM: 'transform', RESULT_CACHE_RESET: 'result_cache_reset' };
          } }, { key: 'fullDateFormat', get: function get() {
               return this.LanguageSettings.fullDateFormat;
          } /* @ngInject*/ }]);function LastUpdates(LanguageSettings) {
          _classCallCheck(this, LastUpdates);this.lastUpdates = [];this.LanguageSettings = LanguageSettings;
     } /**
       * Initialize the service with data
       * @param {array} lastUpdates list of last update objects
       * @returns {LastUpdates}
       */_createClass(LastUpdates, [{ key: 'setAllLastUpdates', value: function setAllLastUpdates(lastUpdates) {
               this.lastUpdates = lastUpdates;return this;
          } /**
            * Returns a clone of the first found update from the list of updates given its updateType.
            * @param   {string} updateType
            * @returns {Object|null}
            * @private
            */ }, { key: 'getFirstUpdateByType_', value: function getFirstUpdateByType_(updateType) {
               return _.chain(this.lastUpdates).find({ updateType: updateType }).cloneDeep().valueOf() || null;
          } /**
            * Returns the update time for the result_cache_reset update.
            * @returns {Object}
            */ }, { key: 'getResultCacheResetUpdateTime', value: function getResultCacheResetUpdateTime() {
               var resultCacheResetUpdate = this.getFirstUpdateByType_(this.UPDATE_TYPES.RESULT_CACHE_RESET);return _.get(resultCacheResetUpdate, 'updateTime', null);
          } /**
            * Returns the update object for the transformer.
            * @returns {Object}
            */ }, { key: 'getTransformerUpdate', value: function getTransformerUpdate() {
               return this.getFirstUpdateByType_(this.UPDATE_TYPES.TRANSFORM);
          } /**
            * Returns the last update time for the transformer
            * @returns {string}
            */ }, { key: 'getTransformerUpdateTime', value: function getTransformerUpdateTime() {
               var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.fullDateFormat;var transformerUpdate = this.getTransformerUpdate();var updateTime = _.get(transformerUpdate, 'updateTime');return moment(updateTime).format(format);
          } /**
            * Returns a clone of the most recent last update by type and id.
            * @param   {number} typeId
            * @param   {string} updateType
            * @returns {Object|null}
            */ }, { key: 'getFirstUpdateByTypeAndId', value: function getFirstUpdateByTypeAndId(typeId, updateType) {
               return _.chain(this.lastUpdates).filter({ typeId: typeId, updateType: updateType }).orderBy(function (_ref) {
                    var updateTime = _ref.updateTime;return moment(updateTime).valueOf();
               }, ['desc']).first().cloneDeep().valueOf() || null;
          } }]);return LastUpdates;
}();

},{}],28:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     LogicalCubeUtils.$inject = ['Monads', 'segmentService', 'arrangeTypeUtils', 'analysisColumnUtils', 'DSCONST', 'metricService', 'filterUtils', 'Analyses'];function LogicalCubeUtils(Monads, segmentService, arrangeTypeUtils, analysisColumnUtils, DSCONST, metricService, filterUtils, Analyses) {
          _classCallCheck(this, LogicalCubeUtils);this.Monads = Monads;this.segmentService = segmentService;this.arrangeTypeUtils = arrangeTypeUtils;this.analysisColumnUtils = analysisColumnUtils;this.DSCONST = DSCONST;this.metricService = metricService;this.filterUtils = filterUtils;this.Analyses = Analyses;
     } /**
       * The fake segment arrangeType used internally
       * @returns {string}
       * @private
       */_createClass(LogicalCubeUtils, [{ key: 'difference', /**
                                                              * Returns a list of sourceLogicalCubes, which are not contained in targetLogicalCubes
                                                              * @param {Array<string>} sourceLogicalCubes List of logical cubes, which should be presented in targetLogicalCubes
                                                              * @param {Array<string>} targetLogicalCubes List of logical cubes, which should have all logicalCubes from sourceLogicalCubes
                                                              * @returns {Array<string>} List of sourceLogicalCubes, which are not contained in targetLogicalCubes
                                                              */value: function difference(sourceLogicalCubes, targetLogicalCubes) {
               var _this = this;var normalizedSourceLogicalCubes = _.map(sourceLogicalCubes, function (logicalCube) {
                    return _this.dropAccountSpecificSuffix(logicalCube);
               });var normalizedTargetLogicalCubes = _.map(targetLogicalCubes, function (logicalCube) {
                    return _this.dropAccountSpecificSuffix(logicalCube);
               });return _.difference(normalizedSourceLogicalCubes, normalizedTargetLogicalCubes);
          } /**
            * Will determine if a list of filters is worth checking for logical cube compatibility. Empty lists are not worth checking. Lists with ONLY segments or nr
            * arrangeTypes are also regarded not worth checking against logical cubes.
            * @param {Array<Object>} filterList List of filter objects
            * @returns {boolean}
            * @private
            */ }, { key: 'isIntersectable_', value: function isIntersectable_(filterList) {
               var filterListArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromFilterList(filterList, true);if (_.isEmpty(filterListArrangeTypes)) {
                    return false;
               }var filteredArrangeTypes = _.without(filterListArrangeTypes, this.SEGMENT_ARRANGE_TYPE_, this.DSCONST.NUMBER_COLUMN_ARRANGE_TYPE);return !_.isEmpty(filteredArrangeTypes);
          } /**
            * Returns a list of intersected logical cubes.
            * @param {Array<string>} logicalCubeList1 List of logical cubes (list of strings)
            * @param {Array<string>} logicalCubeList2 List of logical cubes (list of strings)
            * @returns {Array<string>} List with common intersected logical cubes
            */ }, { key: 'getIntersectedLogicalCubes', value: function getIntersectedLogicalCubes(logicalCubeList1, logicalCubeList2) {
               return _.intersection(logicalCubeList1, logicalCubeList2);
          } /**
            * Returns a list of intersected logical cubes. Always excludes the fake segment arrange type and the nr column arrange type
            * that may pop up in filter sets.
            * @param   {Array<string>} arrangeTypes - List of strings with arrange types
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<string>} List with common intersected logical cubes
            * @private
            */ }, { key: 'getIntersectedLogicalCubesByArrangeTypes_', value: function getIntersectedLogicalCubesByArrangeTypes_(arrangeTypes, layer) {
               var _this2 = this;var logicalCubes = [];var filteredArrangeTypes = _.without(arrangeTypes, this.SEGMENT_ARRANGE_TYPE_, this.DSCONST.NUMBER_COLUMN_ARRANGE_TYPE);_.forEach(filteredArrangeTypes, function (arrangeType, index) {
                    var element = _this2.Monads.layer(layer).monad(arrangeType);if (element && !_.isEmpty(element.logicalCubes)) {
                         logicalCubes = index ? _.intersection(logicalCubes, element.logicalCubes) : element.logicalCubes;
                    }
               });return logicalCubes;
          } /**
            * Returns a list of intersected logical cubes given an analysis configuration
            * @param   {Object} analysisConfig - Analysis configuration object
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<string>} List with common intersected logical cubes
            */ }, { key: 'getIntersectedLogicalCubesByAnalysis', value: function getIntersectedLogicalCubesByAnalysis(analysisConfig, layer) {
               var analysisArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromAnalysis(analysisConfig, true);return this.getIntersectedLogicalCubesByArrangeTypes_(analysisArrangeTypes, layer);
          } /**
            * Returns a list of lists of intersected logical cubes given a report configuration.
            * @param {Object}  reportConfig Report configuration object
            * @returns {Array<Array<string>>} List of lists with common intersected logical cubes
            */ }, { key: 'getIntersectedLogicalCubesByReport', value: function getIntersectedLogicalCubesByReport(reportConfig) {
               var _this3 = this;var intersections = [];_.chain(reportConfig).get('reportElements').filter(function (element) {
                    return _.includes(['ANALYSIS', 'KPI', 'SPARKLINE'], _.get(element, 'type'));
               }).forEach(function (element) {
                    var type = _.get(element, 'type');var configJson = _.get(element, 'configJson');var columns = void 0;if (type === 'ANALYSIS') {
                         columns = _.get(configJson, 'columns', []);
                    } else {
                         columns = _this3.Analyses.getKpiOrSparklineColumns(configJson, type) || [];
                    }_.forEach(_this3.getListOfIntersectedLogicalCubeCombinationsFromColumns(columns, false), function (intersection) {
                         if (_.isArray(intersection)) {
                              intersections.push(intersection);
                         }
                    });
               }).value();return intersections;
          } /**
            * Returns a list of intersected logical cubes given a list of filter objects
            * @param   {Array<Object>} filterList - List of filter objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<string>} List with common - intersected - logical cubes
            */ }, { key: 'getIntersectedLogicalCubesByFilterList', value: function getIntersectedLogicalCubesByFilterList(filterList, layer) {
               var filterListArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromFilterList(filterList, true);return this.getIntersectedLogicalCubesByArrangeTypes_(filterListArrangeTypes, layer);
          } /**
            * Returns a list of intersected logical cubes from a list of columns configurations
            * @param   {Array<Object>} columns
            * @param   {string} type  - Optional: Parameter to get the intersection of certain column types only 'dimensions' and 'metrics' is valid
            * @param   {string} layer - Optional: The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<string>} List with common - intersected - logical cubes
            */ }, { key: 'getIntersectedLogicalCubesFromColumns', value: function getIntersectedLogicalCubesFromColumns(columns, type, layer) {
               var columnArrangeTypes = void 0;if (!_.includes(['dimensions', 'metrics'], type)) {
                    columnArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromColumns(columns, true);
               } else {
                    // Split the columns by type - dimension/metric
                    var columnsTypes_ = this.analysisColumnUtils.splitColumnsByElementType(columns, layer);columnArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromColumns(_.get(columnsTypes_, type), true);
               }return this.getIntersectedLogicalCubesByArrangeTypes_(columnArrangeTypes, layer);
          } /**
            * Will check if the intersection of dimensions logical cubes is empty or iterate over a list of columns, detect
            * only exceptional cases and return a special list of logical cube intersection lists.
            * @param  {Array<Object>} iColumns - List of column configuration objects
            * @param  {Array<string>} iDimensionIntersect - List of intersected logical cubes of dimensions
            * @param  {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Object}
            * @private
            */ }, { key: 'handleExceptionalLogicalCubeCombinations_', value: function handleExceptionalLogicalCubeCombinations_(iColumns, iDimensionIntersection, layer) {
               var exception_ = { isException: false, logicalCubes: [] }; // When only metrics are included in the columns simply collect the logical cube lists
               // of each metric from the columns and return it as a list of logical cubes intersections
               if (this.analysisColumnUtils.hasOnlyMetrics(iColumns, layer)) {
                    exception_.isException = true;exception_.logicalCubes = this.getListOfLogicalCubesFromColumns(iColumns, 'metrics', layer);return exception_;
               } // When all metrics are NONE context metrics simply return the intersection of logical cubes
               // of the dimensions. Same case when intersection of dimension logical cubes is empty - a.k.a. dimensions
               // do not match.
               if (_.isEmpty(iDimensionIntersection) || this.analysisColumnUtils.hasOnlyNoneContextMetrics(iColumns, layer)) {
                    exception_.isException = true;exception_.logicalCubes = [iDimensionIntersection];return exception_;
               }return exception_;
          } /**
            * Returns a combined list of logical cubes sets. Columns are split by type (dimensions and metrics). For
            * each combination of one metric with ALL dimensions the intersected logical cubes are calculated and appended
            * to the list of UNIQUE logical cubes that will be returned by the method.
            * @param  {Array<Object>} columns - List of column configuration objects
            * @param  {boolean} complexOutput - Whether to return a full blown response or just the list
            * @param  {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<Array<string>> | Object} Either returns the list of logical cube intersection lists or a complex object
            */ }, { key: 'getListOfIntersectedLogicalCubeCombinationsFromColumns', value: function getListOfIntersectedLogicalCubeCombinationsFromColumns(columns, complexOutput, layer) {
               var _this4 = this;var logicalCubes_ = [];var mismatch_ = [];var isValid = void 0;var columnType = layer === 'REAL_TIME' ? '' : 'dimensions'; // Intersected logical cube set based on dimensions fished from the columns for RAW_DATA.
               // Intersected logical cube set based on ALL arrangeTypes fished from the columns for REAL_TIME.
               var dimLCs_ = this.getIntersectedLogicalCubesFromColumns(columns, columnType, layer);var exception_ = this.handleExceptionalLogicalCubeCombinations_(columns, dimLCs_, layer);if (exception_.isException) {
                    logicalCubes_ = exception_.logicalCubes;if (complexOutput) {
                         isValid = this.validateLogicalCubeLists_(logicalCubes_);mismatch_ = isValid ? [] : this.arrangeTypeUtils.getArrangeTypesFromColumns(columns, true);return { arrangeTypes: mismatch_, isValid: isValid };
                    }return logicalCubes_;
               } // Split the columns by type - dimension/metric
               var columnsTypes_ = this.analysisColumnUtils.splitColumnsByElementType(columns, layer); // Get the arrangeTypes of the metrics from the columns (analysis)
               var metricAT_ = this.arrangeTypeUtils.getArrangeTypesFromColumns(_.get(columnsTypes_, 'metrics'), true);_.forEach(metricAT_, function (arrangeType) {
                    // Get the logical cubes of the metric
                    var monad = _this4.Monads.layer(layer).monad(arrangeType); // Do not add the intersected logical cube list when the metric has context NONE and is not a Google Adwords metric
                    if (_this4.metricService.ignoresLogicalCubes(monad)) {
                         return;
                    }var metLogicalCubes_ = _.get(monad, 'logicalCubes', []); // Get the intesection of the metric's logical cubes with already intersected logical cubes of the dimensions
                    var intersect_ = _this4.getIntersectedLogicalCubes(metLogicalCubes_, dimLCs_);logicalCubes_.push(intersect_);if (_.isEmpty(intersect_)) {
                         mismatch_.push(arrangeType);
                    }
               }); // Eliminate duplicate lists
               logicalCubes_ = _.uniqBy(logicalCubes_, function (e) {
                    return e.sort().join('');
               });if (complexOutput) {
                    return { arrangeTypes: mismatch_, isValid: this.validateLogicalCubeLists_(logicalCubes_) };
               }return logicalCubes_;
          } /**
            * Willl collect logical cubes and return them as a list given a list of columns with arrangeTypes
            * which could be optionally filtered by type - dimensions or metrics
            * @param  {Array<Object>} columns
            * @param  {string} type    Optional, valid values ['dimensions', 'metrics']
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Array<Array<string>>}
            */ }, { key: 'getListOfLogicalCubesFromColumns', value: function getListOfLogicalCubesFromColumns(columns, type, layer) {
               var _this5 = this;var logicalCubeList = [];var columnArrangeTypes = void 0;if (!_.includes(['dimensions', 'metrics'], type)) {
                    columnArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromColumns(columns, true);
               } else {
                    // Split the columns by type - dimension/metric
                    var columnsTypes_ = this.analysisColumnUtils.splitColumnsByElementType(columns, layer);columnArrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromColumns(_.get(columnsTypes_, type), true);
               }_.forEach(columnArrangeTypes, function (arrangeType) {
                    var monad = _this5.Monads.layer(layer).monad(arrangeType);var logicalCubes_ = _.get(monad, 'logicalCubes', []);logicalCubeList.push(logicalCubes_);
               });return logicalCubeList;
          } /**
            * Will collect logical cubes and return them as a list given a report generation rquest query
            * @param  {Object} query See https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ReportGenerationQuery
            * @returns {Array<Array<string>>}
            */ }, { key: 'getListOfLogicalCubesFromQuery', value: function getListOfLogicalCubesFromQuery(query) {
               var _this6 = this;var logicalCubeList = [];var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromRequestQueryFilters(query, true);var layer = this.Monads.getQueryLayer(query);_.forEach(arrangeTypes, function (arrangeType) {
                    var monad = _this6.Monads.layer(layer).monad(arrangeType);var logicalCubes_ = _.get(monad, 'logicalCubes', []);logicalCubeList.push(logicalCubes_);
               });return logicalCubeList;
          } /**
            * Compiles a list of lists of logical cubes from a list of filters.
            * @param   {Array<Object>} filterList - List of filter objects
            * @param   {string} layer - The layer of the analysis
            * @returns {Array<Array<string>>}
            */ }, { key: 'getLogicalCubesFromFilters_', value: function getLogicalCubesFromFilters_(filterList, layer) {
               var _this7 = this;return _.chain(filterList).filter(function (filter) {
                    var arrangeType = _.get(filter, 'arrangeType');return arrangeType && arrangeType !== _this7.SEGMENT_ARRANGE_TYPE_;
               }).map(function (filter) {
                    var arrangeType = _.get(filter, 'arrangeType');var monad = _this7.Monads.layer(layer).monad(arrangeType);return _.get(monad, 'logicalCubes', []);
               }).value();
          } /**
            * Determines if a filter list can be applied to an analysis - whether strict or non strict
            * @param   {Object} analysisConfig - Analysis configuration object
            * @param   {Array<Object>} filterList - List of filter objects
            * @param   {string} layer - The layer of the analysis
            * @param   {boolean} strict - Strict means that every filter must match combination of dimensions and metrics of the analysis
            * @returns {boolean}
            */ }, { key: 'isAnalysisCompatibleWithFilters', value: function isAnalysisCompatibleWithFilters(analysisConfig, filterList, layer) {
               var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false; // If the filter list is not intersectable - analysis is perfectly addable
               if (!this.isIntersectable_(filterList)) {
                    return true;
               }var logicalCubeList = this.getLogicalCubesFromFilters_(filterList, layer);var columns = _.get(analysisConfig, 'columns', []);return this.isCompatibleColumnList(columns, logicalCubeList, layer, strict, strict);
          } /**
            * Determines if a filter list can be applied to a KPI or Sparkline - whether strict or non strict
            * @param   {Object} kpiConfig The configuration object for a KPI or Sparkline
            * @param   {Array<Object>} filterList List of filter objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @param   {boolean} strict - Strict means that every filter must match intersection of LCs of the dimension and metric
            * @param   {string|null} type - The report element type the config belongs to
            * @returns {boolean}
            */ }, { key: 'isKpiCompatibleWithFilters', value: function isKpiCompatibleWithFilters(kpiConfig, filterList, layer) {
               var strict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null; // If the filter list is not intersectable - kpi/sparkline is perfectly addable
               if (!this.isIntersectable_(filterList)) {
                    return true;
               }var logicalCubeList = this.getLogicalCubesFromFilters_(filterList, layer);var columns = this.Analyses.getKpiOrSparklineColumns(kpiConfig, type) || [];return this.isCompatibleColumnList(columns, logicalCubeList, layer, strict, strict);
          } /**
            * Determines if an arrangeType - to be added as a column to an analysis - will render the analysis incompatible with
            * a given filter set or not; either in strict or non strict mode.
            * @param   {Object} kpiConfig The configuration object for a KPI or Sparkline
            * @param   {Array<Object>} filterList List of filter objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @param   {boolean} strict - Strict means that every filter must match intersection of LCs of the dimension and metric
            * @returns {boolean}
            */ }, { key: 'isColumnCompatibleWithFilters', value: function isColumnCompatibleWithFilters(arrangeType, columns_, filterList, layer) {
               var strict = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // If the filter list is not intersectable - column is considered addable to the analysis columns
               if (!this.isIntersectable_(filterList)) {
                    return true;
               }var logicalCubeList = this.getLogicalCubesFromFilters_(filterList, layer);var columns = [].concat(_toConsumableArray(columns_), [{ arrangeType: arrangeType }]);return this.isCompatibleColumnList(columns, logicalCubeList, layer, strict, strict);
          } /**
            * Will iterate over a list of logical cube sets and check if they intersect with a given logicalCube set.
            * In strict mode (dimension addition): If at least one logical cube set from the list does no intersect with the given logicalCube set, the given
            * logicalCube set is considered incompatible.
            * In non strict mode (filter addition): If the given logicalCube set intersects with at least one set of logical cubes from the list, the
            * given logicalCube set is considered compatible.
            * @param  {Array<Array<string>>} logicalCubeList A list of logical cube lists
            * @param  {Array<string>} logicalCubes The logical cube list to check
            * @param {boolean} strict Will determine whether to perform strict incompatibility check; strict means everything must be compatible with each other
            * @returns {boolean}
            */ }, { key: 'isCompatibleLogicalCubeList', value: function isCompatibleLogicalCubeList(logicalCubeList, logicalCubes, strict) {
               if (!_.isArray(logicalCubes) || !_.isArray(logicalCubeList)) {
                    return false;
               }var isCompatible = false;var compatibilityList = [];_.forEach(logicalCubeList, function (iList) {
                    var matches = !(!_.isArray(iList) || _.chain(iList).intersection(logicalCubes).isEmpty().value());if (strict) {
                         isCompatible = matches; // In case of 'strict' if isCompatible is found false and returned at this point, the iteration
                         // is interrupted and the sets are considered incompatible.
                         return isCompatible;
                    }compatibilityList.push(matches);return true;
               });return strict ? isCompatible : _.includes(compatibilityList, true);
          } /**
            * Will iterate over a list of logical cube lists and try to detect empty sets, which
            * identify incompatible sets rendering the complete column combination invalid
            * @param  {Array<Object>} logicalCubeLists
            * @returns {boolean}
            * @private
            */ }, { key: 'validateLogicalCubeLists_', value: function validateLogicalCubeLists_(logicalCubeLists) {
               var isValid = false;_.forEach(logicalCubeLists, function (logicalCubeList) {
                    isValid = !_.isEmpty(logicalCubeList);return isValid;
               });return isValid;
          } /**
            * Will detect if a given list of lists of logical cubes is compatible with a given set of columns.
            * The method provides two levels of strictness:
            * (1) outerStrict: If set to 'true' all items from the logicalCubeLists must match the given columns; otherwise
            * at least one match is considered sufficient (i.e. analysis filters applied on analysis)
            * (2) innerStrict: If set to 'true' all of the intersections of LCs of all column combinations of dimensions
            * with every metric must match every given list of LCs.
            * @param   {Array<Object>}  columns - The list of columns from an analysis
            * @param   {Array<Array<string>>}  logicalCubeLists - List of lists with logical cubes
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @param   {boolean} outerStrict
            * @param   {boolean} innerStrict
            * @returns {boolean}
            */ }, { key: 'isCompatibleColumnList', value: function isCompatibleColumnList(columns, logicalCubeLists, layer) {
               var _this8 = this;var outerStrict = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;var innerStrict = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;var columnCubes = this.getListOfIntersectedLogicalCubeCombinationsFromColumns(columns, false, layer);if (!this.validateLogicalCubeLists_(columnCubes)) {
                    return false;
               }var compatibilities = _.map(logicalCubeLists, function (logicalCubeList) {
                    return _this8.isCompatibleLogicalCubeList(columnCubes, logicalCubeList, innerStrict);
               });if (_.isEmpty(compatibilities)) {
                    return false;
               }if (!outerStrict) {
                    return _.includes(compatibilities, true);
               }return !_.includes(compatibilities, false);
          } /**
            * Calculates the logical cubes list based on a query filters/containers
            * @param {Object} iQuery Request query
            * @returns {Array} Returns an array of arrays of logical cubes for each
            */ }, { key: 'getFilterLogicalCubeListByQuery', value: function getFilterLogicalCubeListByQuery(iQuery) {
               var _this9 = this;var logicalCubeList = [];var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromRequestQueryFilters(iQuery, true);var layer = this.Monads.getQueryLayer(iQuery);_.forEach(arrangeTypes, function (arrangeType) {
                    var monad = _this9.Monads.layer(layer).monad(arrangeType); // Ignore context NONE metrics - but not Google Adwords metrics
                    if (_.get(monad, 'metric') === true && _this9.metricService.ignoresLogicalCubes(monad)) {
                         return;
                    }logicalCubeList.push(monad.logicalCubes);
               });return logicalCubeList;
          } /**
            * Will determine if a metric configuration is valid against a list of logical cubes. Can be used to verify if a metric
            * can be added to an analysis as column - then logical cube should be the intersection of the logical cube lists of the
            * dimensions.
            * @param  {Object} iMetric       The complete metric configuration
            * @param  {Array<string>} iLogicalCubes List of logical cubes
            * @returns {boolean}
            */ }, { key: 'validateMetric', value: function validateMetric(iMetric, iLogicalCubes) {
               // NONE context metric - but not Google Adwords metric - always validates
               if (this.metricService.ignoresLogicalCubes(iMetric)) {
                    return true;
               } // Empty logical cubes do not validate
               if (_.chain(iMetric).get('logicalCubes').isEmpty().value()) {
                    return false;
               }return !_.isEmpty(this.getIntersectedLogicalCubes(iLogicalCubes, _.get(iMetric, 'logicalCubes')));
          } /**
            * Will determine if a dimension configuration is valid against a list of logical cubes.
            * @param  {Object} iDimension    The complete dimension configuration
            * @param  {Array<string>} iLogicalCubes List of logical cubes
            * @returns {boolean}
            */ }, { key: 'validateDimension', value: function validateDimension(iDimension, iLogicalCubes) {
               if (_.chain(iDimension).get('logicalCubes').isEmpty().value()) {
                    return false;
               }return !_.isEmpty(this.getIntersectedLogicalCubes(iLogicalCubes, _.get(iDimension, 'logicalCubes')));
          } /**
            * Will detect if the query contains non mathcing dimensions or metrics based on logical cube compatibility
            * @param  {Object} iQuery Report generation service query object
            * @returns {Object} will return a complex object stating the validity of the query and the rejected arrangeTypes - if any
            */ }, { key: 'validateMonadsFromQuery', value: function validateMonadsFromQuery(iQuery) {
               // Create a mock list of columns based on the arrangeTypes fetched from the query
               var columns = _.map(this.arrangeTypeUtils.getArrangeTypesFromQueryMonads(iQuery), function (arrangeType) {
                    return { arrangeType: arrangeType };
               });var layer = this.Monads.getQueryLayer(iQuery);return this.getListOfIntersectedLogicalCubeCombinationsFromColumns(columns, true, layer);
          } /**
            * Will return the list of unique and common - i.e. intersected - logical cubes/aggregates of a live query.
            * When the deep flag is utilized, filter and container arrange types are collected and taken into account
            * when compiling the logical cube/aggregate list
            * @param  {Object}  query
            * @param  {boolean} deep
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getLiveQueryLogicalCubes_', value: function getLiveQueryLogicalCubes_(query) {
               var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var queryTypes = this.arrangeTypeUtils.getArrangeTypesFromQueryMonads(query, true, true);if (deep) {
                    var filterTypes = this.arrangeTypeUtils.getArrangeTypesFromContainer(query, true);queryTypes = _.chain(queryTypes).concat(filterTypes).uniq().value();
               }var layer = this.Monads.getQueryLayer(query);return this.getIntersectedLogicalCubesByArrangeTypes_(queryTypes, layer);
          } /**
            * Will return the list of real time layer arrange types that do not match the given logical cubes
            * @param   {Array<string>} arrangeTypes
            * @param   {Array<string>} logicalCubes
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getLiveMismatches_', value: function getLiveMismatches_(arrangeTypes, logicalCubes_) {
               var _this10 = this;var logicalCubes = logicalCubes_;var Monads = this.Monads.layer(this.Monads.REAL_TIME);return _.chain(arrangeTypes).map(function (arrangeType) {
                    var monad = Monads.monad(arrangeType);if (!monad) {
                         return arrangeType;
                    }if (monad.dimension && !_this10.validateDimension(monad, logicalCubes)) {
                         return arrangeType;
                    }if (monad.metric && !_this10.validateMetric(monad, logicalCubes)) {
                         return arrangeType;
                    } // Every filter might restrict the logical cube spectrum of the entire query,
                    // hence the spectrum is reconfigured for every filter rule
                    var monadCubes = _.get(monad, 'logicalCubes');logicalCubes = _this10.getIntersectedLogicalCubes(logicalCubes, monadCubes);return null;
               }).compact().uniq().value();
          } /**
            * Will return the list of raw layer arrange types that do not match the given logical cubes
            * @param   {Array<string>} arrangeTypes
            * @param   {Array<string>} logicalCubes
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getRawMismatches_', value: function getRawMismatches_(arrangeTypes, logicalCubes) {
               var _this11 = this;var Monads = this.Monads.layer(this.Monads.RAW_DATA);return _.chain(arrangeTypes).map(function (arrangeType) {
                    var monad = Monads.monad(arrangeType);if (!monad) {
                         return arrangeType;
                    }if (monad.dimension && _this11.validateDimension(monad, logicalCubes)) {
                         return null;
                    }if (monad.metric && _this11.validateMetric(monad, logicalCubes)) {
                         return null;
                    }return arrangeType;
               }).compact().uniq().value();
          } /**
            * Will return the list of arrange types that do not match the given logical cubes
            * @param   {object} container
            * @param   {Array<string>} logicalCubes
            * @param   {string} layer
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getContainerMismatches_', value: function getContainerMismatches_(container, logicalCubes, layer) {
               // Compile a list of the containers' arrangeTypes
               var arrangeTypes = this.arrangeTypeUtils.getArrangeTypesFromContainer(container, true);if (layer === this.Monads.REAL_TIME) {
                    return this.getLiveMismatches_(arrangeTypes, logicalCubes);
               }return this.getRawMismatches_(arrangeTypes, logicalCubes);
          } /**
            * Will check filter rules inside filter and container lists and try to validate them against the dimensions and metrics
            * of a given query. If the iContainer parameter is skipped the query is checked against it's own filters and containers, otherwise
            * the filter and container lists will be taken into account for the validation.
            * @param   {Object} iQuery Report generation service query object
            * @param   {Object} iContainer An object consisting of a list of filters and a list of containers
            * @returns {boolean}
            */ }, { key: 'validateFiltersFromQuery', value: function validateFiltersFromQuery(iQuery, iContainer) {
               var layer = this.Monads.getQueryLayer(iQuery);var logicalCubes = void 0;if (this.Monads.isRealTimeQuery(iQuery)) {
                    logicalCubes = this.getLiveQueryLogicalCubes_(iQuery, Boolean(iContainer));
               } else {
                    // Create a mock list of columns based on the arrangeTypes fetched from the query
                    var columns = _.map(this.arrangeTypeUtils.getArrangeTypesFromQueryMonads(iQuery), function (arrangeType) {
                         return { arrangeType: arrangeType };
                    }); // Get the flattened list of combinatorial logical cube intersection lists
                    logicalCubes = _.chain(this.getListOfIntersectedLogicalCubeCombinationsFromColumns(columns, false, layer)).flatten().uniq().value();
               }var mismatches = this.getContainerMismatches_(iContainer || iQuery, logicalCubes, layer);return { arrangeTypes: mismatches, isValid: _.isEmpty(mismatches) };
          } /**
            * Will process a query for invalid filter rules in both filter lists and nested containers. If invalid filter rules are detected
            * a copy of the query without them is returned, otherwise the the same query is returned intact
            * @param  {Object} iQuery Report generation service query object
            * @returns {Object}
            */ }, { key: 'omitInvalidFiltersFromQuery', value: function omitInvalidFiltersFromQuery(iQuery) {
               var validation_ = this.validateFiltersFromQuery(iQuery); // Query filters are valid, so nothing to remove
               if (validation_.isValid) {
                    return iQuery;
               } // Get the filters and containers without the invalid filter rules
               var validContainer_ = this.filterUtils.omitFiltersByArrangeTypes(iQuery, validation_.arrangeTypes); // Return a copy of the query with invalid filter rules removed
               return _.chain(iQuery).cloneDeep().assign(validContainer_).value();
          } /**
            * @ngdoc method
            * @name LogicalCubeUtils#normalizeLogicalCubes
            * @description Formats a logical cube to be cross account compatible by dropping the account specific suffix
            * Some logicalCubes are account specific, for example FULL_CUST_PARA_PAGE_3 and FULL_CUST_PARA_PAGE_1
            * Usually it's the same logicalCube but with different id, because the accounts are different
            * @param {string} logicalCube A logical cube
            * @returns {string} normalized logicalCubes
            */ }, { key: 'dropAccountSpecificSuffix', value: function dropAccountSpecificSuffix(logicalCube) {
               var customLogicalCubes = this.CUSTOM_LOGICAL_CUBES.filter(function (customLogicalCube) {
                    return logicalCube.startsWith(customLogicalCube);
               });if (_.size(customLogicalCubes)) {
                    return logicalCube.replace(/[0-9]/g, '');
               }return logicalCube;
          } }, { key: 'SEGMENT_ARRANGE_TYPE_', get: function get() {
               return this.segmentService.getFakeSegmentArrangeType();
          } /**
            * Provides prefix of logical cubes, that are used for associations and custom parameters
            * This logicalCubes end always with number and this number could be different across accounts.
            * @example ASSOCIATION_1, ASSOCIATION_2, CONFIG_ASSOCIATIONS_1, CONFIG_ASSOCIATIONS_2, MULTI_FULL_CUST_PARA_CAMPAIGN_1,
            * MULTI_FULL_CUST_PARA_CAMPAIGN_2 etc.
            *
            * NOTE: all logicalCubes are defined in enum LogicalCubeEnum.class from main server library
            *
            * @returns {Array} list of logicalCubes, which are account specific.
            */ }, { key: 'CUSTOM_LOGICAL_CUBES', get: function get() {
               return ['ASSOCIATION', 'CONFIG_ASSOCIATIONS', 'FULL_CUST_PARA_CAMPAIGN', 'MULTI_FULL_CUST_PARA_CAMPAIGN', 'FULL_CUST_PARA_CLICK', 'MULTI_FULL_CUST_PARA_CLICK', 'FULL_CUST_PARA_PAGE', 'MULTI_FULL_CUST_PARA_PAGE', 'MULTI_FULL_CUST_PARA_PRODUCT', 'FULL_CUST_PARA_PRODUCT', 'MULTI_FULL_CUST_PARA_SESSION', 'FULL_CUST_PARA_SESSION', 'MULTI_FULL_CUST_PARA_TIME', 'FULL_CUST_PARA_TIME'];
          } }]);return LogicalCubeUtils;
}();

},{}],29:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     function Metrics() {
          _classCallCheck(this, Metrics);
     }_createClass(Metrics, [{ key: 'validateRequiredDimension', /**
                                                                 * Will determine if a metric contains the provided arrangeType in the list of requiredFirstDimensions.
                                                                 * In case of non existent requiredFirstDimensions list or an empty list the metric still validates
                                                                 * @param   {string} iArrangeType The arrangeType of the required dimension
                                                                 * @param   {Object} iMetric      The complete metric configuration
                                                                 * @returns {Boolean}
                                                                 */value: function validateRequiredDimension(iArrangeType, iMetric) {
               if (!iMetric || !_.isObject(iMetric)) {
                    return false;
               }if (!_.has(iMetric, 'requiredFirstDimensions') || _.isEmpty(iMetric.requiredFirstDimensions)) {
                    return true;
               }return _.includes(iMetric.requiredFirstDimensions, iArrangeType);
          } /**
            * Will determine if a given metric configuration belongs to the list of 'special' adwords metrics
            * @param   {Object}  config - Metric configuration object
            * @returns {boolean}
            * @private
            */ }, { key: 'isAdwordsMetric_', value: function isAdwordsMetric_(config) {
               var arrangeType = _.get(config, 'arrangeType');return _.includes(this.GOOGLE_ADWORDS_METRICS_, arrangeType);
          } /**
            * Will determine if a given metric configuration is to inherit the context of an analysis main dimension
            * when used as a filter rule
            * @param   {Object}  config - Metric configuration object
            * @returns {boolean}
            */ }, { key: 'inheritsContext', value: function inheritsContext(config) {
               // Adwords metrics ought to keep their context as defined in their configuration
               if (this.isAdwordsMetric_(config)) {
                    return false;
               }return _.get(config, 'defaultContextNotAvailableInFilter');
          } /**
            * Will determine if a metric can skip logical cube validation or not
            * @param   {Object}  config - Metric configuration object
            * @returns {boolean}
            */ }, { key: 'ignoresLogicalCubes', value: function ignoresLogicalCubes(config) {
               // Adwords metrics MUST abide to logical cube validation even though they seem to fall into the same configuration
               // category as the context none metrics
               if (this.isAdwordsMetric_(config)) {
                    return false;
               }return this.isContextNone(config);
          } /**
            * Will determine if a given metric configuration has a 'valid' NONE context
            * @param  {Object}  iMetric The complete metric configuration
            * @returns {Boolean}
            */ }, { key: 'isContextNone', value: function isContextNone(iMetric) {
               return _.chain(iMetric).get('arrangeType').isString().value() && _.get(iMetric, 'context', 'NONE') === 'NONE' && _.chain(iMetric).get('possibleContexts').size().value() === 0;
          } }, { key: 'GOOGLE_ADWORDS_METRICS_', /**
                                                 * List of arrangeTypes of google adwords metrics that need special handling when used as filters
                                                 * @returns {Array<string>}
                                                 * @private
                                                 */get: function get() {
               return ['google_clicks_kw', 'google_position_kw', 'google_costs_kw', 'google_impressions_kw', 'google_clicks', 'google_position', 'google_costs', 'google_impressions', 'google_conversions', 'google_estimatedconversions', 'google_first_page_cpc', 'google_top_of_page_cpc', 'google_average_position'];
          } }]);return Metrics;
}();

},{}],30:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     _createClass(MonadicRawData, [{ key: 'TYPES', /**
                                                   * @ngdocs property
                                                   * @name Monads#TYPES
                                                   * @description Monad types, should be extended to represent all of the possible types
                                                   * @return {Object}
                                                   */get: function get() {
               return { CUSTOM_METRIC: 'CUSTOM_METRIC', CUSTOM_FORMULA: 'CUSTOM_FORMULA', CUSTOM_PARAMETER: 'CUSTOM_PARAMETER', CUSTOM_CATEGORY: 'CUSTOM_CATEGORY', CUSTOM_PROCESS: 'CUSTOM_PROCESS', CUSTOM_WEBSITE_GOALS: 'CUSTOM_WEBSITE_GOALS', CUSTOM_SOURCE: 'CUSTOM_SOURCE', CUSTOM_VISITOR_GROUPS_TRAFFIC: 'CUSTOM_VISITOR_GROUPS_TRAFFIC', DEFAULT_METRIC: 'DEFAULT_METRIC', DEFAULT_DIMENSION: 'DEFAULT_DIMENSION', PREDEFINED_METRIC: 'PREDEFINED_METRIC', PREDEFINED_FORMULA: 'PREDEFINED_FORMULA', CAMPAIGNS_ATTRIBUTION: 'CAMPAIGNS_ATTRIBUTION' };
          } /*@ngInject*/ }]);function MonadicRawData() {
          _classCallCheck(this, MonadicRawData);this.Monads_ = { dimensions: false, metrics: false };
     }_createClass(MonadicRawData, [{ key: 'monads', value: function monads(iConfig) {
               if (iConfig) {
                    //initialises the config
                    this.Monads_.dimensions = iConfig.dimensions;this.Monads_.metrics = iConfig.metrics;
               }return _.assign({}, this.Monads_.metrics, this.Monads_.dimensions);
          } }, { key: 'dimensions', value: function dimensions() {
               return this.Monads_.dimensions || false;
          } }, { key: 'metrics', value: function metrics() {
               return this.Monads_.metrics || false;
          } /**
            * @ngdocs method
            * @name MonadicRawData#setMetric
            * @description Sets a metrics value in Monads object which is held in memory
            * @param {Object} metric - metric object
            * @returns {Object} metric - metric value set in the Monads object
            */ }, { key: 'setMetric', value: function setMetric(metric) {
               this.Monads_.metrics[metric.arrangeType] = metric;return this.Monads_.metrics[metric.arrangeType];
          } /**
            * @ngdocs method
            * @name MonadicRawData#deleteMetric
            * @description Deletes a metric from Monads object which is held in memory
            * @param {Object} metric - metric object
            * @returns {number} - number of deleted entities
            */ }, { key: 'deleteMetric', value: function deleteMetric(metric) {
               if (this.Monads_.metrics[metric.arrangeType]) {
                    delete this.Monads_.metrics[metric.arrangeType];return 1;
               }return 0;
          } // Hack to identify the start of the week
     }, { key: 'hasStandardWeek', value: function hasStandardWeek() {
               return !_.isEmpty(this.Monads_.dimensions['time_id_categories_t_year_week']);
          } /**
            * List of arrange types that based on the account configuration can have an '_en' postfix or not
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getFluctuatedArrangeType_', /**
                                                      * Will return the 'fluctuated' arrange type if any; null otherwise
                                                      * @param   {string} arrangeType
                                                      * @returna {string|null}
                                                      */value: function getFluctuatedArrangeType_(arrangeType) {
               return _.get(this.FLUCTUATION_MAP_, arrangeType, null);
          } }, { key: 'addDimension', value: function addDimension(iDimension) {
               if (!_.isObject(iDimension)) {
                    return false;
               } //add a dimension
               this.Monads_.dimensions[iDimension.arrangeType] = iDimension;return true;
          } }, { key: 'deleteDimension', value: function deleteDimension(arrangeType) {
               //add a dimension
               if (!_.isString(arrangeType)) {
                    return false;
               }delete this.Monads_.dimensions[arrangeType];return true;
          } /**
            * Will collect and return a mini configuration of metrics and dimensions based on a given list of arrangeTypes
            * @param  {Array<string>} arrangeTypes List of arrangeTypes
            * @returns {Object} An object of collected metric and dimension configurations
            */ }, { key: 'collectConfig', value: function collectConfig(arrangeTypes) {
               var _this = this;var res = { metrics: {}, dimensions: {} };_.forEach(arrangeTypes, function (arrangeType) {
                    var metric = _.get(_this, 'Monads_.metrics.' + arrangeType);var dimension = _.get(_this, 'Monads_.dimensions.' + arrangeType);if (dimension) {
                         res.dimensions[arrangeType] = _.cloneDeep(dimension);
                    }if (metric) {
                         res.metrics[arrangeType] = _.cloneDeep(metric);
                    }
               });return res;
          } /**
            * Mutates a given monad configuration, injecting possibleContexts from its source metric.
            * Deals with BE inconsistency; custom metrics do not inherit their baseArrangeType's
            * possibleContexts list.
            * @param   {Object} monad
            * @returns {Object}
            * @private
            */ }, { key: 'inheritPossibleContexts_', value: function inheritPossibleContexts_(monad) {
               if (_.hasIn(monad, 'possibleContexts')) {
                    return monad;
               }var baseArrangeType = _.get(monad, 'baseArrangeType');var baseMonad = this.monad(baseArrangeType);if (!baseMonad) {
                    return monad;
               }var possibleContexts = _.get(baseMonad, 'possibleContexts');return _.isArray(possibleContexts) ? _.merge(monad, { possibleContexts: possibleContexts }) : monad;
          } }, { key: 'monad', value: function monad(arrangeType) {
               if (!_.isString(arrangeType)) {
                    return null;
               }if (_.get(this, 'Monads_.dimensions.' + arrangeType)) {
                    var config_ = _.cloneDeep(this.Monads_.dimensions[arrangeType]);config_.dimension = true;config_.hasMapping = !_.isEmpty(config_.mapping);config_.columnType = 'dimension';return config_;
               }if (_.get(this, 'Monads_.metrics.' + arrangeType)) {
                    var _config_ = _.cloneDeep(this.Monads_.metrics[arrangeType]); // Patch for config inconsistency - customFormula comfiguration should be found elsewhere, in a different property
                    if (_.has(_config_, 'metric')) {
                         _config_.customFormula = _.chain(this.Monads_.metrics[arrangeType]).get('metric').cloneDeep().value();
                    }_config_.metric = true;_config_.hasMapping = !_.isEmpty(_config_.mapping);_config_.columnType = 'metric';return this.inheritPossibleContexts_(_config_);
               }return this.monad(this.getFluctuatedArrangeType_(arrangeType));
          } /**
            * Will determine if a given arrange type can support wildcards or not. Note the extra handling - beyond
            * the actual configuration property 'wildCardFilter' - for monads with mapping that have a '*' key.
            * @param   {string} arrangeType - The arrange type fo check on
            * @returns {boolean}
            */ }, { key: 'canSupportWildcards', value: function canSupportWildcards(arrangeType) {
               var monad = this.monad(arrangeType);if (_.get(monad, 'wildCardFilter')) {
                    return true;
               }if (!_.get(monad, 'hasMapping')) {
                    return false;
               }return _.chain(monad).get('mapping', {}).keys().includes('*').value();
          } /**
            * Will return the baseArrangeType hash - if any - given an arrangeType
            * @param   {string} arrangeType
            * @returns {Object | null}
            */ }, { key: 'getBaseArrangeType', value: function getBaseArrangeType(arrangeType) {
               var monad = this.monad(arrangeType);return _.get(monad, 'baseArrangeType', null);
          } /**
            * Will return the customFormula configuration hash - if any - given an arrangeType
            * @param   {string} arrangeType
            * @returns {Object | null}
            */ }, { key: 'getCustomFormula', value: function getCustomFormula(arrangeType) {
               var monad = this.monad(arrangeType);return _.get(monad, 'customFormula', null);
          } /**
            * Will identify if a monad can be used in a pivot or not
            * @param   {string}  arrangeType
            * @returns {boolean}
            */ }, { key: 'isPivotUsable', value: function isPivotUsable(arrangeType) {
               var monad = this.monad(arrangeType);return _.get(monad, 'pivotUsable', true) === true;
          } /**
            * Asserts if a monad is a custom figure (metric or formula)
            * @param {Object} monad The monad configuration
            * @returns {boolean}
            */ }, { key: 'isMonadCustomFigure', value: function isMonadCustomFigure(monad) {
               return this.isMonadCustomMetric(monad) || this.isMonadCustomFormula(monad);
          } /**
            * Asserts a monad to be a custom metric
            * @param {Object} monad The metric|dimension definition
            * @returns {boolean}
            */ }, { key: 'isMonadCustomMetric', value: function isMonadCustomMetric(monad) {
               return this.hasElementType(monad, this.TYPES.CUSTOM_METRIC);
          } /**
            * Asserts a monad to be a custom formula
            * @param {Object} monad The metric|dimension definition
            * @returns {boolean}
            */ }, { key: 'isMonadCustomFormula', value: function isMonadCustomFormula(monad) {
               return this.hasElementType(monad, this.TYPES.CUSTOM_FORMULA);
          } /**
            * Will identify if a monad has the element type of CAMPAIGNS_ATTRIBUTION
            * @param   {string}  arrangeType
            * @returns {boolean}
            */ }, { key: 'isCampaignsAttribution', value: function isCampaignsAttribution(arrangeType) {
               var monad = this.monad(arrangeType);return _.get(monad, 'elementType') === this.TYPES.CAMPAIGNS_ATTRIBUTION;
          } }, { key: 'FLUCTUATING_ARRANGE_TYPES_', get: function get() {
               return ['time_id_categories_t_year_week', 'time_id_categories_t_weekday'];
          } /**
            * Generates a hash to map to help replace 'fluctuated' arrange types with their correct 'replacements' based on the
            * account configuration
            * @returns {Object}
            */ }, { key: 'FLUCTUATION_MAP_', get: function get() {
               if (this.hasStandardWeek()) {
                    return _.chain(this.FLUCTUATING_ARRANGE_TYPES_).map(function (arrangeType) {
                         return [arrangeType + '_en', arrangeType];
                    }).fromPairs().value();
               }return _.chain(this.FLUCTUATING_ARRANGE_TYPES_).map(function (arrangeType) {
                    return [arrangeType, arrangeType + '_en'];
               }).fromPairs().value();
          } }]);return MonadicRawData;
}();

},{}],31:[function(require,module,exports){
'use strict';
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var MonadicRawData = require('./MonadicRawData');module.exports = function (_MonadicRawData) {
  _inherits(MonadicReal, _MonadicRawData);function MonadicReal() {
    _classCallCheck(this, MonadicReal);return _possibleConstructorReturn(this, (MonadicReal.__proto__ || Object.getPrototypeOf(MonadicReal)).apply(this, arguments));
  }return MonadicReal;
}(MonadicRawData);

},{"./MonadicRawData":30}],32:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}function _possibleConstructorReturn(self, call) {
     if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
     }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
     if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
     }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var MonadicRawData = require('./MonadicRawData');var MonadicRealTime = require('./MonadicRealTime');module.exports = function (_MonadicRawData) {
     _inherits(Monads, _MonadicRawData); /*@ngInject*/function Monads() {
          _classCallCheck(this, Monads);var _this = _possibleConstructorReturn(this, (Monads.__proto__ || Object.getPrototypeOf(Monads)).call(this));_this.layers_ = { RAW_DATA: _this, REAL_TIME: new MonadicRealTime() };return _this;
     } /**
       * Returns the available layers
       * @returns {Array<string>}
       */_createClass(Monads, [{ key: 'isLayerValid', /**
                                                      * Will detect if the given layer is amongst the supported ones
                                                      * @param   {string}  layer
                                                      * @returns {boolean}
                                                      */value: function isLayerValid(layer) {
               return _.includes(this.LAYERS, layer);
          } /**
            * Will return the appropriate layer from which to fetch metrics and dimensions from.
            * Defaults to RAW_DATA layer
            * @param   {string} layer
            * @returns {Object}
            */ }, { key: 'layer', value: function layer(_layer) {
               if (!this.isLayerValid(_layer)) {
                    return this;
               }return this.layers_[_layer];
          } /**
            * Given a list of calculation layers will identify if the first one is the REAL_TIME layer
            * @param   {Array<string>}  calculationLayers
            * @returns {boolean}
            * @private
            */ }, { key: 'hasRealTimeFirst_', value: function hasRealTimeFirst_(calculationLayers) {
               return _.chain(calculationLayers).first().isEqual(this.REAL_TIME).value();
          } /**
            * Will identify if a query is REAL_TIME layer query or not and return the appropriate layer.
            * Will default to RAW_DATA layer - ONLY in terms of dimension and metric fishing. NOT in
            * terms of the actual calculation layer.
            * @param  {Object} query - A 'whole query' calculation object
            * @returns {string}
            */ }, { key: 'getQueryLayer', value: function getQueryLayer(query) {
               var calculationLayers = _.get(query, 'possibleCalculationLayers'); // Will try to fish the possibleCalculationLayers property of a query
               // in order to determine if it's a live query or not
               var isRealTime = this.hasRealTimeFirst_(calculationLayers);return isRealTime ? this.REAL_TIME : this.RAW_DATA;
          } /**
            * List of report elements that are real time enabled
            * @returns {Array<string>}
            * @private
            */ }, { key: 'isRealTimeByType', /**
                                             * If entire report element config - not only the configJson - is passed, will
                                             * check the type and determine if it's to be used in the real time context
                                             * @param   {Object} config - A complete report element configuration - not only the configJson
                                             * @returns {boolean}
                                             */value: function isRealTimeByType(config) {
               var type = _.get(config, 'type');return _.includes(this.REAL_TIME_ELEMENTS_, type);
          } /**
            * Will try to fetch the realTime property from a configuration. Will work with
            * plain configs AND nested configs - i.e. report elements configJson.
            * @param   {Object}  config_ - analysis config || report element config || configJson of report element config
            * @returns {boolean}
            */ }, { key: 'isRealTimeByConfig_', value: function isRealTimeByConfig_(config_) {
               // Fish the configJson - for report element configurations - or work with the config directly
               var config = _.get(config_, 'configJson', config_);return _.get(config, 'realTime', false);
          } /**
            * Will identify if an analysis configuration - of any sort - is to be validated against
            * the REAL_TIME of the RAW_DATA layer.
            * @param  {Object} config - The analysis configuration object - can be a regular analysis, report analysis, sparkline, KPI, live KPI etc
            * @returns {string}
            */ }, { key: 'getConfigLayer', value: function getConfigLayer(config) {
               // Exceptional case for KPI_LIVE elements where in the outer report element configuration - outside
               // the configJson - an extra property calculationLayers is appended, just to enforce REAL_TIME.
               var calculationLayers = _.get(config, 'calculationLayers');if (this.hasRealTimeFirst_(calculationLayers)) {
                    return this.REAL_TIME;
               }if (this.isRealTimeByType(config)) {
                    return this.REAL_TIME;
               }if (this.isRealTimeByConfig_(config)) {
                    return this.REAL_TIME;
               }return this.RAW_DATA;
          } /**
            * Will identify real time related configurations
            * @param   {Object} config - The analysis configuration object - can be a regular analysis, report analysis, sparkline, KPI, live KPI etc
            * @returns {boolean}
            */ }, { key: 'isRealTimeConfig', value: function isRealTimeConfig(config) {
               var layer = this.getConfigLayer(config);return _.isEqual(layer, this.REAL_TIME);
          } /**
            * Will identify real time related queries
            * @param   {Object} query - A 'whole query' calculation object
            * @returns {boolean}
            */ }, { key: 'isRealTimeQuery', value: function isRealTimeQuery(query) {
               return _.isEqual(this.getQueryLayer(query), this.REAL_TIME);
          } /**
            * Provides all custom categories mapped by arrangeType
            * @param   {Object} config - could metrics, dimensions, live.metrics or live.dimensions
            * @returns {Object} includes only custom categories mapped by arrangeType
            */ }, { key: 'getCustomCategories', value: function getCustomCategories(config) {
               return this.getElementsByType(config, this.TYPES.CUSTOM_CATEGORY);
          } /**
            * Provides all custom parameters mapped by arrangeType
            * @param   {Object} config - could be metrics, dimensions, live.metrics or live.dimensions
            * @returns {Object} includes only custom parameters mapped by arrangeType
            */ }, { key: 'getCustomParameters', value: function getCustomParameters(config) {
               return this.getElementsByType(config, this.TYPES.CUSTOM_PARAMETER);
          } /**
            * Provides all custom parameters mapped by arrangeType
            * @param   {Object} config - could be metrics, dimensions, live.metrics or live.dimensions
            * @returns {Object} includes only custom attributions mapped by arrangeType
            */ }, { key: 'getCustomAttributions', value: function getCustomAttributions(config) {
               return this.getElementsByType(config, this.TYPES.CAMPAIGNS_ATTRIBUTION);
          } /**
            * Provides elements matched to the given elementType
            * @param   {Object} config - could be metrics, dimensions, live.metrics or live.dimensions
            * @param   {String} elementType - supported element types TYPES()
            * @returns {Object} includes elements matched to the given elementType and mapped by arrangeType
            */ }, { key: 'getElementsByType', value: function getElementsByType(config, elementType) {
               var _this2 = this;var result = {};_.forOwn(config, function (element, arrangeType) {
                    if (_this2.hasElementType(element, elementType)) {
                         result[arrangeType] = element;
                    }
               });return result;
          } /**
            * Will identify if the element.elementType is equal to given elementType
            * @param   {Object} monad - metric or dimension
            * @param   {String} elementType - supported element types TYPES()
            * @returns {boolean} true if equal otherwise false
            */ }, { key: 'hasElementType', value: function hasElementType(monad, elementType) {
               var elementTypeValue = _.get(monad, 'elementType');return _.isEqual(elementTypeValue, elementType);
          } /**
            * Will collect arrange type configurations from all possible layers and return them
            * as a key value map. The order in this.LAYER list is important on which configuration
            * will prevail - i.e. currently RAW_DATA config prevails over REAL_TIME
            * @param   {Array<string>} arrangeTypes
            * @returns {Object}
            */ }, { key: 'collectAllLayerConfig', value: function collectAllLayerConfig(arrangeTypes) {
               var _this3 = this;return _.chain(this.LAYERS).map(function (layer) {
                    return _this3.layer(layer).collectConfig(arrangeTypes);
               }).reduce(function (config, layerConfig) {
                    return _.chain(['dimensions', 'metrics']).map(function (type) {
                         var collectedTypes = _.get(config, type, {});var layerTypes = _.get(layerConfig, type, {});return [type, _.extend(layerTypes, collectedTypes)];
                    }).fromPairs().value();
               }).value();
          } }, { key: 'LAYERS', get: function get() {
               return ['RAW_DATA', 'REAL_TIME'];
          } }, { key: 'RAW_DATA', get: function get() {
               return this.LAYERS[0];
          } }, { key: 'REAL_TIME', get: function get() {
               return this.LAYERS[1];
          } }, { key: 'REAL_TIME_ELEMENTS_', get: function get() {
               return ['KPI_LIVE', 'ANALYSIS_LIVE', 'SPARKLINE_LIVE'];
          } }]);return Monads;
}(MonadicRawData);

},{"./MonadicRawData":30,"./MonadicRealTime":31}],33:[function(require,module,exports){
'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
} /**
  * @ngdoc service
  * @name ProcessService
  * @description Containers service used to hold and manipulate the processes
  */var ProcessService = function () {
    /*@ngInject*/function ProcessService() {
        _classCallCheck(this, ProcessService);this.processes_ = {};
    } /**
      * @ngdoc property
      * @name ProcessService#processes
      * @description Map of processes keyed by pid (process id)
      * @returns {Object}
      */_createClass(ProcessService, [{ key: 'setAccountProcesses', /**
                                                                    * @ngdoc method
                                                                    * @name ProcessService#setAccountProcesses
                                                                    * @description Sets the list of processes
                                                                    * @param {Array|Object} processes A list or map of processes
                                                                    * @returns {ProcessService}
                                                                    */value: function setAccountProcesses(processes) {
            if (_.isArray(processes)) {
                this.processes_ = _.keyBy(processes, 'pid');
            } else if (_.isPlainObject(processes)) {
                this.processes_ = processes;
            }return this;
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessAnalysisId
          * @description Gets the analysis id corresponding to a process
          * @param {number} processId The process id
          * @returns {string}
          */ }, { key: 'getProcessAnalysisId', value: function getProcessAnalysisId(processId) {
            return 'process_' + processId;
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessDimensionArrangeTypes
          * @description Gets the dimension arrange types corresponding to a process
          * @param {number} processId The process id
          * @returns {Array}
          */ }, { key: 'getProcessDimensionArrangeTypes', value: function getProcessDimensionArrangeTypes(processId) {
            return ['process_' + processId, 'process_exits_' + processId];
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessMetricArrangeTypes
          * @description Gets the dimension arrange types corresponding to a process
          * @param {number} processId The process id
          * @returns {Array}
          */ }, { key: 'getProcessMetricArrangeTypes', value: function getProcessMetricArrangeTypes(processId) {
            return ['process_' + processId + '_amount', 'process_' + processId + '_exit_amount'];
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessFormulaArrangeTypes
          * @description Gets the dimension arrange types corresponding to a process
          * @param {number} processId The process id
          * @returns {Array}
          */ }, { key: 'getProcessFormulaArrangeTypes', value: function getProcessFormulaArrangeTypes(processId) {
            return ['predefined_formula_process_step_conversions_' + processId, 'predefined_formula_process_step_conversion_rate_percent_' + processId, 'predefined_formula_process_step_exit_rate_percent_' + processId];
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessArrangeTypes
          * @description Provides the list of affected arrangeTypes for given process id.
          * NOTE: The arrangeType of metrics and dimensions based on parameter includes process id.
          * @param {Number} processId The process id
          * @returns {Array}
          */ }, { key: 'getProcessArrangeTypes', value: function getProcessArrangeTypes(processId) {
            return _.flatMap([this.getProcessDimensionArrangeTypes(processId), this.getProcessMetricArrangeTypes(processId), this.getProcessFormulaArrangeTypes(processId)]);
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessesAnalysisIds
          * @description Returns the list of analysis Ids of all existing processes
          * @returns {Array}
          */ }, { key: 'getProcessesAnalysisIds', value: function getProcessesAnalysisIds() {
            var _this = this;return _.chain(this.processes).keys().map(function (processId) {
                return _this.getProcessAnalysisId(processId);
            }).value();
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessesArrangeTypes
          * @description Returns the arrange types of all existing processes
          * @returns {Array}
          */ }, { key: 'getProcessesArrangeTypes', value: function getProcessesArrangeTypes() {
            var _this2 = this;return _.chain(this.processes).keys().flatMap(function (processId) {
                return _this2.getProcessArrangeTypes(processId);
            }).value();
        } /**
          * @ngdoc method
          * @name ProcessService#getProcessByArrangeType
          * @description Find a process by given arrangeType
          * @param {string} arrangeType monad arrangeType
          * @returns {Object|null}
          */ }, { key: 'getProcessByArrangeType', value: function getProcessByArrangeType(arrangeType) {
            var _this3 = this;return _.chain(this.processes).filter(function (process) {
                return _.includes(_this3.getProcessArrangeTypes(process.pid), arrangeType);
            }).first().cloneDeep().value();
        } }, { key: 'processes', get: function get() {
            return this.processes_;
        } }]);return ProcessService;
}();module.exports = ProcessService;

},{}],34:[function(require,module,exports){
'use strict'; /**
              * Contains proposal id logic...
              * @type {ProposalId}
              */
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}module.exports = function () {
    function ProposalId() {
        _classCallCheck(this, ProposalId);
    }_createClass(ProposalId, [{ key: 'getId_', /**
                                                * Will generate a proposal id based on the passed options hash. Will return
                                                * an empty string if no accountId is fished from the options hash.
                                                * @param   {Object} options
                                                * @returns {string}
                                                * @private
                                                */value: function getId_(options) {
            var accountId = _.get(options, 'accountId');return _.isUndefined(accountId) ? '' : accountId + '_';
        } /**
          * Will inject a proposalId - if options allow - to a given query.
          * @param  {Object} query - RGS calculation object
          * @param  {Object} options
          */ }, { key: 'injectProposalId', value: function injectProposalId(query, options) {
            var proposalId = this.getId_(options);if (_.isEmpty(proposalId)) {
                return;
            }_.set(query, 'proposalId', proposalId);
        } }]);return ProposalId;
}();

},{}],35:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     QueryLimits.$inject = ['Monads', 'Filters', 'TimesDynamicCache', 'accountService'];function QueryLimits(Monads, Filters, TimesDynamicCache, accountService) {
          _classCallCheck(this, QueryLimits);this.QueryLimits_ = { Monads: Monads, Filters: Filters, TimesDynamicCache: TimesDynamicCache, accountService: accountService };
     } /**
       * Will return an upper limit number for known time related timeFormats of dimensions
       * @param  {string} iTimeFormat
       * @returns {nummber|null}
       */_createClass(QueryLimits, [{ key: 'limitFromMap_', value: function limitFromMap_(iTimeFormat) {
               var TIME_FORMAT_UPPER_LIMIT_MAP = { hour: 24, high_time: 60, weekday: 7 };return TIME_FORMAT_UPPER_LIMIT_MAP[iTimeFormat] || null;
          } /**
            * Will return complete configuration of the first dimension in the query
            * @param  {Object} iQuery The query of report generation request
            * @returns {Object|null}        The complete original dimension configuration or null if none found
            */ }, { key: 'firstDimension_', value: function firstDimension_(iQuery) {
               var dimension_ = void 0;if (!_.has(iQuery, 'dimensions') || !_.isArray(iQuery.dimensions) || _.isEmpty(iQuery.dimensions)) {
                    return null;
               }dimension_ = _.first(iQuery.dimensions);if (!dimension_) {
                    return null;
               }var layer = this.QueryLimits_.Monads.getQueryLayer(iQuery);dimension_ = this.QueryLimits_.Monads.layer(layer).monad(dimension_.arrangeType);return dimension_ || null;
          } /**
            * Will return the timFormat value of the first dimension of a given query
            * @param  {Object} iQuery A query object
            * @returns {string|null}        Either the timeFormat from the dimension configuration or null
            */ }, { key: 'timeFormat', value: function timeFormat(iQuery) {
               var dimension_ = this.firstDimension_(iQuery);if (!dimension_ || _.isEmpty(dimension_.timeFormat)) {
                    return null;
               }return dimension_.timeFormat;
          } /**
            * Will resolve a given time filter. Will retrieve from the TimesDynamicCache for dynamic times filters
            * or simply return the given time filter for normal filters.
            * @param  {Object} iTimeFilter A filter object
            * @returns {Object|null}
            */ }, { key: 'timeFilterResolve', value: function timeFilterResolve(iTimeFilter) {
               // If not a time filter returns null
               if (!this.QueryLimits_.Filters.isTime(iTimeFilter)) {
                    return null;
               } // Retrieves the resolved time filter of the dynamic time range from the cache
               if (this.QueryLimits_.Filters.isTimeDynamic(iTimeFilter)) {
                    return this.QueryLimits_.TimesDynamicCache.getCachedKey(iTimeFilter.value1);
               }return iTimeFilter;
          } /**
            * Will return the number of days based on a given time filter
            * @param  {Object} iTimeFilter A filter object
            * @returns {number|null}
            */ }, { key: 'numberOfDays', value: function numberOfDays(iTimeFilter) {
               var days = void 0;var endDate = void 0;var startDate = void 0;var timeFilter = this.timeFilterResolve(iTimeFilter);if (!timeFilter) {
                    return null;
               }startDate = moment(timeFilter.value1);endDate = moment(timeFilter.value2);days = endDate.diff(startDate, 'days');return days;
          } /**
            * Will return the number of weeks based on a given time filter
            * @param  {Object} iTimeFilter A filter object
            * @returns {number|null}
            */ }, { key: 'numberOfWeeks', value: function numberOfWeeks(iTimeFilter) {
               var weeks = void 0;var endDate = void 0;var startDate = void 0;var timeFilter = this.timeFilterResolve(iTimeFilter);if (!timeFilter) {
                    return null;
               }startDate = moment(timeFilter.value1);endDate = moment(timeFilter.value2);weeks = Math.ceil(endDate.endOf('week').diff(startDate.startOf('week'), 'days') / 7);return weeks;
          } /**
            * Will return the number of months based on a given time filter
            * @param  {Object} iTimeFilter A filter object
            * @returns {number|null}
            */ }, { key: 'numberOfMonths', value: function numberOfMonths(iTimeFilter) {
               var months = void 0;var endDate = void 0;var startDate = void 0;var timeFilter = this.timeFilterResolve(iTimeFilter);if (!timeFilter) {
                    return null;
               }startDate = moment(timeFilter.value1).startOf('month');endDate = moment(timeFilter.value2).endOf('month');months = Math.round(moment.duration(endDate.diff(startDate)).as('month'));if (months === 2 && startDate.month() === endDate.month()) {
                    months = 1;
               }return months;
          } /**
            * Will return the number of quarters based on a given time filter
            * @param  {Object} iTimeFilter A filter object
            * @returns {number|null}
            */ }, { key: 'numberOfQuarters', value: function numberOfQuarters(iTimeFilter) {
               var quarters = void 0;var startDate = void 0;var endDate = void 0;var timeFilter = this.timeFilterResolve(iTimeFilter);if (!timeFilter) {
                    return null;
               }startDate = moment(timeFilter.value1);endDate = moment(timeFilter.value2);var startMonth = Math.floor(startDate.month() / 3) * 3;var startYear = startDate.year();var endMonth = Math.floor(endDate.month() / 3) * 3 + 2;var endYear = endDate.year();startDate = moment().year(startYear).month(startMonth).startOf('month');endDate = moment().year(endYear).month(endMonth).endOf('month');quarters = Math.floor(moment.duration(endDate.diff(startDate)).as('month')) / 3;return Math.ceil(quarters);
          } /**
            * Will return the number of years based on a given time filter
            * @param  {Object} iTimeFilter A filter object
            * @returns {number|null}
            */ }, { key: 'numberOfYears', value: function numberOfYears(iTimeFilter) {
               var years = void 0;var startDate = void 0;var endDate = void 0;var timeFilter = this.timeFilterResolve(iTimeFilter);if (!timeFilter) {
                    return null;
               }startDate = moment(timeFilter.value1).startOf('year');endDate = moment(timeFilter.value2).endOf('year');years = Math.round(moment.duration(endDate.diff(startDate)).as('years'));return years;
          } /**
            * Will determine the upper limit value - the actual number of rows to request - given
            * the timeFormat of a dimension or metric. Format of day and high_time will return a fixed number, whereas
            * for days, week, week_en, month, quarter, year the number of units that fit in the given time range - as
            * calculated from the given filter - will be returned. For non-timeFormat null is returned.
            * @param  {string} iTimeFormat timeFormat property value of the dimension/metric configuration
            * @param  {Object} iTimeFilter A time filter object
            * @returns {number|null}
            */ }, { key: 'getUpperLimitByTimeFormat', value: function getUpperLimitByTimeFormat(iTimeFormat, iTimeFilter) {
               if (this.limitFromMap_(iTimeFormat)) {
                    // Return the fixed number for day and high_time
                    return this.limitFromMap_(iTimeFormat);
               } // Try to detect the number units that fit in the given time range
               switch (iTimeFormat) {case 'day':
                         return this.numberOfDays(iTimeFilter);case 'week':case 'week_en':
                         return this.numberOfWeeks(iTimeFilter);case 'month':
                         return this.numberOfMonths(iTimeFilter);case 'quarter':
                         return this.numberOfQuarters(iTimeFilter);case 'year':
                         return this.numberOfYears(iTimeFilter);default:
                         return null;}
          } /**
            * Will return the upper limit of the first dimension of a given config. Will ignore already set upperLimit of the first dimension
            * column and instead will try to figure out if the first dimension is time related. If this is the case and a time filter exists
            * in the predefinedContainer's filter list, it will return the output of method getUpperLimitByTimeFormat. Otherwise it will simply
            * return the default upper limit given the config's variant.
            * @param  {Object} iConfig - The analysis config
            * @returns {number}
            */ }, { key: 'getUpperLimitByConfig', value: function getUpperLimitByConfig(iConfig) {
               var _this = this; // Fetch the config, regardless if it's a report element or a regular config
               var config_ = _.get(iConfig, 'configJson', iConfig);var layer = this.QueryLimits_.Monads.getConfigLayer(iConfig);var firstDimension_ = _.chain(config_).get('columns').find(function (iColumn) {
                    return _.get(_this.QueryLimits_.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')), 'dimension');
               }).value();var timeFormat_ = _.get(this.QueryLimits_.Monads.layer(layer).monad(_.get(firstDimension_, 'arrangeType')), 'timeFormat');var timeFilter_ = this.QueryLimits_.Filters.hasTimeFilter(_.get(config_, 'predefinedContainer.filters')); // Do not try to auto adjust the limits based on time for PIVOT_AS_LIST variants. Simply return
               // the fixed default.
               if (_.get(config_, 'variant') === 'PIVOT_AS_LIST') {
                    return this.getDefaultUpperLimitByVariant(_.get(config_, 'variant'));
               }return this.getUpperLimitByTimeFormat(timeFormat_, timeFilter_) || this.getDefaultUpperLimitByVariant(_.get(config_, 'variant'));
          } /**
            * Will return an upperLimit value based on the time filter of request and only if the
            * first dimension is of a known timeFormat
            * @param  {Object} iQuery              A query object constructed
            * @param  {Object} iSettings           Additional query configurations
            * @param  {Object} iTimeFilterFallBack A filter object to use as a fallback if no filter is defined in the query
            * @returns {number|null}
            */ }, { key: 'getUpperLimitValue', value: function getUpperLimitValue(iQuery, iSettings, iTimeFilterFallBack) {
               // Fetch the time filter from the iSettings or set to the fallback if any
               var timeFilter = this.QueryLimits_.Filters.hasTimeFilter(_.get(iSettings, 'filters')) || iTimeFilterFallBack;return this.getUpperLimitByTimeFormat(this.timeFormat(iQuery), timeFilter);
          } /**
            * Will return the default upperLimit
            * @returns {number}
            */ }, { key: 'getDefaultUpperLimit', value: function getDefaultUpperLimit() {
               return 20;
          } /**
            * Will return the default upper limit for pivots
            * @returns {number}
            */ }, { key: 'getDefaultUpperLimitForPivot', value: function getDefaultUpperLimitForPivot() {
               return 10;
          } /**
            * Will return the default upperlimit for a query based on a given variant
            * @param  {string} iVariant
            * @returns {number}
            */ }, { key: 'getDefaultUpperLimitByVariant', value: function getDefaultUpperLimitByVariant(iVariant) {
               if (iVariant === 'PIVOT') {
                    return this.getDefaultUpperLimitForPivot();
               }return this.getDefaultUpperLimit();
          } /**
            * Will force limit for Live KPI requests. Live KPI requests need special handling as the contain no dimension
            * @param {Object} iQuery - The query object so far
            * @param {Object} iConfig - The analysis configuration
            */ }, { key: 'forceKpiLiveLimits', value: function forceKpiLiveLimits(iQuery, iConfig) {
               var analysisType = _.get(iConfig, 'analysisType');if (!_.includes(['KPI_LIVE', 'SPARKLINE_LIVE'], analysisType)) {
                    return;
               }_.chain(iQuery).set('lowerLimits', [1]).set('upperLimits', [100]).value();
          } /**
            * Will force a hard coded upperLimit in sparklines that have some comparison type so as to allow all
            * values (of both time-ranges to return from the core)
            * @param {Object} iQuery The query object so far
            * @param {Object} iConfig The analysis configuration
            */ }, { key: 'forceSparkLineUpperLimit', value: function forceSparkLineUpperLimit(iQuery, iConfig) {
               // Do nothing for analyses that have no comparison type
               var comparisonType_ = _.get(iConfig, 'comparison.type');if (comparisonType_ !== 'PERIOD' && comparisonType_ !== 'SLIDING_WINDOW') {
                    return;
               } // Do nothing for elements that are not sparklines
               if (_.get(iConfig, 'analysisType') !== 'SPARKLINE') {
                    return;
               } // Set the limit only when the number of metrics is 2 - an actual comparison exists
               if (_.chain(iQuery).get('metrics').size().value() !== 2) {
                    return;
               }iQuery.upperLimits[0] = 157680000; // 365 * 5 * 24 * 60 * 60
          } /**
                * Will set the upper and lower limits for initial query requests ONLY
                * @param {Object} iQuery The query object so far
                * @param {Object} iConfig The analysis configuration
                * @param {Object} iSettings Additional query parameters
                */ }, { key: 'setUpperAndLowerLimits', value: function setUpperAndLowerLimits(iQuery, iConfig, iSettings) {
               var _this2 = this; // Empty previous limits of query
               iQuery.lowerLimits = [];iQuery.upperLimits = [];var layer = this.QueryLimits_.Monads.getQueryLayer(iQuery);var upperDefault_ = this.getDefaultUpperLimitByVariant(_.get(iConfig, 'variant'));_.chain(iConfig).get('columns').filter(function (iColumn) {
                    return _.get(_this2.QueryLimits_.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')), 'dimension');
               }).forEach(function (iColumn, iNdex) {
                    iQuery.lowerLimits.push(_.get(iColumn, 'lowerLimit', 1));var upperLimit_ = _.get(iColumn, 'upperLimit', upperDefault_); // If not upperLimit is explicitly set in the first columns, try to figure out a value for it based on the time range.
                    // Applies to all variants aside from PIVOT_AS_LIST.
                    if (iNdex === 0 && !_.get(iColumn, 'upperLimit') && _.get(iConfig, 'variant') !== 'PIVOT_AS_LIST') {
                         upperLimit_ = _this2.getUpperLimitValue(iQuery, iSettings) || upperLimit_;
                    }iQuery.upperLimits.push(upperLimit_);if (_.get(iConfig, 'variant') === 'PIVOT_AS_LIST') {
                         // Break the iteration for PIVOT_AS_LIST analyses. All limits apart from the first one
                         // should be ingored.
                         return false;
                    }return true;
               }).value();if (!_.chain(iSettings).get('lowerLimits').isEmpty().value()) {
                    iQuery.lowerLimits[0] = iSettings.lowerLimits[0];
               }if (!_.chain(iSettings).get('upperLimits').isEmpty().value()) {
                    iQuery.upperLimits[0] = iSettings.upperLimits[0];
               }this.forceKpiLiveLimits(iQuery, iConfig);this.forceSparkLineUpperLimit(iQuery, iConfig);
          } }, { key: 'hasLimits', value: function hasLimits(iQuery) {
               return !_.chain(iQuery).get('lowerLimits').isEmpty().value() && !_.chain(iQuery).get('upperLimits').isEmpty().value();
          } /**
            * Will try to contrust the upper and lower limit lists based on the analysis configuration. Will return an empty object
            * if invalid lists occur based on the given configuration.
            * @param  {Object} iConfig Analysis configuration object
            * @returns {Object}
            */ }, { key: 'getLimitsByConfig', value: function getLimitsByConfig(iConfig) {
               var _this3 = this;var layer = this.QueryLimits_.Monads.getConfigLayer(iConfig);var dimensions_ = _.chain(iConfig).get('columns').filter(function (iColumn) {
                    return _.get(_this3.QueryLimits_.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')), 'dimension');
               }).value();var limits_ = { lowerLimits: _.chain(dimensions_).map('lowerLimit').compact().value(), upperLimits: _.chain(dimensions_).map('upperLimit').compact().value() };if (!this.hasLimits(limits_) && _.has(iConfig, 'predefinedTableRows')) {
                    var row_ = this.prepareLimit(0, _.get(iConfig, 'predefinedTableRows'));limits_.lowerLimits[0] = row_.lowerLimits[0];limits_.upperLimits[0] = row_.upperLimits[0];
               } // Clean falsy values
               limits_.lowerLimits = _.compact(limits_.lowerLimits);limits_.upperLimits = _.compact(limits_.upperLimits); // Return an empty object if any of the limit lists is empty
               if (!this.hasLimits(limits_)) {
                    return {};
               }return limits_;
          } /**
            * Returns an object that can be used as a filter for table rows.
            * @param {number} start Zero based index
            * @param {number} rows Number of entries in the table or graph to show.
            * @returns {{lowerLimits: *[], upperLimits: *[]}}
            */ }, { key: 'prepareLimit', value: function prepareLimit(start, rows) {
               return { lowerLimits: [start + 1], upperLimits: [start + rows] };
          } /**
            * Will iterate over two lists of limits and replace values of iOldList with values iNewList of the same index.
            * Values of iNewList whose index exceeds the length of iOldList will be ignored
            * @param  {Array<number>} iOldList
            * @param  {Array<number>} iNewList
            * @private
            */ }, { key: 'updateLimitList_', value: function updateLimitList_(iOldList, iNewList) {
               if (!_.isArray(iOldList) || !_.isArray(iNewList)) {
                    return;
               }var oldLn_ = iOldList.length;_.forEach(iNewList, function (iValue, iNdex) {
                    // Break the iteration if the explicit upperLimits are more then the actual limits
                    // of the query
                    if (iNdex === oldLn_) {
                         return false;
                    }iOldList[iNdex] = _.isNumber(iValue) ? iValue : iOldList[iNdex]; // Keeps lint happy
                    return true;
               });
          } /**
            * Will ensure that query limits do not exceed the account maximum for the given export type
            * @param  {Object} iQuery -  The report generation calculation
            * @param  {string|null} iResultType - A string indicating that export type the query is build for. Will be used to check agaist account limits.
            * @private
            */ }, { key: 'restrict_', value: function restrict_(iQuery) {
               var iResultType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var max_ = this.QueryLimits_.accountService.getExportLimit(iResultType);if (!max_) {
                    return;
               }var rows_ = iQuery.upperLimits[0] - iQuery.lowerLimits[0] + 1;if (rows_ > max_) {
                    iQuery.upperLimits[0] = iQuery.lowerLimits[0] + max_;
               }
          } /**
            * Will clone and explicitly set the first index of the upperLimits and lowerLimits lists of a calculation of a whole query.
            * @param  {Object} iQuery -  The report generation calculation
            * @param  {Object} iOptions - Hash with lists of set limits (upperLimits and lowerLimits) to enforce to a query and optionally resultType.
            * @param  {boolean} iDiscardTime - Flag to enforce limits to queries that have a time dimension as first dimension
            * @returns {Object} A clone of the query provided. If the limits are applicable the modified clone, otherwise a clone of the original query
            */ }, { key: 'forceAnalysisLimits', value: function forceAnalysisLimits(iQuery, iOptions) {
               var iDiscardTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;var query_ = _.cloneDeep(iQuery);var resultType_ = _.get(iOptions, 'resultType'); // Should the passed query have no lower and upper limit lists do nothing
               if (!_.has(query_, 'upperLimits') || !_.has(query_, 'lowerLimits')) {
                    return query_;
               } // Do not enforce limits if the first dimension is time related
               if (!iDiscardTime && this.timeFormat(query_)) {
                    this.restrict_(query_, resultType_);return query_;
               }this.updateLimitList_(query_.upperLimits, iOptions.upperLimits);this.updateLimitList_(query_.lowerLimits, iOptions.lowerLimits);this.restrict_(query_, resultType_);return query_;
          } }]);return QueryLimits;
}();

},{}],36:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     QueryMetrics.$inject = ['Columns', 'QueryTemplates', 'reportElementUtils', 'Filters', 'TimesDynamic', 'Monads', 'LanguageSettings', 'segmentService', 'ConfigPeriodColumn'];function QueryMetrics(Columns, QueryTemplates, reportElementUtils, Filters, TimesDynamic, Monads, LanguageSettings, segmentService, ConfigPeriodColumn) {
          _classCallCheck(this, QueryMetrics);this.Columns = Columns;this.QueryTemplates = QueryTemplates;this.reportElementUtils = reportElementUtils;this.Filters = Filters;this.TimesDynamic = TimesDynamic;this.Monads = Monads;this.LanguageSettings = LanguageSettings;this.segmentService = segmentService;this.ConfigPeriodColumn = ConfigPeriodColumn;
     } /**
       * Converts a given column configuration to a query metric object inheriting only basic properties.
       * 1. arrangeType
       * 2. title
       * 3. context
       * 4. sumValue
       * @param   {Object} column The column configuration
       * @param   {string=} alias
       * @returns {Object}
       * @private
       */_createClass(QueryMetrics, [{ key: 'initMetricFromColumn_', value: function initMetricFromColumn_(column) {
               var alias = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var metric = this.QueryTemplates.metric();_.chain(metric).set('alias', alias).get('value').set('arrangeType', _.get(column, 'arrangeType')).set('title', _.get(column, 'title')).set('context', column.context || metric.value.context).set('sumValue', _.get(column, 'sumValue', false)).value();return metric;
          } /**
            * Constructs the list of metrics for a request
            * @param  	{Array<Object>} columns - List of column objects
            * @param  	{Object} arrTypeIndx - HashMap of arrangeTypes and list of indexes
            * @returns {Array<Object>}
            */ }, { key: 'initMetrics', value: function initMetrics(columns, arrTypeIndx) {
               var _this = this;var keepAliases = this.Columns.hasHealthyAliases(columns);return _.chain(columns).filter(function (column) {
                    // Ignore non metrics
                    if (_.get(column, 'columnType') !== 'metric') {
                         return false;
                    }var isVisible = _.get(column, 'visible'); // Columns with 'undefined' visible setting are plainly considered visible
                    return _.isUndefined(isVisible) || isVisible;
               }).map(function (metricColumn) {
                    // get the first number in the index for this arrange type
                    var temporaryIndex = _.first(arrTypeIndx[metricColumn.arrangeType]); // Now remove it from the array
                    _.remove(arrTypeIndx[metricColumn.arrangeType], function (e) {
                         return e === temporaryIndex;
                    });var alias = keepAliases ? metricColumn.alias : _this.Columns.alias(metricColumn.arrangeType, temporaryIndex);return _this.initMetricFromColumn_(metricColumn, alias);
               }).value();
          } /**
            * Will inject or remove the appropriate time filter in the filter list of a 'query' metric based
            * on it's corresponding column configuration.
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} filters - A list of filters
            * @param  {string} layer
            * @private
            * @chainable
            */ }, { key: 'injectTimeFilter_', value: function injectTimeFilter_(column_, filters, layer) {
               var column = _.cloneDeep(column_); // Set the 'columnPeriod' in the clone of the column if necesarry, detect
               // and return the proper filter to inject
               var timeFilter = this.ConfigPeriodColumn.initPeriod(column, layer).getConfigTimeFilter(column, layer, true); // If the time filter is proper inject it - while removing existing time filters
               if (timeFilter) {
                    this.Filters.insertTimes(filters, timeFilter, true);
               } else {
                    // Otherwise just remove all time filters
                    this.Filters.deleteTimes(filters, true);
               }return this;
          } /**
            * Will append filter rules - apart from time filter rules - coming from a 'metric' configuration
            * to a given list of filters.
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} filters - A list of filters
            * @param  {string} layer
            * @private
            * @chainable
            */ }, { key: 'injectMonadFilters_', value: function injectMonadFilters_(column, filters, layer) {
               var arrangeType = _.get(column, 'arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);if (!monad) {
                    return this;
               } // The the filter rules from the configuration
               var monadFilters = _.chain(monad).get('filters').cloneDeep().value(); // Ditch any time filter if present - even Q3 time filters
               this.Filters.deleteTimes(monadFilters, true);_.forEach(monadFilters, function (monadFilter) {
                    filters.push(monadFilter);
               });return this;
          } /**
            * Will append filter rules - apart from time filter rules - coming from a column configuration
            * to a given list of filters.
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} filters - A list of filters
            * @private
            * @chainable
            */ }, { key: 'injectColumnFilters_', value: function injectColumnFilters_(column, filters) {
               var columnFilters = _.chain(column).get('predefinedContainer.filters').cloneDeep().value(); // Ditch any time filter if present - even Q3 time filters
               this.Filters.deleteTimes(columnFilters, true);_.forEach(columnFilters, function (columnFilter) {
                    filters.push(columnFilter);
               });return this;
          } /**
            * Will append containers coming from a 'metric' configuration to a given list.
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} containers - A list of containers
            * @param  {string} layer
            * @private
            * @chainable
            */ }, { key: 'injectMonadContainers_', value: function injectMonadContainers_(column, containers, layer) {
               var _this2 = this;var arrangeType = _.get(column, 'arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);if (!monad) {
                    return this;
               }_.chain(monad).get('containers').cloneDeep().forEach(function (container) {
                    _this2.Filters.applyAndRuleToContainer(container);containers.push(container);
               }).value();return this;
          } /**
            * Will convert a list of segment connector configurations them to containers
            * 3. Add them to the given list of containers
            * @param  {Array<Object>} segmentConnectors - List of segmentConnector objects
            * @param  {Array<Object>} containers - List of containers
            * @chainable
            * @private
            */ }, { key: 'appendSegmentContainers_', value: function appendSegmentContainers_(segmentConnectors, containers) {
               if (_.isEmpty(segmentConnectors)) {
                    return this;
               }if (!_.isArray(containers)) {
                    return this;
               }var segmentContainers = this.segmentService.getSegmentConnectorsAsContainers(segmentConnectors);_.forEach(segmentContainers, function (segmentContainer) {
                    containers.push(segmentContainer);
               });return this;
          } /**
            * Will resolve segments coming from a 'metric', convert them to containers
            * and append them to a list of containers
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} containers - A list of containers
            * @param  {string} layer
            * @private
            * @chainable
            */ }, { key: 'injectMonadSegments_', value: function injectMonadSegments_(column, containers, layer) {
               var arrangeType = _.get(column, 'arrangeType');var monad = this.Monads.layer(layer).monad(arrangeType);if (!monad) {
                    return this;
               }var segmentConnectors = _.get(monad, 'predefinedSegmentConnections', []);return this.appendSegmentContainers_(segmentConnectors, containers);
          } /**
            * Will append containers coming from a column configuration to a given list.
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} containers - A list of containers
            * @private
            * @chainable
            */ }, { key: 'injectColumnContainers_', value: function injectColumnContainers_(column, containers) {
               var _this3 = this;_.chain(column).get('predefinedContainer.containers').cloneDeep().forEach(function (container) {
                    _this3.Filters.applyAndRuleToContainer(container);containers.push(container);
               }).value();return this;
          } /**
            * Will resolve segments coming from a column, convert them to containers
            * and append them to a list of containers
            * @param  {Object} column_ - The column configuration object
            * @param  {Array<Object>} containers - A list of containers
            * @private
            * @chainable
            */ }, { key: 'injectColumnSegments_', value: function injectColumnSegments_(column, containers) {
               var segmentConnectors = _.get(column, 'predefinedSegmentConnections', []);return this.appendSegmentContainers_(segmentConnectors, containers);
          } /**
            * Will manipulate/mutate a given metric based on the column configuration of the analysis
            * updating filters and containers
            * @param   {Object} metric A query metric
            * @param   {Object} column A column configuration object
            * @param   {string} layer
            * @returns {QueryMetrics}
            * @private
            */ }, { key: 'setFiltersAndSegmentsFromColumn_', value: function setFiltersAndSegmentsFromColumn_(metric, column, layer) {
               if (!column) {
                    return this;
               }var metricFilters = [];var metricContainers = [];this.injectTimeFilter_(column, metricFilters, layer).injectMonadFilters_(column, metricFilters, layer).injectColumnFilters_(column, metricFilters).injectMonadContainers_(column, metricContainers, layer).injectMonadSegments_(column, metricContainers, layer).injectColumnContainers_(column, metricContainers).injectColumnSegments_(column, metricContainers);this.Filters.applyAndRule(metricFilters);_.chain(metric).get('value').set('filters', metricFilters).set('containers', metricContainers).value();return this;
          } /**
            * Will manipulate/mutate a given metric based on the column configuration of the analysis
            * updating scope and context
            * @param   {Object} metric A query metric
            * @param   {Object} column A column configuration object
            * @returns {QueryMetrics}
            * @private
            */ }, { key: 'setScopeAndContextFromColumn_', value: function setScopeAndContextFromColumn_(metric, column) {
               if (!column) {
                    return this;
               }var props = _.pick(column, ['scope', 'context']);_.chain(metric).get('value').assignWith(props, function (oldValue, newValue) {
                    // Update scope and context only if the column propery is set
                    // properly
                    return _.isEmpty(newValue) ? oldValue : newValue;
               }).value();return this;
          } /**
            * Will manipulate/mutate a given metric based on the column configuration of the analysis
            * updating timeShiftBy and timeShiftUnit
            * @param   {Object} metric A query metric
            * @param   {Object} column A column configuration object
            * @returns {QueryMetrics}
            * @private
            */ }, { key: 'setTimeShiftFromColumn_', value: function setTimeShiftFromColumn_(metric, column) {
               if (!column) {
                    return this;
               }var props = _.pick(column, ['timeShiftBy', 'timeShiftUnit']);_.chain(metric).get('value').assignWith(props, function (oldValue, newValue) {
                    return _.isNil(newValue) ? oldValue : newValue;
               }).value();return this;
          } /**
            * Will manipulate the metrics of a request based on the column configuration of the analysis updating:
            * 1. scope,
            * 2. context
            * 3. filters
            * 4. containers
            * filters and containers of the metric.
            * @param  {Object} config The analysis configuration, including columns. See https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-Analysis
            * @param  {Object} query  See https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-ReportGenerationQuery
            * @param   {string} layer
            */ }, { key: 'updateMetrics', value: function updateMetrics(config, query, layer) {
               var _this4 = this;_.chain(query).get('metrics').forEach(function (requestMetric) {
                    var alias = _.get(requestMetric, 'alias');if (!alias) {
                         return;
                    } // Customized columns always have an alias
                    var customColumn = _.chain(config).get('columns').find({ alias: alias }).value();_this4.setFiltersAndSegmentsFromColumn_(requestMetric, customColumn, layer).setScopeAndContextFromColumn_(requestMetric, customColumn);
               }).value();
          } /**
            * Will construct a time range string from a time filter that might exist in a column configuration
            * @param   {Object} column - Column configuration object
            * @returns {string}
            */ }, { key: 'getTimeRange', value: function getTimeRange(column) {
               // The custom time filter of the column - if any
               var timeFilter = this.Filters.hasTimeFilter(_.get(column, 'predefinedContainer.filters'));return this.Filters.getTimeRange(timeFilter);
          } /**
            * Will set titles in metrics of a query based on the title found in columns of the analysis configuration
            * @param  {Object} config Complete analysis configuration
            * @param  {Object} query  The query that is constructed based on the configuration
            */ }, { key: 'entitleMetrics', value: function entitleMetrics(config, query) {
               var _this5 = this;var columns = _.get(config, 'columns');var metrics = _.get(query, 'metrics');if (!columns || !metrics) {
                    return;
               }var layer = this.Monads.getConfigLayer(config);_.forEach(metrics, function (metric) {
                    var alias = _.get(metric, 'alias');var column = _.find(columns, function (column_) {
                         return _.get(column_, 'alias') === alias;
                    });if (!column) {
                         return;
                    }var arrangeType = _.get(column, 'arrangeType');var monad = _this5.Monads.layer(layer).monad(arrangeType);var title_ = _.get(column, 'title', '') || _.get(metric, 'value.title', '') || _.get(monad, 'title', '');var timeRange = _this5.getTimeRange(column);var title = timeRange ? title_ + ' (' + timeRange + ')' : title_;_.set(metric, 'value.title', title);
               });
          } /**
            * Will inject the time filter found in a real time analysis/report-element config in all metrics
            * in the query that have no predefined time filter already set.
            * @param  {Object} config
            * @param  {Object} query
            */ }, { key: 'injectRealTimeFilter_', value: function injectRealTimeFilter_(config, query) {
               var _this6 = this; // The time filter of the live element
               var timeFilter = this.reportElementUtils.getTimeFilter(config); // Nothing to do if the config has no predefined time filter
               if (!timeFilter) {
                    return;
               }_.chain(query).get('metrics').reject(function (metric) {
                    return _.get(metric, 'comparisonFormula', false);
               }).filter(function (metric) {
                    var queryMetricFilters = _.get(metric, 'value.filters', []); // Based on metric alias on query, find the column configuration
                    // and fetch the filters if any
                    var filters = _.chain(config).get('columns').find(function (col) {
                         return _.get(col, 'alias') === _.get(metric, 'alias');
                    }).get('predefinedContainer.filters').value();return !_this6.Filters.hasTimeFilter(filters) && !_this6.Filters.hasTimeFilter(queryMetricFilters);
               }).forEach(function (metric) {
                    // Inject the element time filter in ALL metrics that have
                    // no time filter specified
                    // @todo: NORMALLY THIS CLONING AND RESETTING THE FILTER LIST IN THE QUERY IS NOT NEEDED.
                    // MUST FIND OUT AT WHICH POINT THE CONFIG COLUMN FILTERS AND THE METRIC FILTERS ARE BEING
                    // COPIED WITHOUT BEING CLONED.
                    var filters = _.chain(metric).get('value.filters').cloneDeep().value();_this6.Filters.insertTimes(filters, timeFilter);_.set(metric, 'value.filters', filters);
               }).value();
          } /**
            * Will inject the time filter found in a real time analysis/report-element config in all metrics
            * in the query that have no predefined time filter already set and modify the metric title if the
            * metric has a predefined time filter set in its corresponding column configuration.
            * @param  {Object} config
            * @param  {Object} query
            */ }, { key: 'handleRealTimeMetrics', value: function handleRealTimeMetrics(config, query) {
               // Work only on queries of real time objects
               if (!this.reportElementUtils.isRealTime(config)) {
                    return;
               } // Inject time filters where necessary
               // @TODO: Is this really needed?
               this.injectRealTimeFilter_(config, query);
          } /**
            * Will convert a given column to a metric query object
            * @param   {Object} column The column configuration object
            * @param   {string} layer
            * @param   {string=} alias
            * @returns {Object}
            */ }, { key: 'getMetricFromColumn', value: function getMetricFromColumn(column, layer) {
               var alias = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var metric = this.initMetricFromColumn_(column, alias);this.setFiltersAndSegmentsFromColumn_(metric, column, layer).setScopeAndContextFromColumn_(metric, column).setTimeShiftFromColumn_(metric, column);return metric;
          } /**
            * Generates a query metric to be used in a path viewMode query.
            * @param   {string} arrangeType
            * @param   {string} context_
            * @param   {number=} index
            * @returns {Object}
            */ }, { key: 'getPathMetric', value: function getPathMetric(arrangeType, context_) {
               var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;var metric = this.Monads.monad(arrangeType);var title = _.get(metric, 'title', '');var sumValue = false;var alias = '' + arrangeType + this.Columns.ALIAS_SEPARATOR + index; // Defaults the context to NONE when the given context_ is not compatible.
               var possibleContexts = _.get(metric, 'possibleContexts', []);var context = _.includes(possibleContexts, context_) ? context_ : 'NONE';var column = { arrangeType: arrangeType, title: title, context: context, sumValue: sumValue };return this.getMetricFromColumn(column, this.Monads.RAW_DATA, alias);
          } }]);return QueryMetrics;
}();

},{}],37:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     function QueryTemplates() {
          _classCallCheck(this, QueryTemplates);
     }_createClass(QueryTemplates, [{ key: 'query', /**
                                                    * Provides a calculation template
                                                    * @param {number} iCalculationId The calculation id to be used in the template
                                                    * @returns {Object}
                                                    */value: function query(iCalculationId) {
               var calculationId = String(iCalculationId);return { id: 'c' + calculationId, filters: [], containers: [], dimensions: [], hideSubFooters: false, metrics: [], orderColumns: [] };
          } }, { key: 'request', value: function request(iCalculationLayers) {
               return { abortAllowed: false, calculations: [], possibleCalculationLayers: iCalculationLayers || ['RAW_DATA'], resultType: 'DATA_ONLY' };
          } }, { key: 'dimension', value: function dimension() {
               return { alias: null, arrangeType: null, mappingMode: 'NORMAL', pathLength: 0, pathMode: 'NORMAL' };
          } }, { key: 'metric', value: function metric() {
               return { alias: null, value: { arrangeType: '', containers: [], context: 'NONE', filters: [], scope: 'OBJECT', sumValue: false, timeShiftBy: 0, timeShiftUnit: 'NONE', type: 'METRIC' } };
          } }, { key: 'filter', value: function filter(iProperties) {
               return _.merge({ caseSensitive: false, context: 'NONE', arrangeType: null, filterPredicate: null, connector: null, intern: false, value1: '', value2: '' }, iProperties);
          } }, { key: 'container', value: function container(iProperties) {
               return _.merge({ filters: [], containers: [], type: 'NORMAL', // NORMAL || TIME_ORDER || USER_PREFERENCE
                    connector: 'AND', // AND || OR
                    context: 'VISITOR', // VISITOR || VISITS (Could potentially be: SESSION || PAGE || ACTION || ATOMIC || NONE)
                    inOrNotIn: 'IN' // IN || NOT_IN
               }, iProperties);
          } }, { key: 'orderColumn', value: function orderColumn(iVariant) {
               var footerType_ = !_.isUndefined(iVariant) && iVariant === 'pivot' ? 'UNIQUE_SUM' : 'SUM';return { columnAlias: '', direction: 'DESCENDING', footerType: footerType_ };
          } }]);return QueryTemplates;
}();

},{}],38:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     QueryUtility.$inject = ['Filters', 'filterUtils', 'LastUpdates', 'arrangeTypeUtils'];_createClass(QueryUtility, [{ key: 'PIVOT_AS_LIST_QUERY_PROPS', /**
                                                                                                                                                          * The properties needed to be defined and set to true on a query
                                                                                                                                                          * if it is a PIVOT_AS_LIST query
                                                                                                                                                          * @returns {Array<string>}
                                                                                                                                                          */get: function get() {
               return ['showAsList', 'buildWholeBranchFirst'];
          } /* @ngInject*/ }]);function QueryUtility(Filters, filterUtils, LastUpdates, arrangeTypeUtils) {
          _classCallCheck(this, QueryUtility);this.Filters = Filters;this.filterUtils = filterUtils;this.LastUpdates = LastUpdates;this.arrangeTypeUtils = arrangeTypeUtils;
     } /**
       * Determines if a query is a pivot as list query based on specific properties.
       * @param   {Object} query
       * @returns {boolean}
       */_createClass(QueryUtility, [{ key: 'isPivotAsList', value: function isPivotAsList(query) {
               return _.chain(query).pick(this.PIVOT_AS_LIST_QUERY_PROPS).values().map(function (val) {
                    return Boolean(val);
               }).compact().uniq().first().isEqual(true).value();
          } /**
            * Sets the pivot as list query properties to true on a query.
            * @param   {Object} query
            * @returns {QueryUtility}
            */ }, { key: 'setPivotAsList', value: function setPivotAsList(query) {
               _.forEach(this.PIVOT_AS_LIST_QUERY_PROPS, function (property) {
                    _.set(query, '' + property, true);
               });return this;
          } /**
            * Deletes the pivot as list query properties from a query.
            * @param   {Object} query
            * @returns {QueryUtility}
            */ }, { key: 'unsetPivotAsList', value: function unsetPivotAsList(query) {
               _.forEach(this.PIVOT_AS_LIST_QUERY_PROPS, function (property) {
                    delete query['' + property];
               });return this;
          } /**
            * Determines if a given query includes any time filters that include today.
            * @param   {Object} query
            * @returns {boolean}
            */ }, { key: 'includesToday', value: function includesToday(query) {
               var _this = this;var todayFilters = function todayFilters(filter) {
                    return _this.Filters.includesToday(filter);
               };var queryFilters = this.filterUtils.filterQueryFilters(query, todayFilters);return _.chain(queryFilters).size().gt(0).valueOf();
          } /**
            * Returns the lastUpdate time if a query includes today.
            * @param   {Object} query
            * @returns {string|null}
            */ }, { key: 'getLastUpdate', value: function getLastUpdate(query) {
               return this.includesToday(query) ? '' + this.Filters.transformerToday : null;
          } /**
            * Returns the resultCacheReset time.
            * @return {string|null}
            */ }, { key: 'getResultCacheResetUpdate', value: function getResultCacheResetUpdate() {
               var resultCacheResetUpdate = this.LastUpdates.getResultCacheResetUpdateTime();return resultCacheResetUpdate ? '' + resultCacheResetUpdate : null;
          } /**
            * Collects the unique lastUpdate objects based on the lastUpdate properties of arrangeTypes used in a query.
            * @param   {Object} query
            * @returns {Array<Object>}
            */ }, { key: 'getArrangeTypeUpdates', value: function getArrangeTypeUpdates(query) {
               var _this2 = this;var filterCallback = function filterCallback(monad) {
                    return _.chain(monad).get('lastUpdates').size().gt(0).valueOf();
               };var mapCallback = function mapCallback(monad) {
                    return _.get(monad, 'lastUpdates');
               };var lastUpdates = this.arrangeTypeUtils.filterQueryArrangeTypes(query, filterCallback, mapCallback);return _.chain(lastUpdates).flatten().uniqWith(_.isEqual).map(function (_ref) {
                    var typeId = _ref.typeId,
                        updateType = _ref.updateType;return _this2.LastUpdates.getFirstUpdateByTypeAndId(typeId, updateType);
               }).compact().valueOf();
          } }]);return QueryUtility;
}();

},{}],39:[function(require,module,exports){
'use strict'; /* eslint no-useless-constructor:0 */
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}function _possibleConstructorReturn(self, call) {
     if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
     }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
     if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
     }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}var AccountContainer = require('./AccountContainer');module.exports = function (_AccountContainer) {
     ReportContainer.$inject = ['Monads', 'logicalCubeUtils', 'segmentService', 'filterUtils'];_inherits(ReportContainer, _AccountContainer); /* @ngInject*/function ReportContainer(Monads, logicalCubeUtils, segmentService, filterUtils) {
          _classCallCheck(this, ReportContainer);return _possibleConstructorReturn(this, (ReportContainer.__proto__ || Object.getPrototypeOf(ReportContainer)).call(this, Monads, logicalCubeUtils, segmentService, filterUtils));
     } /**
       * Will convert a given list of dashboardQuickFilters to a list of containers while resolving
       * segments at the same time
       * @param   {Array<Object>} quickFilters_
       * @returns {Object}
       * @private
       */_createClass(ReportContainer, [{ key: 'convertToContainer_', value: function convertToContainer_(quickFilters_) {
               var _this2 = this;var quickFilters = _.cloneDeep(quickFilters_);var segment = _.chain(quickFilters).remove({ arrangeType: this.segmentService.SEGMENT_FAKE_ARRANGE_TYPE }).map(function (filter) {
                    return _.cloneDeep(_this2.segmentService.getActiveSegmentById(filter.value1));
               }).first().get('filter').value();var containers = _.get(segment, 'containers', []);var segmentFilters = _.get(segment, 'filters', []);var filters = [].concat(_toConsumableArray(quickFilters), _toConsumableArray(segmentFilters));if (!_.isEmpty(filters)) {
                    var autoContainer = { filters: filters, context: 'NONE' };containers.push(autoContainer);
               }return { filters: [], containers: containers };
          } /**
            * Will validate a list of dashboardQuickFilters against a live query
            * @param   {Object} query - The calculation object
            * @param   {Array<Object>} quickFilters_ - The list of dashboardQuickFilters
            * @returns {boolean}
            */ }, { key: 'validateQuery', value: function validateQuery(query) {
               var quickFilters_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []; // No validation for RAW_DATA filters
               if (!this.Monads.isRealTimeQuery(query)) {
                    return true;
               }var quickFilters = _.cloneDeep(quickFilters_);this.filterUtils.cleanEmptyFilters(quickFilters);var container = this.convertToContainer_(quickFilters);var validationMeta = {};this.validateAccountContainerForLive_(query, container, validationMeta).validateQuery_(query, container, validationMeta);return _.chain(validationMeta).get('errors', []).size().eq(0).value();
          } }]);return ReportContainer;
}(AccountContainer);

},{"./AccountContainer":1}],40:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     ReportElementQuery.$inject = ['CustomFormulas', 'reportElementUtils', 'Columns', 'Filters', 'Monads', 'Comparison'];function ReportElementQuery(CustomFormulas, reportElementUtils, Columns, Filters, Monads, Comparison) {
          _classCallCheck(this, ReportElementQuery);this.CustomFormulas = CustomFormulas;this.reportElementUtils = reportElementUtils;this.Columns = Columns;this.Filters = Filters;this.Monads = Monads;this.Comparison = Comparison;
     } /**
       * Will iterate over the metrics of a query and replace custom formulas with their 'metric' definition.
       * @param  {Object} query - The report generation query object
       */_createClass(ReportElementQuery, [{ key: 'resolveCustomFormulas', value: function resolveCustomFormulas(query) {
               var _this = this;_.chain(query).get('metrics').forEach(function (metric, index, metrics) {
                    _.set(metrics, index + '.value', _this.CustomFormulas.resolveDeep(_.get(metric, 'value')));
               }).value();
          } /**
            * Will drop all metrics apart from the first one from a given query
            * @param  {Object} query - The report generation query object
            * @private
            */ }, { key: 'firstMetric_', value: function firstMetric_(query) {
               _.chain(query).get('metrics').remove(function (metric, index) {
                    return index !== 0;
               }).value();
          } /**
            * Will check the validity of a timeShiftBy value
            * @param  {number}  timeShiftBy
            * @returns {boolean}
            * @private
            */ }, { key: 'isValidTimeShiftBy_', value: function isValidTimeShiftBy_(timeShiftBy) {
               return _.isNumber(timeShiftBy) && timeShiftBy % 1 === 0;
          } /**
            * Will return the comparison metric based on the original metric of a KPI || Sprakline request with either
            * PERIOD or SLIDING_WINDOW comparison, based on the config of the element.
            * @param  {Object} metric - The first metric definition object of the KPI || Sprakline request
            * @param  {Object} config - The report element (KPI || Sparkline) configuration object
            * @returns {Object}
            * @private
            */ }, { key: 'getComparisonMetric_', value: function getComparisonMetric_(metric, config) {
               var comparisonMetric = _.cloneDeep(metric);var timeShiftBy = _.get(config, 'comparison.timeShiftBy');if (this.reportElementUtils.isPeriod(config)) {
                    // Inherits comparison time filter from configuration
                    var comparisonFilter = _.get(config, 'comparison.filter');this.reportElementUtils.comparisonTimeFilters(comparisonMetric, comparisonFilter);
               }if (this.isValidTimeShiftBy_(timeShiftBy)) {
                    // Sets timeShiftBy according to configuration
                    _.set(comparisonMetric, 'value.timeShiftBy', timeShiftBy); // Sets the timeShiftUnit to DAY. Only days are taken into account currently
                    _.set(comparisonMetric, 'value.timeShiftUnit', 'DAY');
               }return comparisonMetric;
          } /**
            * Will inject a given comparison formula into a query
            * @param  {Object} query - The report generation query object
            * @param  {Object} comparisonFormula - The comparison formula configuration object
            * @private
            */ }, { key: 'injectComparisonFormula_', value: function injectComparisonFormula_(query, comparisonFormula) {
               var metricArrangeType = _.chain(query).get('metrics').first().get('value.arrangeType').value();_.chain(query).get('metrics').push({ alias: this.Columns.alias(metricArrangeType, 1), comparisonFormula: true, value: comparisonFormula }).value();
          } /**
            * Will inject a given comparison metric into a query
            * @param  {Object} query - The report generation query object
            * @param  {Object} comparisonMetric - The comparison metric
            * @private
            */ }, { key: 'injectComparisonMetric_', value: function injectComparisonMetric_(query, comparisonMetric) {
               var metricArrangeType = _.chain(query).get('metrics').first().get('value.arrangeType').value();_.set(comparisonMetric, 'alias', this.Columns.alias(metricArrangeType, 1));_.chain(query).get('metrics').push(comparisonMetric).value();
          } /**
            * Will handle comparison KPI queries by:
            * i. Generating the comparison metric
            * ii. Generating the comparison formula
            * iii. Injecting the comparison formula in the query
            * iv. Resolve any custom formulas that might be included the query to their definitions
            * v. Adjust the main and comparison time filters to current time when one of them includes today's date
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element (KPI) configuration object
            * @private
            */ }, { key: 'handleKPIMetrics_', value: function handleKPIMetrics_(query, config) {
               var firstMetric = _.chain(query).get('metrics').first().value(); // Build the comparison metric based on the comparison type
               var comparisonMetric = this.getComparisonMetric_(firstMetric, config);var hasObjectDivisorScope = this.reportElementUtils.isSlidingWindow(config) || this.Monads.isRealTimeConfig(config); // Build the comparison formula
               var comparisonFormula = this.CustomFormulas.getKPIComparisonFormula(firstMetric, comparisonMetric, hasObjectDivisorScope); // Inject the comparison formula in the query
               this.injectComparisonFormula_(query, comparisonFormula); // Convert custom formulas to their definition
               this.resolveCustomFormulas(query);if (!this.Monads.isRealTimeConfig(config)) {
                    this.adjustComparisonTime_(config, query);
               }
          } /**
            * Will handle comparison Sparkline queries by:
            * i. Generating the comparison metric
            * ii. Injecting the comparison metric in the query
            * iii. Resolve any custom formulas that might be included the query to their definitions
            * iv. Time filters adjustment for today is ignored for Sparklines as sparklines should show the trend.
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element (KPI) configuration object
            * @private
            */ }, { key: 'handleSparklineMetrics_', value: function handleSparklineMetrics_(query, config) {
               var firstMetric = _.chain(query).get('metrics').first().value(); // Build the comparison metric based on the comparison type
               var comparisonMetric = this.getComparisonMetric_(firstMetric, config);this.injectComparisonMetric_(query, comparisonMetric); // Convert custom formulas to their definition
               this.resolveCustomFormulas(query);
          } /**
            * Will adjust the sorting of KPI and Sparkline query/request by:
            * i. Removing all orderColumns apart from the first one
            * ii. Set the order column to the first METRIC for KPIs
            * iii. Set the order column to the first DIMENSION (Days) for Sparkline
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element (KPI) configuration object
            * @private
            */ }, { key: 'adjustSorting_', value: function adjustSorting_(query, config) {
               var _this2 = this; // Do nothing if the element is not a KPI or a Sparkline
               if (!this.reportElementUtils.isAnySparklineOrAnyKPI(config)) {
                    return;
               } // Make sure we only have ONE sorting column by removing all others && update the alias
               // based on the type
               _.chain(query).get('orderColumns').remove(function (orderColumn, index) {
                    return index;
               }).forEach(function (orderColumn) {
                    var alias = void 0;if (_this2.reportElementUtils.isAnyKPI(config)) {
                         // KPIs are sorted by metric value and DESC
                         alias = _.get(query, 'metrics.0.alias');
                    } else if (_this2.reportElementUtils.isAnySparkline(config)) {
                         // SPARKLINES are sorted by date -> dimension and ASC
                         alias = _.get(query, 'dimensions.0.alias');
                    }_.set(orderColumn, 'columnAlias', alias || orderColumn.columnAlias);
               }).value();
          } /**
            * Will force the main time filter of a LIVE KPI query in the filters of the first and only
            * metric.
            * @param  {Object} config - The report element (LIVE KPI) configuration object
            * @param  {Object} query - The report generation query object
            * @private
            */ }, { key: 'handleLiveKpiMetricTime_', value: function handleLiveKpiMetricTime_(config, query) {
               // Do nothing for elements that are not Live KPIs
               if (!this.reportElementUtils.isLiveKPI(config)) {
                    return;
               }var timeFilter = _.cloneDeep(this.reportElementUtils.getTimeFilter(config));var metricFilters = _.get(query, 'metrics.0.value.filters');this.Filters.insertTimes(metricFilters, timeFilter);
          } /**
            * Will set the sumValue to true for all LIVE KPIs
            * metric.
            * @param  {Object} config - The report element (LIVE KPI) configuration object
            * @param  {Object} query - The report generation query object
            * @private
            */ }, { key: 'handleLiveKpiMetricSum_', value: function handleLiveKpiMetricSum_(config, query) {
               // Do nothing for elements that are not Live KPIs
               if (!this.reportElementUtils.isLiveKPI(config)) {
                    return;
               }_.chain(query).get('metrics').forEach(function (metric) {
                    _.set(metric, 'value.sumValue', true);
               }).value();
          } /**
            * Will delete time filters from the metric config on their filter level for Sparklines and KPIs on RAW_DATA layer
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element configuration object
            * @private
            */ }, { key: 'handleCustomFormulaTime_', value: function handleCustomFormulaTime_(config, query) {
               if (!this.reportElementUtils.isSparkline(config) && !this.reportElementUtils.isKPI(config)) {
                    return;
               }var metricFilters = _.get(query, 'metrics.0.value.filters', []);this.Filters.deleteTimes(metricFilters, true);
          } /**
            * Will remove filters - all but the time filter - and containers - segments included - from the top level
            * of the query and inject it in the first metric of the query for RAW Sparklines and KPIs.
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element configuration object
            * @private
            */ }, { key: 'moveQueryFilters_', value: function moveQueryFilters_(config, query) {
               var _this3 = this;if (!this.reportElementUtils.isSparkline(config) && !this.reportElementUtils.isKPI(config)) {
                    return;
               }var mainFilters = _.chain(query).get('filters', []).remove(function (filter) {
                    return !_this3.Filters.isTime(filter, true);
               }).value();var filters = _.chain(query).get('metrics.0.value.filters', []).concat(mainFilters).value();_.set(query, 'metrics.0.value.filters', filters);var mainContainers = _.chain(query).get('containers', []).remove(function () {
                    return true;
               }).value();var containers = _.chain(query).get('metrics.0.value.containers', []).concat(mainContainers).value();_.set(query, 'metrics.0.value.containers', containers);
          } /**
            * Adjusts a non-live KPI calculation containing comparison metric by taking into account the main and comparison time filter end date.
            * When either one includes today's date, both time filters are adjusted to the today's current time so that the comparison is fair
            * The comparison time filter is not adjusted if it is not applicable (eg. sliding window comparison type)
            * @param {Object} config The KPI configuration
            * @param {Object} query The KPI calculation
            * @private
            */ }, { key: 'adjustComparisonTime_', value: function adjustComparisonTime_(config, query) {
               var _this4 = this;var isPeriodComparison = _.get(config, 'comparison.type') === this.Comparison.PERIOD; // Asserts today inclusion only based on the main and comparison time filters. Any other time filter (eg. custom metric|formula time filter) are ignored.
               var timeFilters = _.chain(query).get('filters').filter(function (filter) {
                    return _this4.Filters.isTime(filter, true);
               }).concat(isPeriodComparison ? this.getQueryComparisonTimeFilters(query) : []).value();var overlapsToday = _.reduce(timeFilters, function (overlaps, filter) {
                    return overlaps || _this4.Filters.includesToday(filter);
               }, false);if (overlapsToday) {
                    _.forEach(timeFilters, function (filter) {
                         return _this4.Filters.syncTimeFilterEndTime(filter);
                    });
               }
          } /**
            * Will handle Sparkline and KPI queries of any sort by:
            * i. Adjusting the sorting (setting the proper alias in the orderColumns)
            * ii. Ditching all metrics but the first one - when i.e. cached queries are to be reworked
            * iii. If comparison is NONE will simply resolve custom/predefined formulas and return
            * iv. if KPI of any sort will inject the comparison formula in the list of metrics and return
            * v. if Sparkline will simply inject the comparison metric in the list of metrics
            * @param  {Object} query - The report generation query object
            * @param  {Object} config - The report element (KPI) configuration object
            */ }, { key: 'handleSparklineOrAnyKPI', value: function handleSparklineOrAnyKPI(config, query) {
               // Nothing todo if query has no metrics of if element is not a Sparkline or KPI of any sort
               if (!_.chain(query).get('metrics').size().value() || !this.reportElementUtils.isAnySparklineOrAnyKPI(config)) {
                    return;
               }this.adjustSorting_(query, config);this.firstMetric_(query);this.handleCustomFormulaTime_(config, query);this.handleLiveKpiMetricTime_(config, query);this.handleLiveKpiMetricSum_(config, query);this.moveQueryFilters_(config, query);if (!this.reportElementUtils.hasComparison(config)) {
                    this.resolveCustomFormulas(query);return;
               }if (this.reportElementUtils.isAnyKPI(config)) {
                    this.handleKPIMetrics_(query, config);
               }if (this.reportElementUtils.isAnySparkline(config)) {
                    this.handleSparklineMetrics_(query, config);
               }
          } /**
            * Retrieves all comparison time filters that might be present in a query.
            * The comparison formula is build in {CustomFormulas#getKPIComparisonFormula}
            * TODO Formulas with own time filters are not handled properly, but these do not make sense in a KPI anyway (see ReportElementUtils#comparisonTimeFilters)
            * @param   {Object} query
            * @returns {Array<Object>}
            */ }, { key: 'getQueryComparisonTimeFilters', value: function getQueryComparisonTimeFilters(query) {
               var _this5 = this;var mainPeriodFilters = _.get(query, 'metrics[1].value.parameters[0].parameters[0].parameters[0].filters', []);var compPeriodFilters0 = _.get(query, 'metrics[1].value.parameters[0].parameters[0].parameters[1].filters', []);var compPeriodFilters1 = _.get(query, 'metrics[1].value.parameters[0].parameters[1].filters', []);return _.chain([]).concat(mainPeriodFilters, compPeriodFilters0, compPeriodFilters1).filter(function (filter) {
                    return _this5.Filters.isTime(filter, true);
               }).value();
          } }]);return ReportElementQuery;
}();

},{}],41:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     ReportElementUtils.$inject = ['$q', 'dateService', 'Filters', 'Monads', 'Comparison', 'timeShiftService'];function ReportElementUtils($q, dateService, Filters, Monads, Comparison, timeShiftService) {
          _classCallCheck(this, ReportElementUtils);this.$q = $q;this.dateService = dateService;this.Filters = Filters;this.Monads = Monads;this.Comparison = Comparison;this.timeShiftService = timeShiftService;
     } /**
       * Given a report element configuration it will return the type of the comparison if any
       * @param {Object} reportElementConfig - The configuration object of a report element
       * @returns {string|false}
       */_createClass(ReportElementUtils, [{ key: 'getComparisonType', value: function getComparisonType(reportElementConfig) {
               return _.get(reportElementConfig, 'comparison.type', false);
          } /**
            * Updates the type of a comparison type of a given report element.
            * @param {string} type - The type of the comparison (PERIOD || SLIDING_WINDOW || NONE)
            * @param {Object} reportElementConfig - The configuration object of a report element
            * @returns {string}
            */ }, { key: 'setComparisonType', value: function setComparisonType(type, reportElementConfig) {
               if (!type || !_.has(reportElementConfig, 'comparison')) {
                    return null;
               }return reportElementConfig.comparison.type = type;
          } /**
            * Given a report element configuration it will return the comparison limit
            * @param {Object} reportElementConfig - The configuration object of a report element
            * @returns {*}
            */ }, { key: 'getComparisonLimit', value: function getComparisonLimit(reportElementConfig) {
               return _.get(reportElementConfig, 'comparison.limit');
          } /**
            * Given a report element configuration it will determine if a max is set or not
            * @param {Object} reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'getComparisonIsMax', value: function getComparisonIsMax(reportElementConfig) {
               return Boolean(_.get(reportElementConfig, 'comparison.max'));
          } /**
            * Will determine if a report element config has a comparison type of 'PERIOD'
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isPeriod', value: function isPeriod(reportElementConfig) {
               return this.getComparisonType(reportElementConfig) === this.Comparison.PERIOD;
          } /**
            * Will determine if a report element config has a comparison type of 'SLIDING_WINDOW'
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isSlidingWindow', value: function isSlidingWindow(reportElementConfig) {
               return this.getComparisonType(reportElementConfig) === this.Comparison.SLIDING_WINDOW;
          } /**
            * Will determine if a report element config is of PERIOD or SLIDING_WINDOW type (other then NONE)
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'hasComparison', value: function hasComparison(reportElementConfig) {
               var type = this.getComparisonType(reportElementConfig);return this.Comparison.isNotNone(type);
          } /**
            * Returns the type of a report element
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {Object}
            */ }, { key: 'getTypeOfElement', value: function getTypeOfElement(reportElementConfig) {
               return _.get(reportElementConfig, 'type') || _.get(reportElementConfig, 'analysisType');
          } /**
            * Will determine if a report element config is a normal analysis or not
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isAnalysis', value: function isAnalysis(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return !type || type === 'ANALYSIS';
          } /**
            * Will determine if a report element configuration is a ANALYSIS_LIVE
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isLiveAnalysis', value: function isLiveAnalysis(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return type === 'ANALYSIS_LIVE';
          } /**
            * Will determine if a report element configuration is a KPI of any sort (live or regular)
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isAnyKPI', value: function isAnyKPI(reportElementConfig) {
               return this.isKPI(reportElementConfig) || this.isLiveKPI(reportElementConfig);
          } /**
            * Will determine if a report element configuration is a KPI
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isKPI', value: function isKPI(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return type === 'KPI';
          } /**
            * Will determine if a report element configuration is a KPI_LIVE
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isLiveKPI', value: function isLiveKPI(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return type === 'KPI_LIVE';
          } /**
            * Will determine if a report element configuration is a sparkline of any sort (live or regular)
            * @param  {Object}  reportElementConfig The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isAnySparkline', value: function isAnySparkline(reportElementConfig) {
               return this.isSparkline(reportElementConfig) || this.isLiveSparkline(reportElementConfig);
          } /**
            * Will determine if a report element configuration is a Sparkline
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isSparkline', value: function isSparkline(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return type === 'SPARKLINE';
          } /**
            * Will determine if a report element configuration is a Live Sparkline
            * @param {Object} reportElementConfig The configuration of the report element
            * @returns {boolean}
            */ }, { key: 'isLiveSparkline', value: function isLiveSparkline(reportElementConfig) {
               var type = this.getTypeOfElement(reportElementConfig);return type === 'SPARKLINE_LIVE';
          } /**
            * Will determine if a report element configuration is a Sparkline or a KPI of any sort
            * @param  {Object}  reportElementConfig - The configuration object of a report element
            * @returns {boolean}
            */ }, { key: 'isAnySparklineOrAnyKPI', value: function isAnySparklineOrAnyKPI(reportElementConfig) {
               return this.isAnySparkline(reportElementConfig) || this.isAnyKPI(reportElementConfig);
          } /**
            * Retrieves the time filter of a report element
            * @param {Object} reportElementConfig The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Object|null} Either the filter if found or a falsy value otherwise
            */ }, { key: 'getTimeFilter', value: function getTimeFilter(reportElementConfig) {
               if (!_.has(reportElementConfig, 'predefinedContainer.filters')) {
                    return null;
               } //@todo needs to be added to the Filters class
               return this.Filters.hasTimeFilter(reportElementConfig.predefinedContainer.filters) || null;
          } /**
            * Retrieves the time filter for the comparison in case of Sparklines and KPIs.
            * NOTE: In case of sliding window comparison, the retrieved filter is not a valid
            * time filter.
            * @param {Object} reportElementConfig - The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {Object|undefined} Either the filter if found or undefined
            */ }, { key: 'getComparisonTimeFilter', value: function getComparisonTimeFilter(reportElementConfig) {
               return _.get(reportElementConfig, 'comparison.filter');
          } /**
            * Returns a valid 'slidingWindowTimeShift' value.
            * @param   {Object} reportElementConfig The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {string}
            * @private
            */ }, { key: 'getComparisonSlidingWindowTimeShift_', value: function getComparisonSlidingWindowTimeShift_(reportElementConfig) {
               var slidingWindowTimeShift = _.get(reportElementConfig, 'comparison.slidingWindowTimeShift');return this.Comparison.resolveSlidingWindowTimeShift(slidingWindowTimeShift);
          } /**
            * Returns the slidingWindowWeekdayAdjust comarison property of a report element.
            * @param   {Object} reportElementConfig The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {boolean}
            * @private
            */ }, { key: 'hasSlidingWindowWeekdayAdjust_', value: function hasSlidingWindowWeekdayAdjust_(reportElementConfig) {
               return Boolean(_.get(reportElementConfig, 'comparison.slidingWindowWeekdayAdjust'));
          } /**
            * Returns the timeShiftBy to be set in a Sparkline or KPI when period comparison is set.
            * @param   {Object} config The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @param   {Object} mainFilter The time filter to be applied to the query of the analysis described by config.
            * @returns {Promise}
            * @private
            */ }, { key: 'getPeriodTimeShift_', value: function getPeriodTimeShift_(config, mainFilter) {
               var _this = this;var comparisonFilter = this.getComparisonTimeFilter(config);var promises = _.map([mainFilter, comparisonFilter], function (filter) {
                    return _this.dateService.resolveTimeRangeByFilter(filter);
               });return this.$q.all(promises).then(function (resolvedFilters) {
                    var _timeShiftService; // The list of the resolved times_internal_day filter objects.
                    var filters = _.map(resolvedFilters, 'filter');var timeShiftBy = (_timeShiftService = _this.timeShiftService).getFilterTimeShift.apply(_timeShiftService, _toConsumableArray(filters));if (_.isNaN(timeShiftBy)) {
                         return _this.$q.reject(new Error('Failed to calculate timeShiftBy for ' + (JSON.stringify(mainFilter) + ' and ' + JSON.stringify(comparisonFilter) + '. Value for timeShiftBy is NaN.')));
                    }return _this.$q.resolve(timeShiftBy);
               }).catch(function (error) {
                    return _this.$q.reject(error || new Error('Failed to calculate timeShiftBy for ' + (JSON.stringify(mainFilter) + ' and ' + JSON.stringify(comparisonFilter) + '. Filters could not be resolved.')));
               });
          } /**
            * Returns the offset to be set in a Sparkline or KPI when PRECEDING in sliding window comparison is set.
            * @param  {Object} config The report element configuration object
            * @param  {Object} filter The resolved main time filter object
            * @returns {number|NaN}
            * @private
            */ }, { key: 'getPrecedingOffset_', value: function getPrecedingOffset_(config, timeFilter) {
               var _this2 = this;return this.dateService.resolveTimeRangeByFilter(timeFilter).then(function (_ref) {
                    var weekdayOffset = _ref.weekdayOffset,
                        numberOfDays = _ref.numberOfDays; // If weekday adjustment is set, consider the weekdayOffset as the timeShiftBy
                    return Math.abs(_this2.hasSlidingWindowWeekdayAdjust_(config) ? weekdayOffset : numberOfDays);
               });
          } /**
            * Returns the offset of the comparison filter for a report element with sliding window comparison configuration.
            * @param   {Object} config The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @param   {Object} timeFilter The time filter object applied to an analysis.
            * @returns {Promise}
            */ }, { key: 'getSlidingWindowOffset', value: function getSlidingWindowOffset(config, timeFilter) {
               var _this3 = this;var slidingWindowTimeShift = this.getComparisonSlidingWindowTimeShift_(config);if (this.Comparison.isPreceding(slidingWindowTimeShift)) {
                    return this.getPrecedingOffset_(config, timeFilter);
               }var offsetUnit = _.get(this.Comparison.SLIDING_WINDOW_TIME_SHIFTS_TO_MOMENT, '' + slidingWindowTimeShift);return this.dateService.resolveTimeRangeByFilter(timeFilter).then(function (_ref2) {
                    var filter = _ref2.filter;var hasWeekdayAdjust = _this3.hasSlidingWindowWeekdayAdjust_(config);return _this3.dateService.getTimeFilterOffsetByUnit(filter, offsetUnit, hasWeekdayAdjust);
               });
          } /**
            * Returns the timeShiftBy value for sliding window comparison configuration, which is the nagtive offset, since its refering to the past.
            * @param   {Object} config The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @param   {Object} timeFilter The time filter object applied to an analysis.
            * @returns {Promise}
            */ }, { key: 'getSlidingWindowTimeShift_', value: function getSlidingWindowTimeShift_(config, timeFilter) {
               return this.getSlidingWindowOffset(config, timeFilter).then(function (timeShiftBy) {
                    return timeShiftBy * -1;
               });
          } /**
            * Updates the timeShiftBy property of comparison object of an element with respect to the weekday adjustment setting.
            * @param {Object} config The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @param {Object} timeFilter The time filter object applied to an analysis.
            * @param {Promise}
            */ }, { key: 'updateComparisonTimeShiftBy', value: function updateComparisonTimeShiftBy(config, timeFilter) {
               if (!this.hasComparison(config)) {
                    return this.$q.reject(new Error('Failed to set timeShiftBy. Analysis has no comparison.'));
               }if (this.isPeriod(config)) {
                    return this.getPeriodTimeShift_(config, timeFilter).then(function (timeShiftBy) {
                         _.set(config, 'comparison.timeShiftBy', timeShiftBy);return config;
                    });
               }if (this.isSlidingWindow(config)) {
                    return this.getSlidingWindowTimeShift_(config, timeFilter).then(function (timeShiftBy) {
                         _.set(config, 'comparison.timeShiftBy', timeShiftBy);return config;
                    });
               }return this.$q.reject(new Error('Failed to set timeShiftBy. Analysis has no valid comparison type.'));
          } /**
            * Will handle the time filter for a comparison metric (only applicable to KPIs and Sparklines). Will actually inject the time filter
            * ONLY if the metric has NO predefined time filter in it's configuration.
            * @todo: We could treat this in a more elegant way for sure. Most likely by dumping entirely time filters from custom formulas when using them in reports? Needs
            * clarification with POs and QAs.
            * Addendum: Adjust ReportElementQuery#getQueryComparisonTimeFilters if changes in current handling of custom formulas with time are made
            * @param {Object} iMetric The metric configuration object as defined for the report generation requests (https://wiki.webtrekk.com/display/WS/ReportGeneration+Service#ReportGenerationService-QueryMetric)
            * @param {Object} iFilter A regular filter object (https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-Filter)
            */ }, { key: 'comparisonTimeFilters', value: function comparisonTimeFilters(iMetric, iFilter) {
               if (!iMetric || !iMetric.value || !iFilter) {
                    return;
               }iMetric.value.timeShiftUnit = 'DAY';if (_.isArray(iMetric.value.filters) && !this.Filters.find(iFilter, iMetric.value.filters)) {
                    this.Filters.deleteTimes(iMetric.value.filters);iMetric.value.filters.unshift(iFilter);
               }
          } /**
            * Will determine if it's a real time element based on its configuration
            * @param   {Object} reportElementConfig - The report element configuration object (see https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures)
            * @returns {boolean}
            */ }, { key: 'isRealTime', value: function isRealTime(reportElementConfig) {
               return this.Monads.isRealTimeConfig(reportElementConfig);
          } }]);return ReportElementUtils;
}();

},{}],42:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
} /**
  * @ngdoc service
  * @name Reports
  * @description Stateless (wannabe) service that provides utility methods of deriving data from a report configuration
  */var Reports = function () {
     /*@ngInject*/
     Reports.$inject = ['QueryTemplates', 'Filters', 'filterUtils', 'Analyses', 'Columns', 'utils', 'DSCONST', 'QueryLimits', 'segmentService', 'ConfigPeriodElement', 'CustomFormulas', 'Monads', 'reportElementUtils', 'viewModeComparison'];function Reports(QueryTemplates, Filters, filterUtils, Analyses, Columns, utils, DSCONST, QueryLimits, segmentService, ConfigPeriodElement, CustomFormulas, Monads, reportElementUtils, viewModeComparison) {
          _classCallCheck(this, Reports);this.QueryTemplates = QueryTemplates;this.Filters = Filters;this.filterUtils = filterUtils;this.Analyses = Analyses;this.Columns = Columns;this.utils = utils;this.DSCONST = DSCONST;this.QueryLimits = QueryLimits;this.segmentService = segmentService;this.ConfigPeriodElement = ConfigPeriodElement;this.CustomFormulas = CustomFormulas;this.Monads = Monads;this.reportElementUtils = reportElementUtils;this.viewModeComparison = viewModeComparison;
     } /**
       * Returns the default list of report elements to query for
       * @returns {Array<string>}
       */_createClass(Reports, [{ key: 'getElementTime', /**
                                                         * Will return a custom time filter for report elements; null otherwise.
                                                         * @param   {Object} config - Report element config
                                                         * @returns {Object|null}
                                                         * @private
                                                         */value: function getElementTime(config) {
               var type = _.get(config, 'type');if (_.includes(this.CONFIG_PERIOD_ELEMENTS, type)) {
                    var configJson = _.chain(config).get('configJson').cloneDeep().value(); // Avoiding another dependency injection for now as Sparklines and KPIs are default RAW_DATA layer,
                    // hence explictly setting layer to null so as to fallback to RAW_DATA
                    return this.ConfigPeriodElement.initPeriod(configJson).getConfigTimeFilter(configJson, null, true);
               }var predefinedFilters = _.get(config, 'configJson.predefinedContainer.filters', []);return this.Filters.hasTimeFilter(predefinedFilters) || null;
          } /**
            * Will determine if an analysis element's calculation is to be added to the list of calculations of a report
            * request
            * @param   {Object}  analysisElement
            * @param   {boolean} excludeTimeAnalyses
            * @returns {boolean}
            */ }, { key: 'canIncludeCalculation_', value: function canIncludeCalculation_(analysisElement) {
               var excludeTimeAnalyses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;if (!excludeTimeAnalyses) {
                    return true;
               }var viewMode = _.get(analysisElement, 'configJson.viewMode');if (this.viewModeComparison.isTimeBasedComparison(viewMode)) {
                    return false;
               }return !this.getElementTime(analysisElement);
          } /**
            * Will iterate over a report element configurations, prepare config objects to construct report generation queries and return the collected
            * request configuration objects (analysisRequests) plus the main request object for the complete report request (reportRequest).
            * @param  {Object} report                    https://wiki.webtrekk.com/display/WS/Report+Service+API+Data+Structures#ReportServiceAPIDataStructures-Report
            * @param  {Object} defaultTimeRange          Optional object - can be a time filter to be applied when report element has no time filter set or an object with timeStart and timeStop properties
            * @param  {Object} iOptions                  Optional additional options {skipSpinners: {Boolean}, singleResultRunningJob: {Boolean}, reportElementTypesToRequest: {Array<string>}, setSamplingFactor: {*}, excludeTimeAnalyses: {Boolean}}
            * @todo Are these options the ones received from the query builder service? FE and BE calls to this method have inconsistent options
            * @param  {Array<string>} possibleCalculationLayers List of calculation layers to set for the complete report request
            * @returns {Object}                           {analysisRequests: {Array<Object>} // query building options for each report element, reportRequest: {Object} // complete request body for report request}
            */ }, { key: 'prepareReportForQuery', value: function prepareReportForQuery(report, defaultTimeRange, iOptions, possibleCalculationLayers) {
               var _this = this;var options = _.isPlainObject(iOptions) ? iOptions : {}; // Options that are not to be included in the query - are passed only to construct it
               var omitOptions = ['endpointConfigKey', 'endpointConfigPlaceholders', 'setSamplingFactor'];var analysisSettings = {};var reportRequest = this.QueryTemplates.request(possibleCalculationLayers);var skipSpinners = _.get(options, 'skipSpinners');var analysisRequestConfigs = []; // Report requests are not single run jobs
               reportRequest.singleResultRunningJob = _.has(options, 'singleResultRunningJob') ? options.singleResultRunningJob : false;var reportElementTypesToRequest = _.get(options, 'reportElementTypesToRequest', this.REPORT_ELEMENTS_TO_REQUEST);_.chain(report).get('reportElements', []).filter(function (reportElement) {
                    var type = _.get(reportElement, 'type');return _.includes(reportElementTypesToRequest, type);
               }).orderBy([function (e) {
                    return _.get(e, 'positionAsPoint.y', 0);
               }, function (e) {
                    return _.get(e, 'positionAsPoint.x', 0);
               }], ['asc', 'asc']).forEach(function (analysisElement) {
                    var analysisRequestConfig = {};var predefinedContainer = _.get(analysisElement, 'configJson.predefinedContainer');if (_.has(analysisElement, 'configJson.columns')) {
                         analysisElement.configJson.columns = _this.Columns.getAnalysisConfigurationColumnsWithAliases(analysisElement.configJson.columns);
                    }analysisRequestConfig.initialLimitFilter = _this.QueryLimits.getLimitsByConfig(analysisElement.configJson);var newTimeFilter = _this.getElementTime(analysisElement);var addAnalyses = _this.canIncludeCalculation_(analysisElement, _.get(options, 'excludeTimeAnalyses')); // Analyses without time filter are always calculated
                    if (!newTimeFilter) {
                         if (report.timeFilter) {
                              newTimeFilter = report.timeFilter;
                         } else if (_this.Filters.isTime(defaultTimeRange)) {
                              newTimeFilter = _.cloneDeep(defaultTimeRange);
                         } else {
                              newTimeFilter = _this.Filters.time();newTimeFilter.value1 = defaultTimeRange.timeStart;newTimeFilter.value2 = defaultTimeRange.timeStop;
                         }
                    }var timeLessFilterSet = _.get(_this.filterUtils.omitTimeFilters(predefinedContainer), 'filters', []);var filterSet = [newTimeFilter].concat(timeLessFilterSet);if (addAnalyses) {
                         _this.utils.deepExtend(analysisRequestConfig.initialLimitFilter, { filters: filterSet });analysisSettings = options && options.setSamplingFactor ? { samplingFactor: _this.Analyses.getSamplingFactor(analysisElement, true) } : {};if (skipSpinners) {
                              analysisSettings.skipSpinners = skipSpinners;
                         } // Specify explicit calculationLayers to be set inside the query of a report element
                         var explicitCalculationLayers = _.get(analysisElement, 'calculationLayers');if (_.isArray(explicitCalculationLayers) && !_.isEmpty(explicitCalculationLayers)) {
                              analysisSettings.possibleCalculationLayers = explicitCalculationLayers;
                         }var isPageDetailAnalysis = analysisElement.reportId === 'page_detail';var analysisId = analysisElement.id;analysisRequestConfig.analysisIdentifier = isPageDetailAnalysis ? analysisId : 'report__analysis__' + analysisId;analysisRequestConfig.requestOptions = _.merge({ analysisConfig: analysisElement, multiple: true, messageSuffix: analysisRequestConfig.analysisIdentifier }, analysisSettings, _.omit(options, omitOptions)); // Merged the incoming query builder service options so these are available when building each analysis
                         analysisRequestConfigs.push(analysisRequestConfig);
                    }
               }).value();return { analysisRequests: analysisRequestConfigs, reportRequest: reportRequest };
          } /**
            * Computes a map of filters and containers based on a report dashboardQuickFilters
            * @param {Object} report A report configuration
            * @returns {{filters: Array, containers: Array}}
            */ }, { key: 'getQuickFilters', value: function getQuickFilters(report) {
               var _this2 = this;var dashboardQuickFilters = _.cloneDeep(report.dashboardQuickFilters);var quickFilters = { filters: [], containers: [] };if (!_.has(report, 'dashboardQuickFilters') || !_.isArray(report.dashboardQuickFilters)) {
                    return quickFilters;
               }var segmentContainers = _.chain(dashboardQuickFilters).remove(function (filterObject) {
                    return _.get(filterObject, 'arrangeType') === _this2.segmentService.getFakeSegmentArrangeType();
               }).map(function (segmentFilter) {
                    _.set(segmentFilter, 'context', _this2.segmentService.SEGMENT_DEFAULT_CONTEXT);var connector = _this2.segmentService.getSegmentConnectorFromFilter(segmentFilter);return _this2.segmentService.getSegmentConnectorAsContainer(connector);
               }).valueOf();quickFilters.filters = quickFilters.filters.concat(dashboardQuickFilters);quickFilters.containers = quickFilters.containers.concat(segmentContainers);this.filterUtils.cleanEmptyFilters(quickFilters.filters);this.filterUtils.cleanEmptyContainers(quickFilters.containers);return quickFilters;
          } /**
            * Retrieves an union of filters used in the metric that a KPI or Sparkline report element is based on. Resolves deep the underlying metric when it is a formula.
            * @param {Object} reportElement The report element configuration
            * @returns {Array}
            */ }, { key: 'getKpiSparklineMetricFilters', value: function getKpiSparklineMetricFilters(reportElement) {
               if (!this.reportElementUtils.isAnySparklineOrAnyKPI(reportElement)) {
                    return [];
               }return this.CustomFormulas.getCustomFigureFilters(this.Analyses.getKpiSparklineMetric(reportElement));
          } /**
            * Retrieves all custom figures metric|formula from a report configuration.
            * Does not perform the lookup into filters and segments as these can not be based on custom elements.
            * @param {Object} report The report configuration
            * @param {boolean=} ownCustomMonadsOnly Retrieve only the custom monads that are used directly in the report configuration,
            * do not resolve the references to other custom monads
            * @returns {Array}
            * TODO Refactor using the traverse mechanism
            */ }, { key: 'getReportCustomFigureMonads', value: function getReportCustomFigureMonads(report) {
               var _this3 = this;var ownCustomMonadsOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var inheritedCustomMonads = [];var reportElements = _.get(report, 'reportElements', []);var ownCustomMonads = _.reduce(reportElements, function (figures, reportElement) {
                    return figures.concat(_this3.getReportElementCustomFiguresMonads(reportElement));
               }, []);if (!ownCustomMonadsOnly) {
                    inheritedCustomMonads = _.reduce(ownCustomMonads, function (acc, figure) {
                         if (!_this3.Monads.isMonadCustomFormula(figure)) {
                              return acc;
                         }return acc.concat(_this3.CustomFormulas.getFormulaCustomMonads(figure));
                    }, []);
               }return _.uniqBy(ownCustomMonads.concat(inheritedCustomMonads), 'arrangeType');
          } /**
            * Retrieves the custom figures used in a report element
            * @param {Object} reportElement The report element to extract the custom figures from
            * @returns {Array}
            */ }, { key: 'getReportElementCustomFiguresMonads', value: function getReportElementCustomFiguresMonads(reportElement) {
               if (this.reportElementUtils.isAnySparklineOrAnyKPI(reportElement)) {
                    return this.getKpiSparklineCustomFiguresMonads(reportElement);
               }if (this.reportElementUtils.isAnalysis(reportElement)) {
                    return this.getAnalysisCustomFiguresMonads(reportElement);
               }return [];
          } /**
            * Retrieves the custom figures used in a report element of type KPI or Sparkline
            * @param {Object} reportElement The report element to extract the custom figures from
            * @returns {Array}
            */ }, { key: 'getKpiSparklineCustomFiguresMonads', value: function getKpiSparklineCustomFiguresMonads(reportElement) {
               var kpiSparklineMetric = this.Analyses.getKpiSparklineMetric(reportElement);var figures = [];if (this.Monads.isMonadCustomFigure(kpiSparklineMetric)) {
                    figures.push(kpiSparklineMetric);
               }return figures;
          } /**
            * Retrieves the custom figures used in a report element of type analysis
            * @param {Object} reportElement The report element to extract the custom figures from
            * @returns {Array}
            */ }, { key: 'getAnalysisCustomFiguresMonads', value: function getAnalysisCustomFiguresMonads(reportElement) {
               var analysisConfig = _.get(reportElement, 'configJson');return this.Analyses.getAnalysisCustomFigureMonads(analysisConfig);
          } }, { key: 'REPORT_ELEMENTS_TO_REQUEST', get: function get() {
               return ['ANALYSIS', 'ANALYSIS_LIVE', 'KPI', 'KPI_LIVE', 'SPARKLINE', 'SPARKLINE_LIVE'];
          } /**
            * Report element types that could potentially go beyond simple report filters and
            * inherit - apart from report time filter or the explictly set 'alternative' time filter -
            * a time filter from the depths of the - custom - metric configuration.
            * @returns {Array<string>}
            */ }, { key: 'CONFIG_PERIOD_ELEMENTS', get: function get() {
               return ['SPARKLINE', 'KPI'];
          } }]);return Reports;
}();module.exports = Reports;

},{}],43:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     Request.$inject = ['$q', 'DSCONST', 'Analyses', 'Reports', 'QueryTemplates', 'Columns', 'Filters', 'filterUtils', 'Monads', 'QueryLimits', 'segmentService', 'SamplingFactor', 'accountService', 'arrangeTypeUtils', 'logicalCubeUtils', 'ViewMode', 'ReportElementQuery', 'QueryMetrics', 'LanguageSettings', 'CalculationLayer', 'ProposalId', 'CustomFormulas', 'TimesDynamic', 'UserPreferenceThreshold', 'HashGen', 'AccountContainer', 'ReportContainer', 'campaignsAttributionService', 'historizedCacheService', 'queryUtilityService'];function Request($q, DSCONST, Analyses, Reports, QueryTemplates, Columns, Filters, filterUtils, Monads, QueryLimits, segmentService, SamplingFactor, accountService, arrangeTypeUtils, logicalCubeUtils, ViewMode, ReportElementQuery, QueryMetrics, LanguageSettings, CalculationLayer, ProposalId, CustomFormulas, TimesDynamic, UserPreferenceThreshold, HashGen, AccountContainer, ReportContainer, campaignsAttributionService, historizedCacheService, queryUtilityService) {
          _classCallCheck(this, Request);this.$q = $q;this.DSCONST = DSCONST;this.accountService = accountService;this.Analyses = Analyses;this.Reports = Reports;this.QueryTemplates = QueryTemplates;this.Columns = Columns;this.Filters = Filters;this.filterUtils = filterUtils;this.Monads = Monads;this.QueryLimits = QueryLimits;this.segmentService = segmentService;this.SamplingFactor = SamplingFactor;this.arrangeTypeUtils = arrangeTypeUtils;this.logicalCubeUtils = logicalCubeUtils;this.ViewMode = ViewMode;this.ReportElementQuery = ReportElementQuery;this.QueryMetrics = QueryMetrics;this.LanguageSettings = LanguageSettings;this.CalculationLayer = CalculationLayer;this.ProposalId = ProposalId;this.CustomFormulas = CustomFormulas;this.TimesDynamic = TimesDynamic;this.UserPreferenceThreshold = UserPreferenceThreshold;this.HashGen = HashGen;this.AccountContainer = AccountContainer;this.ReportContainer = ReportContainer;this.campaignsAttributionService = campaignsAttributionService;this.historizedCacheService = historizedCacheService;this.queryUtilityService = queryUtilityService;
     } /**
       * Replaces all times_dynamic value1 values with their coreName equivalent on a query, inluding:
       * 1. filters
       * 2. containers
       * 3. metric filters
       * 4. metric containers
       * 5. metric parameters
       * @param  {Object} query An calculation object
       * @private
       */_createClass(Request, [{ key: 'setCoreName', value: function setCoreName(query) {
               var _this = this;var queryFilters = this.filterUtils.getQueryFilters(query);_.forEach(queryFilters, function (filter) {
                    return _this.TimesDynamic.setCoreName(filter);
               });
          } /**
            * Replaces all dynamic time filters of a query with their resolved equivalent.
            * @param  {Object} query An calculation object
            * @returns {Request}
            * @chainable
            * @private
            */ }, { key: 'resolveDynamicTimeFilters', value: function resolveDynamicTimeFilters(query) {
               var _this2 = this;var queryFilters = this.filterUtils.getQueryFilters(query);_.forEach(queryFilters, function (filter) {
                    return _this2.TimesDynamic.setResolvedFilter(filter);
               });return this;
          } /**
            * Mutates a query, injecting a lastUpdate property - with transformers lastUpdate value - on queries that contain time filters that
            * include today. Aims at generating different cacheIds when stringifying the query.
            * @param   {Object} query An calculation object
            * @returns {Request}
            * @chainable
            * @private
            */ }, { key: 'injectLastUpdates', value: function injectLastUpdates(query) {
               // Add the latest transformer updates.
               var lastUpdate = this.queryUtilityService.getLastUpdate(query);if (lastUpdate !== null) {
                    _.merge(query, { lastUpdate: lastUpdate });
               } // Add the latest resultCacheReset updates.
               var resultCacheResetUpdate = this.queryUtilityService.getResultCacheResetUpdate();if (resultCacheResetUpdate !== null) {
                    _.merge(query, { resultCacheResetUpdate: resultCacheResetUpdate });
               } // Add the latest updates based on the arrangeTypes of the query.
               var arrangeTypeUpdates = this.queryUtilityService.getArrangeTypeUpdates(query);_.forEach(arrangeTypeUpdates, function (_ref) {
                    var typeId = _ref.typeId,
                        updateType = _ref.updateType,
                        updateTime = _ref.updateTime;_.set(query, _.camelCase('' + updateType + typeId), updateTime);
               });return this;
          } /**
            * Mutates queries after they have been constructed. Will apply to queries either these additional manipulations:
            * 1. Inject the custom formula configuration/metric for every custom formula/metric found in a query
            * 2. Replace arrangeTypes of custom metrics with their respective 'base' arrangeType
            * 3. Inject additional and necessary filters to containers of type 'USER_PREFERENCE'
            * 4. Deep replace dynamic time filters with their resolved static time filter - for RAW DATA queries only.
            * 2. Deep replace dynamic time filter ids with their respective coreNames
            * @param  {Object} query - Calculation hash of an RGS query
            * @private
            */ }, { key: 'mutateStructure_', value: function mutateStructure_(query) {
               this.CustomFormulas.injectCustomFormulaConfig(query);this.CustomFormulas.injectBaseArrangeTypes(query);this.UserPreferenceThreshold.injectBaseFactRules(query);if (!this.Monads.isRealTimeQuery(query)) {
                    this.resolveDynamicTimeFilters(query);
               }this.setCoreName(query);
          } /**
            * Mutates a given query by injecting additional meta properties to it.
            * @param  {Object} query - Calculation hash of an RGS query
            * @param  {Object} options - Misc options hash
            * @private
            */ }, { key: 'injectMetaProperties_', value: function injectMetaProperties_(query, options) {
               this.ProposalId.injectProposalId(query, options);if (!this.Monads.isRealTimeQuery(query)) {
                    this.injectLastUpdates(query);
               }this.HashGen.injectCacheId(query, options);
          } /**
            * Constructs the list of dimensions for a request
            * @param  {Array<Object>} iColumns         List of column objects
            * @param  {Object} iArrangeTypeIndexes     HashMap of arrangeTypes and list of indexes
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'dimensionColumns_', value: function dimensionColumns_(iColumns, iArrangeTypeIndexes) {
               var _this3 = this;var dimensions = [];var keepAliases = this.Columns.hasHealthyAliases(iColumns);_.chain(iColumns).filter(function (column) {
                    return column.columnType === 'dimension';
               }).forEach(function (dimensionColumn) {
                    var dimension = _this3.QueryTemplates.dimension();dimension.arrangeType = dimensionColumn.arrangeType; // get the first number in the index for this arrange type
                    var temporaryIndex = _.first(iArrangeTypeIndexes[dimensionColumn.arrangeType]); // Now remove it from the array
                    _.remove(iArrangeTypeIndexes[dimensionColumn.arrangeType], function (e) {
                         return e === temporaryIndex;
                    });dimension.alias = keepAliases ? dimensionColumn.alias : _this3.Columns.alias(dimensionColumn.arrangeType, temporaryIndex);dimensions.push(dimension);
               }).value();return dimensions;
          } /**
            * Prepare the dimensions and metrics out of columns to request data for
            * @param   {Object} iColumns
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {Object}
            * @private
            */ }, { key: 'monadColumns_', value: function monadColumns_(iColumns, layer) {
               var monads = { dimensions: [], metrics: [] };if (_.isUndefined(iColumns.filteredColumns) || _.isUndefined(iColumns.arrangeTypeColumnIndex)) {
                    return monads;
               }var arrangeTypeColumnIndex = _.cloneDeep(iColumns.arrangeTypeColumnIndex);var filteredColumns = this.Columns.usableComplete(iColumns.filteredColumns, layer);monads.metrics = this.QueryMetrics.initMetrics(filteredColumns, arrangeTypeColumnIndex);monads.dimensions = this.dimensionColumns_(filteredColumns, arrangeTypeColumnIndex);return monads;
          } /**
            * Will set the orderColumns of the passed 'settings' object, based on externally set options or the existing query or config
            * @param {Object} config - The analysis configuration object
            * @param {Object} settings - An slimmed down report generation query object also containing list of orderColumns
            * @param {Object} query - The report generation query object as build based on analysis so far
            * @private
            */ }, { key: 'setOrderColumns_', value: function setOrderColumns_(config, settings, query) {
               // If the orderColumns are already set in the settings, there's nothing to do
               if (!_.chain(settings).get('orderColumns').isEmpty().value()) {
                    return;
               } // If the orderColumns are already set in the query update the settings and move on
               if (_.chain(query).get('orderColumns').size().value() > 0) {
                    _.set(settings, 'orderColumns', query.orderColumns);return;
               } // Get a clone of the columns with aliases - if the columns have set aliases nothing will be changed on the column list clone
               var aliasedColumns = this.Columns.getAnalysisConfigurationColumnsWithAliases(config.columns); // Fetch the first column that has the 'sortDirection' property set
               var sortingColumn = this.Columns.sorting(aliasedColumns); // If no sorting column is detected, there's nothing to do. The core will define by which column to sort. See also
               // method sorting in Columns class.
               if (!sortingColumn) {
                    return;
               }var layer = this.Monads.getConfigLayer(config); // Get an order column object...
               var orderColumn = this.QueryTemplates.orderColumn(this.Columns.variant(aliasedColumns, layer)); // ...and set the columnAlias && direction based on the sorting column
               _.chain(orderColumn).set('columnAlias', sortingColumn.alias).set('direction', sortingColumn.sortDirection).value();settings.orderColumns.push(orderColumn);
          } }, { key: 'settings', value: function settings(iConfig, iSettings, iQuery, iOptions) {
               var settings = _.assign({ filters: [], containers: [], orderColumns: [], upperLimits: [], lowerLimits: [] }, iSettings || {});this.setOrderColumns_(iConfig, settings, iQuery);if (!iOptions.skipTimeFilter && iOptions.timeFilter && _.isEmpty(settings.filters)) {
                    settings.filters.push(iOptions.timeFilter);
               }return settings;
          } /**
            * Builds a query for mainserver based on an analysis configuration
            * @param {Object} iConfig
            * @param {Object} iOptions Options passed via the query builder service
            * @param {string} iAnalysisId
            * @param {Object} iSettings
            * @param {Object} iQuery
            * @param {string} iCalculationId
            * @param {string} isReportAnalysis Identifies if the analysis is part of a report
            * @returns {Promise}
            */ }, { key: 'buildAnalysis', value: function buildAnalysis(iConfig, iOptions, iAnalysisId, iSettings, iQuery, iCalculationId) {
               var _this4 = this;var isReportAnalysis = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;var deferred = this.$q.defer();var settings = iSettings || {};var query = iQuery || {};var options = iOptions || {};var calculationId = iCalculationId || 0;var analysis = this.Analyses.prepareAnalysisForQuery(iConfig, options);var analysisId = iAnalysisId || analysis.id;this.Analyses.timeResolveAsync(analysis).then(function () {
                    _this4.Analyses.setTimeShiftBy(analysis, settings).then(function (iAnalysis) {
                         _this4.query(analysisId, iAnalysis, settings, query, options, calculationId);_this4.adjust(analysisId, iAnalysis, settings, query, options);var resultType = _.get(iOptions, 'resultType'); // The requests for file exports should allow enforcing the limits overrides even for time based analyses except repotr analyses
                         var discardTime = !isReportAnalysis && _.includes(['EXCEL_XLS', 'EXCEL_XLSX', 'CSV'], resultType); // Reinforce limits if requested in the options
                         query = _this4.QueryLimits.forceAnalysisLimits(query, _.pick(iOptions, ['upperLimits', 'lowerLimits', 'resultType']), discardTime);deferred.resolve(query);
                    }).catch(function (reason) {
                         return deferred.reject(reason);
                    });
               }).catch(function () {
                    return deferred.reject('Failed to resolve time filters.');
               });return deferred.promise;
          } /**
            * Build a query for mainserver based on a report configuration
            * @param {Object} iConfig
            * @param {Object} iOptions Options passed via the query builder service
            * @returns {Promise}
            */ }, { key: 'buildReport', value: function buildReport(iConfig, iOptions) {
               var _this5 = this;var deferred = this.$q.defer();var options = iOptions || {};var possibleCalculationLayers_ = _.get(options, 'possibleCalculationLayers', this.accountService.getPossibleCalculationLayers());var defaultTimeRange_ = _.get(options, 'timeFilter', this.Filters.timeDefault());var report = this.Reports.prepareReportForQuery(iConfig, defaultTimeRange_, options, possibleCalculationLayers_);var calculationId = 0;var queryPromises_ = _.map(report.analysisRequests, function (analysisReq) {
                    return _this5.buildAnalysis(null, analysisReq.requestOptions, analysisReq.analysisIdentifier, analysisReq.initialLimitFilter, null, calculationId++, true);
               });this.$q.all(queryPromises_).then(function (calculations) {
                    // Converted and 'cleaned' dashboardQuickFilters
                    var quickFilters = _this5.Reports.getQuickFilters(iConfig);var dashboardQuickFilters = _.get(iConfig, 'dashboardQuickFilters', []);report.reportRequest.calculations = _.map(calculations, function (iCalculation) {
                         // BE-377700: Discard time dimensions when it's a pivot as list
                         var discardTime = _this5.queryUtilityService.isPivotAsList(iCalculation); // Reinforce limits for every element if requested in the options
                         var calculation = _this5.QueryLimits.forceAnalysisLimits(iCalculation, _.pick(iOptions, ['upperLimits', 'lowerLimits', 'resultType']), discardTime); // Apply dashboard quick filters if saved on the report configuration to calculations where they can be applied
                         if (_this5.ReportContainer.validateQuery(calculation, dashboardQuickFilters)) {
                              calculation.containers = calculation.containers.concat(quickFilters.containers);calculation.filters = calculation.filters.concat(quickFilters.filters);
                         }return calculation;
                    });report.reportRequest.resultType = _.get(iOptions, 'resultType', report.reportRequest.resultType);report.reportRequest.language = _this5.LanguageSettings.language;deferred.resolve(report.reportRequest);
               }).catch(function (reason) {
                    return deferred.reject(reason);
               });return deferred.promise;
          } /**
            * Builds a mainserver query for an analysis, report, kpi, sparkline, etc configuration.
            * @param {Object} iConfig
            * @param {Object} iOptions Options passed via the query builder service
            * @param {string} iAnalysisId
            * @param {Object} iSettings
            * @param {Object} iQuery
            * @returns {Promise}
            */ }, { key: 'build', value: function build(iConfig, iOptions, iAnalysisId, iSettings, iQuery) {
               var _this6 = this;var deferred = this.$q.defer(); // Set the language based on the options - used only from service
               var language = _.get(iOptions, 'language');this.LanguageSettings.setLanguage(language);if (_.has(iConfig, 'reportElements')) {
                    this.buildReport(iConfig, iOptions).then(function (report) {
                         deferred.resolve(report);
                    }).catch(function (reason) {
                         return deferred.reject(reason);
                    });
               } else {
                    this.buildAnalysis(_.get(iConfig, 'configJson', iConfig), iOptions, iAnalysisId, iSettings, iQuery).then(function (query) {
                         var request_ = _this6.QueryTemplates.request(_.get(iOptions, 'possibleCalculationLayers', _this6.accountService.getPossibleCalculationLayers()));request_.calculations.push(query);request_.resultType = _.get(iOptions, 'resultType', request_.resultType);request_.language = _this6.LanguageSettings.language;deferred.resolve(request_);
                    }).catch(function (reason) {
                         return deferred.reject(reason);
                    });
               }return deferred.promise;
          } /**
            * Will build the request query based on various configurations
            * @param  {string} iAnalysisId     The analysis id
            * @param  {Object} iConfig   Complete analysis configuration
            * @param  {Object} iSettings Additional user defined settings
            * @param  {Object} iQuery    An optional existing query
            * @param  {Object} iOptions  Additional options
            * @param  {Number} iCalculationId  Sequence number of the calculation in the query
            */ }, { key: 'query', value: function query(iAnalysisId, iConfig, iSettings, iQuery, iOptions, iCalculationId) {
               var analysisId_ = iAnalysisId || iConfig.id;var columns = this.Columns.usableIncrementMap(iConfig.columns);var calculationId = Number(iCalculationId) || 0;var layer = this.Monads.getConfigLayer(iConfig);_.assign(iQuery, this.QueryTemplates.query(calculationId), this.monadColumns_(columns, layer));if (iOptions.samplingFactor) {
                    iQuery.samplingFactor = iOptions.samplingFactor;
               }_.merge(iSettings, this.settings(iConfig, iSettings, iQuery, iOptions));this.injectPredefinedContainer(iConfig, iSettings);this.injectPredefinedSegments(analysisId_, iConfig, iSettings);
          } /**
            * Sets filter rule connectors to AND where required.
            * @param   {Object} query The query object.
            * @param   {Object} config The analysis/kpi/sparkline config object.
            * @private
            */ }, { key: 'applyAndRuleToQuery', value: function applyAndRuleToQuery(query, config) {
               var _this7 = this; // Forces AND connector to filter list of analyses only
               this.Analyses.afterTime(config, query); // Forces AND connector to filter lists inside containers for analyses/kpis/sparklines
               _.chain(query).get('containers').forEach(function (container) {
                    return _this7.Filters.applyAndRuleToContainer(container);
               }).value();
          } /**
            * Adjusts a given query.
            * @param  {string} iAnalysisId     The analysis id
            * @param  {Object} iConfig         The analysis configuration
            * @param  {Object} iSettings       Optional additional settings
            * @param  {Object} iQuery          Previous query
            * @param  {Object} iOptions        Addtional options
            */ }, { key: 'adjust', value: function adjust(iAnalysisId, iConfig, iSettings, iQuery, iOptions) {
               // Determine the list of calculation layers for the query
               this.CalculationLayer.injectLayers(iQuery, iConfig); // @todo: Something very fishy is causing the existance of these lines...
               var timeFilters = this.Filters.deleteTimes(iSettings.filters);if (!_.isEmpty(timeFilters)) {
                    iSettings.filters.unshift(timeFilters[0]);
               } // Set intern property to false on ALL filter objects
               this.Filters.addIntern(iSettings);_.merge(iQuery, iSettings); // Eliminate duplicates (?!?)
               iQuery.filters = _.uniq(iQuery.filters);this.applyAndRuleToQuery(iQuery, iConfig);this.QueryMetrics.entitleMetrics(iConfig, iQuery);this.asList(iAnalysisId, iConfig, iQuery);this.videoEngagement(iAnalysisId, iQuery);var layer = this.Monads.getConfigLayer(iConfig);this.QueryMetrics.updateMetrics(iConfig, iQuery, layer);this.filterUtils.normalizeContainer(iQuery);this.propertiesByType(iConfig, iQuery); // Deals with Sparklines and KPIS
               this.ReportElementQuery.handleSparklineOrAnyKPI(iConfig, iQuery);this.footerTypes(iQuery, iConfig);this.kpiSparklineFooterTypes(iConfig, iQuery, 'UNIQUE_SUM');this.hideSubFooters(iAnalysisId, iConfig, iQuery);this.setSamplingFactor(iQuery, iOptions);this.QueryLimits.setUpperAndLowerLimits(iQuery, iConfig, iSettings); // Adjust in case of special viewMode
               this.ViewMode.adjustQuery(iConfig, iQuery); // Sets chart info in the request - useful for report analyses/sparklines only
               this.setChartProperties(iConfig, iQuery); // Sets the variant for report elements
               this.setQueryVariant(iConfig, iQuery); // Will handle metrics of live queries
               this.QueryMetrics.handleRealTimeMetrics(iConfig, iQuery); // Set analysisTitle on the entire query
               var analysisTitle = _.get(iConfig, 'title', '');_.set(iQuery, 'analysisTitle', analysisTitle);
          } /**
            * Will set the showAsList in the query based on the analysis id
            * @param  {string} iAnalysisId
            * @param  {Object} iConfig
            * @param  {Object} iQuery
            */ }, { key: 'asList', value: function asList(iAnalysisId, iConfig, iQuery) {
               if (_.includes(['media_summary', 'video_engagement'], iAnalysisId)) {
                    this.queryUtilityService.setPivotAsList(iQuery);return;
               }if (_.get(iConfig, 'variant') === 'PIVOT_AS_LIST') {
                    this.queryUtilityService.setPivotAsList(iQuery);return;
               } // Delete the properties alltogether
               this.queryUtilityService.unsetPivotAsList(iQuery);
          } /**
            * Set the videoEngagement property in the request
            * @param  {string} iAnalysisId
            * @param  {Object} iQuery
            */ }, { key: 'videoEngagement', value: function videoEngagement(iAnalysisId, iQuery) {
               if (_.includes(['video_engagement'], iAnalysisId)) {
                    iQuery.videoEngagement = true;
               }
          } /**
            * Sets additional properties to requests based on their analysis type (if defined)
            * @param  {Object} iConfig
            * @param  {Object} iQuery
            */ }, { key: 'propertiesByType', value: function propertiesByType(iConfig, iQuery) {
               if (!iConfig || !iQuery) {
                    return;
               }delete iQuery.sparklineRequest;delete iQuery.kpiRequest;if (_.includes(['KPI', 'KPI_LIVE'], iConfig.analysisType)) {
                    iQuery.kpiRequest = true;
               } else if (_.includes(['SPARKLINE', 'SPARKLINE_LIVE'], iConfig.analysisType)) {
                    iQuery.sparklineRequest = true;
               }
          } /**
            * Will add a footerTypes array to a query of a request object, by simply getting the footer types of all
            * order columns.
            * @param {Object} iQuery - The query generated so far
            * @param {Object} iConfig - The configuration of the analysis that is to be constructed
            */ }, { key: 'footerTypes', value: function footerTypes(iQuery, iConfig) {
               var footerTypes = void 0;var footerTypeValue = void 0;if (!iQuery) {
                    return;
               } // Fix for BE-373743. Setting the footer type to UNIQUE_SUM for pivots.
               // Should not be the case when we have a pivot as list, which is not yet implemented.
               if (iQuery.dimensions) {
                    footerTypeValue = iQuery.dimensions.length > 1 && _.get(iConfig, 'variant') !== 'PIVOT_AS_LIST' ? 'UNIQUE_SUM' : 'SUM'; // Set the footerType for the complete iQuery
                    iQuery.footerTypes = [footerTypeValue]; // Set the footerType for the orderColumns as well
                    _.forEach(iQuery.orderColumns, function (col) {
                         col.footerType = footerTypeValue;
                    });
               } else if (iQuery.orderColumns) {
                    footerTypes = _.uniq(_.map(iQuery.orderColumns, 'footerType'));if (!_.isEmpty(footerTypes)) {
                         iQuery.footerTypes = footerTypes;
                    }
               } else {
                    // If no orderColumns exist set the footerTypes to ['SUM']
                    iQuery.footerTypes = ['SUM'];
               }
          } /**
            * Set all footerType properties to the given type.
            * @param {Object} iConfig
            * @param {Object} iQuery
            * @param {string} type
            */ }, { key: 'kpiSparklineFooterTypes', value: function kpiSparklineFooterTypes(iConfig, iQuery, type) {
               if (!_.get(iConfig, 'comparison.type') || !iQuery || !_.includes(['KPI', 'KPI_LIVE', 'SPARKLINE', 'SPARKLINE_LIVE'], _.get(iConfig, 'analysisType'))) {
                    return;
               }_.chain(iQuery).get('footerTypes').forEach(function (footerType, index, footerTypes) {
                    _.set(footerTypes, '' + index, type);
               }).value();_.chain(iQuery).get('orderColumns').forEach(function (orderColumn) {
                    _.set(orderColumn, 'footerType', type);
               }).value();
          } /**
            * Adjust Video Engagement Request
            * @param {object} iQuery This object is the representaion of a single calculation of a request payload.
            */ }, { key: 'adjustVideoEngagement', value: function adjustVideoEngagement(iQuery) {
               var timeFilters = [];var mediaActionFilters = [];var filters = iQuery.filters;var orderColumns = iQuery.orderColumns;if (!iQuery.videoEngagement) {
                    return;
               }if (_.findIndex(filters, { arrangeType: 'media_actions' }) === -1) {
                    filters.push({ caseSensitive: true, context: 'NONE', arrangeType: 'media_actions', filterPredicate: 'LIKE', connector: 'AND', intern: false, value1: 'play' });
               } else {
                    // Rip the time filters first
                    timeFilters = this.Filters.deleteTimes(filters); // Rip the media actions next
                    mediaActionFilters = _.remove(filters, { arrangeType: 'media_actions' }); // Reassign the proper array: 1st time filters, 2nd media_actions then the rest
                    iQuery.filters = timeFilters.concat(mediaActionFilters, filters);
               }if (!_.isEmpty(orderColumns)) {
                    orderColumns[0].columnAlias = this.Columns.alias('media_independent', 0);
               }
          } /**
            * @todo This should be configurable in analysis config, at the moment it is only needed for one analysis
            * @param {string} iAnalysisId The analysis id
            * @param  {Object} iConfig The analysis configuration
            * @param {Object} iQuery the query constructed so far for a given analysis
            */ }, { key: 'hideSubFooters', value: function hideSubFooters(iAnalysisId, iConfig, iQuery) {
               if (_.includes(['media_summary'], iAnalysisId)) {
                    iQuery.hideSubFooters = true;iQuery.footerTypes = [];return;
               }if (_.get(iConfig, 'variant') === 'PIVOT_AS_LIST') {
                    iQuery.hideSubFooters = true;iQuery.footerTypes = [];return;
               }iQuery.hideSubFooters = false;
          } /**
            * Will inject predefined filters and containers from an analysis config to the settings - the requested query adjustments
            * @param  {Object} iConfig   The analysis configuration object
            * @param  {Object} iSettings Additional query configurations for an analysis query
            */ }, { key: 'injectPredefinedContainer', value: function injectPredefinedContainer(iConfig, iSettings) {
               var exludeFiltersProps = ['intern', 'position', 'numberOfDays', 'combined'];if (!_.has(iConfig, 'predefinedContainer') || _.isEmpty(iConfig.predefinedContainer)) {
                    return;
               } // Work on filters
               if (!_.isEmpty(iConfig.predefinedContainer.filters)) {
                    // The time filter explicitely requested - if any
                    var timeFilter = this.Filters.deleteTimes(iSettings.filters, true);if (_.isEmpty(timeFilter)) {
                         // The time filter from the config - if any
                         var timeFilterConfig = this.Filters.hasTimeFilter(iConfig.predefinedContainer.filters, true); // Last resort the default time filter
                         timeFilter = timeFilterConfig ? [timeFilterConfig] : [this.Filters.timeDefault()];
                    }iSettings.filters = iConfig.predefinedContainer.filters.concat(iSettings.filters); // The prefered timeFilter restored on top of the list
                    iSettings.filters = timeFilter.concat(iSettings.filters); // Eliminate duplicates
                    this.filterUtils.uniqFilters(iSettings.filters, exludeFiltersProps);
               }if (!_.isEmpty(iConfig.predefinedContainer.containers)) {
                    iSettings.containers = iConfig.predefinedContainer.containers.concat(iSettings.containers); // Eliminate duplicates
                    this.filterUtils.uniqContainers(iSettings.containers, exludeFiltersProps);
               }
          } /**
            * Will convert predefined segment connectors from the analysis configuration to containers and inject them in the
            * settings object
            * @param  {string} iAnalysisId     The analysis id
            * @param  {Object} iConfig         The analysis configuration object
            * @param  {Object} iSettings       Additional query configurations for an analysis query
            */ }, { key: 'injectPredefinedSegments', value: function injectPredefinedSegments(iAnalysisId, iConfig, iSettings) {
               var _this8 = this;var exludeFiltersProps = ['intern', 'position', 'numberOfDays', 'combined'];if (!_.has(iConfig, 'predefinedSegmentConnections') || _.isEmpty(iConfig.predefinedSegmentConnections)) {
                    return;
               }var segmentList = [];_.chain(iConfig).get('predefinedSegmentConnections').filter(function (segmentConnection) {
                    var segmentID = _.get(segmentConnection, 'segmentID');var segment = _this8.segmentService.getActiveSegmentById(segmentID);return !_.isEmpty(segment);
               }).forEach(function (segmentConnector) {
                    var segmentContainer = _this8.segmentService.getSegmentConnectorAsContainer(segmentConnector);iSettings.containers.push(segmentContainer);segmentList.push({ id: String(segmentConnector.segmentID), position: segmentConnector.position || 0 });
               }).value();if (!_.isEmpty(segmentList)) {
                    this.segmentService.setSegmentsByAnalysisId(segmentList, iAnalysisId);
               } // Eliminate duplicates
               this.filterUtils.uniqContainers(iSettings.containers, exludeFiltersProps);
          } /**
            * Will set or delete the samplingFactor property from a query
            * @param {Object} iQuery
            * @param {Object} iOptions
            */ }, { key: 'setSamplingFactor', value: function setSamplingFactor(iQuery, iOptions) {
               if (!_.has(iOptions, 'samplingFactor')) {
                    return;
               }var samplingFactor = this.SamplingFactor.getSamplingFactor(iOptions.samplingFactor);if (samplingFactor) {
                    iQuery.samplingFactor = samplingFactor;
               } else {
                    delete iQuery.samplingFactor;
               }
          } /**
            * Will include chart information in the query for specific analysesTypes
            * @param  {Object} iConfig         The analysis configuration object
            * @param  {Object} iQuery          The constructed query
            */ }, { key: 'setChartProperties', value: function setChartProperties(iConfig, iQuery) {
               var analysisType = _.get(iConfig, 'analysisType');if (!_.includes(['ANALYSIS', 'SPARKLINE', 'SPARKLINE_LIVE'], analysisType)) {
                    return;
               }iQuery.chartConfig = _.merge({}, { width: _.get(iConfig, 'chartWidth', null), height: _.get(iConfig, 'chartHeight', null) }, { type: _.get(iConfig, 'standardChart', null) });
          } /**
            * Will set the analysisVariant property in queries of specific analysis type
            * @param  {Object} iConfig         The analysis configuration object
            * @param  {Object} iQuery          The constructed query
            */ }, { key: 'setQueryVariant', value: function setQueryVariant(iConfig, iQuery) {
               var analysisType = _.get(iConfig, 'analysisType');if (!_.includes(['ANALYSIS', 'SPARKLINE', 'SPARKLINE_LIVE'], analysisType)) {
                    return;
               }iQuery.analysisVariant = 'LIST';
          } /**
            * Will validate multidimensional - a.k.a. pivot - queries.
            * @param   {Object} query A calculation hash
            * @returns {Object} An object like {arrangeTypes: [], isValid: Boolean}. isValid will be set
            * to true if arrangeTypes is empty, false otherwise.
            * @private
            */ }, { key: 'validatePivotQuery_', value: function validatePivotQuery_(query) {
               var _this9 = this;var arrangeTypes = [];var isValid = true;var isMultiDimensional = _.chain(query).get('dimensions', []).size().gt(1).value();if (!isMultiDimensional) {
                    return { arrangeTypes: arrangeTypes, isValid: isValid };
               }if (this.ViewMode.isTimeSeriesQuery(query)) {
                    return { arrangeTypes: arrangeTypes, isValid: isValid };
               }var layer = this.Monads.getQueryLayer(query);arrangeTypes = _.chain(query).get('dimensions', []).filter(function (dimension) {
                    return !_this9.Monads.layer(layer).isPivotUsable(_.get(dimension, 'arrangeType'));
               }).map(function (dimension) {
                    return _.get(dimension, 'arrangeType');
               }).value();isValid = arrangeTypes.length === 0;return { arrangeTypes: arrangeTypes, isValid: isValid };
          } /**
            * Will iterate over a list of calculations - a.k.a. queries - of a report generation service request, check for arrangeTypes
            * whose configuration is not defined in the list of dimensions and metrics, check if the logical cubes of elements combined match
            * and return the actual query and a list of meta information of possible errors for every calculation, plus the configurations of
            * all involved arrangeTypes under config.
            * @param  {Object} iRequest The report generation request payload
            * @returns {Object}
            */ }, { key: 'validateRequest', value: function validateRequest(iRequest) {
               var _this10 = this;var calculations = _.get(iRequest, 'calculations');var meta = { calculations: {} };var resolvedArrangeTypes = [];if (_.isEmpty(calculations)) {
                    throw new Error('Invalid request object detected.');
               }var validationErrors = this.DSCONST.VALIDATION_META.ERRORS;var validationWarnings = this.DSCONST.VALIDATION_META.WARNINGS;_.forEach(calculations, function (iQuery) {
                    var calculationMeta = {};var calculationId = _.get(iQuery, 'id');if (!calculationId) {
                         throw new Error('Calculation id missing. Cannot return meta.');
                    }if (!_this10.CalculationLayer.validateGoogleParameterQuery(iQuery)) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: validationErrors.GOOGLE_PARAMETER_LAYER_MISSING, parameters: { possibleCalculationLayers: _this10.accountService.getPossibleCalculationLayers(), missingCalculationLayers: _this10.CalculationLayer.GOOGLE_QUERY_LAYERS } });
                    } // Check that analysis has at least one dimension
                    if (!iQuery.kpiRequest && !iQuery.sparklineRequest && !iQuery.sampleRequest) {
                         if (_.size(iQuery.dimensions) <= 0) {
                              if (!_.has(calculationMeta, 'errors')) {
                                   calculationMeta.errors = [];
                              }calculationMeta.errors.push({ name: validationErrors.DIMENSION_LIST_EMPTY, parameters: {} });
                         }
                    } // Check that kpi or sparkline has at least one metric
                    if (iQuery.kpiRequest || iQuery.sparklineRequest) {
                         if (_.size(iQuery.metrics) <= 0) {
                              if (!_.has(calculationMeta, 'errors')) {
                                   calculationMeta.errors = [];
                              }calculationMeta.errors.push({ name: validationErrors.METRIC_LIST_EMPTY, parameters: {} });
                         }
                    } // Validate viewMode queries; currently only path queries are being validated.
                    var validViewMode = _this10.ViewMode.validateQuery(iQuery);if (!validViewMode.isValid) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: validationErrors.INVALID_VIEW_MODE_QUERY, parameters: validViewMode.parameters });
                    } // Check for missing arrangeTypes and populate ERRORS
                    var validAT = _this10.arrangeTypeUtils.validateArrangeTypesFromQuery(iQuery); // Populate the list of detected arrangeTypes
                    resolvedArrangeTypes = resolvedArrangeTypes.concat(_.get(validAT, 'arrangeTypes.resolved', []));if (!validAT.isValid) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: validationErrors.QUERY_ARRANGE_TYPES_MISSING, parameters: { arrangeTypes: _.get(validAT, 'arrangeTypes.missing', []) } });
                    } // Validate dimensions and metrics logical cube compatibility and populate ERRORS
                    var validMonadLC = _this10.logicalCubeUtils.validateMonadsFromQuery(iQuery);if (!validMonadLC.isValid) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: validationErrors.ANALYSIS_LOGICAL_CUBE_MISMATCH, parameters: { arrangeTypes: validMonadLC.arrangeTypes } });
                    } // Validate multidimensional queries agains pivotUsable property
                    var validPivot = _this10.validatePivotQuery_(iQuery);if (!validPivot.isValid) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: validationErrors.PIVOT_INCOMPATIBLE_DIMENSION, parameters: { arrangeTypes: validPivot.arrangeTypes } });
                    } // Validate filter rules from both filter lists and containers from the query and populate WARNINGS
                    var validFilterLC = _this10.logicalCubeUtils.validateFiltersFromQuery(iQuery);if (!validFilterLC.isValid) {
                         if (!_.has(calculationMeta, 'warnings')) {
                              calculationMeta.warnings = [];
                         }calculationMeta.warnings.push({ name: validationWarnings.FILTER_LOGICAL_CUBE_MISMATCH, parameters: { arrangeTypes: validFilterLC.arrangeTypes } });
                    } // Detect campaign attribution dimensions
                    var validCampaignsAttributionDimensions = _this10.campaignsAttributionService.validateDimensionsFromQuery(iQuery);if (!validCampaignsAttributionDimensions.isValid) {
                         if (!_.has(calculationMeta, 'warnings')) {
                              calculationMeta.warnings = [];
                         }calculationMeta.warnings.push({ name: validationWarnings.CAMPAIGNS_ATTRIBUTION_IN_DIMENSION_LIST, parameters: { arrangeTypes: validCampaignsAttributionDimensions.arrangeTypes } });
                    }var validCampaignsAttributionMetrics = _this10.campaignsAttributionService.validateMetricsFromQuery(iQuery);if (!validCampaignsAttributionMetrics.isValid) {
                         if (!_.has(calculationMeta, 'warnings')) {
                              calculationMeta.warnings = [];
                         }calculationMeta.warnings.push({ name: validationWarnings.CAMPAIGNS_ATTRIBUTION_METRIC_FILTER_MISSING, parameters: { arrangeTypes: validCampaignsAttributionMetrics.arrangeTypes } });
                    } // Add only when there's something to add
                    if (calculationMeta.warnings || calculationMeta.errors) {
                         meta.calculations[calculationId] = calculationMeta;
                    }_this10.adjustVideoEngagement(iQuery);
               }); // arrangeType config on purpose left to fetch things from the RAW_DATA configs. Will and should be dropped.
               return { meta: meta, data: iRequest, config: this.Monads.collectAllLayerConfig(_.uniq(resolvedArrangeTypes)) };
          } /**
            * Will validate a given container against ALL calculations - a.k.a. queries of a report generation service query and
            * populate appropriate meta information regarding validity and compatibility of arrangeTypes. Will also return the configurations
            * of found arrangeTypes in the container itself
            * @param  {Object} iRequest The report generation request payload
            * @param  {Object} iContainer A container object with lists of filters and containers
            * @returns {Object}
            */ }, { key: 'validateInjectedContainer', value: function validateInjectedContainer(iRequest, iContainer) {
               var _this11 = this;var calculations = _.get(iRequest, 'calculations');var meta = { calculations: {} };var resolvedArrangeTypes = [];if (_.isEmpty(calculations)) {
                    throw new Error('Invalid request object detected.');
               }var hasFilters = _.chain(iContainer).get('filters').isArray().value();var hasContainers = _.chain(iContainer).get('containers').isArray().value();if (!hasFilters && !hasContainers) {
                    throw new Error('Invalid container detected.');
               } // Validate the arrangeTypes of the container against the known arrange types ONCE
               var validAT_ = this.arrangeTypeUtils.validateArrangeTypesFromContainer(iContainer); // Populate the list of detected arrangeTypes from the container
               resolvedArrangeTypes = resolvedArrangeTypes.concat(_.get(validAT_, 'arrangeTypes.resolved', []));_.chain(calculations).forEach(function (iQuery) {
                    var calculationMeta = {};var calculationId = _.get(iQuery, 'id');if (!calculationId) {
                         throw new Error('Calculation id missing. Cannot return meta.');
                    }if (!validAT_.isValid) {
                         if (!_.has(calculationMeta, 'errors')) {
                              calculationMeta.errors = [];
                         }calculationMeta.errors.push({ name: _this11.DSCONST.VALIDATION_META.ERRORS.INJECTED_CONTAINER_ARRANGE_TYPES_MISSING, parameters: { arrangeTypes: _.get(validAT_, 'arrangeTypes.missing', []) } });
                    } // Validate filter rules from injected container and populate ERRORS
                    _this11.AccountContainer.validateQuery(iQuery, iContainer, calculationMeta); // Add only when there's something to add
                    if (calculationMeta.errors) {
                         meta.calculations[calculationId] = calculationMeta;
                    }
               }).value();return { meta: meta, data: iRequest, config: this.Monads.collectAllLayerConfig(_.uniq(resolvedArrangeTypes)) };
          } /**
            * Extends the meta object of every calculation adding the 'historizedCache' object.
            * @param   {Object} options.meta A key value map where key is the calculation id and value another object.
            * @param   {Object} options.data The actual request that includes the list of calculations/queries.
            * @param   {string} accountId
            * @returns {Request}
            * @chainable
            * @private
            */ }, { key: 'addHistorizedCacheMeta_', value: function addHistorizedCacheMeta_(_ref2, accountId) {
               var _this12 = this;var meta = _ref2.meta,
                   data = _ref2.data;_.chain(data).get('calculations', []).forEach(function (calculation) {
                    var isRealTime = _this12.Monads.isRealTimeQuery(calculation);var categories = isRealTime ? [] : _this12.historizedCacheService.getCategoriesForQuery(calculation);var id = isRealTime || !_.isEmpty(categories) ? '' : _this12.historizedCacheService.getHistorizedCacheId(calculation, accountId);var historizedCache = { id: id, categories: categories };_.set(meta, 'calculations.' + calculation.id + '.historizedCache', historizedCache);
               }).value();return this;
          } /**
            * Will validate a given query and return the validation results if no container to be injected is provided.
            * Given a valid container it will validate the query, validate the container itself and against the query, collect
            * validity meta data - mismatching and missconfigured arrangeTypes etc. - and inject the container filters and containers in
            * every calculation - a.k.a. query - of the given request object. Will also return configurations for all involved arrangeTypes
            * in query and injected container under the config hash.
            * @param   {Object} iRequest - The report generation request payload
            * @param   {Object} iContainer - A container object with lists of filters and containers
            * @param   {Object} iOptions - Misc options hash
            * @returns {Object}
            */ }, { key: 'validateAndInject', value: function validateAndInject(iRequest, iContainer, iOptions) {
               var _this13 = this;var queryValidate = this.validateRequest(iRequest); // Do post process manipulations on the query after the validation and most importantly after the collection of
               // metric and dimenison configurations is completed
               _.chain(iRequest).get('calculations').forEach(function (iQuery) {
                    _this13.mutateStructure_(iQuery);
               }).value(); // Swallow empty objects
               var isContainerEmpty = _.isPlainObject(iContainer) && _.isEmpty(iContainer);if (!iContainer || isContainerEmpty) {
                    _.chain(iRequest).get('calculations').forEach(function (query) {
                         _this13.injectMetaProperties_(query, iOptions);
                    }).valueOf();this.addHistorizedCacheMeta_(queryValidate, _.get(iOptions, 'accountId', ''));return queryValidate;
               } // Reposition NONE containers and remove empty-ish filters
               this.filterUtils.prepareContainerForInjection(iContainer); // Validate the injected filter against the query
               var containerValidate = this.validateInjectedContainer(iRequest, iContainer); // Prepend the validated filter at every calculation of the query
               _.chain(iRequest).get('calculations').forEach(function (iQuery) {
                    _this13.filterUtils.prependContainerToQuery(iQuery, iContainer);_this13.injectMetaProperties_(iQuery, iOptions);
               }).value();this.addHistorizedCacheMeta_(queryValidate, _.get(iOptions, 'accountId', '')); // Iterate over meta of injection validation and extend the query meta information
               _.chain(containerValidate).get('meta.calculations').forEach(function (iMeta, iCalculationId) {
                    var queryValidateMeta = _.get(queryValidate, 'meta.calculations.' + iCalculationId);if (!queryValidateMeta) {
                         queryValidate.meta.calculations[iCalculationId] = {}; // reassign :)
                         queryValidateMeta = queryValidate.meta.calculations[iCalculationId];
                    } // Extend queryValidateMeta errors with errors from the containerValidate meta
                    if (_.get(iMeta, 'errors')) {
                         queryValidateMeta.errors = _.chain(iMeta).get('errors', []).concat(_.get(queryValidateMeta, 'errors', [])).value();
                    }
               }).value();return { meta: queryValidate.meta, data: iRequest, config: _.merge(queryValidate.config, containerValidate.config) };
          } /**
            * Updates the request calculation configurations by performing adjustments for URM specific analyses.
            * @param {Object} request The request object
            * @returns {Object}
            */ }, { key: 'injectUrmParameters', value: function injectUrmParameters(request) {
               if (!_.has(request, 'calculations')) {
                    return request;
               }_.each(request.calculations, function (calculation) {
                    var hasUrmDimension = _.find(calculation.dimensions, function (dimension) {
                         return dimension.arrangeType.indexOf('urm_') === 0;
                    });if (hasUrmDimension) {
                         calculation.urmAnalysis = true;_.set(calculation, 'possibleCalculationLayers', ['RAW_DATA']); // BE-377709
                    }
               });return request;
          } }]);return Request;
}();

},{}],44:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     SamplingFactor.$inject = ['DSCONST'];function SamplingFactor(DSCONST) {
          _classCallCheck(this, SamplingFactor);this.SamplingFactor_ = { dynamicSamplingMode: null, DSCONST: DSCONST };
     } /**
       * Will set dynamicSamplingMode
       * @param  {Object} iAccountConfig User config object
       */_createClass(SamplingFactor, [{ key: 'setDynamicSamplingMode', value: function setDynamicSamplingMode(iAccountConfig) {
               this.SamplingFactor_.dynamicSamplingMode = _.get(iAccountConfig, 'config.dynamic_sampling_mode');
          } /**
            * Will define the sampling factor based on given input
            * @param  {*} iSamplingFactor [description]
            * @returns {number|null}
            */ }, { key: 'getSamplingFactor', value: function getSamplingFactor(iSamplingFactor) {
               var samplingFactor = null;var dynamicSamplingMode = this.SamplingFactor_.dynamicSamplingMode;if (iSamplingFactor) {
                    if (_.isBoolean(iSamplingFactor)) {
                         samplingFactor = this.SamplingFactor_.DSCONST.SAMPLING_FACTOR_DEFAULT_VALUE[dynamicSamplingMode] || null;
                    } else if (Number(iSamplingFactor) >= 1 && Number(iSamplingFactor) <= 49) {
                         samplingFactor = Number(iSamplingFactor);
                    }
               }return samplingFactor;
          } }]);return SamplingFactor;
}();

},{}],45:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     Segments.$inject = ['QueryTemplates', 'Filters'];_createClass(Segments, [{ key: 'SEGMENT_DEFAULT_CONTEXT', /**
                                                                                                                * The default context used in segment connectors
                                                                                                                * @returns {string}
                                                                                                                */get: function get() {
               return 'VISITOR';
          } /**
            * The 'hacky' dimension arrange type used to disguise segments as dimension
            * @returns {string}
            */ }, { key: 'SEGMENT_FAKE_ARRANGE_TYPE', get: function get() {
               return 'segment_fake_dimension';
          } /**
            * Will return the segment connector template
            * @returns {Object}
            */ }, { key: 'SEGMENT_CONNECTOR_TEMPLATE', get: function get() {
               return { segmentID: null, connectorPredicate: 'AND', inOrNotInPredicate: 'IN', context: null, position: 0 };
          } /* @ngInject*/ }]);function Segments(QueryTemplates, Filters) {
          _classCallCheck(this, Segments);this.QueryTemplates = QueryTemplates;this.Filters = Filters;this.CONTAINER_PREDICATE_ATTRIBUTE = 'inOrNotIn';this.ACTIVE_PROPERTY = 'active';this.allSegments = {};this.activeSegments = {};this.analysisFilterQueryCache = {};this.currentSegments = [];this.segmentsByAnalysisId = [];this.segmentsAsMapping = {}; /**
                                                                                                                                                                                                                                                                                                                                                               * The template to convert segments to a dimension with mapping.
                                                                                                                                                                                                                                                                                                                                                               * @type {Object}
                                                                                                                                                                                                                                                                                                                                                               */this.segmentAsDimensionTemplate = { context: this.SEGMENT_DEFAULT_CONTEXT, dataType: 'NUMBER', dimension: true, defaultSortDirection: 'DESCENDING', filterGroup: '', arrangeType: this.SEGMENT_FAKE_ARRANGE_TYPE, caseSensitive: false, internalObject: false, sortable: true, logicalCubes: [], mapping: {}, possibleContexts: ['SESSION', 'VISITOR'], timeFormat: '', title: '', // To be translated
               typeOf: [], defaultContextNotAvailableInFilter: false };
     } /**
       * Get all segments
       * @returns {Object}
       */_createClass(Segments, [{ key: 'getAllSegments', value: function getAllSegments() {
               return this.allSegments;
          } /**
            * Set all segments
            * @param {Array<Object>} segments
            */ }, { key: 'setAllSegments', value: function setAllSegments(segments) {
               var _this = this;if (segments && _.isArray(segments)) {
                    _.each(segments, function (segment) {
                         // Build a hash with all segments as values and their ids as keys
                         _this.allSegments[String(segment.id)] = segment; // Populate the active segments
                         if (segment[_this.ACTIVE_PROPERTY]) {
                              _this.activeSegments[String(segment.id)] = segment;
                         }
                    });
               }
          } /**
            * Get filter query by analysis Id
            * @param {string} analysisId
            * @returns {*}
            */ }, { key: 'getFilterQueryByAnalysisId', value: function getFilterQueryByAnalysisId(analysisId) {
               return this.analysisFilterQueryCache[analysisId];
          } /**
            * To support both versions of the filter engine: filterObject can be an Array with filters (or containers)
            * or an object like {filters: [...], containers: [...]}
            * @todo It is completely UNACCEPTABLE to have a second filter cache inside the segment factory.
            * This filter is used only in the grouped filter handler. Must go. Causes problems and must be cleaned every time a segment is removed.
            * @param {string} analysisId
            * @param {Object} filterObject
            * @returns {boolean}
            */ }, { key: 'setFilterQueryByAnalysisId', value: function setFilterQueryByAnalysisId(analysisId, filterObject) {
               if (!analysisId || _.isEmpty(filterObject)) {
                    return false;
               }if (_.isObject(filterObject)) {
                    // _.omit(filterObject, function (key) {
                    //     return !key.match(/^(filters|containers)$/);
                    // });
                    if (_.isEmpty(filterObject.filters)) {
                         filterObject.filters = [];
                    }if (_.isEmpty(filterObject.containers)) {
                         filterObject.containers = [];
                    }
               }this.analysisFilterQueryCache[analysisId] = filterObject;return true;
          } /**
            * Delete filter query by analysis Id
            * @param {string} analysisId
            */ }, { key: 'deleteFilterQueryByAnalysisId', value: function deleteFilterQueryByAnalysisId(analysisId) {
               delete this.analysisFilterQueryCache[analysisId];return this;
          } /**
            * Get active segments
            * @returns {Object}
            */ }, { key: 'getActiveSegments', value: function getActiveSegments() {
               return this.activeSegments;
          } /**
            * Get the segments that are applied to the current analysis
            * @returns {Object}
            */ }, { key: 'getCurrentSegments', value: function getCurrentSegments() {
               return this.currentSegments;
          } /**
            * Set current segments
            * @param {Array} segments
            */ }, { key: 'setCurrentSegments', value: function setCurrentSegments(segments) {
               if (_.isArray(segments)) {
                    this.currentSegments = segments;
               }
          } /**
            * Get segments by analysis Id
            * @param {string} analysisId
            * @returns {Object}
            */ }, { key: 'getSegmentsByAnalysisId', value: function getSegmentsByAnalysisId(analysisId) {
               return this.segmentsByAnalysisId[analysisId];
          } /**
            * Eliminates the list of segments associated with an analysis if
            * @param {string} analysisId
            * @returns {Segments}
            */ }, { key: 'deleteSegmentsByAnalysisId', value: function deleteSegmentsByAnalysisId(analysisId) {
               delete this.segmentsByAnalysisId[analysisId];return this;
          } /**
            * Set segments by analysis Id
            * @param {Array} iSegments
            * @param {string} analysisId
            */ }, { key: 'setSegmentsByAnalysisId', value: function setSegmentsByAnalysisId(iSegments, analysisId) {
               var segments = iSegments || [];if (!analysisId || !_.isString(analysisId)) {
                    throw Error('Invalid analysisId');
               }if (_.isArray(segments)) {
                    this.segmentsByAnalysisId[analysisId] = segments;
               }
          } /**
            * Get active or inactive segment by id
            * @param {string} segmentId
            * @returns {Object}
            */ }, { key: 'getSegmentById', value: function getSegmentById(segmentId) {
               return this.allSegments[String(segmentId)];
          } /**
            * Get active segments by id
            * @param {string} segmentId
            * @returns {Object}
            */ }, { key: 'getActiveSegmentById', value: function getActiveSegmentById(segmentId) {
               return this.activeSegments[String(segmentId)];
          } /**
            * Returns the title that corresponds to a segment connector that corresponds to a segment.
            * @param   {Object} segmentConnector
            * @returns {string}
            */ }, { key: 'getTitleFromSegmentConnector', value: function getTitleFromSegmentConnector(segmentConnector) {
               var segmentID = _.get(segmentConnector, 'segmentID');var segment = this.getActiveSegmentById(segmentID);return _.get(segment, 'title', null);
          } /**
            * Validates segment connector. See https://wiki.webtrekk.com/display/WS/Analysis+Service#SegmentConnector
            * @returns {boolean}
            */ }, { key: 'validateSegmentConnector', value: function validateSegmentConnector(segmentConnector) {
               return _.has(segmentConnector, 'segmentID') && _.has(segmentConnector, 'connectorPredicate') && _.has(segmentConnector, 'inOrNotInPredicate') && _.has(segmentConnector, 'context') && _.has(segmentConnector, 'position');
          } /**
            * Converts a segment into a container ready to use in a whole query request
            * @param  {string} segmentId
            * @returns {Object}           https://wiki.webtrekk.com/display/WS/Analysis+Service#AnalysisService-Container
            */ }, { key: 'getSegmentConnectorAsContainer', value: function getSegmentConnectorAsContainer(segmentConnector) {
               if (!this.validateSegmentConnector(segmentConnector)) {
                    return {};
               }var segment = this.getActiveSegmentById(String(segmentConnector.segmentID));if (!_.has(segment, 'filter')) {
                    return {};
               }var container = _.cloneDeep(segment.filter);this.Filters.applyAndRuleToContainer(container);container.connector = segmentConnector.connectorPredicate;container.context = segmentConnector.context;container[this.CONTAINER_PREDICATE_ATTRIBUTE] = segmentConnector.inOrNotInPredicate;container.isSegment = true;container.segmentId = segmentConnector.segmentID;return container;
          } /**
            * Will return a list of containers generated from a list of segment connections
            * @param   {Array<Object>} segmentConnectors - List of segment connector configuration objects
            * @returns {Array<Object>}
            */ }, { key: 'getSegmentConnectorsAsContainers', value: function getSegmentConnectorsAsContainers(segmentConnectors) {
               var _this2 = this;return _.chain(segmentConnectors).map(function (segmentConnector) {
                    return _this2.getSegmentConnectorAsContainer(segmentConnector);
               }).filter(function (segmentContainer) {
                    return !_.isEmpty(segmentContainer);
               }).value();
          } /**
            * Get segments as mapping
            * @returns {Object}
            */ }, { key: 'getSegmentsAsMapping', value: function getSegmentsAsMapping() {
               return this.segmentsAsMapping;
          } /**
            * Set the segments as mapping
            */ }, { key: 'setSegmentsAsMapping', value: function setSegmentsAsMapping() {
               var _this3 = this;this.segmentsAsMapping = {};_.each(this.activeSegments, function (segment) {
                    _this3.segmentsAsMapping[String(segment.id)] = segment.title;
               });
          } /**
            * Get segments as dimension template
            * @param {string} title
            * @param {string} filterGroup
            * @param {string} defaultText
            * @returns {Object}
            */ }, { key: 'getSegmentAsDimensionTemplate', value: function getSegmentAsDimensionTemplate(title, filterGroup, defaultText) {
               var template = _.cloneDeep(this.segmentAsDimensionTemplate);template.title = title ? title : '';template.filterGroup = filterGroup ? filterGroup : '';var mappings = _.cloneDeep(this.segmentsAsMapping);if (!_.isUndefined(defaultText)) {
                    mappings[''] = defaultText;
               }template.mapping = mappings;return template;
          } /**
            * @todo: Please remove and replace all usages with the getter
            * Get fake segment arrange type
            * @returns {string}
            */ }, { key: 'getFakeSegmentArrangeType', value: function getFakeSegmentArrangeType() {
               return this.SEGMENT_FAKE_ARRANGE_TYPE;
          } /**
            * Will return the 'filter' representation of a segment connector object
            * @param   {Object}  segmentConnector - Object with 'segment' implementational settings
            * @param   {boolean} addPosition - Whether to include the position property or not
            * @returns {Object}
            */ }, { key: 'getSegmentConnectorAsFilter', value: function getSegmentConnectorAsFilter(segmentConnector) {
               var addPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var filterPredicate = _.get(segmentConnector, 'inOrNotInPredicate') === 'IN' ? 'LIKE' : 'NOT_LIKE';var filter = _.chain(this.QueryTemplates.filter()).set('internalObject', false).set('arrangeType', this.SEGMENT_FAKE_ARRANGE_TYPE).set('value1', '' + _.get(segmentConnector, 'segmentID')).set('context', _.get(segmentConnector, 'context')).set('connector', _.get(segmentConnector, 'connectorPredicate')).set('filterPredicate', filterPredicate).value();if (addPosition) {
                    _.set(filter, 'position', _.get(segmentConnector, 'position', 0));
               }return filter;
          } /**
            * Will convert a given filter to a segment connector object
            * @param   {Object} filter - Filter rule configuration object
            * @param   {number} position
            * @returns {Object}
            */ }, { key: 'getSegmentConnectorFromFilter', value: function getSegmentConnectorFromFilter(filter) {
               var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var segmentID = Number(_.get(filter, 'value1'));var connectorPredicate = _.get(filter, 'connector');var inOrNotInPredicate = _.get(filter, 'filterPredicate') === 'LIKE' ? 'IN' : 'NOT_IN';var context = _.get(filter, 'context');return _.chain(this.SEGMENT_CONNECTOR_TEMPLATE).set('segmentID', segmentID).set('connectorPredicate', connectorPredicate).set('inOrNotInPredicate', inOrNotInPredicate).set('context', context).set('position', position).value();
          } /**
            * Will return a list of filters based on a given list of segment connections
            * @param   {Array<Object>} segmentConnectors - List of objects with 'segment' implementational settings
            * @param   {boolean} addPosition - Whether to include the position property or not in the returned filters
            * @param   {null|Object} activeSegmentsOverride When provided will be used as the segments resource for resolving segments instead of
            * the currently initialised segments. E.g. Can be used to construct connectors as filters for segments that do not belong to the current account.
            * @returns {Array<Object>}
            */ }, { key: 'getSegmentConnectorsAsFilters', value: function getSegmentConnectorsAsFilters(segmentConnectors) {
               var _this4 = this;var addPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var activeSegmentsOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var useSegmentsOverride = _.isPlainObject(activeSegmentsOverride);return _.chain(segmentConnectors).filter(function (segmentConnector) {
                    var segmentID = _.get(segmentConnector, 'segmentID');var segment = useSegmentsOverride ? activeSegmentsOverride[segmentID] : _this4.getActiveSegmentById(segmentID);return !_.isEmpty(segment);
               }).map(function (segmentConnector) {
                    return _this4.getSegmentConnectorAsFilter(segmentConnector, addPosition);
               }).value();
          } /**
            * Will determine if a filter rule is a 'segment' filter rule, based solely on its
            * arrangeType
            * @param   {Object}  filter - A filter object
            * @returns {boolean}        [description]
            */ }, { key: 'isSegmentFilter', value: function isSegmentFilter(filter) {
               return _.get(filter, 'arrangeType') === this.SEGMENT_FAKE_ARRANGE_TYPE;
          } /**
            * Will remove all 'segment' filters from a given list of filters and return
            * the removed segment filters as a list of segment connectors.
            * @param   {Array<Object>} filters - List of filter rules
            * @returns {Array<Object>}
            */ }, { key: 'getSegmentConnectorsFromFilters', value: function getSegmentConnectorsFromFilters(filters) {
               var _this5 = this;var segmentConnectors = [];_.remove(filters, function (filter, index) {
                    var isSegment = _this5.isSegmentFilter(filter);if (isSegment) {
                         var segmentConnector = _this5.getSegmentConnectorFromFilter(filter, index);segmentConnectors.push(segmentConnector);
                    }return isSegment;
               });return segmentConnectors;
          } /**
            * Will extract a list of segment connectors - if any - from a list of containers
            * @param  {Array<Object>} iContainers
            * @returns {Array<Object>}
            */ }, { key: 'getSegmentConnectorsFromContainers', value: function getSegmentConnectorsFromContainers(iContainers) {
               var _this6 = this;var segmentConnectors_ = [];_.chain(iContainers).filter({ isSegment: true }).forEach(function (iContainer, iNdex) {
                    var connector_ = _.merge(_this6.SEGMENT_CONNECTOR_TEMPLATE, { segmentID: _.get(iContainer, 'segmentId'), connectorPredicate: _.get(iContainer, 'connector'), inOrNotInPredicate: _.get(iContainer, 'inOrNotIn'), context: _.get(iContainer, 'context'), position: _.get(iContainer, 'position') || iNdex });segmentConnectors_.push(connector_);
               }).value();return segmentConnectors_;
          } /**
            * Will return a list of segment connectors - if any - from a report generation query
            * @param  {Object} iQuery
            * @returna {Array<Object>}
            */ }, { key: 'getSegmentConnectorsFromQuery', value: function getSegmentConnectorsFromQuery(iQuery) {
               return this.getSegmentConnectorsFromContainers(_.get(iQuery, 'containers'));
          } /**
            * @name Segments#removeInactiveSegmentConnection
            * @description Go through all segmentConnections, check if segmentID exist in list of activeSegment and remove if segmentId doesn't exist
            * Why it doesn't exists in active segments?
            *  1. segment was deleted, but steal in report or in monad
            *  2. segment was activate and later deactivate
            * Why it is necessary to do this clean up
            *  1. Report has some deleted segment, after copying report to the other account, the segment could be unexpected active,
            *  because exist in other account
            *  2. To avoid collisions by mapping identity between accounts
            * @param {Object} nodeWithSegmentConnections some node with segment connections
            * @private
            */ }, { key: 'removeInactiveSegmentConnection', value: function removeInactiveSegmentConnection(nodeWithSegmentConnections) {
               var _this7 = this;if (_.isEmpty(nodeWithSegmentConnections) || _.isEmpty(nodeWithSegmentConnections.predefinedSegmentConnections)) {
                    return;
               }var predefinedSegmentConnections = _.get(nodeWithSegmentConnections, 'predefinedSegmentConnections', []);var activeSegmentConnections = _.filter(predefinedSegmentConnections, function (segmentConnection) {
                    return !_.isEmpty(_this7.getActiveSegmentById(segmentConnection.segmentID));
               });var hasInactiveConnections = predefinedSegmentConnections.length !== activeSegmentConnections.length;if (hasInactiveConnections) {
                    _.set(nodeWithSegmentConnections, 'predefinedSegmentConnections', activeSegmentConnections);
               }
          } /**
            * Will return the corresponding connector given a segment
            * @param   {Object} segment
            * @returns {Object}
            */ }, { key: 'getSegmentAsConnector', value: function getSegmentAsConnector(segment) {
               return _.chain(this.SEGMENT_CONNECTOR_TEMPLATE).set('context', this.SEGMENT_DEFAULT_CONTEXT).set('segmentID', _.get(segment, 'id')).value();
          } }]);return Segments;
}();

},{}],46:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     TimeSeries.$inject = ['Monads', 'QueryTemplates', 'QueryLimits', 'filterUtils', 'Columns', 'Analyses', 'dateService'];function TimeSeries(Monads, QueryTemplates, QueryLimits, filterUtils, Columns, Analyses, dateService) {
          _classCallCheck(this, TimeSeries);this.Monads = Monads;this.QueryTemplates = QueryTemplates;this.QueryLimits = QueryLimits;this.filterUtils = filterUtils;this.Columns = Columns;this.Analyses = Analyses;this.dateService = dateService;
     } /**
       * The value of the view mode this class represents
       * @returns {string}
       */_createClass(TimeSeries, [{ key: 'canHaveTimeSeries', /**
                                                               * Will determine if an analysis can have a time series variant or not. Analyses whose first dimension has
                                                               * a timeFormat specified - are in other words related to time - cannot be converted to a time series. Same goes for analyses
                                                               * that have more than one dimension - whether pivot or pivot as list.
                                                               * @param  {Object} iAnalysis - The analysis configuration
                                                               * @param  {boolean=} includeTimeAnalyses - Should the analyses with first and only time dimension be excluded from the check
                                                               * @returns {boolean}
                                                               */value: function canHaveTimeSeries(iAnalysis, includeTimeAnalyses) {
               var _this = this;var layer = this.Monads.getConfigLayer(iAnalysis);var dimensions_ = _.chain(iAnalysis).get('columns').map(function (iColumn) {
                    return _this.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType'));
               }).filter({ dimension: true }).value(); // Analyses with more than one dimension cannot be converted to time series
               if (dimensions_.length !== 1) {
                    return false;
               }if (!includeTimeAnalyses) {
                    // Analyses whose first dimension is related to time cannot be converted to time series
                    return _.chain(dimensions_).first().get('timeFormat').isEmpty().value();
               }return true;
          } /**
            * Will delete the timeSeries configuration from an analysis and (re)set the active viewMode to ''
            * @param  {Object} iAnalysis - The analysis configuration
            */ }, { key: 'deleteTimeSeries', value: function deleteTimeSeries(iAnalysis) {
               if (_.get(iAnalysis, 'viewMode.active') === 'timeSeries') {
                    _.set(iAnalysis, 'viewMode.active', '');
               }if (_.has(iAnalysis, 'viewMode.timeSeries')) {
                    delete iAnalysis.viewMode.timeSeries;
               }
          } /**
            * Will validate the timeSeries configuration object of the viewType
            * @param  {Object} iAnalysis - The analysis configuration
            * @return {boolean}
            */ }, { key: 'validateTimeSeries', value: function validateTimeSeries(iAnalysis) {
               // Empty time series object is invalid
               if (_.chain(iAnalysis).get('viewMode.timeSeries').isEmpty().value()) {
                    return false;
               } // timeArrangeType must be a string
               if (!_.chain(iAnalysis).get('viewMode.timeSeries.timeArrangeType').isString().value()) {
                    return false;
               } // values must be an array
               if (!_.chain(iAnalysis).get('viewMode.timeSeries.values').isArray().value()) {
                    return false;
               } // top must be a number
               if (!_.chain(iAnalysis).get('viewMode.timeSeries.top').isNumber().value()) {
                    return false;
               } // viewType must be string
               if (!_.chain(iAnalysis).get('viewMode.timeSeries.viewType').isString().value()) {
                    return false;
               }return true;
          } /**
            * Will init some default timeSeries configuraion on an analysis if it qualifies for a time series
            * variant. If a timeSeries already exists and the analysis does not qualify will delete the timeSeries
            * config. If it qualifies and a time series config exists, it will do nothing.
            * @param {Object} iAnalysis - The analysis configuration
            * @returns {Object}           The modified analysis config if it's valid
            */ }, { key: 'resolveTimeSeries', value: function resolveTimeSeries(iAnalysis) {
               var analysis = iAnalysis; // If the analyses does not qualify to have time series variant, simply delete the timeSeries config
               if (!this.canHaveTimeSeries(analysis, true)) {
                    this.deleteTimeSeries(analysis);return analysis;
               } // Preselect first time series column if none selected
               if (!_.find(analysis.columns, { inTimeSeries: true })) {
                    var metric = _.find(analysis.columns, { metric: true });if (metric) {
                         metric.inTimeSeries = true;
                    }
               } // Do nothing if the analysis has a set and valid time series
               if (_.has(analysis, 'viewMode.timeSeries') && this.validateTimeSeries(analysis)) {
                    return analysis;
               }if (!_.has(analysis, 'viewMode.active')) {
                    _.set(analysis, 'viewMode.active', '');
               }_.set(analysis, 'viewMode.timeSeries', { timeArrangeType: '', values: [], top: 3, viewType: 'values', editState: false });return analysis;
          } /**
            * Will inject the timeArrangeType of the timeSeries in the query - under certain conditions.
            * @param {Object} iAnalysis - The analysis configuration
            * @param {Object} iQuery - The regular query for the analysis
            * @returns {boolean}
            */ }, { key: 'addTimeDimension', value: function addTimeDimension(iAnalysis, iQuery) {
               if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries') {
                    return false;
               }var timeArrangeType_ = _.get(iAnalysis, 'viewMode.timeSeries.timeArrangeType');var layer = this.Monads.getConfigLayer(iAnalysis); // If the timeArrangeType is not a time related function do nothing
               if (_.chain(this.Monads.layer(layer).monad(timeArrangeType_)).get('timeFormat').isEmpty().value()) {
                    return false;
               } // If the timeArrangeType is already in the dimensions of the query something fishy is going on.
               if (!_.chain(iQuery).get('dimensions').find({ arrangeType: timeArrangeType_ }).isEmpty().value()) {
                    return false;
               } // Add the new dimension in the query
               iQuery.dimensions.push(_.merge(this.QueryTemplates.dimension(), { alias: timeArrangeType_ + '|0', arrangeType: timeArrangeType_ }));var footerType_ = _.chain(iQuery).get('dimensions').size().value() === 1 ? 'SUM' : 'UNIQUE_SUM'; // Update the footerTypes
               iQuery.footerTypes = _.map(iQuery.footerTypes, function () {
                    return footerType_;
               }); // Update the footerTypes inside the order columns
               iQuery.orderColumns = _.map(iQuery.orderColumns, function (iOrderColumn) {
                    iOrderColumn.footerType = footerType_;return iOrderColumn;
               });return true;
          } /**
            * Will indicate how many times each inTimeSeries metric should be replicated to build a time series query
            * @param {Object} iAnalysis - The analysis configuration
            * @returns {number}
            */ }, { key: 'getMetricReplicationFactor', value: function getMetricReplicationFactor(iAnalysis) {
               switch (_.get(iAnalysis, 'viewMode.timeSeries.viewType')) {case 'top':
                         return _.get(iAnalysis, 'viewMode.timeSeries.top', 0);case 'values':
                         return _.chain(iAnalysis).get('viewMode.timeSeries.values').size().value();default:
                         return 0;}
          } /**
            * Returns the viewType value of the time series configuration given an analysis configuration object.
            * @param   {Object} analysis
            * @returns {string}
            * @private
            */ }, { key: 'getTimeSeriesViewType_', value: function getTimeSeriesViewType_(analysis) {
               return _.get(analysis, 'viewMode.timeSeries.viewType', '');
          } /**
            * Determines if a time series configuration is of type 'values'.
            * @param   {Object} analysis
            * @returns {boolean}
            * @private
            */ }, { key: 'isViewTypeValues_', value: function isViewTypeValues_(analysis) {
               return this.getTimeSeriesViewType_(analysis) === 'values';
          } /**
            * Returns the specific values for time series.
            * @param   {Object} analysis
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getViewTypeValues_', value: function getViewTypeValues_(analysis) {
               return _.get(analysis, 'viewMode.timeSeries.values', []);
          } /**
            * Mutates time series metric replicas when the viewType is set to 'values' and explicitly selected values
            * exist in the time series configuration, by setting their title to an explicitly selected value.
            * @param {Object} analysis The analysis configuration.
            * @param {Object} metric   The query metric to be mutated.
            * @param {number} index    The replica index of the query metric.
            */ }, { key: 'setMetricReplicaTitle_', value: function setMetricReplicaTitle_(analysis, metric, index) {
               _.unset(metric, 'value.title');if (!this.isViewTypeValues_(analysis)) {
                    return;
               }var values = this.getViewTypeValues_(analysis);var title = _.get(values, '' + index);if (title) {
                    _.set(metric, 'value.title', title);
               }
          } /**
            * Will modify the metrics of iQuery based on the analysis configuration if a the timeSeries viewMode is set.
            * Will remove metrics that are not set as inTimeSeries, multiply the inTimeSeries accordingly and reset the aliases
            * of all metrics.
            * @param {Object} iAnalysis - The analysis configuration
            * @param {Object} iQuery - The regular query for the analysis
            * @returns {boolean}
            */ }, { key: 'adjustMetrics', value: function adjustMetrics(iAnalysis, iQuery) {
               var _this2 = this;if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries') {
                    return false;
               } // List with metric aliases that should be included in the time series request
               var inTimeSeries_ = _.chain(iAnalysis).get('columns').filter(function (iColumn) {
                    return _.get(iColumn, 'inTimeSeries');
               }).map(function (iColumn) {
                    return _.get(iColumn, 'alias');
               }).value(); // If no columns to be included in the time series exist stop further processing
               if (_.isEmpty(inTimeSeries_)) {
                    return false;
               } // Remove metrics that are not related to time series and any related order columns - if any at all
               _.chain(iQuery).get('metrics').remove(function (iMetric) {
                    return !_.includes(inTimeSeries_, _.get(iMetric, 'alias'));
               }).forEach(function (iMetric) {
                    _.chain(iQuery).get('orderColumns').remove(function (iOrderColumn) {
                         return _.get(iOrderColumn, 'columnAlias') === _.get(iMetric, 'alias');
                    }).value();
               }).value(); // Find out how many replicas each metric needs
               var replicas_ = this.getMetricReplicationFactor(iAnalysis); // Inits a hash to keep track of the indexes of each arrangeType. Used to build the aliases anew.
               var atIndex_ = _.chain(iQuery).get('metrics').map('value.arrangeType').uniq().map(function (iArrangeType) {
                    return [iArrangeType, 0];
               }).fromPairs().value();_.chain(iQuery).get('metrics').remove(function () {
                    return true;
               }).forEach(function (iMetric) {
                    var groupBy = _.get(iMetric, 'alias'); // For each removed metric object insert #replicas_ with updated alias
                    for (var i = 0; i < replicas_; i++) {
                         var metric_ = _.chain(iMetric).cloneDeep().merge({ groupBy: groupBy }).valueOf();var at_ = _.get(metric_, 'value.arrangeType');_this2.setMetricReplicaTitle_(iAnalysis, metric_, i); // Replace the order column alias if necessary
                         var orderColumn_ = _.chain(iQuery).get('orderColumns').find({ columnAlias: _.get(metric_, 'alias') }).value(); // Reset the alias
                         metric_.alias = at_ + '|' + _.get(atIndex_, at_); // Reset the related orderColumn if needed
                         if (orderColumn_) {
                              orderColumn_.columnAlias = metric_.alias;
                         } // Increase the index for the next alias of the same arrangeType
                         _.set(atIndex_, at_, _.get(atIndex_, at_) + 1);iQuery.metrics.push(metric_);
                    }
               }).value();return true;
          } /**
            * Will adjust the limits of the query for a timeSeries
            * @param {Object} iAnalysis - The analysis configuration
            * @param {Object} iQuery - The regular query for the analysis
            * @returns {boolean}
            */ }, { key: 'adjustLimits', value: function adjustLimits(iAnalysis, iQuery) {
               if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries') {
                    return false;
               }var timeArrangeType_ = _.get(iAnalysis, 'viewMode.timeSeries.timeArrangeType');var layer = this.Monads.getConfigLayer(iAnalysis); // If the timeArrangeType is not a time related function do nothing
               if (_.chain(this.Monads.layer(layer).monad(timeArrangeType_)).get('timeFormat').isEmpty().value()) {
                    return false;
               } // Make sure the time arrange type is the second dimension in the query already
               if (_.get(iQuery, 'dimensions.0.arrangeType') === timeArrangeType_) {
                    return false;
               }iQuery.lowerLimits = [1, 1];iQuery.upperLimits = []; // Limit of the first dimension is the number of replicas configured in the TS configuration
               iQuery.upperLimits.push(this.getMetricReplicationFactor(iAnalysis)); // The time units - days, weeks, months, quarters, years, hours, weekdays - to calculate the
               // limit of the time dimension for TS query
               var timeUnits = _.get(this.Monads.layer(layer).monad(timeArrangeType_), 'timeFormat'); // The query's time filter
               var timeFilter = this.filterUtils.getTimeFilterFromList(_.get(iQuery, 'filters')); // Retrieve other time filters from the analysis configuration
               var filters = this.Analyses.timeResolve(iAnalysis); // Add the query time filter in the list
               filters.push(timeFilter); // Generate a super set time filter that will span the entire period
               var superSetTimeFilter = this.dateService.getTimeFilterSuperSet(filters) || timeFilter; // Number of timeUnits in superSet
               var timeUnitsInSuperSet = this.QueryLimits.getUpperLimitByTimeFormat(timeUnits, superSetTimeFilter);iQuery.upperLimits.push(timeUnitsInSuperSet);return true;
          } /**
            * Will inject time series related filters if the time series has specific values selected
            * @param {Object} iAnalysis - The analysis configuration
            * @param {Object} iQuery - The regular query for the analysis
            * @returns {boolean}
            * @private
            */ }, { key: 'adjustFilters_', value: function adjustFilters_(iAnalysis, iQuery) {
               var _this3 = this;if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries') {
                    return false;
               }if (_.get(iAnalysis, 'viewMode.timeSeries.viewType') !== 'values') {
                    return true;
               }if (_.chain(iAnalysis).get('viewMode.timeSeries.values').size().value() === 0) {
                    return true;
               }var layer = this.Monads.getConfigLayer(iAnalysis);var firstDimension = this.Monads.layer(layer).monad(_.get(iQuery, 'dimensions.0.arrangeType'));var context = _.get(firstDimension, 'context');var caseSensitive = _.get(firstDimension, 'caseSensitive'); // Important! First TS filter rules gets and AND, the rest gets an OR, so as to form a grouped
               // condition for the core to process - i.e. AND (rule1 OR rule2 OR rule3).
               // NOTE: FE TS queries coming from cache should NEVER include these enforced filters, so as not
               // to mess the internal workings of the filter engine on display.
               // NOTE #2: Important mark the filters as intern to skip duplicate filter elimination - if
               // and when - user inserted filter rules may clash.
               _.chain(iAnalysis).get('viewMode.timeSeries.values').forEach(function (value1, iNdex) {
                    iQuery.filters.push(_this3.filterUtils.getFilterTemplateByAnalysisObject(firstDimension, { value1: value1, context: context, caseSensitive: caseSensitive, intern: true, connector: iNdex === 0 ? 'AND' : 'OR' }));
               }).value();return true;
          } /**
            * Will modify the order columns and the footerTypes
            * @param {Object} iAnalysis - The analysis configuration
            * @param {Object} iQuery - The regular query for the analysis
            * @return {boolean}
            */ }, { key: 'adjustSortingColumns', value: function adjustSortingColumns(iAnalysis, iQuery) {
               if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries') {
                    return false;
               }var footerType_ = _.chain(iQuery).get('dimensions').size().value() === 1 ? 'SUM' : 'UNIQUE_SUM';iQuery.orderColumns.unshift({ columnAlias: _.get(iAnalysis, 'viewMode.timeSeries.timeArrangeType') + '|0', direction: 'ASCENDING', footerType: footerType_ });iQuery.footerTypes.unshift(footerType_);return true;
          } /**
            * The value of a query's viewMode property that indicates if its a time series or not
            * @returns {string}
            */ }, { key: 'adjustQuery', /**
                                        * Will modify a query for an analysis based on its timeSeries viewMode configuration
                                        * @param {Object} iAnalysis - The analysis configuration
                                        * @param {Object} iQuery - The regular query for the analysis
                                        * @returns {Object}
                                        */value: function adjustQuery(iAnalysis, iQuery) {
               // If current analysis is configured for timeSeries viewMode but is in edit state, do not adjust the query for time series
               if (_.get(iAnalysis, 'viewMode.active') !== 'timeSeries' || _.get(iAnalysis, 'viewMode.timeSeries.editState', false)) {
                    return iQuery;
               } // Set the aliases properly if they are not there,
               var iAnalysis_ = _.cloneDeep(iAnalysis);iAnalysis_.columns = this.Columns.getAnalysisConfigurationColumnsWithAliases(iAnalysis_.columns); // If the addTimeDimension method fails, stop further processing and return the query
               if (!this.addTimeDimension(iAnalysis_, iQuery)) {
                    return iQuery;
               } // If the adjustMetrics method fails, stop further processing and return the query
               if (!this.adjustMetrics(iAnalysis_, iQuery)) {
                    return iQuery;
               } // If the adjustLimits method fails, stop further processing and return the query
               if (!this.adjustLimits(iAnalysis_, iQuery)) {
                    return iQuery;
               } // If the adjustFilters_ method fails, stop further processing and return the query
               if (!this.adjustFilters_(iAnalysis_, iQuery)) {
                    return iQuery;
               }if (!this.adjustSortingColumns(iAnalysis_, iQuery)) {
                    return iQuery;
               }iQuery.viewMode = this.QUERY_VIEW_MODE;return iQuery;
          } /**
            * Retrieves all columns that are configured to be displayed in the time series
            * @param {Object} iAnalysis The analysis configuration
            * @returns {Array}
            */ }, { key: 'getTimeSeriesColumns', value: function getTimeSeriesColumns(iAnalysis) {
               var analysis = _.isPlainObject(iAnalysis) ? iAnalysis : null;if (!analysis) {
                    return [];
               }return _.filter(analysis.columns, { inTimeSeries: true });
          } /**
            * Will return the list of allowed arrange types to construct time series
            * requests by.
            * @returns {Array<string>}
            */ }, { key: 'timeCategoryArrangeTypesList', value: function timeCategoryArrangeTypesList() {
               if (this.Monads.hasStandardWeek()) {
                    return ['time_id_categories_t_year_month_day', 'time_id_categories_t_year_week', 'time_id_categories_t_year_month', 'time_id_categories_t_quarter', 'time_id_categories_t_year', 'time_id_categories_t_hour', 'time_id_categories_t_weekday'];
               }return ['time_id_categories_t_year_month_day', 'time_id_categories_t_year_week_en', 'time_id_categories_t_year_month', 'time_id_categories_t_quarter', 'time_id_categories_t_year', 'time_id_categories_t_hour', 'time_id_categories_t_weekday_en'];
          } /**
            * Will return the default arrange type used a time dimension in a time series request. If empty will
            * return the default from timeCategoryArrangeTypesList
            * @param  {Object} iAnalysis - the analysis configuration object
            * @returns {string}
            */ }, { key: 'getDefaultTimeArrangeType', value: function getDefaultTimeArrangeType(iAnalysis) {
               var _this4 = this;var timeArrangeType_ = _.get(iAnalysis, 'viewMode.timeSeries.timeArrangeType'); // Return the set time arrange type in the time series view mode configuration
               if (!_.isEmpty(timeArrangeType_)) {
                    return timeArrangeType_;
               }var layer = this.Monads.getConfigLayer(iAnalysis);var firstDimension_ = _.chain(iAnalysis).get('columns').find(function (iColumn) {
                    return _.get(_this4.Monads.layer(layer).monad(_.get(iColumn, 'arrangeType')), 'dimension');
               }).get('arrangeType').value();return _.chain(this.timeCategoryArrangeTypesList()).without(firstDimension_).first().value();
          } }, { key: 'VIEW_MODE_NAME', get: function get() {
               return 'timeSeries';
          } }, { key: 'QUERY_VIEW_MODE', get: function get() {
               return 'TIME_SERIES';
          } }]);return TimeSeries;
}();

},{}],47:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     TimeShift.$inject = ['Filters', 'TimesDynamicCache'];_createClass(TimeShift, [{ key: 'TIME_SHIFT_UNITS', get: function get() {
               return ['NONE', 'DAY', 'WEEK', 'MONTH', 'QUARTER', 'YEAR'];
          } }, { key: 'QUARTER', get: function get() {
               return this.TIME_SHIFT_UNITS[4];
          } }, { key: 'TIME_SHIFT_UNIT_TO_MOMENT_MEASUREMENT', get: function get() {
               return { DAY: 'days', WEEK: 'weeks', MONTH: 'months', YEAR: 'years' };
          } /*@ngInject*/ }]);function TimeShift(Filters, TimesDynamicCache) {
          _classCallCheck(this, TimeShift);this.Filters = Filters;this.TimesDynamicCache = TimesDynamicCache;
     } /**
       * Determines if a given time shift unit is in the list of known/valid time shift units
       * @param   {string}  timeShiftUnit
       * @returns {boolean}
       */_createClass(TimeShift, [{ key: 'isValidTimeShiftUnit', value: function isValidTimeShiftUnit(timeShiftUnit) {
               return _.includes(this.TIME_SHIFT_UNITS, timeShiftUnit);
          } /**
            * Will try to retrieve the resolved static filter of a dynamic time filter from the cache and return its
            * corresponding start or end date string, as dictated in the value1 pr value2 property
            * @param   {Object} timeFilter
            * @param   {boolean=} value2
            * @returns {string}
            * @throws Error
            * @private
            */ }, { key: 'getDateStringFromDynamicTime_', value: function getDateStringFromDynamicTime_(timeFilter) {
               var value2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var dynamicTime = _.get(timeFilter, 'value1');var resolvedDynamicTime = this.TimesDynamicCache.getCachedKey(dynamicTime);if (!this.Filters.isTime(resolvedDynamicTime, true)) {
                    throw new Error('Resolved filter for ' + dynamicTime + ' is not a valid time filter. Failed to extract start date.');
               }return this.getDateStringFromStaticTime_(resolvedDynamicTime, value2);
          } /**
            * Will try to retrieve the start or end date string, as dictated in the value1 or value2 property of a given filter
            * @param   {Object} timeFilter
            * @param   {boolean=} value2
            * @returns {string}
            * @throws Error
            * @private
            */ }, { key: 'getDateStringFromStaticTime_', value: function getDateStringFromStaticTime_(timeFilter) {
               var value2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var dateString = _.get(timeFilter, value2 ? 'value2' : 'value1');if (!dateString) {
                    throw new Error('Resolved start date is empty.');
               }return dateString;
          } /**
            * Will try to retrieve the start or end date string of a given filter
            * @param   {Object} timeFilter
            * @param   {boolean=} value2
            * @returns {string}
            * @throws Error
            * @private
            */ }, { key: 'getDateStringFromTime_', value: function getDateStringFromTime_(timeFilter) {
               var value2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;if (!this.Filters.isTime(timeFilter, true)) {
                    throw new Error('Object ' + JSON.stringify(timeFilter) + ' is not a time filter. Failed to extract start date.');
               }if (this.Filters.isTimeDynamic(timeFilter)) {
                    return this.getDateStringFromDynamicTime_(timeFilter, value2);
               }return this.getDateStringFromStaticTime_(timeFilter, value2);
          } /**
            * Will figure out how many quarters are included in the time range of a STATIC time filter, regardless of the year;
            * i.e. if the period includes the 1st quarter of multiple years the list of quarters will include only a single
            * number '1'.
            * @param   {Object} timeFilter [description]
            * @returns {Array<number>}
            * @private
            */ }, { key: 'getQuartersFromFilter_', value: function getQuartersFromFilter_(timeFilter) {
               try {
                    var startString = this.getDateStringFromTime_(timeFilter, false);var endString = this.getDateStringFromTime_(timeFilter, true);var momentMeasurement = this.TIME_SHIFT_UNIT_TO_MOMENT_MEASUREMENT.MONTH;var startMoment = moment(startString).startOf(momentMeasurement); // Drop the +1 magic to calculate the quarter correctly
                    var endMoment = moment(endString).subtract(1, this.TIME_SHIFT_UNIT_TO_MOMENT_MEASUREMENT.DAY).startOf(momentMeasurement);var diff = endMoment.diff(startMoment, momentMeasurement);return _.chain(diff + 1).times(function (num) {
                         var date = moment(startString).startOf(momentMeasurement).add(num, momentMeasurement);return _.toInteger(date.month() / 3) + 1;
                    }).uniq().sortBy().value();
               } catch (e) {
                    console.log('Failed to calculate quarters for ' + JSON.stringify(timeFilter) + '.', e);return [];
               }
          } /**
            * Will calculate the difference of yearly quarters between two given time filters
            * @param   {Object} comparisonFilter A comparison time filter
            * @param   {Object} filter A time filter
            * @returns {number}
            * @private
            */ }, { key: 'getQuarterDiff_', value: function getQuarterDiff_(comparisonFilter, filter) {
               var comparisonQuarter = this.getQuartersFromFilter_(comparisonFilter)[0];var filterQuarter = this.getQuartersFromFilter_(filter)[0];return comparisonQuarter - filterQuarter;
          } /**
            * Computes the number of days between the start of two given filters
            * @param   {Object} filter A time filter
            * @param   {Object} comparisonFilter A comparison time filter
            * @param   {string=} timeShiftUnit The unit to calculate the diff in - i.e. DAYS, WEEKS etc.
            * @returns {number} The number of days between the start of the filter and the comparison filter
            */ }, { key: 'getFilterTimeShift', value: function getFilterTimeShift(filter, comparisonFilter) {
               var _this = this;var timeShiftUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DAY';try {
                    var startDates = _.map([comparisonFilter, filter], function (timeFilter) {
                         return _this.getDateStringFromTime_(timeFilter);
                    });if (timeShiftUnit === this.QUARTER) {
                         return this.getQuarterDiff_(comparisonFilter, filter);
                    }var momentMeasurement = _.get(this.TIME_SHIFT_UNIT_TO_MOMENT_MEASUREMENT, timeShiftUnit);return moment(startDates[0]).startOf(momentMeasurement).diff(moment(startDates[1]).startOf(momentMeasurement), momentMeasurement);
               } catch (e) {
                    console.log('Failed to calculate time shift for filters ' + JSON.stringify(filter) + ' and ' + JSON.stringify(comparisonFilter) + ' with timeShiftUnit ' + timeShiftUnit + '.', e);return 0;
               }
          } }]);return TimeShift;
}();

},{}],48:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/function TimesDynamic() {
          _classCallCheck(this, TimesDynamic); // one minute to keep the resolved dynamic time filter in the cache
          this.defaultLanguage = 'en';this.timeRangeDropdownItems = {};this.timeRangesLoadedAt = false;
     } /**
       * Returns a map of all dynamic time filters that might have a comparison dynamic time filter,
       * with their respective comparisons.
       * @returns {Object}
       * @private
       */_createClass(TimesDynamic, [{ key: 'delegate', /**
                                                        * Since extends does not play nice with nested require, Class provides this helper method to delegate
                                                        * properties and methods to classes wishing to extend it.
                                                        * @param  {Object} iForeignContext The this of the foreign context
                                                        * @todo: Eliminate this method with regular inheritance,
                                                        */value: function delegate(iForeignContext) {
               var _this = this;var getOwnPropertyNamesDeep = function getOwnPropertyNamesDeep(obj) {
                    var props = [];var proto = Object.getPrototypeOf(obj);if (!proto) {
                         return props;
                    }props = Object.getOwnPropertyNames(proto);if (_.includes(props, 'delegate')) {
                         return props;
                    }return getOwnPropertyNamesDeep(proto);
               };var methodNames = getOwnPropertyNamesDeep(this); // Delegate properties
               _.forEach(this, function (p, propertyName) {
                    iForeignContext[propertyName] = _this[propertyName];
               }); // Delegate methods
               _.forEach(methodNames, function (methodName) {
                    if (methodName !== 'constructor' && methodName !== 'delegate' && _.isFunction(_this[methodName])) {
                         Object.getPrototypeOf(iForeignContext)[methodName] = _this[methodName];
                    }
               });
          } /**
            * The arrange type of a dynamic time period
            */ }, { key: 'setDefaultLanguage', /**
                                               * setting the language
                                               * @param {string} language
                                               */value: function setDefaultLanguage(language) {
               if (!_.isString(language)) {
                    return;
               }this.defaultLanguage = language;
          } /**
            * Saves the time range array locally
            * @param {Array} items
            * @param {string} lang
            * @returns {boolean}
            */ }, { key: 'setDynamicTimeRanges', value: function setDynamicTimeRanges(items, lang) {
               if (_.isUndefined(items) || !items) {
                    return false;
               }this.timeRangeDropdownItems[lang || this.defaultLanguage] = items;return true;
          } /**
            * On timerange loaded callback
            */ }, { key: 'onTimeRangesLoaded', value: function onTimeRangesLoaded() {
               this.timeRangesLoadedAt = moment().valueOf();
          } /**
            * The time ranges array
            * @param {string} lang
            * @returns {*}
            */ }, { key: 'getDynamicTimeRanges', value: function getDynamicTimeRanges(lang) {
               return this.timeRangeDropdownItems[lang || this.defaultLanguage];
          } /**
            * Retrieves the dynamic time ranges that are usable within the real time
            * calculation layer.
            * @param   {string}  lang
            * @param   {boolean} excludeComparison Whether to include time ranges that are mostly comparison related
            * @returns {Array<Object>}
            */ }, { key: 'getRealTimeRanges', value: function getRealTimeRanges(lang) {
               var _this2 = this;var excludeComparison = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;var timeRanges = this.getDynamicTimeRanges(lang); // TODO Added last_60_minutes suite non realtime timerange for SWAT-1830. Proper solution will follow in SWAT-1825
               var realTimes = _.chain(timeRanges).filter(function (timeRange) {
                    return timeRange.realTime || timeRange.id === 'last_60_minutes';
               }).cloneDeep().value();if (!excludeComparison) {
                    return realTimes;
               }return _.chain(realTimes).reject(function (realTime) {
                    var id = _.get(realTime, 'id');return _.includes(_this2.REAL_TIME_COMPARISONS_, id);
               }).orderBy([function (realTime) {
                    var id = _.get(realTime, 'id');var index = _.indexOf(_this2.REAL_TIME_TO_COMPARE_, id);return index === -1 ? realTimes.length : index;
               }, 'title'], ['asc', 'desc']).value();
          } /**
            * Retrieves the dynamic time ranges that are used as comparison in the real time
            * calculation layer.
            * @param   {string} lang The language for which to load dynamic time filters
            * @param   {string} type The element type for which to look comparison for
            * @returns {Array<Object>}
            */ }, { key: 'getRealTimeComparisons', value: function getRealTimeComparisons(lang, type) {
               var realTimes = this.getRealTimeRanges(lang);return _.chain(this.REAL_TIME_COMPARISON_MAP_).map(function (comparisons, key) {
                    _.forEach(comparisons, function (comparison) {
                         return _.set(comparison, 'compares', key);
                    });return comparisons;
               }).flatten().filter(function (comparison) {
                    return _.includes(comparison.types, type);
               }).map(function (comparison) {
                    var dynamicTime = _.find(realTimes, { id: comparison.id });return _.chain(comparison).pick(['compares']).merge(dynamicTime).value();
               }).value();
          } /**
            * Returns the time range object from the list
            * @param {string} key
            * @param {string} lang
            * @returns {Array}
            */ }, { key: 'getDynamicTimeRangeByKey', value: function getDynamicTimeRangeByKey(key, lang) {
               if (!_.isString(key)) {
                    return false;
               }return _.find(this.timeRangeDropdownItems[lang || this.defaultLanguage], function (dynamicTimeRange) {
                    if (key === _.get(dynamicTimeRange, 'id')) {
                         return true;
                    }return key === _.get(dynamicTimeRange, 'coreName');
               });
          } /**
            * Will return only the acceptable properties for a dynamic time range object
            * @param {Object} dynamicTimeRange An object hopefully containing the proper properties
            * @returns {Object} An object containing only the following properties 'id', 'coreName', 'title', 'type', 'visibleInFrontend'
            */ }, { key: 'sanitizeDynamicTimeRange', value: function sanitizeDynamicTimeRange(dynamicTimeRange) {
               return _.pick(dynamicTimeRange, ['id', 'coreName', 'title', 'type', 'visibleInFrontend']);
          } }, { key: 'getDynamicTimeRangeByFilter_', value: function getDynamicTimeRangeByFilter_(filter) {
               // Get the value1, should be the id of the dynamic time filter
               var id = _.get(filter, 'value1'); // Try to fetch the entire dynamic filter configuration
               return this.getDynamicTimeRangeByKey(id);
          } /**
            * Replaces the value1 of a given times_dynamic filter rule with the equivalent coreName.
            * @param {Object} filter
            */ }, { key: 'setCoreName', value: function setCoreName(filter) {
               if (_.get(filter, 'arrangeType') !== this.TIMES_DYNAMIC_ARRANGE_TYPE) {
                    return;
               }var dynamicTime = this.getDynamicTimeRangeByFilter_(filter);var coreName = _.get(dynamicTime, 'coreName');if (!coreName) {
                    return;
               }_.set(filter, 'value1', coreName);
          } /**
            * Replaces dynamic time filters with their resolved equivalent.
            * @param {Object} filter
            */ }, { key: 'setResolvedFilter', value: function setResolvedFilter(filter) {
               if (_.get(filter, 'arrangeType') !== this.TIMES_DYNAMIC_ARRANGE_TYPE) {
                    return;
               }var dynamicTime = this.getDynamicTimeRangeByFilter_(filter);var resolvedFilter = _.get(dynamicTime, 'resolvedFilter', {});_.merge(filter, resolvedFilter);
          } }, { key: 'REAL_TIME_COMPARISON_MAP_', get: function get() {
               // TODO Added last_60_minutes suite non realtime timerange for SWAT-1830. Proper solution will follow in SWAT-1825
               return { today: [{ id: 'before_7_days', types: ['SPARKLINE_LIVE'] }, { id: 'before_7_days_realtime', types: ['KPI_LIVE'] }], last_2_hours: [{ id: 'before_7_days_last_2_hours', types: ['KPI_LIVE', 'SPARKLINE_LIVE'] }], last_60_minutes: [{ id: 'before_7_days_last_60_minutes', types: ['KPI_LIVE', 'SPARKLINE_LIVE'] }], last_30_minutes: [{ id: 'before_7_days_last_30_minutes', types: ['KPI_LIVE', 'SPARKLINE_LIVE'] }], last_30_seconds: [] };
          } /**
            * The list of dynamic time filters that are mainly used
            * for comparison
            * @returns {Array<string>} List of dynamic filter ids
            * @private
            */ }, { key: 'REAL_TIME_COMPARISONS_', get: function get() {
               return _.chain(this.REAL_TIME_COMPARISON_MAP_).values().flatten().map('id').concat(['yesterday', 'yesterday_realtime']) // add the two y-day comparison values for now until the core can deal with them
               .value();
          } /**
            * The list of dynamic time filters that have a matching dynamic time comparison
            * @returns {Array<string>} List of dynamic filter ids
            * @private
            */ }, { key: 'REAL_TIME_TO_COMPARE_', get: function get() {
               return _.keys(this.REAL_TIME_COMPARISON_MAP_);
          } /**
            * The list of dynamic time filters used in live analyses that resolve to a day interval
            * @returns {Array}
            * @constructor
            */ }, { key: 'REAL_TIME_DAILY_TIME_FILTERS', get: function get() {
               return ['today', 'before_7_days', 'yesterday'];
          } }, { key: 'TIMES_DYNAMIC_ARRANGE_TYPE', get: function get() {
               return 'times_dynamic';
          } }]);return TimesDynamic;
}();

},{}],49:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject */function TimesDynamicCache() {
          _classCallCheck(this, TimesDynamicCache);this.TimesDynamicCache_ = {};
     } /**
       * Get all resolved dynamic time ranges
       * @returns {Object}
       */_createClass(TimesDynamicCache, [{ key: 'getCachedKeys', value: function getCachedKeys() {
               return this.TimesDynamicCache_;
          } /**
            * Sets multiple resolved filters based on a given collection
            * @param  {Object} dynamicTimeRanges List of dynamic time range objects with resolvedFilter property
            * @param  {number} ttl Optional parameter to define a time-to-live for each set value
            */ }, { key: 'setCachedKeys', value: function setCachedKeys(dynamicTimeRanges, ttl) {
               var _this = this;_.chain(dynamicTimeRanges).filter(function (dynamicTimeRange) {
                    return _.hasIn(dynamicTimeRange, 'id') && _.hasIn(dynamicTimeRange, 'resolvedFilter');
               }).forEach(function (_ref) {
                    var id = _ref.id,
                        resolvedFilter = _ref.resolvedFilter;return _this.setCachedKey(id, resolvedFilter, ttl);
               }).value();
          } /**
            * @param {string} iKey
            * @param {Object} iTimesDynamic
            * @param  {number} iTtl Optional parameter to define a time-to-live for each set value
            */ }, { key: 'setCachedKey', value: function setCachedKey(iKey, iTimesDynamic, iTtl) {
               var _this2 = this;this.TimesDynamicCache_[iKey] = iTimesDynamic;if (iTtl) {
                    setTimeout(function () {
                         _this2.removeCachedKey(iKey);
                    }, iTtl);
               }
          } /**
            * @param  {string} iKey
            * @returns {Object|null}
            */ }, { key: 'getCachedKey', value: function getCachedKey(iKey) {
               return this.TimesDynamicCache_[iKey] || null;
          } /**
            * @param  {string} iKey
            */ }, { key: 'removeCachedKey', value: function removeCachedKey(iKey) {
               delete this.TimesDynamicCache_[iKey];
          } }]);return TimesDynamicCache;
}();

},{}],50:[function(require,module,exports){
'use strict';
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
} /**
  * @typedef {Object} TraverseGraphNode
  * @property {Object} node Contains the graph node information
  * @property {Object} node.source Contains the node configuration
  * @property {TraverseGraphNode} node.parent Contains the reference to the parent node
  * @property {string} node.type Contains the type of the configuration the node points to
  * @property {Object} context Contains the meta information about the graph node
  *
  * TODO: Refactor the visit result to include the following pattern
  * {
  *  parentNode: {},     // The parent node (graph node)
  *  source: {},         // The child entity configuration
  *  connection: {},     // The connection object if the node is transitive (eg. via a filter or segment connection object)
  *  context: {}         // Additional meta information to pass to the caller
  * }
  */ /**
     * TraverseFactory is a cursor for traversing the configurations graph of a configuration entity.
     *
     * Following configuration entities are known:
     * - Report: Includes Report configurations
     * - Analysis: Include Analysis, KPI, Sparkline configurations
     * - Segment: Includes Segment configurations
     * - Monad: Includes configurations that implement the monad interface as analysis column, metric, dimension, custom metric, formula, metric based formula parameter
     *
     * The traversal of the configuration graph is performed using Depth-first search algorithm.
     * The linear order of the vertices during the graph traversal is based on "pre-ordering", meaning that for every visited vertex, the order will be
     * - The visited vertex
     * - The result of in depth visit of each sub-tree
     *
     * Even though the configuration graph is a finite graph, its vertices may very often occur several times during the traversal due to their
     * nature of being recursive (eg. a metric may be based on another metric) and often being referenced by more than one parent vertex
     * (eg. same metric may be referenced by two columns). That is why the traversal result consists of the graphs nodes (vertex + edge that lead to this vertex),
     * as these are always unique and are self sufficient when describing the relationships between two graph vertices.
     *
     * Two graph vertices can have direct adjacency (eg. Column -> Metric) or transitive adjacency (eg. Column => Segment Connection -> Segment)
     *
     * Two graph vertices can belong to the same configuration (eg. Analysis => Column) or can be external configurations (eg. Column -> Metric).
     * The graph nodes that are connected to the parent node via an external edge, will have the "connection" property set so that the caller
     * can identify own and external nodes.
     *
     * The diagram of the entire configurations graph can be found {@link https://stash.webtrekk.com/projects/WTMOD/repos/wt-libraries/browse/docs/diagrams/configurations-graph.jpg|here}
     */var TraverseFactory = function () {
    function TraverseFactory(rawMonads, liveMonads, segments) {
        _classCallCheck(this, TraverseFactory);this.rawMonads = _.isArray(rawMonads) ? _.keyBy(rawMonads, 'arrangeType') : rawMonads;this.liveMonads = _.isArray(liveMonads) ? _.keyBy(liveMonads, 'arrangeType') : liveMonads;this.segments = _.isArray(segments) ? _.keyBy(segments, 'id') : segments;
    } /**
      * @ngdoc property
      * @name TraverseFactory#TRAVERSE_LEVEL
      * @description Provides level used in traverse logic
      * LAZY - provides only nodes used in element, but no monads or segments
      * SHALLOW - provides nodes used in element, but also the monads and segments used in element
      * DEEP - provides nodes used in element, also the monads and segments used in element, but also all nodes used
      * deep in monads or segments
      *
      * @example
      * 1. report use segment with id 15 and segment has filter city = berlin
      * LAZY level provides only predefinedSegmentConnection used in report
      * SHALLOW level, provides predefinedSegmentConnection used in report and also active segment object
      * DEEP level, provides predefinedSegmentConnection used in report, active segment object and also monad city
      *
      * 2. report use category city
      * LAZY level provides only metric or dimension node used in report
      * SHALLOW level, provides metric or dimension node used in report and also monad city
      * DEEP level, there is no DEEP level for categories or parameters
      *
      * @returns {Object}
      */_createClass(TraverseFactory, [{ key: 'getVisitorTemplate', /**
                                                                    * @ngdoc method
                                                                    * @name TraverseFactory#getVisitorTemplate
                                                                    * @description Provides a template of the visited node to get more information to the caller
                                                                    * @returns {Object}
                                                                    */value: function getVisitorTemplate() {
            return { /**
                     * Contains the visited node
                     * It could be only Report, Analysis, Monad, Segment
                     * @type {Object}
                     */node: { /**
                               * Visited node settings
                               * @type {Object|null}
                               */source: null, /**
                                               * Parent node
                                               * Report has no parent
                                               * Analyse has Report as parent
                                               * Column has Analyse as parent
                                               * Segment in the analyse has Column as parent
                                               * Dimension used as filter in segment has Column as parent, but Segment as connection
                                               * @type {Object|null}
                                               */parent: null, /**
                                                               * Closest visited parent node
                                                               * Report has no connection
                                                               * Analyse has no connection
                                                               * Column has no connection
                                                               * Segment in the analyse has no connection
                                                               * Dimension used as filter in segment has Segment as connection, but Column as parent
                                                               * @type {Object|null}
                                                               */connection: null, /**
                                                                                   * Describes the graph node type
                                                                                   * @type {null|string}
                                                                                   */type: null }, /**
                                                                                                   * The meta information of the current node
                                                                                                   * @type {Object}
                                                                                                   */context: { /**
                                                                                                                * Is node used in live analysis
                                                                                                                * @type {Boolean|false}
                                                                                                                */realTime: false } };
        } /**
          * @ngdoc method
          * @name TraverseFactory#isLazyConnection
          * @description Check if traverseLevel is LAZY and parent has no connection
          * @param {Object} node represents visitorTemplate
          * @param {string} traverseLevel The traverse level
          * @returns {Boolean} true, if LAZY and connectionsCount === 0
          */ }, { key: 'isLazyConnection', value: function isLazyConnection(node, traverseLevel) {
            return _.isEqual(traverseLevel, this.TRAVERSE_LEVEL.LAZY) && this.getConnectionsCount_(node) === 0;
        } /**
          * @ngdoc method
          * @name TraverseFactory#isShallowConnection
          * @description Check if traverseLevel is shallow and parent has already one connection, which means node is called from some other node
          * @param {Object} node represents visitorTemplate
          * @param {string} traverseLevel The traverse level
          * @returns {Boolean} true, if SHALLOW and connectionsCount === 1
          */ }, { key: 'isShallowConnection', value: function isShallowConnection(node, traverseLevel) {
            return _.isEqual(traverseLevel, this.TRAVERSE_LEVEL.SHALLOW) && this.getConnectionsCount_(node) === 1;
        } /**
          * @ngdoc method
          * @name TraverseFactory#isDeepConnection
          * @description Check if traverseLevel is DEEP and parent has more than 1 connection
          * @param {Object} node represents visitorTemplate
          * @param {string} traverseLevel The traverse level
          * @returns {Boolean} true, if DEEP and connectionsCount > 1
          */ }, { key: 'isDeepConnection', value: function isDeepConnection(node, traverseLevel) {
            return _.isEqual(traverseLevel, this.TRAVERSE_LEVEL.DEEP) && this.getConnectionsCount_(node) > 1;
        } /**
          * Assesses that a graph node is of specified type
          * @param {TraverseGraphNode} node A traversal graph node
          * @param {string} type The node type to assert
          * @returns {boolean}
          */ }, { key: 'isNodeOfType', value: function isNodeOfType(node, type) {
            return _.get(node, 'node.type') === type;
        } /**
          * @ngdoc method
          * @name TraverseFactory#isReportNode
          * @description Assesses that a graph node is a report configuration
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isReportNode', value: function isReportNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_REPORT);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isAnalysisNode
          * @description Assesses that a graph node is an analysis configuration
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isAnalysisNode', value: function isAnalysisNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_ANALYSIS);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isColumnNode
          * @description Assesses that a graph node is an analysis column configuration
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isColumnNode', value: function isColumnNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_COLUMN);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isMonadNode
          * @description Assesses that a graph node is a monad configuration (metric|dimension)
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isMonadNode', value: function isMonadNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_MONAD);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isFormulaParamNode
          * @description Assesses that a graph node is a metric based formula parameter configuration
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isFormulaParamNode', value: function isFormulaParamNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_FORMULA_PARAMETER);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isSegmentNode
          * @description Assesses that a graph node is a segment configuration
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isSegmentNode', value: function isSegmentNode(node) {
            return this.isNodeOfType(node, this.NODE_TYPE_SEGMENT);
        } /**
          * @ngdoc method
          * @name TraverseFactory#isFilterConnection
          * @description Assesses that the node is connected to the parent node, if any, via a filter
          * @param {TraverseGraphNode} node  A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isFilterConnection', value: function isFilterConnection(node) {
            var connection = _.get(node, 'node.connection', {});return _.has(connection, 'arrangeType') && _.has(connection, 'value1') && _.has(connection, 'value2');
        } /**
          * @ngdoc method
          * @name TraverseFactory#isSegmentConnectionConnection
          * @description Assesses that the node is connected to the parent node, if any, via a segment connection
          * @param {TraverseGraphNode} node  A traversal graph node
          * @returns {boolean}
          */ }, { key: 'isSegmentConnectionConnection', value: function isSegmentConnectionConnection(node) {
            var connection = _.get(node, 'node.connection', {});return _.has(connection, 'segmentID');
        } /**
          * @ngdoc method
          * @name TraverseFactory#getNodeConnectionIdentifier
          * @description Identifies the property by which a connection is linked to an external configuration entity
          * @example
          * Custom Metric -> Metric -> 'baseArrangeType'
          * Segment Connection -> Segment -> 'segmentID'
          * Column -> Metric -> 'arrangeType'
          * KPI -> Metric -> 'metricArrangeType'
          * @param {TraverseGraphNode} node A traversal graph node
          * @returns {string|null}
          */ }, { key: 'getNodeConnectionIdentifier', value: function getNodeConnectionIdentifier(node) {
            var source = _.get(node, 'node.source');var connection = _.get(node, 'node.connection');var sourceIdentifier = this.isSegmentNode(node) ? 'id' : 'arrangeType';var connectionIdentifiers = this.isSegmentNode(node) ? this.SEGMENT_CONNECTION_IDENTIFIERS : this.MONAD_CONNECTION_IDENTIFIERS;if (!connection) {
                return null;
            }return _.find(connectionIdentifiers, function (connectionIdentifier) {
                return _.has(connection, connectionIdentifier) && _.isEqual(connection[connectionIdentifier], source[sourceIdentifier]);
            }) || null;
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseReportLazy
          * @description Traverses a report with lazy level invoking the provided callback on any node
          * that implements the report, analysis or columns interface
          * @param {Object} report report configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseReportLazy', value: function traverseReportLazy(report) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.LAZY;return this.traverseReport_(report, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseReportShallow
          * @description Traverses a report with shallow level invoking the provided callback on any node
          * that implements the report, analysis, columns and monads interface, also monads used in segments
          * @param {Object} report report configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseReportShallow', value: function traverseReportShallow(report) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.SHALLOW;return this.traverseReport_(report, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseReportDeep
          * @description Traverses a report with shallow level invoking the provided callback on any node
          * that implements the report, analysis, columns, monads interface and go deep in the monads
          * Use case only for resolving custom metrics, formulas
          * @param {Object} report report configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseReportDeep', value: function traverseReportDeep(report) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.DEEP;return this.traverseReport_(report, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseAnalysisLazy
          * @description Traverses an analysis with lazy level invoking the provided callback on analyse and any column
          * @param {Object} analysis analysis configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseAnalysisLazy', value: function traverseAnalysisLazy(analysis) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.LAZY;return this.traverseAnalysis_(analysis, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseAnalysisShallow
          * @description Traverses an analysis with shallow level invoking the provided callback on analyse, columns
          * and also every monad used in dimensions, metrics or filters
          * @param {Object} analysis analysis configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseAnalysisShallow', value: function traverseAnalysisShallow(analysis) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.SHALLOW;return this.traverseAnalysis_(analysis, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseAnalysisDeep
          * @description Traverses an analysis with deep level invoking the provided callback on analyse, columns
          * and also every monad used in dimensions, metrics or filters and also on every monads used in monads
          * @example Analyse has column with custom formula and custom formula has metric. All monads will be visited.
          * @param {Object} analysis analysis configuration
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseAnalysisDeep', value: function traverseAnalysisDeep(analysis) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.DEEP;return this.traverseAnalysis_(analysis, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseMonadLazy
          * @description Traverses with lazy level a metric monad (metrics, formulas, predefined and custom) invoking
          * the provided callback on any node that implements the monad interface
          * @param {Object} monad A dimension or metric or formula monad, includes the custom and predefined monads
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseMonadLazy', value: function traverseMonadLazy(monad) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.LAZY;return this.traverseMonad_(monad, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseMonadShallow
          * @description Traverses with shallow level a metric monad (metrics, formulas, predefined and custom) invoking
          * the provided callback on any node that implements the monad interface
          * @param {Object} monad A dimension or metric or formula monad, includes the custom and predefined monads
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseMonadShallow', value: function traverseMonadShallow(monad) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.SHALLOW;return this.traverseMonad_(monad, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseMonadDeep
          * @description Traverses with deep level a metric monad (metrics, formulas, predefined and custom) invoking
          * the provided callback on any node that implements the monad interface
          * @param {Object} monad A dimension or metric or formula monad, includes the custom and predefined monads
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseMonadDeep', value: function traverseMonadDeep(monad) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.DEEP;return this.traverseMonad_(monad, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseSegmentLazy
          * @description Traverse only segment object
          * @param {Object} segment segment object
          * @param {Function=} onVisit Callback to be invoked on node traversal
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseSegmentLazy', value: function traverseSegmentLazy(segment) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.LAZY;return this.traverseSegment_(segment, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseSegmentShallow
          * @description Traverse segment and monads used in filters
          * @param {Object} segment segment object
          * @param {Function=} onVisit Callback to be invoked on node traverse
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          */ }, { key: 'traverseSegmentShallow', value: function traverseSegmentShallow(segment) {
            var onVisit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;var traverseLevel = this.TRAVERSE_LEVEL.SHALLOW;return this.traverseSegment_(segment, onVisit, traverseLevel);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseReport_
          * @description Traverses an report, analysis and analysis columns
          * @param {Object} report report configuration
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The travers level
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseReport_', value: function traverseReport_(report, onVisit, traverseLevel) {
            var _this = this;if (_.isUndefined(report)) {
                return [];
            }var dashboardQuickFilters = _.get(report, 'dashboardQuickFilters', []);var reportElements = _.chain(report).get('reportElements', []).filter(function (element) {
                return _.includes(_this.TRAVERSE_REPORT_ELEMENT_TYPES, element.type);
            }).value();var rootNode = this.createReportGraphNode_(report);onVisit(rootNode);var quickFilterNodes = _.flatMap(dashboardQuickFilters, function (dashBoardFilter) {
                return _this.traverseArrangeTypeConnection_(dashBoardFilter.arrangeType, onVisit, traverseLevel, rootNode, dashBoardFilter);
            });var reportElementsNodes = _.flatMap(reportElements, function (reportElement) {
                return _this.traverseAnalysis_(reportElement.configJson, onVisit, traverseLevel, rootNode);
            });return _.concat(rootNode, quickFilterNodes, reportElementsNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseAnalysis_
          * @description Traverses an analysis and analysis columns
          * @param {Object} analysis A dimension or metric
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The travers level
          * @param {Object} parent empty or report
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseAnalysis_', value: function traverseAnalysis_(analysis, onVisit, traverseLevel) {
            var _this2 = this;var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (_.isUndefined(analysis)) {
                return [];
            }var columns = _.get(analysis, 'columns', []);var comparisonFilter = _.get(analysis, 'comparison.filter', {});var visitorContext = _.assign({}, this.defaultContext, { realTime: analysis.realTime });var rootNode = this.createAnalysisGraphNode_(analysis, parent, null, visitorContext);onVisit(rootNode);var columnsNodes = _.flatMap(columns, function (column) {
                return _this2.traverseAnalysisColumn_(column, onVisit, traverseLevel, rootNode);
            });var comparisonNodes = this.traverseArrangeTypeConnection_(comparisonFilter.arrangeType, onVisit, traverseLevel, rootNode, comparisonFilter);var dimensionNodes = this.traverseArrangeTypeConnection_(analysis.dimensionArrangeType, onVisit, traverseLevel, rootNode, analysis);var metricNodes = this.traverseArrangeTypeConnection_(analysis.metricArrangeType, onVisit, traverseLevel, rootNode, analysis);var filtersNodes = this.traverseContainerFilters_(analysis.predefinedContainer, onVisit, traverseLevel, rootNode);var segmentsNodes = this.traversePredefinedSegmentConnections_(analysis, onVisit, traverseLevel, rootNode);var viewModeNodes = this.traverseViewMode_(analysis.viewMode, onVisit, traverseLevel, rootNode);return _.concat(rootNode, columnsNodes, comparisonNodes, dimensionNodes, metricNodes, filtersNodes, segmentsNodes, viewModeNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseAnalysisColumn_
          * @description Traverses an analysis column
          * @param {Object} column A dimension or metric
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent analysis
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseAnalysisColumn_', value: function traverseAnalysisColumn_(column, onVisit, traverseLevel, parent) {
            if (_.isUndefined(column)) {
                return [];
            }var rootNode = this.createColumnGraphNode_(column, parent);onVisit(rootNode);var columnNodes = this.traverseArrangeTypeConnection_(column.arrangeType, onVisit, traverseLevel, rootNode, column);var filtersNodes = this.traverseContainerFilters_(column.predefinedContainer, onVisit, traverseLevel, rootNode);var segmentsNodes = this.traversePredefinedSegmentConnections_(column, onVisit, traverseLevel, rootNode);return _.concat(rootNode, columnNodes, filtersNodes, segmentsNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseViewMode_
          * @description Traverses an viewMode of analysis
          * @param {Object} viewMode comparisons view mode
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent analysis
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseViewMode_', value: function traverseViewMode_(viewMode, onVisit, traverseLevel, parent) {
            var _this3 = this;if (_.isUndefined(viewMode)) {
                return [];
            }var comparisonTimes = _.get(viewMode, 'comparison.values.time', []);var comparisonSegments = _.get(viewMode, 'comparison.values.segment', []);var comparisonTimesNodes = _.flatMap(comparisonTimes, function (comparisonTime) {
                return _this3.traverseArrangeTypeConnection_(comparisonTime.arrangeType, onVisit, traverseLevel, parent);
            });var comparisonSegmentsNodes = _.flatMap(comparisonSegments, function (segmentConnection) {
                return _this3.traverseSegmentConnection_(segmentConnection, onVisit, traverseLevel, parent);
            });return _.concat(comparisonTimesNodes, comparisonSegmentsNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseMonad_
          * @description Traverses a metric monad (metrics, formulas, predefined and custom) invoking
          * the provided callback on any node that implements the monad interface
          * @param {Object} monad A dimension or metric or formula monad, includes the custom and predefined monads
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The travers level
          * @param {Object} parent parent node
          * @param {Object} connection closest parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseMonad_', value: function traverseMonad_(monad, onVisit, traverseLevel) {
            var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var connection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;if (_.isUndefined(monad) || !_.isPlainObject(monad) || !_.has(monad, 'arrangeType')) {
                return [];
            }var formulaDefinition = _.get(monad, 'customFormula');var rootNode = this.createMonadGraphNode_(monad, parent, connection);onVisit(rootNode);if (this.isShallowConnection(rootNode, traverseLevel)) {
                return _.concat(rootNode);
            }var formulaNodes = this.traverseFormula_(formulaDefinition, onVisit, traverseLevel, rootNode);var filtersNodes = this.traverseContainerFilters_(monad, onVisit, traverseLevel, rootNode);var segmentsNodes = this.traversePredefinedSegmentConnections_(monad, onVisit, traverseLevel, rootNode);var monadNodes = this.traverseArrangeTypeConnection_(monad.baseArrangeType, onVisit, traverseLevel, rootNode, monad);return _.concat(rootNode, formulaNodes, filtersNodes, segmentsNodes, monadNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseFormula_
          * @description Get monad by arrangeType and traverse monad
          * @param {Object} formulaDefinition formula definition
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseFormula_', value: function traverseFormula_(formulaDefinition, onVisit, traverseLevel, parent) {
            if (_.isUndefined(formulaDefinition)) {
                return [];
            }return this.traverseParameter_(formulaDefinition, onVisit, traverseLevel, parent);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseSegment_
          * @description Traverses segment
          * If method doesn't have connection, than handle it depends on traverseLevel
          * If method is called from some other node and traverseLevel is shallow, than just visit the segment and don't go deeper
          *
          * @param {Object} segment segment object
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object|null} parent parent node
          * @param {Object|null} connection closest parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseSegment_', value: function traverseSegment_(segment, onVisit, traverseLevel) {
            var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var connection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;if (_.isUndefined(segment)) {
                return [];
            }var rootNode = this.createSegmentGraphNode_(segment, parent, connection);onVisit(rootNode);if (this.isShallowConnection(rootNode, traverseLevel)) {
                return _.concat(rootNode);
            }var filtersNodes = this.traverseContainerFilters_(segment.filter, onVisit, traverseLevel, rootNode);return _.concat(rootNode, filtersNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseSegment_
          * @description Get segment by id and traverse segment
          * @param {Object} segmentConnection segmentConnection
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseSegmentConnection_', value: function traverseSegmentConnection_(segmentConnection, onVisit, traverseLevel) {
            var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (!_.get(segmentConnection, 'segmentID') || _.isEqual(traverseLevel, this.TRAVERSE_LEVEL.LAZY)) {
                return [];
            }var segment = this.segments[segmentConnection.segmentID];return this.traverseSegment_(segment, onVisit, traverseLevel, parent, segmentConnection);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseParameter_
          * @description Traverses a formula parameter of any type
          * @param {Object} parameter A formula parameter of any type
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseParameter_', value: function traverseParameter_(parameter, onVisit, traverseLevel, parent) {
            // Processes the function parameters
            if (this.isParameterFunction_(parameter)) {
                return this.traverseFunctionParameter_(parameter, onVisit, traverseLevel, parent);
            } // Processes the metric parameters (metrics and formulas)
            if (this.isParameterMetric_(parameter)) {
                return this.traverseMetricParameter_(parameter, onVisit, traverseLevel, parent);
            } // Ignores constants
            return [];
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseMetricParameter_
          * @description Traverses a formula parameter of type metric
          * @param {Object} parameter A formula parameter of type metric|formula
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseMetricParameter_', value: function traverseMetricParameter_(parameter, onVisit, traverseLevel, parent) {
            var rootNode = this.createFormulaParamGraphNode_(parameter, parent);onVisit(rootNode);var parameterNodes = this.traverseArrangeTypeConnection_(parameter.arrangeType, onVisit, traverseLevel, rootNode, parameter);var filtersNodes = this.traverseContainerFilters_(parameter, onVisit, traverseLevel, rootNode);var segmentsNodes = this.traversePredefinedSegmentConnections_(parameter, onVisit, traverseLevel, rootNode);return _.concat(rootNode, parameterNodes, filtersNodes, segmentsNodes);
        } /**
          * Traverses a formula parameter of type function
          * @param {Object} parameter A formula parameter of type function
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseFunctionParameter_', value: function traverseFunctionParameter_(parameter, onVisit, traverseLevel, parent) {
            var _this4 = this;var funcParameters = _.get(parameter, 'parameters', []);return _.flatMap(funcParameters, function (funcParameter) {
                return _this4.traverseParameter_(funcParameter, onVisit, traverseLevel, parent);
            });
        } /**
          * @ngdoc method
          * @name TraverseFactory#traversePredefinedSegmentConnections_
          * @description Traverses predefinedSegmentConnections
          * @param {Object} monad monad with predefinedSegmentConnections
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traversePredefinedSegmentConnections_', value: function traversePredefinedSegmentConnections_(monad, onVisit, traverseLevel) {
            var _this5 = this;var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (_.isUndefined(monad)) {
                return [];
            }return _.flatMap(_.get(monad, 'predefinedSegmentConnections', []), function (segmentConnection) {
                return _this5.traverseSegmentConnection_(segmentConnection, onVisit, traverseLevel, parent);
            });
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseContainerFilters_
          * @description Traverses container and filters recursive and for every filter traverse monad
          * Visit filter only if settings visitFilter is true.
          * @param {Object} container every node that has containers or filters
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The traverse level
          * @param {Object} parent parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseContainerFilters_', value: function traverseContainerFilters_(container, onVisit, traverseLevel) {
            var _this6 = this;var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;if (_.isUndefined(container)) {
                return [];
            }var containersNodes = _.flatMap(_.get(container, 'containers', []), function (nestedContainer) {
                return _this6.traverseContainerFilters_(nestedContainer, onVisit, traverseLevel, parent);
            });var filtersNodes = _.flatMap(_.get(container, 'filters', []), function (filter) {
                return _this6.traverseArrangeTypeConnection_(filter.arrangeType, onVisit, traverseLevel, parent, filter);
            });return _.concat(containersNodes, filtersNodes);
        } /**
          * @ngdoc method
          * @name TraverseFactory#traverseArrangeTypeConnection_
          * @description Get monad by arrangeType and traverse monad
          * @param {String} arrangeType monad identity
          * @param {Function} onVisit Callback to be invoked on node traversal
          * @param {string} traverseLevel The travers level
          * @param {Object} parent parent node
          * @param {Object} connection closest parent node
          * @returns {Array<TraverseGraphNode>} The linear representation of the traversed graph nodes
          * @private
          */ }, { key: 'traverseArrangeTypeConnection_', value: function traverseArrangeTypeConnection_(arrangeType, onVisit, traverseLevel) {
            var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var connection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;if (_.isUndefined(arrangeType) || _.isEqual(traverseLevel, this.TRAVERSE_LEVEL.LAZY)) {
                return [];
            }var context = _.isEmpty(parent) ? this.defaultContext : parent.context;var monad = context.realTime ? this.liveMonads[arrangeType] : this.rawMonads[arrangeType];return this.traverseMonad_(monad, onVisit, traverseLevel, parent, connection);
        } /**
          * Assesses a parameter to be of type function
          * @param {Object} parameter The parameter to be checked
          * @returns {boolean}
          */ }, { key: 'isParameterFunction_', value: function isParameterFunction_(parameter) {
            return _.get(parameter, 'type') === 'FUNCTION';
        } /**
          * Assesses a parameter to be of type metric. These parameters can be based on metrics, custom metrics or custom formulas.
          * @param {Object} parameter The parameter to be checked
          * @returns {boolean}
          */ }, { key: 'isParameterMetric_', value: function isParameterMetric_(parameter) {
            return _.get(parameter, 'type') === 'METRIC';
        } /**
          * @ngdoc method
          * @name TraverseFactory#createGraphNode_
          * @description Creates a new graph node
          * @param {Object} source The graph node source configuration (eg. metric, analysis, segment configuration)
          * @param {Object|null} parent The parent graph node
          * @param {Object|null} connection The configuration via which the two graph nodes are connected (eg. filter, segmentConnection, etc.)
          * @param {Object|null} contextOverride Each child graph node inherits its parent context with the ability to override it
          * @returns {TraverseGraphNode}
          * @private
          */ }, { key: 'createGraphNode_', value: function createGraphNode_(source) {
            var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var connection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var contextOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;var context = _.chain(parent).get('context', this.defaultContext).cloneDeep().merge(contextOverride).value();var template = this.getVisitorTemplate();return _.assign(template, { node: { source: source, parent: parent, connection: connection }, context: context });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createReportGraphNode_', value: function createReportGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_REPORT } });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createAnalysisGraphNode_', value: function createAnalysisGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_ANALYSIS } });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createColumnGraphNode_', value: function createColumnGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_COLUMN } });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createMonadGraphNode_', value: function createMonadGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_MONAD } });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createFormulaParamGraphNode_', value: function createFormulaParamGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_FORMULA_PARAMETER } });
        } /**
          * @returns {Object}
          * @private
          */ }, { key: 'createSegmentGraphNode_', value: function createSegmentGraphNode_() {
            return _.merge(this.createGraphNode_.apply(this, arguments), { node: { type: this.NODE_TYPE_SEGMENT } });
        } /**
          * @param {Object} visitorNode
          * @returns {number}
          * @private
          */ }, { key: 'getConnectionsCount_', value: function getConnectionsCount_(visitorNode) {
            var parent = _.get(visitorNode, 'node.parent');var count = _.chain(visitorNode).get('node.connection').isEmpty().value() ? 0 : 1;if (!parent) {
                return count;
            }return count + this.getConnectionsCount_(parent);
        } }, { key: 'TRAVERSE_LEVEL', get: function get() {
            return { LAZY: 'LAZY', SHALLOW: 'SHALLOW', DEEP: 'DEEP' };
        } /**
          * Report element types containing analyses
          * @returns {Array}
          */ }, { key: 'TRAVERSE_REPORT_ELEMENT_TYPES', get: function get() {
            return ['ANALYSIS', 'ANALYSIS_LIVE', 'KPI', 'KPI_LIVE', 'SPARKLINE', 'SPARKLINE_LIVE'];
        } /**
          * Node name for nodes of type report
          * @returns {string}
          */ }, { key: 'NODE_TYPE_REPORT', get: function get() {
            return 'REPORT';
        } /**
          * Node name for nodes of type analysis (analysis|kpi|sparkline)
          * @returns {string}
          */ }, { key: 'NODE_TYPE_ANALYSIS', get: function get() {
            return 'ANALYSIS';
        } /**
          * Node name for nodes of type analysis column
          * @returns {string}
          */ }, { key: 'NODE_TYPE_COLUMN', get: function get() {
            return 'COLUMN';
        } /**
          * Node name for nodes of type monad (metric|dimension|formula)
          * @returns {string}
          */ }, { key: 'NODE_TYPE_MONAD', get: function get() {
            return 'MONAD';
        } /**
          * Node name for nodes of type formula parameter based on metrics
          * @returns {string}
          */ }, { key: 'NODE_TYPE_FORMULA_PARAMETER', get: function get() {
            return 'FORMULA_PARAMETER';
        } /**
          * Node name for nodes of type segment
          * @returns {string}
          */ }, { key: 'NODE_TYPE_SEGMENT', get: function get() {
            return 'SEGMENT';
        } /**
          * Provides all the properties of a connection configuration that can be linked to an entity of type monad
          * @returns {Array}
          */ }, { key: 'MONAD_CONNECTION_IDENTIFIERS', get: function get() {
            return ['arrangeType', 'baseArrangeType', 'metricArrangeType', 'dimensionArrangeType'];
        } /**
          * Provides all the properties of a connection configuration that can be linked to an entity of type segment
          * @returns {Array}
          */ }, { key: 'SEGMENT_CONNECTION_IDENTIFIERS', get: function get() {
            return ['segmentID'];
        } /**
          * @ngdoc property
          * @name TraverseFactory#defaultContext
          * @description Returns default context
          * @returns {Object} with realTime: false
          */ }, { key: 'defaultContext', get: function get() {
            return { realTime: false };
        } }]);return TraverseFactory;
}();module.exports = TraverseFactory;

},{}],51:[function(require,module,exports){
"use strict";
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}var TraverseService = function () {
     /*@ngInject*/
     TraverseService.$inject = ['TraverseFactory'];function TraverseService(TraverseFactory) {
          _classCallCheck(this, TraverseService);this.TraverseFactory = TraverseFactory;
     } /**
       * Creates a new traversal cursor for the given primitive configurations
       * @param {Object|Array} rawMonads A collection of raw data metrics and dimensions to use when resolving the configurations graph
       * @param {Object|Array} liveMonads A collection of live data metrics and dimensions to use when resolving the configurations graph
       * @param {Object|Array} segments A collection of segments to use when resolving the configurations graph
       * @returns {TraverseFactory}
       */_createClass(TraverseService, [{ key: "createCursor", value: function createCursor(rawMonads, liveMonads, segments) {
               return new this.TraverseFactory(rawMonads, liveMonads, segments);
          } }]);return TraverseService;
}();module.exports = TraverseService;

},{}],52:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     UserPreferenceThreshold.$inject = ['Monads', 'QueryTemplates', 'accountService'];function UserPreferenceThreshold(Monads, QueryTemplates, accountService) {
          _classCallCheck(this, UserPreferenceThreshold);this.Monads = Monads;this.QueryTemplates = QueryTemplates;this.accountService = accountService;
     } /**
       * List of 'arrangeTypes' used in the
       */_createClass(UserPreferenceThreshold, [{ key: 'isUserPreferenceContainer_', /**
                                                                                     * Will determine is a container is a 'user preference' container
                                                                                     * @param   {Object}  container - A container configuration hash
                                                                                     * @returns {boolean}
                                                                                     * @private
                                                                                     */value: function isUserPreferenceContainer_(container) {
               return _.chain(container).get('type').isEqual(this.USER_PREFERENCE_TYPE).value();
          } /**
            * Will return the 'user preference' containers from a list of containers
            * @param  {Array<Object>} containers - List of container configuration hashes
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getUserPreferenceContainersFromList_', value: function getUserPreferenceContainersFromList_(containers) {
               var _this = this;return _.filter(containers, function (container) {
                    return _this.isUserPreferenceContainer_(container);
               });
          } /**
            * Will deeply and recursively fetch the 'user preference' containers from a metric
            * @param   {Object} metric - A metric/parameter configuration object
            * @param   {Array<Object>}  containers - Optional list of containers
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getUserPreferenceContainersFromMetric_', value: function getUserPreferenceContainersFromMetric_(metric) {
               var _this2 = this;var containers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []; // First level 'user preference' container fishing from the container list of the metric
               _.forEach(this.getUserPreferenceContainersFromList_(_.get(metric, 'containers')), function (userPreferenceContainer) {
                    containers.push(userPreferenceContainer);
               }); // Deep fetch 'user preference' containers from parameters inside the metric configuration
               _.chain(metric).get('parameters').forEach(function (parameter) {
                    _this2.getUserPreferenceContainersFromMetric_(parameter, containers);
               }).value();return containers;
          } /**
            * Will deep pick 'user preference' containers from the metrics of a given query
            * @param   {Object} query - A single RGS request calculation object
            * @returns {Array<Object>}
            */ }, { key: 'getUserPreferenceContainersFromQueryMetrics_', value: function getUserPreferenceContainersFromQueryMetrics_(query) {
               var _this3 = this;return _.chain(query).get('metrics').map(function (metric) {
                    return _this3.getUserPreferenceContainersFromMetric_(_.get(metric, 'value'));
               }).flatten().compact().value();
          } /**
            * Will iterate over a collection of filters and return the first baseFact that is not empty and not part of USER_PREFERENCE_BASE_METRICS list
            * @param   {Array<Object>} filterList - A list if filter objects
            * @param   {string} layer - The layer (RAW_DATA or REAL_TIME) from which monad configuration is to be retrieved
            * @returns {string|null}
            */ }, { key: 'getFirstValidBaseFact', value: function getFirstValidBaseFact(filterList, layer) {
               var _this4 = this;var baseFact = null;_.forEach(filterList, function (filterItem) {
                    var arrangeType = _.get(filterItem, 'arrangeType');var monad = _this4.Monads.layer(layer).monad(arrangeType);var monadBaseFact = _.get(monad, 'baseFact');if (!_.isEmpty(monadBaseFact) && !_.includes(_this4.USER_PREFERENCE_BASE_METRICS, monadBaseFact)) {
                         baseFact = monadBaseFact; //break the iteration
                         return false;
                    }return true;
               });return baseFact;
          } /**
            * Will modify a 'user preference' container by:
            * 1. Appending a baseFact filter based on the first valid baseFact of the first filter rule
            * 2. Appending a 'twenty-percent' filter rule based on the 'user_preference_threshold' user config limit
            * 3. Will set the combined setting to true
            * @param  {Object} container - A container configuration hash
            * @param  {string} layer - The layer from which to fetch monad configurations from
            * @private
            */ }, { key: 'appendBaseFactFilters_', value: function appendBaseFactFilters_(container, layer) {
               // Do nothing if the container is not a 'user preference' container
               if (!this.isUserPreferenceContainer_(container)) {
                    return;
               }var filters = _.get(container, 'filters');var baseFact = this.getFirstValidBaseFact(filters, layer); // Do nothing if no baseFact was spotted
               if (_.isEmpty(baseFact)) {
                    return;
               }var userPreferenceThreshold = this.accountService.getConfig('user_preference_threshold'); // Do nothing for unexpected user_preference_threshold limit
               if (!_.isNumber(userPreferenceThreshold)) {
                    return;
               } // The context of the container
               var context = _.get(container, 'context');var baseFactFilter = _.chain(this.QueryTemplates.filter()).set('arrangeType', baseFact.toLowerCase()).set('filterPredicate', 'GREATER').set('connector', 'AND').set('value1', '1').set('context', context).set('intern', true).value();var twentyPercentFilter = _.chain(this.QueryTemplates.filter()).set('arrangeType', this.TWENTY_PERCENT_FORMULA).set('filterPredicate', 'GREATER').set('connector', 'AND').set('value1', '' + userPreferenceThreshold).set('context', context).set('intern', true).value();filters.push(baseFactFilter);filters.push(twentyPercentFilter); // Set combined
               _.set(container, 'combined', true);
          } /**
            * Will deep collect all 'user preference' containers of a query and apply trasnformations
            * dictated by appendBaseFactFilters_ method to them
            * @param  {Object} query - A single RGS request calculation object
            */ }, { key: 'injectBaseFactRules', value: function injectBaseFactRules(query) {
               var _this5 = this; // Fish the 'user preference' containers from the list of containers of the main query
               var fromContainers_ = this.getUserPreferenceContainersFromList_(_.get(query, 'containers')); // Firsh the 'user preference' containers from the metrics of the query and
               // their subsequent parameters.
               var fromMetrics_ = this.getUserPreferenceContainersFromQueryMetrics_(query); // List of ALL 'user preference' containers present in the query
               var userPreferenceContainers = fromContainers_.concat(fromMetrics_); // The layer of the query
               var layer = this.Monads.getQueryLayer(query);_.forEach(userPreferenceContainers, function (userPreferenceContainer) {
                    _this5.appendBaseFactFilters_(userPreferenceContainer, layer);
               });
          } }, { key: 'USER_PREFERENCE_BASE_METRICS', get: function get() {
               return ['USER_PREFERENCE_BASE_METRIC'];
          } /**
            * The type that indicates whether a container is a 'user preference' container
            */ }, { key: 'USER_PREFERENCE_TYPE', get: function get() {
               return 'USER_PREFERENCE';
          } /**
            * The arrangeType for the twenty percent filter injected in the 'user preference'
            * containers
            */ }, { key: 'TWENTY_PERCENT_FORMULA', get: function get() {
               return 'twenty_percent_formula';
          } }]);return UserPreferenceThreshold;
}();

},{}],53:[function(require,module,exports){
'use strict';
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
     return typeof obj;
} : function (obj) {
     return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     function Utils() {
          _classCallCheck(this, Utils);
     }_createClass(Utils, [{ key: 'memberExists', /**
                                                  * Members exists
                                                  * @param {Object} obj
                                                  * @param {string} memberChain
                                                  * @returns {boolean}
                                                  */value: function memberExists(obj, memberChain) {
               if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
                    return false;
               }if (typeof memberChain !== 'string' || memberChain.match(/\.$/)) {
                    throw new Error('Wrong argument type in argument memberChain or string is configured wrong.');
               }var memberToCheck = memberChain.split('.');if (memberToCheck.length === 1 && memberToCheck[0].length === 0 || typeof obj[memberToCheck[0]] === 'undefined') {
                    return false;
               }if (memberToCheck.length === 1 && typeof obj[memberToCheck[0]] !== 'undefined') {
                    return true;
               }return this.memberExists(obj[memberToCheck.shift()], memberToCheck.join('.'));
          } /**
            * Compares objects excluding properties defined in the excludePropertyList
            * @param {Object} obj1 Any object
            * @param {Object} obj2 Any object
            * @param {Array<string>} excludePropertyList An array of strings/properties to exlude when comparing
            * @returns {boolean}
            */ }, { key: 'compareObjects', value: function compareObjects(obj1, obj2, excludePropertyList) {
               var tmpObj1 = _.omit(obj1, excludePropertyList);var tmpObj2 = _.omit(obj2, excludePropertyList);return _.isEqual(tmpObj1, tmpObj2);
          } /**
            * Compares two lists of objects for equality, optionally excluding properties defined in the excludePropertyList.
            * @param  {Array<Object>} list1 Array of objects
            * @param  {Array<Object>} list2 Array of objects
            * @param  {Array<string>} excludePropertyList Array of strings/properties to exclude when comparing
            * @returns {boolean}
            */ }, { key: 'compareObjectLists', value: function compareObjectLists(list1, list2, excludePropertyList) {
               var _this = this;var match = true;if (!list1 || !list2) {
                    return false;
               }if (!_.isArray(list1) || !_.isArray(list2)) {
                    return false;
               }if (list1.length !== list2.length) {
                    return false;
               }_.forEach(list1, function (list1Object, index) {
                    match = _this.compareObjects(list1Object, list2[index], excludePropertyList);return Boolean(match);
               });return Boolean(match);
          } /**
            * Deep extend
            * @param {Object} destination
            * @param {Object} source
            * @returns {*}
            */ }, { key: 'deepExtend', value: function deepExtend(destination, source) {
               for (var property in source) {
                    if (source[property] && source[property].constructor && source[property].constructor === Object) {
                         destination[property] = destination[property] || {};this.deepExtend(destination[property], source[property]);
                    } else {
                         destination[property] = source[property];
                    }
               }return destination;
          } }]);return Utils;
}();

},{}],54:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /*@ngInject*/
     Variants.$inject = ['analysisColumnUtils'];function Variants(analysisColumnUtils) {
          _classCallCheck(this, Variants);this.analysisColumnUtils = analysisColumnUtils;
     } /**
       * The list of valid variants for an analysis
       * @returns {Array<string>}
       */_createClass(Variants, [{ key: 'resolve', /**
                                                   * Will resolve the new variant of an analysis based on the number of dimensions, the previously
                                                   * set variant of the analysis and an optional force list flag
                                                   * @param  {number} iNumberOfDimensions
                                                   * @param  {string} iVariant
                                                   * @param  {Boolean} iForceList
                                                   * @returns {string}
                                                   */value: function resolve(iNumberOfDimensions, iVariant, iForceList) {
               // If only one dimension is set and the previous variant is either LIST or PIVOT_AS_LIST
               // the variant stays intact, otherwise the LIST variant is resolved.
               if (iNumberOfDimensions === 1) {
                    return 'LIST';
               } // More then one dimension and force list view requested resolves in PIVOT_AS_LIST
               if (iForceList) {
                    return 'PIVOT_AS_LIST';
               } // If more than one dimension is set and the previous variant is either PIVOT or PIVOT_AS_LIST
               // the variant stays intact, otherwise the PIVOT variant is resolved.
               return _.includes(['PIVOT', 'PIVOT_AS_LIST'], iVariant) ? iVariant : 'PIVOT';
          } /**
            * Will resolve the variant of an analysis based on it's configuration - it's columns and it's variant.
            * @param  {Object} iConfiguration The complete configuration of an analysis
            * @returns {string}
            */ }, { key: 'resolveByConfiguration', value: function resolveByConfiguration(iConfiguration) {
               // Get the number of dimensions from the analysis configuration
               var dimensions_ = _.size(this.analysisColumnUtils.getDimensions(iConfiguration)); // Get the variant of the same configuration
               var variant_ = _.get(iConfiguration, 'variant');return this.resolve(dimensions_, variant_);
          } /**
            * Will determine if an analysis configuration is that of a pivot analysis
            * @param   {Object}  analysisConfig The complete analysis configuration object
            * @returns {boolean}
            */ }, { key: 'isPivot', value: function isPivot(analysisConfig) {
               return this.resolveByConfiguration(analysisConfig) === this.PIVOT;
          } /**
            * Will determine if an analysis configuration is that of a pivot as list analysis
            * @param   {Object}  analysisConfig The complete analysis configuration object
            * @returns {boolean}
            */ }, { key: 'isPivotAsList', value: function isPivotAsList(analysisConfig) {
               return this.resolveByConfiguration(analysisConfig) === this.PIVOT_AS_LIST;
          } /**
            * Will determine if an analysis configuration is that of a list analysis
            * @param   {Object}  analysisConfig The complete analysis configuration object
            * @returns {boolean}
            */ }, { key: 'isList', value: function isList(analysisConfig) {
               return this.resolveByConfiguration(analysisConfig) === this.LIST;
          } /**
            * Will determine the footer type for an analysis query based on its variant
            * @param   {Object}  analysisConfig The complete analysis configuration object
            * @returns {string}
            */ }, { key: 'getFooterType', value: function getFooterType(analysisConfig) {
               return this.isPivot(analysisConfig) ? 'UNIQUE_SUM' : 'SUM';
          } }, { key: 'VARIANTS_', get: function get() {
               return ['LIST', 'PIVOT', 'PIVOT_AS_LIST'];
          } /**
            * The value of the list variant of an analysis
            * @returns {string}
            */ }, { key: 'LIST', get: function get() {
               return this.VARIANTS_[0];
          } /**
            * The value of the pivot variant of an analysis
            * @returns {string}
            */ }, { key: 'PIVOT', get: function get() {
               return this.VARIANTS_[1];
          } /**
            * The value of the pivot as list variant of an analysis
            * @returns {string}
            */ }, { key: 'PIVOT_AS_LIST', get: function get() {
               return this.VARIANTS_[2];
          } }]);return Variants;
}();

},{}],55:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     ViewMode.$inject = ['TimeSeries', 'viewModePath', 'viewModeComparison'];function ViewMode(TimeSeries, viewModePath, viewModeComparison) {
          _classCallCheck(this, ViewMode);this.TimeSeries = TimeSeries;this.viewModePath = viewModePath;this.viewModeComparison = viewModeComparison;
     }_createClass(ViewMode, [{ key: 'getActive', /**
                                                  * Will return the active viewMode of an analysis
                                                  * @param  {Object} iAnalysis - The analysis configuration
                                                  * @returns {string}
                                                  */value: function getActive(iAnalysis) {
               return _.get(iAnalysis, 'viewMode.active', this.VIEW_MODES.DEFAULT);
          } /**
            * Retrieves the edit state of the specified view mode. If no view mode provided, will retrieve the edit state of the active view mode.
            * @param {Object} iAnalysis The analysis configuration to retrieve the view mode edit state for
            * @param {string=} iViewMode The view mode to retrieve the edit state for
            * @returns {boolean}
            */ }, { key: 'getEditState', value: function getEditState(iAnalysis, iViewMode) {
               var viewMode = iViewMode ? String(iViewMode) : this.getActive(iAnalysis);return _.get(iAnalysis, 'viewMode.' + viewMode + '.editState', false);
          } /**
            * Will try to figure out if an analysis has viewMode settings and if not will default to an object
            * with empty active viewMode
            * @param  {Object} analysisConfiguration_ - The analysis configuration
            * @returns {Object}           The modified analysis config if it's valid
            */ }, { key: 'resolveViewMode', value: function resolveViewMode(analysisConfiguration_) {
               var analysisConfiguration = analysisConfiguration_.configJson || analysisConfiguration_;if (!_.chain(analysisConfiguration).get('columns').isArray().value()) {
                    return analysisConfiguration_;
               }this.resolveViewMode_(analysisConfiguration);return analysisConfiguration_;
          } }, { key: 'resolveViewMode_', value: function resolveViewMode_(analysisConfiguration) {
               // Init an empty viewMode if none is defined
               if (_.chain(analysisConfiguration).get('viewMode').isEmpty().value()) {
                    analysisConfiguration.viewMode = { active: this.VIEW_MODES.DEFAULT };
               } // Init timeSeries config if necessary
               this.TimeSeries.resolveTimeSeries(analysisConfiguration); // Init path config if necessary
               this.viewModePath.resolvePath(analysisConfiguration); // Init comparison config if necessary
               this.viewModeComparison.resolveComparison(analysisConfiguration);
          } /**
            * Will determine if a query is a time series query or not
            * @param   {Object}  query
            * @returns {boolean}
            */ }, { key: 'isTimeSeriesQuery', value: function isTimeSeriesQuery(query) {
               return _.get(query, 'viewMode') === this.TimeSeries.QUERY_VIEW_MODE;
          } /**
            * Will modify the query to be sent to the core based on the the viewMode that is currently
            * active in the analysis configuration
            * @param  {Object} analysisConfig - The analysis configuration
            * @param  {Object} query - The query constructed for an analysis
            * @returns {Object}
            */ }, { key: 'adjustQuery', value: function adjustQuery(analysisConfig, query) {
               switch (_.get(analysisConfig, 'viewMode.active')) {case this.VIEW_MODES.TIME_SERIES:
                         return this.TimeSeries.adjustQuery(analysisConfig, query);case this.VIEW_MODES.PATH:
                         return this.viewModePath.adjustQuery(analysisConfig, query);case this.VIEW_MODES.COMPARISON:
                         return this.viewModeComparison.adjustQuery(analysisConfig, query);default:
                         delete query.viewMode;return query;}
          } }, { key: 'validateQuery', value: function validateQuery(query) {
               var viewMode = _.get(query, 'viewMode');switch (viewMode) {case this.viewModePath.QUERY_VIEW_MODE:
                         return this.viewModePath.validateQuery(query); //@todo: Validate all viewModes like path mode.
                    case this.TimeSeries.QUERY_VIEW_MODE:default:
                         return { isValid: true, parameters: {} };}
          } /**
            * Checks whether or not the given iViewMode is a complete view mode object.
            * @param {Object} iViewMode
            * @returns {boolean}
            */ }, { key: 'isValid', value: function isValid(iViewMode) {
               if (!_.get(iViewMode, 'active')) {
                    return false;
               }return true;
          } /**
            * Converts the analysis view mode identifier into query view mode identifier
            * @example timeSeries will be converted into TIME_SERIES
            * @param {Object} iViewMode
            * @returns {string}
            */ }, { key: 'analysisToQueryViewMode', value: function analysisToQueryViewMode(iVewMode) {
               var viewMode = iVewMode ? String(iVewMode) : this.VIEW_MODES.DEFAULT;return _.snakeCase(viewMode).toUpperCase();
          } /**
            * Converts the query view mode identifier into analysis view mode identifier
            * @example TIME_SERIES will be converted into timeSeries
            * @param {Object} iViewMode
            * @returns {string}
            */ }, { key: 'queryToAnalysisViewMode', value: function queryToAnalysisViewMode(iVewMode) {
               var viewMode = iVewMode ? String(iVewMode) : this.VIEW_MODES.DEFAULT;return _.camelCase(viewMode);
          } /**
            * Performs a check if the analysis view mode changed
            * @param {Object} iAnalysis The analysis configuration
            * @param {Object} iQuery The request object
            * @returns {boolean}
            */ }, { key: 'hasViewModeChanged', value: function hasViewModeChanged(iAnalysis, iQuery) {
               var analysis = _.isObject(iAnalysis) ? iAnalysis : {};var query = _.isObject(iQuery) ? iQuery : {};var activeViewMode = String(this.getActive(analysis));var queryViewMode = this.queryToAnalysisViewMode(query.viewMode);return activeViewMode !== queryViewMode;
          } /**
            * Calculates if the two view modes with their corresponding edit states can share the same request
            * @param {string} iViewMode1 The first view mode
            * @param {boolean} iEditState1 The edit state of the first view mode
            * @param {string} iViewMode2 The Second view mode
            * @param {boolean} iEditState2 The edit state of the second view mode
            * @returns {boolean}
            */ }, { key: 'areViewModeQueriesCompatible', value: function areViewModeQueriesCompatible(iViewMode1, iEditState1, iViewMode2, iEditState2) {
               var VIEW_MODES = this.VIEW_MODES;if (!_.includes(VIEW_MODES, iViewMode1) || !_.includes(VIEW_MODES, iViewMode2)) {
                    return false;
               }var editState1 = Boolean(iEditState1);var editState2 = Boolean(iEditState2);return this.getViewModeRequestsCompatibilityMatrix()[iViewMode1][editState1][iViewMode2][editState2];
          } /**
            * Computes and retrieves the compatibility of requests across different view modes and their corresponding edit states
            * Eg. The default view mode shares the same request structure as the time series in edit state.
            * This can be deducted by accessing the compatibility matrix as follows matrix[DEFAULT_VIEW_MODE][DEFAULT_VIEW_STATE][TIME_SERIES_VIEW_MODE][TIME_SERIES_EDIT_STATE]
            * @returns {{}}
            * @private
            */ }, { key: 'getViewModeRequestsCompatibilityMatrix', value: function getViewModeRequestsCompatibilityMatrix() {
               var compatibilityMatrix = {};var VIEW_MODES = this.VIEW_MODES;if (_.isPlainObject(this.compatibilityMatrix)) {
                    return this.compatibilityMatrix;
               } // Initializes the multidimensional structure with all possible combinations marked as incompatible
               var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
                    for (var _iterator = Object.keys(VIEW_MODES)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                         var key1 = _step.value;var vm1 = VIEW_MODES[key1];compatibilityMatrix[vm1] = { 'false': {}, 'true': {} };var _iteratorNormalCompletion2 = true;var _didIteratorError2 = false;var _iteratorError2 = undefined;try {
                              for (var _iterator2 = Object.keys(VIEW_MODES)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                   var key2 = _step2.value;var vm2 = VIEW_MODES[key2];compatibilityMatrix[vm1].false[vm2] = { 'false': vm1 === vm2, 'true': false };compatibilityMatrix[vm1].true[vm2] = { 'false': false, 'true': vm1 === vm2 };
                              }
                         } catch (err) {
                              _didIteratorError2 = true;_iteratorError2 = err;
                         } finally {
                              try {
                                   if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                   }
                              } finally {
                                   if (_didIteratorError2) {
                                        throw _iteratorError2;
                                   }
                              }
                         }
                    } // Special case for view modes that do not have edit states. Although will never happen, let it be
               } catch (err) {
                    _didIteratorError = true;_iteratorError = err;
               } finally {
                    try {
                         if (!_iteratorNormalCompletion && _iterator.return) {
                              _iterator.return();
                         }
                    } finally {
                         if (_didIteratorError) {
                              throw _iteratorError;
                         }
                    }
               }compatibilityMatrix[VIEW_MODES.DEFAULT].true[VIEW_MODES.DEFAULT].false = true;compatibilityMatrix[VIEW_MODES.DEFAULT].false[VIEW_MODES.DEFAULT].true = true; // Time series edit state and default view mode share same query structure
               compatibilityMatrix[VIEW_MODES.DEFAULT].false[VIEW_MODES.TIME_SERIES].true = true;compatibilityMatrix[VIEW_MODES.TIME_SERIES].true[VIEW_MODES.DEFAULT].false = true;this.compatibilityMatrix = Object.freeze(compatibilityMatrix);return this.compatibilityMatrix;
          } /**
            * Creates a signature array containing the view mode and edit state combination
            * @param {Object} iAnalysis
            * @param {string=} iViewMode Optional view mode to calculate the signature for. Defaults to active view mode.
            * @param {string=} iEditState Optional edit state to calculate the signature for. Defaults to the edit state of the selected view mode.
            * @returns {Array}
            */ }, { key: 'getRequestSignature', value: function getRequestSignature(iAnalysis, iViewMode, iEditState) {
               var analysis = _.isPlainObject(iAnalysis) ? iAnalysis : null;var viewMode = iViewMode ? iViewMode : this.getActive(analysis);var editState = iEditState ? iEditState : this.getEditState(analysis, viewMode);var signature = [];signature.push(viewMode);signature.push(editState);return signature;
          } }, { key: 'VIEW_MODES', get: function get() {
               return { DEFAULT: '', PATH: this.viewModePath.VIEW_MODE_NAME, TIME_SERIES: this.TimeSeries.VIEW_MODE_NAME, COMPARISON: this.viewModeComparison.VIEW_MODE_NAME };
          } }, { key: 'DEFAULT', get: function get() {
               return { active: '' };
          } }]);return ViewMode;
}();

},{}],56:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     ViewModeComparison.$inject = ['Monads', 'Variants', 'cohortUtils', 'Filters', 'segmentService', 'QueryMetrics', 'ConfigPeriodColumn', 'CustomFormulas', 'Columns', 'timeShiftService', 'featureFlagService'];function ViewModeComparison(Monads, Variants, cohortUtils, Filters, segmentService, QueryMetrics, ConfigPeriodColumn, CustomFormulas, Columns, timeShiftService, featureFlagService) {
          _classCallCheck(this, ViewModeComparison);this.Monads = Monads;this.Variants = Variants;this.cohortUtils = cohortUtils;this.Filters = Filters;this.segmentService = segmentService;this.QueryMetrics = QueryMetrics;this.ConfigPeriodColumn = ConfigPeriodColumn;this.CustomFormulas = CustomFormulas;this.Columns = Columns;this.timeShiftService = timeShiftService;this.featureFlagService = featureFlagService;
     } /**
       * The value of the comparison view mode
       * @returns {string}
       */_createClass(ViewModeComparison, [{ key: 'deactivateViewMode_', /**
                                                                         * Will empty the active view mode value if comparison is the active view mode
                                                                         * @param   {Object} analysisConfig The analysis configuration
                                                                         * @returns {ViewModeComparison}
                                                                         * @chainable
                                                                         * @private
                                                                         */value: function deactivateViewMode_(analysisConfig) {
               if (_.get(analysisConfig, 'viewMode.active') === this.VIEW_MODE_NAME) {
                    _.set(analysisConfig, 'viewMode.active', '');
               }return this;
          } /**
            * Will delete the comparison configuration of the given analysis configuration
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {ViewModeComparison}
            * @chainable
            * @private
            */ }, { key: 'deleteViewModeConfig_', value: function deleteViewModeConfig_(analysisConfig) {
               if (_.has(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME)) {
                    delete analysisConfig.viewMode[this.VIEW_MODE_NAME];
               }return this;
          } /**
            * Will determine if the type of a comparison config is a valid string.
            * @param   {Object}  viewModeConfig
            * @returns {boolean}
            * @private
            */ }, { key: 'hasValidType_', value: function hasValidType_(viewModeConfig) {
               var type = _.get(viewModeConfig, 'type');return _.chain(this.TYPES).values().includes(type).value();
          } /**
            * Will determine if the schema of the values property consists of a map
            * with the expected keys and with the correct types - arrays - as values.
            * @param   {Object}  viewModeConfig
            * @returns {boolean}
            * @private
            */ }, { key: 'hasValidValuesSchema_', value: function hasValidValuesSchema_(viewModeConfig) {
               var types = _.values(this.TYPES);return _.chain(viewModeConfig).get('values').pick(types).map(function (list) {
                    return _.isArray(list);
               }).compact().size().eq(types.length).value();
          } /**
            * Will determine if the schema of the sorting property consists of a map
            * with the expected keys and with the correct types - arrays - as values.
            * @param   {Object}  viewModeConfig
            * @returns {boolean}
            * @private
            */ }, { key: 'hasValidSortingSchema_', value: function hasValidSortingSchema_(viewModeConfig) {
               var types = _.values(this.TYPES);return _.chain(viewModeConfig).get('sorting').pick(types).map(function (list) {
                    return _.isArray(list);
               }).compact().size().eq(types.length).value();
          } /**
            * Will determine if the schema of comparison view mode is of the expcted structure.
            * @param   {Object}  viewModeConfig
            * @returns {boolean}
            * @private
            */ }, { key: 'isValidConfigurationSchema_', value: function isValidConfigurationSchema_(viewModeConfig) {
               return this.hasValidType_(viewModeConfig) && this.hasValidValuesSchema_(viewModeConfig) && this.hasValidSortingSchema_(viewModeConfig);
          } /**
            * Will determine if the usage/feature of pivot as list in comparison is enabled or not
            * @returns {boolean}
            */ }, { key: 'isComparisonPivotEnabled', value: function isComparisonPivotEnabled() {
               return Boolean(this.featureFlagService.getFeatureFlag('comparisonPivotEnabled'));
          } /**
            * Will determine if an analysis can have a comparison variant or not.
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {boolean}
            */ }, { key: 'canHaveComparison', value: function canHaveComparison(analysisConfig) {
               if (this.Variants.isPivot(analysisConfig)) {
                    return false;
               }if (!this.isComparisonPivotEnabled() && this.Variants.isPivotAsList(analysisConfig)) {
                    return false;
               }return this.canBecomeComparison_(analysisConfig);
          } /**
            * Determines whether a analysis configuration can become a comparison variant.
            * @param analysisConfig
            * @returns {boolean}
            * @private
            */ }, { key: 'canBecomeComparison_', value: function canBecomeComparison_(analysisConfig) {
               if (this.Monads.isRealTimeConfig(analysisConfig)) {
                    return false;
               }if (this.cohortUtils.isCohortAnalysis(_.get(analysisConfig, 'columns', []))) {
                    return false;
               }return true;
          } /**
            * Will resolve - init, delete or leave as is - the comparison configuration of a given analysis config
            * returning the modified analysis object.
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {Object}
            */ }, { key: 'resolveComparison', value: function resolveComparison(analysisConfig) {
               if (!this.canBecomeComparison_(analysisConfig)) {
                    this.deactivateViewMode_(analysisConfig).deleteViewModeConfig_(analysisConfig);return analysisConfig;
               }if (this.isValidConfigurationSchema_(_.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME))) {
                    return analysisConfig;
               }return _.set(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME, this.CONFIGURATION_SCHEMA);
          } /**
            * Will determine if a given comparison object if valid based on the given type
            * @param   {Object}  comparisonObject Either a time filter or a segment connector
            * @param   {string}  type  Any value from this.TYPES
            * @returns {boolean}
            */ }, { key: 'isValidComparisonObject', value: function isValidComparisonObject(comparisonObject, type) {
               if (type === this.TYPES.TIME) {
                    return this.Filters.isTime(comparisonObject, true);
               }if (type === this.TYPES.SEGMENT) {
                    return this.segmentService.getActiveSegmentById(_.get(comparisonObject, 'segmentID'));
               }return false;
          } /**
            * Will collect and return the valid objects from the given comparison object list
            * @param   {Object} viewModeConfig
            * @param   {string} type_
            * @returns {Array<Object>}
            */ }, { key: 'getValidComparisonObjects', value: function getValidComparisonObjects(viewModeConfig) {
               var _this = this;var type_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var type = type_ || _.get(viewModeConfig, 'type');return _.chain(viewModeConfig).get('values.' + type).filter(function (comparisonObject) {
                    return _this.isValidComparisonObject(comparisonObject, type);
               }).cloneDeep().value();
          } /**
            * Will determine if a comparison can be applied for a given comparison type
            * @param   {Object} viewModeConfig
            * @param   {string} type_
            * @returns {boolean}
            */ }, { key: 'canApplyComparisonByType', value: function canApplyComparisonByType(viewModeConfig) {
               var type_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var type = type_ || _.get(viewModeConfig, 'type');var values = this.getValidComparisonObjects(viewModeConfig, type);return _.chain(values).size().inRange(2, 4).value();
          } /**
            * Will determine the replication factor of a comparison config i.e. the number of sub aliases each
            * analysis metric alias should be broken down to
            * @param   {Object} viewModeConfig
            * @param   {string} type_
            * @returns {number}
            */ }, { key: 'getReplicationFactor', value: function getReplicationFactor(viewModeConfig) {
               var type_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var comparisonObjects = this.getValidComparisonObjects(viewModeConfig, type_);var factor = 2 * comparisonObjects.length - 1;return Math.max(this.MIN_REPLICATION_FACTOR, factor);
          } /**
            * Will return the sorting objects for a given comparison type or the currently active type
            * @param   {Object} viewModeConfig
            * @param   {string} type_
            * @returns {Array<Object>}
            */ }, { key: 'getSortingObjects', value: function getSortingObjects(viewModeConfig) {
               var type_ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var type = type_ || _.get(viewModeConfig, 'type');return _.get(viewModeConfig, 'sorting.' + type);
          } /**
            * Will generate the post fix string for a comparison object
            * @param   {Object} comparisonObject Time filter or segment connector
            * @param   {string} type
            * @returns {string}
            * @private
            */ }, { key: 'getPostFixByComparisonObject_', value: function getPostFixByComparisonObject_(comparisonObject, type) {
               if (type === this.TYPES.TIME) {
                    return this.Filters.getTimeRange(comparisonObject);
               }return this.segmentService.getTitleFromSegmentConnector(comparisonObject);
          } /**
            * Will mutate the given metric, updating its title to include a descriptive text post fix based on
            * the corresponding comparison object
            * @param   {Object} metric The metric column configuration
            * @param   {Object} comparisonObject Time filter or segment connector
            * @param   {string} type
            * @returns {ViewModeComparison}
            * @private
            */ }, { key: 'alterTitleInComparableMetric_', value: function alterTitleInComparableMetric_(metric, comparisonObject, type) {
               var title = _.get(metric, 'title', '');var titlePostfix = this.getPostFixByComparisonObject_(comparisonObject, type);_.set(metric, 'title', title + ' (' + titlePostfix + ')');return this;
          } /**
            * Will mutate a given metric configuration injecting a given comparison object in the proper list
            * based on comparison type
            * @param   {Object} metric The metric column configuration
            * @param   {Object} comparisonObject Time filter or segment connector
            * @param   {string} type
            * @returns {ViewModeComparison}
            * @private
            */ }, { key: 'injectComparisonObjectToMetric_', value: function injectComparisonObjectToMetric_(metric, comparisonObject, type) {
               var path = type === this.TYPES.TIME ? 'predefinedContainer.filters' : 'predefinedSegmentConnections';var list = _.get(metric, path, []);list.unshift(comparisonObject);_.set(metric, path, list);return this;
          } /**
            * Will mutate a given metric configuration injecting time shift related properties - timeShiftUnit and timeShiftBy - based
            * on time comparison configuration objects. Will inject only for known time shift unit values and only
            * in case of time comparison. Will do nothing in all other cases.
            * @param   {Object} metric The metric column configuration
            * @param   {Object} referenceObject Reference time filter or segment connector object
            * @param   {Object} comparisonObject Time filter or segment connector object
            * @param   {string} timeShiftUnit
            * @param   {string} type
            * @returns {ViewModeComparison}
            */ }, { key: 'injectTimeShiftSettings_', value: function injectTimeShiftSettings_(metric, referenceObject, comparisonObject, timeShiftUnit, type) {
               if (this.timeShiftService.isValidTimeShiftUnit(timeShiftUnit) && type === this.TYPES.TIME) {
                    var timeShiftBy = this.timeShiftService.getFilterTimeShift(referenceObject, comparisonObject, timeShiftUnit);_.extend(metric, { timeShiftBy: timeShiftBy, timeShiftUnit: timeShiftUnit });
               }return this;
          } /**
            * Will return a replica of a given metric column configuration with an
            * injected comparison object
            * @param   {Object} metric_ The metric column configuration
            * @returns {Object}
            * @private
            */ }, { key: 'getComparableMetric_', value: function getComparableMetric_(metric_) {
               return _.chain(metric_).omit(this.ConfigPeriodColumn.PERIOD_PROPERTY).cloneDeep().value();
          } /**
            * Will return a list of all variants of a given metric column configuration
            * @param   {Object} metric The metric column configuration
            * @param   {Object} viewModeConfig
            * @param   {string} layer
            * @param   {string=} timeShiftUnit
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getComparableMetrics_', value: function getComparableMetrics_(metric, viewModeConfig, layer) {
               var _this2 = this;var timeShiftUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';var comparisonObjects = this.getValidComparisonObjects(viewModeConfig);var referenceObject = _.head(comparisonObjects);var overlapsToday = this.TYPES.TIME === viewModeConfig.type && this.overlapsToday_(comparisonObjects);return _.map(comparisonObjects, function (comparisonObject) {
                    var adjustedComparisonObject = _.cloneDeep(comparisonObject);if (overlapsToday) {
                         _this2.Filters.syncTimeFilterEndTime(adjustedComparisonObject);
                    }var metricReplica = _this2.getComparableMetric_(metric);_this2.alterTitleInComparableMetric_(metricReplica, comparisonObject, viewModeConfig.type).injectComparisonObjectToMetric_(metricReplica, adjustedComparisonObject, viewModeConfig.type).injectTimeShiftSettings_(metricReplica, referenceObject, comparisonObject, timeShiftUnit, viewModeConfig.type);return _this2.QueryMetrics.getMetricFromColumn(metricReplica, layer);
               });
          } /**
            * Will generate the comparison metric build on the given list of query metrics, taking also care of the title of the comparison column.
            * @param   {Array<Object>} queryMetrics List of query metrics used to generate the comparison formula
            * @param   {Array<Object>} comparisonObjects List of comparison objects involved in this comparison
            * @param   {string} type The type of this comparison
            * @param   {string} columnTitle The title of the origin(al) metric column
            * @returns {Object}
            * @private
            */ }, { key: 'getComparisonMetric_', value: function getComparisonMetric_(queryMetrics, comparisonObjects, type, columnTitle) {
               var _this3 = this;var value = this.CustomFormulas.getComparisonFormula(queryMetrics);var titlePostfix = _.chain(comparisonObjects).map(function (comparisonObject) {
                    return _this3.getPostFixByComparisonObject_(comparisonObject, type);
               }).join(' / ').value();_.set(value, 'title', '\u0394% ' + columnTitle + ' (' + titlePostfix + ')');var alias = null;return { alias: alias, value: value };
          } /**
            * Will generate from and inject to a list of metrics the resulting comparison metrics.
            * @param   {Array<Object>} comparableMetrics List of all metric variants
            * @param   {Array<Object>} comparisonObjects_ List of comparison objects used by a comparison config
            * @param   {string} type The type of the comparison objects
            * @param   {string} columnTitle The title of the origin(al) metric column
            * @returns {Array<Object>}
            * @private
            */ }, { key: 'getGroupedComparableMetrics_', value: function getGroupedComparableMetrics_(comparableMetrics, comparisonObjects_, type, columnTitle) {
               var _this4 = this;return _.chain(comparableMetrics).tail().map(function (metric) {
                    var firstMetric = _.head(comparableMetrics);var index = _.findIndex(comparableMetrics, metric);var comparisonObjects = [comparisonObjects_[0], comparisonObjects_[index]];var comparisonMetric = _this4.getComparisonMetric_([firstMetric, metric], comparisonObjects, type, columnTitle);return [firstMetric, metric, comparisonMetric];
               }).unzip().map(function (metricGroups, groupIndex) {
                    if (groupIndex === 0) {
                         // Keep only the first metric from the first block
                         _.chain(metricGroups).remove(function (metric, metricIndex) {
                              return metricIndex;
                         }).value();
                    }return metricGroups;
               }).flatten().value();
          } /**
            * Will retrieve the time format value of the configuration of the first dimension of an analysis configuration
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {string}
            * @private
            */ }, { key: 'getFirstDimensionTimeFormat_', value: function getFirstDimensionTimeFormat_(analysisConfig) {
               var layer = this.Monads.getConfigLayer(analysisConfig);var monads = this.Monads.layer(layer);return _.chain(analysisConfig).get('columns', []).map(function (column) {
                    return monads.monad(column.arrangeType);
               }).filter({ dimension: true }).head().get('timeFormat').value();
          } /**
            * Builds the comparison metrics for a given analysis configuration and mutates the given query
            * @param   {Object} analysisConfig The analysis configuration
            * @param   {Object} query
            * @returns {ViewModeComparison}
            * @private
            */ }, { key: 'adjustMetrics_', value: function adjustMetrics_(analysisConfig, query) {
               var _this5 = this;var layer = this.Monads.getConfigLayer(analysisConfig);var monads = this.Monads.layer(layer);var viewModeConfig = _.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME);var columns = _.chain(analysisConfig).get('columns', []).filter(function (column) {
                    return _.get(monads.monad(column.arrangeType), 'metric');
               }).value();var aliases = _.chain(this.Columns.getAliasGroups(columns, this.getReplicationFactor(viewModeConfig))).values().flatten().value();var comparisonObjects = this.getValidComparisonObjects(viewModeConfig);var timeShiftUnit = ('' + this.getFirstDimensionTimeFormat_(analysisConfig)).toUpperCase();var metrics = _.chain(columns).map(function (metric) {
                    var columnTitle = _.get(metric, 'title', '');var comparableMetrics = _this5.getComparableMetrics_(metric, viewModeConfig, layer, timeShiftUnit);return { columnTitle: columnTitle, comparableMetrics: comparableMetrics };
               }).map(function (_ref) {
                    var columnTitle = _ref.columnTitle,
                        comparableMetrics = _ref.comparableMetrics;return _this5.getGroupedComparableMetrics_(comparableMetrics, comparisonObjects, viewModeConfig.type, columnTitle);
               }).flatten().forEach(function (metric, index) {
                    var alias = _.get(aliases, index, null);_.extend(metric, { alias: alias });
               }).value();_.extend(query, { metrics: metrics });if (this.isTimeBasedComparison(_.get(analysisConfig, 'viewMode'))) {
                    this.CustomFormulas.injectDivnull(query);
               }return this;
          } /**
            * Mutates a given query's orderColumns and footerTypes by injecting comparison order columns if any
            * @param   {Object} analysisConfig The analysis configuration
            * @param   {Object} query
            * @returns {ViewModeComparison}
            * @private
            */ }, { key: 'adjustSorting_', value: function adjustSorting_(analysisConfig, query) {
               var footerType = this.Variants.getFooterType(analysisConfig);var metricAliases = _.chain(query).get('metrics').map('alias').value();var viewModeConfig = _.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME);var comparisonOrderColumns = _.chain(this.getSortingObjects(viewModeConfig)).filter(function (sortingObject) {
                    return _.includes(metricAliases, sortingObject.alias);
               }).map(function (sortingObject) {
                    var columnAlias = _.get(sortingObject, 'alias');var direction = _.get(sortingObject, 'direction');return { columnAlias: columnAlias, direction: direction, footerType: footerType };
               }).value();var dimensionAliases = _.chain(query).get('dimensions').map('alias').value();var orderColumns = _.chain(query).get('orderColumns').filter(function (orderColumn) {
                    return _.includes(dimensionAliases, orderColumn.columnAlias);
               }).value();_.chain(query).set('orderColumns', [].concat(_toConsumableArray(comparisonOrderColumns), _toConsumableArray(orderColumns))).set('footerTypes', [footerType]).value();return this;
          } /**
            * Mutates a given query injecting the first time comparison object - i.e. time filter - in the query's
            * filter list, replacing the  time filter originally set for the query ONLY in case of time comparison queries.
            * Does nothing for non time comparison queries.
            * @param   {Object} analysisConfig The analysis configuration
            * @param   {Object} query
            * @returns {ViewModeComparison}
            * @private
            */ }, { key: 'adjustQueryTime_', value: function adjustQueryTime_(analysisConfig, query) {
               if (_.get(analysisConfig, 'viewMode.active') !== this.VIEW_MODE_NAME) {
                    return this;
               }var viewModeConfig = _.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME);if (_.get(viewModeConfig, 'type') === this.TYPES.SEGMENT) {
                    return this;
               }var comparisonObjects = this.getValidComparisonObjects(viewModeConfig);var overlapsToday = this.overlapsToday_(comparisonObjects);var firstComparisonFilter = _.head(comparisonObjects);if (overlapsToday) {
                    this.Filters.syncTimeFilterEndTime(firstComparisonFilter);
               }this.Filters.insertTimes(_.get(query, 'filters'), firstComparisonFilter, true);return this;
          } /**
            * Injects the comparison metrics in a comparison query and tweaks orderColumns and footerTypes accordingly
            * @param   {Object} analysisConfig The analysis configuration
            * @param   {Object} query
            * @returns {Object}
            */ }, { key: 'adjustQuery', value: function adjustQuery(analysisConfig, query) {
               if (!this.canHaveComparison(analysisConfig)) {
                    return query;
               }if (_.get(analysisConfig, 'viewMode.active') !== this.VIEW_MODE_NAME) {
                    return query;
               }this.adjustMetrics_(analysisConfig, query).adjustSorting_(analysisConfig, query).adjustQueryTime_(analysisConfig, query);return query;
          } /**
            * Will determine if an analysis configuration is that of a time coparison one.
            * @param   {Object} viewMode The view mode object of an analysis configuration
            * @returns {boolean}
            */ }, { key: 'isTimeBasedComparison', value: function isTimeBasedComparison(viewMode) {
               if (_.get(viewMode, 'active') !== this.VIEW_MODE_NAME) {
                    return false;
               }var viewModeConfig = _.get(viewMode, '' + this.VIEW_MODE_NAME);return _.get(viewModeConfig, 'type') === this.TYPES.TIME;
          } /**
            * Returns the list of time filter comparison objects if the time comparison is active; an empty array otherwise.
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {Array<Object>}
            */ }, { key: 'getActiveTimeComparisonObjects', value: function getActiveTimeComparisonObjects(analysisConfig) {
               if (_.get(analysisConfig, 'viewMode.active') !== this.VIEW_MODE_NAME) {
                    return [];
               }var viewModeConfig = _.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME);return _.get(viewModeConfig, 'type') === this.TYPES.SEGMENT ? [] : this.getValidComparisonObjects(viewModeConfig);
          } /**
            * Will return a list of time shift related settings for every comparable metric of a given analysis if applicable
            * @param   {Object} analysisConfig The analysis configuration
            * @returns {Array<{timeFormat: string, timeShiftBy: number, timeShiftUnit: string>}
            */ }, { key: 'getComparisonTimeShifts', value: function getComparisonTimeShifts(analysisConfig) {
               var _this6 = this;var timeFormat = this.getFirstDimensionTimeFormat_(analysisConfig);if (!timeFormat) {
                    return [];
               }var timeShiftUnit = ('' + timeFormat).toUpperCase();var comparisonObjects = this.getActiveTimeComparisonObjects(analysisConfig);var referenceObject = _.head(comparisonObjects);return _.map(comparisonObjects, function (comparisonObject) {
                    var timeShiftBy = _this6.timeShiftService.getFilterTimeShift(referenceObject, comparisonObject, timeShiftUnit);return { timeFormat: timeFormat, timeShiftBy: timeShiftBy, timeShiftUnit: timeShiftUnit };
               });
          } /**
            * Performs a check if any of the provided time filters list overlaps todays date
            * @param {Array} timeFilters An array of time filters
            * @returns {boolean}
            * @private
            */ }, { key: 'overlapsToday_', value: function overlapsToday_(timeFilters) {
               var _this7 = this;return _.reduce(timeFilters, function (overlaps, filter) {
                    return overlaps || _this7.Filters.includesToday(filter);
               }, false);
          } }, { key: 'VIEW_MODE_NAME', get: function get() {
               return 'comparison';
          } }, { key: 'MIN_REPLICATION_FACTOR', get: function get() {
               return 3;
          } /**
            * Returns a map of available comparison types
            * @returns {Object}
            */ }, { key: 'TYPES', get: function get() {
               return { TIME: 'time', SEGMENT: 'segment' };
          } /**
            * Returns the schema of the comparison configuration
            * @returns {Object}
            */ }, { key: 'CONFIGURATION_SCHEMA', get: function get() {
               var type = this.TYPES.TIME;var values = _.chain(this.TYPES).values().zipObject([[], []]).value();var sorting = _.chain(this.TYPES).values().zipObject([[], []]).value();return { type: type, values: values, sorting: sorting };
          } }]);return ViewModeComparison;
}();

},{}],57:[function(require,module,exports){
'use strict';
var _createClass = function () {
     function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
               var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
     }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
     };
}();function _toConsumableArray(arr) {
     if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
               arr2[i] = arr[i];
          }return arr2;
     } else {
          return Array.from(arr);
     }
}function _classCallCheck(instance, Constructor) {
     if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
     }
}module.exports = function () {
     /* @ngInject*/
     ViewModePath.$inject = ['Monads', 'DSCONST', 'Columns', 'Variants', 'QueryMetrics', 'QueryTemplates', 'logicalCubeUtils'];function ViewModePath(Monads, DSCONST, Columns, Variants, QueryMetrics, QueryTemplates, logicalCubeUtils) {
          _classCallCheck(this, ViewModePath);this.Monads = Monads;this.DSCONST = DSCONST;this.Columns = Columns;this.Variants = Variants;this.QueryMetrics = QueryMetrics;this.QueryTemplates = QueryTemplates;this.logicalCubeUtils = logicalCubeUtils;
     } /**
       * Map of path mode query errors.
       */_createClass(ViewModePath, [{ key: 'getPathConfig', /**
                                                             * Returns the path viewMode configuration from an analysis configuration.
                                                             * @param   {Object}  analysisConfig Complete analysis configuration object
                                                             * @returns {Object}
                                                             */value: function getPathConfig(analysisConfig) {
               return _.get(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME);
          } /**
            * Returns the pathLength from the path viewMode configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {number}
            */ }, { key: 'getPathLength', value: function getPathLength(pathConfig) {
               return _.get(pathConfig, 'pathLength');
          } /**
            * Returns the distinct from the path viewMode configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {boolean}
            */ }, { key: 'getDistinct', value: function getDistinct(pathConfig) {
               return _.get(pathConfig, 'distinct');
          } /**
            * Returns the reverse from the path viewMode configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {boolean}
            */ }, { key: 'getReverse', value: function getReverse(pathConfig) {
               return _.get(pathConfig, 'reverse');
          } /**
            * Returns the dimensionContext from the path viewMode configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {string}
            */ }, { key: 'getDimensionContext', value: function getDimensionContext(pathConfig) {
               return _.get(pathConfig, 'dimensionContext');
          } /**
            * Returns the metricArrangeType from the path viewMode configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {string}
            */ }, { key: 'getMetricArrangeType', value: function getMetricArrangeType(pathConfig) {
               return _.get(pathConfig, 'metricArrangeType');
          } /**
            * Returns the alias for the metricArrangeType of a given path configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {string}
            */ }, { key: 'getMetricAlias', value: function getMetricAlias(pathConfig) {
               var metric = this.getQueryMetric_(pathConfig);return _.get(metric, 'alias');
          } /**
            * Builds the metric to be injected in a path query.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {Object}
            * @private
            */ }, { key: 'getQueryMetric_', value: function getQueryMetric_(pathConfig) {
               var metricArrangeType = this.getMetricArrangeType(pathConfig);var context = this.getDimensionContext(pathConfig);return this.QueryMetrics.getPathMetric(metricArrangeType, context);
          } /**
            * Retrieves the first path view mode compatible context of a dimension. Simply to bypass\
            * ATOMIC natural contexts.
            * @param   {Object} dimension
            * @returns {string}
            * @private
            */ }, { key: 'getUsableNaturalContext_', value: function getUsableNaturalContext_(dimension) {
               var naturalContext = _.get(dimension, 'context');if (naturalContext === this.DSCONST.CONTEXTS.NONE) {
                    return naturalContext;
               }if (naturalContext !== this.DSCONST.CONTEXTS.ATOMIC) {
                    return naturalContext;
               }var possibleContexts = _.get(dimension, 'possibleContexts', []);var rankedPossibleContexts = _.filter(this.DSCONST.CONTEXT_RANK, function (rankedContext) {
                    return _.includes(possibleContexts, rankedContext);
               });return _.first(rankedPossibleContexts);
          } /**
            * Returns the list of possible contexts for a path viewMode based on an analysis' dimension.
            * @param   {Array<Object>}  columns List of analysis configuration objects.
            * @returns {Array<string>}
            */ }, { key: 'getDimensionContexts', value: function getDimensionContexts(columns) {
               var dimension = this.getPathCompatibleDimension(columns);var naturalContext = this.getUsableNaturalContext_(dimension);if (naturalContext === this.DSCONST.CONTEXTS.NONE) {
                    return [this.DSCONST.CONTEXTS.VISITOR];
               }var possibleContexts = _.get(dimension, 'possibleContexts', []);var rankedPossibleContexts = _.filter(this.DSCONST.CONTEXT_RANK, function (rankedContext) {
                    return _.includes(possibleContexts, rankedContext);
               });var naturalContextIndex = _.indexOf(rankedPossibleContexts, naturalContext);return naturalContextIndex === -1 ? [] : _.slice(rankedPossibleContexts, naturalContextIndex + 1);
          } }, { key: 'isValidDimensionContext', value: function isValidDimensionContext(dimensionContext, dimensionContexts) {
               return _.isEmpty(dimensionContext) ? false : _.includes(dimensionContexts, dimensionContext);
          } /**
            * Determines if a given monad is path compatible.
            * @param   {Object} monad
            * @returns {boolean}
            * @private
            */ }, { key: 'isMonadPathCompatible_', value: function isMonadPathCompatible_(monad) {
               return _.get(monad, 'pathCompatible') === true;
          } /**
            * Determines if the given path length exceeds the defined limits.
            * @param   {number} pathLength
            * @returns {boolean}
            * @private
            */ }, { key: 'isValidPathLength_', value: function isValidPathLength_(pathLength) {
               if (!_.isNumber(pathLength)) {
                    return false;
               }if (pathLength > this.MAX_PATH_LENGTH) {
                    return false;
               }return pathLength >= this.MIN_PATH_LENGTH;
          } /**
            * Determines if the dimensionContext of a path viewMode configuration is valid based on the first and only
            * path compatible dimension of a list of columns.
            * @param   {Object}  pathConfig Path configuration object.
            * @param   {Array<Object>}  columns List of analysis configuration objects.
            * @returns {boolean}
            * @private
            */ }, { key: 'hasValidDimensionContext_', value: function hasValidDimensionContext_(pathConfig, columns) {
               var dimensionContext = this.getDimensionContext(pathConfig);var dimensionContexts = this.getDimensionContexts(columns);return this.isValidDimensionContext(dimensionContext, dimensionContexts);
          } /**
            * Determines if a metric's possible contexts has any intersection with a list of contexts.
            * @param   {Object}  metric
            * @param   {string|Array<string>}  contexts_
            * @returns {boolean}
            * @private
            */ }, { key: 'isValidMetricContext_', value: function isValidMetricContext_(metric, contexts_) {
               var possibleContexts = _.get(metric, 'possibleContexts', []);if (_.isEmpty(possibleContexts)) {
                    return true;
               }var contexts = _.isArray(contexts_) ? contexts_ : [contexts_];return _.chain(possibleContexts).intersection(contexts).isEmpty().isEqual(false).valueOf();
          } /**
            * Determines if the given metric configuration is compatible with the given dimension
            * and context in order to be used in a path query.
            * @param   {Object}  metric
            * @param   {Object}  dimension
            * @param   {Array<string>|string}  pathContexts_
            * @returns {boolean}
            */ }, { key: 'isValidMetricForPath', value: function isValidMetricForPath(metric, dimension, pathContexts_) {
               if (!this.isMonadPathCompatible_(metric) || !this.isMonadPathCompatible_(dimension)) {
                    return false;
               }var logicalCubes = _.get(dimension, 'logicalCubes', []);if (!this.logicalCubeUtils.validateMetric(metric, logicalCubes)) {
                    return false;
               }return this.isValidMetricContext_(metric, pathContexts_);
          } /**
            * Returns the metric configuation object that is used for the analysis' path configuration.
            * @param   {Object}  pathConfig Path configuration object.
            * @returns {Object}
            */ }, { key: 'getPathMetric', value: function getPathMetric(pathConfig) {
               var metricArrangeType = this.getMetricArrangeType(pathConfig);return this.Monads.monad(metricArrangeType);
          } /**
            * Determines if the metric arrange type of the path viewMode is valid against its dimensionContext.
            * @param   {Object}  pathConfig Path configuration object.
            * @param   {Array<Object>}  columns List of analysis configuration objects.
            * @returns {boolean}
            * @private
            */ }, { key: 'hasValidMetricArrangeType_', value: function hasValidMetricArrangeType_(pathConfig, columns) {
               var dimension = this.getPathCompatibleDimension(columns);var metric = this.getPathMetric(pathConfig);var dimensionContext = this.getDimensionContext(pathConfig);return this.isValidMetricForPath(metric, dimension, dimensionContext);
          } /**
            * Returns the first and only path compatible dimension from a list of columns; null otherwise.
            * @param   {Array<Object>}  columns List of analysis configuration objects.
            * @returns {Object|null}
            */ }, { key: 'getPathCompatibleDimension', value: function getPathCompatibleDimension(columns) {
               var _this = this;var dimensions = _.filter(this.Columns.complete(columns), { dimension: true });return _.size(dimensions) !== 1 ? null : _.find(dimensions, function (monad) {
                    return _this.isMonadPathCompatible_(monad);
               }) || null;
          } /**
            * Determines if a given analysisConfig contains one pathCompatible dimension column.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {boolean}
            */ }, { key: 'hasPathCompatibleDimension', value: function hasPathCompatibleDimension(analysisConfig) {
               var columns = _.get(analysisConfig, 'columns');return !_.isNil(this.getPathCompatibleDimension(columns));
          } /**
            * Determines if a given analysisConfig can have path viewMode.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {boolean}
            */ }, { key: 'canHavePath', value: function canHavePath(analysisConfig) {
               if (this.Monads.isRealTimeConfig(analysisConfig)) {
                    return false;
               }if (!this.Variants.isList(analysisConfig)) {
                    return false;
               }return this.hasPathCompatibleDimension(analysisConfig);
          } /**
            * Determines if a given pathConfig and a list of columns can be used to build a path query.
            * @param   {Object}  pathConfig Path configuration object.
            * @param   {Array<Object>}  columns List of analysis configuration objects.
            * @returns {boolean}
            */ }, { key: 'canApplyPath', value: function canApplyPath(pathConfig, columns) {
               if (_.isEmpty(pathConfig)) {
                    return false;
               }var reverse = this.getReverse(pathConfig);if (!_.isBoolean(reverse)) {
                    return false;
               }var distinct = this.getDistinct(pathConfig);if (!_.isBoolean(distinct)) {
                    return false;
               }var pathLength = this.getPathLength(pathConfig);if (!this.isValidPathLength_(pathLength)) {
                    return false;
               }if (!this.hasValidDimensionContext_(pathConfig, columns)) {
                    return false;
               }return this.hasValidMetricArrangeType_(pathConfig, columns);
          } /**
            * Mutates the given analysis cofiguration by emptying the active view mode value
            * if path is the active view mode.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {ViewModePath}
            * @private
            */ }, { key: 'deactivateViewMode_', value: function deactivateViewMode_(analysisConfig) {
               if (_.get(analysisConfig, 'viewMode.active') === this.VIEW_MODE_NAME) {
                    _.set(analysisConfig, 'viewMode.active', '');
               }return this;
          } /**
            * Mutates the given analysis cofiguration by deleting the path configuration of
            * the given analysis configuration.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {ViewModePath}
            * @private
            */ }, { key: 'deleteViewModeConfig_', value: function deleteViewModeConfig_(analysisConfig) {
               if (_.has(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME)) {
                    delete analysisConfig.viewMode[this.VIEW_MODE_NAME];
               }return this;
          } /**
            * Mutates a given analysis configuration by initializing its path viewMode config if possible.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {Object}
            */ }, { key: 'initPath', value: function initPath(analysisConfig) {
               var columns = _.get(analysisConfig, 'columns');var dimensionContexts = this.getDimensionContexts(columns);var dimensionContext = _.first(dimensionContexts);if (_.isEmpty(dimensionContext)) {
                    return analysisConfig;
               }var metricArrangeType = '';var path = _.defaults({ dimensionContext: dimensionContext, metricArrangeType: metricArrangeType }, this.CONFIGURATION_SCHEMA);_.set(analysisConfig, 'viewMode.' + this.VIEW_MODE_NAME, path);return analysisConfig;
          } /**
            * Mutates a given analysis configuration modifying its path viewMode configuration.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @returns {Object}
            */ }, { key: 'resolvePath', value: function resolvePath(analysisConfig) {
               if (!this.canHavePath(analysisConfig)) {
                    this.deactivateViewMode_(analysisConfig).deleteViewModeConfig_(analysisConfig);return analysisConfig;
               }var pathConfig = this.getPathConfig(analysisConfig);var columns = _.get(analysisConfig, 'columns');return this.canApplyPath(pathConfig, columns) ? analysisConfig : this.initPath(analysisConfig);
          } /**
            * Mutates the first dimension of a given path query by setting the pathMode and pathLength properties.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @param   {Object}  query
            * @returns {ViewModePath}
            * @private
            */ }, { key: 'adjustDimension_', value: function adjustDimension_(analysisConfig, query) {
               var pathConfig = this.getPathConfig(analysisConfig);var distinct = this.getDistinct(pathConfig);var pathMode = distinct ? this.PATH_MODES.PATH_DISTINCT : this.PATH_MODES.PATH;var reverse = this.getReverse(pathConfig);var configPathLenght = this.getPathLength(pathConfig);var pathLength = (reverse ? -1 : 1) * (configPathLenght + this.PATH_LENGTH_EXTRA_BIT);_.chain(query).get('dimensions').first().merge({ pathMode: pathMode, pathLength: pathLength }).valueOf();return this;
          } /**
            * Mutates the list of metrics of path query, removing all metrics generated and simply adding the one
            * path metric required.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @param   {Object}  query
            * @returns {ViewModePath}
            * @private
            */ }, { key: 'adjustMetric_', value: function adjustMetric_(analysisConfig, query) {
               var pathConfig = this.getPathConfig(analysisConfig);var metric = this.getQueryMetric_(pathConfig);_.set(query, 'metrics', [metric]);return this;
          } /**
            * Mutates a given query by simply emptying its orderColumns and re-setting its footerTypes list.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @param   {Object}  query
            * @returns {ViewModePath}
            * @private
            */ }, { key: 'adjustSorting_', value: function adjustSorting_(analysisConfig, query) {
               var footerType = this.Variants.getFooterType(analysisConfig);var columnAlias = _.chain(query).get('metrics').map('alias').first().valueOf();var orderColumn = _.merge(this.QueryTemplates.orderColumn(), { columnAlias: columnAlias });_.chain(query).set('orderColumns', [orderColumn]).set('footerTypes', [footerType]).valueOf();return this;
          } /**
            * Mutates a given query based on the given analysis configuration, converting it to a path viewMode query.
            * @param   {Object}  analysisConfig Complete analysis configuration object
            * @param   {Object}  query
            * @returns {Object}
            */ }, { key: 'adjustQuery', value: function adjustQuery(analysisConfig, query) {
               if (_.get(analysisConfig, 'viewMode.active') !== this.VIEW_MODE_NAME) {
                    return query;
               }this.adjustDimension_(analysisConfig, query).adjustMetric_(analysisConfig, query).adjustSorting_(analysisConfig, query);_.set(query, 'viewMode', this.QUERY_VIEW_MODE);return query;
          } }, { key: 'isValidPathMode_', value: function isValidPathMode_(pathMode) {
               return _.chain(this.PATH_MODES).values().includes(pathMode).valueOf();
          } /**
            * Returns a list of path view mode query errors strings based on the dimension(s) of a query.
            * @param   {Object} query
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getDimensionErrors_', value: function getDimensionErrors_(query) {
               var errors = [];var dimensions = _.get(query, 'dimensions', []);if (dimensions.length === 0) {
                    errors.push(this.QUERY_ERRORS.DIMENSION_ARRANGE_TYPE_MISSING);return errors;
               }if (dimensions.length > 1) {
                    errors.push(this.QUERY_ERRORS.MULTIPLE_DIMENSIONS_IN_PATH_QUERY);
               }var dimension = _.first(dimensions);var pathLength = Math.abs(_.get(dimension, 'pathLength', 0)) - this.PATH_LENGTH_EXTRA_BIT;if (!this.isValidPathLength_(pathLength)) {
                    errors.push(this.QUERY_ERRORS.INVALID_PATH_LENGTH);
               }var pathMode = _.get(dimension, 'pathMode');if (!this.isValidPathMode_(pathMode)) {
                    errors.push(this.QUERY_ERRORS.INVALID_PATH_MODE);
               }var layer = this.Monads.getQueryLayer(query);var monad = this.Monads.layer(layer).monad(_.get(dimension, 'arrangeType'));if (!this.isMonadPathCompatible_(monad)) {
                    errors.push(this.QUERY_ERRORS.DIMENSION_IS_NOT_PATH_COMPATIBLE);
               }return errors;
          } /**
            * Returns a list of path view mode query errors strings based on the metric(s) of a query.
            * @param   {Object} query
            * @returns {Array<string>}
            * @private
            */ }, { key: 'getMetricErrors_', value: function getMetricErrors_(query) {
               var _this2 = this;var errors = [];var metrics = _.get(query, 'metrics', []);if (metrics.length !== 1) {
                    errors.push(this.QUERY_ERRORS.MULTIPLE_METRICS_IN_PATH_QUERY);
               }var metric = _.first(metrics);var layer = this.Monads.getQueryLayer(query);var monad = this.Monads.layer(layer).monad(_.get(metric, 'value.arrangeType'));if (!monad) {
                    errors.push(this.QUERY_ERRORS.PATH_METRIC_ARRANGE_TYPE_MISSING);return errors;
               }if (!this.isMonadPathCompatible_(monad)) {
                    errors.push(this.QUERY_ERRORS.METRIC_IS_NOT_PATH_COMPATIBLE);
               }var context = _.get(metric, 'value.context');if (!this.isValidMetricContext_(monad, context)) {
                    errors.push(this.QUERY_ERRORS.INVALID_PATH_METRIC_CONTEXT);
               }var dimension = _.chain(query).get('dimensions').map(function (_ref) {
                    var arrangeType = _ref.arrangeType;return _this2.Monads.layer(layer).monad(arrangeType);
               }).filter(function (dimensionMonad) {
                    return _this2.isMonadPathCompatible_(dimensionMonad);
               }).first().valueOf();if (!dimension) {
                    return errors;
               }var logicalCubes = _.get(dimension, 'logicalCubes', []);if (!this.logicalCubeUtils.validateMetric(monad, logicalCubes)) {
                    errors.push(this.QUERY_ERRORS.PATH_METRIC_LOGICAL_CUBE_MISMATCH);
               }return errors;
          } /**
            * Validates a query in terms of path view mode terms. Returns a validation object indicating the query's validity
            * and the list of possible errors.
            * @param   {Object} query
            * @returns {Object}
            */ }, { key: 'validateQuery', value: function validateQuery(query) {
               var dimensionErrors = this.getDimensionErrors_(query);var metricErrors = this.getMetricErrors_(query);var errors = [].concat(_toConsumableArray(dimensionErrors), _toConsumableArray(metricErrors));var isValid = _.isEmpty(errors);var parameters = _.set({}, '' + this.VIEW_MODE_NAME, errors);return { isValid: isValid, parameters: parameters };
          } }, { key: 'QUERY_ERRORS', get: function get() {
               return this.DSCONST.VIEW_MODE_QUERY_VALIDATION.PATH.ERRORS;
          } /**
            * Map of all possible path modes
            * @returns {Object}
            */ }, { key: 'PATH_MODES', get: function get() {
               return { PATH: 'PATH', PATH_DISTINCT: 'PATH_DISTINCT' };
          } /**
            * Returns the extra bit that is added to the pathLength of the path configuration when the query is build.
            * @returns {number}
            */ }, { key: 'PATH_LENGTH_EXTRA_BIT', get: function get() {
               return 1;
          } /**
            * Returns the minimum value of the pathLength property.
            * @returns {number}
            */ }, { key: 'MIN_PATH_LENGTH', get: function get() {
               return 1;
          } /**
            * Returns the maximum value of the pathLength property.
            * @returns {number}
            */ }, { key: 'MAX_PATH_LENGTH', get: function get() {
               return 20;
          } /**
            * Returns the default path length value.
            * @returns {number}
            */ }, { key: 'DEFAULT_PATH_LENGTH', get: function get() {
               return 5;
          } /**
            * Returns the value of the path view mode.
            * @returns {string}
            */ }, { key: 'VIEW_MODE_NAME', get: function get() {
               return 'path';
          } /**
            * Returns the value of a query's viewMode property that indicates if its a path or not.
            * @returns {string}
            */ }, { key: 'QUERY_VIEW_MODE', get: function get() {
               return 'PATH';
          } /**
            * Returns a map of dimension contexts with their default metric arrange types.
            * @returns {Object}
            */ }, { key: 'DIMENSION_CONTEXT_TO_METRIC_ARRANGE_TYPE', get: function get() {
               return { PAGE: 'page_impressions', SESSION: 'visits', VISITOR: 'visitors', NONE: 'website_goals_amount' };
          } /**
            * Returns the schema of the path configuration
            * @returns {Object}
            */ }, { key: 'CONFIGURATION_SCHEMA', get: function get() {
               var reverse = false;var distinct = true;var pathLength = this.DEFAULT_PATH_LENGTH;var dimensionContext = '';var metricArrangeType = '';return { reverse: reverse, distinct: distinct, pathLength: pathLength, dimensionContext: dimensionContext, metricArrangeType: metricArrangeType };
          } }]);return ViewModePath;
}();

},{}],58:[function(require,module,exports){
'use strict';
var AccountContainer = require('./src/AccountContainer');var AccountService = require('./src/AccountService');var Analyses = require('./src/Analyses');var AnalysisColumnUtils = require('./src/AnalysisColumnUtils');var ArrangeTypeUtils = require('./src/ArrangeTypeUtils');var CalculationLayer = require('./src/CalculationLayer');var CohortUtils = require('./src/CohortUtils');var CampaignsAttribution = require('./src/CampaignsAttribution');var ConfigPeriodColumn = require('./src/ConfigPeriodColumn');var ConfigPeriodElement = require('./src/ConfigPeriodElement');var Columns = require('./src/Columns');var Comparison = require('./src/Comparison');var ComparisonRealTime = require('./src/ComparisonRealTime');var CustomFiguresService = require('./src/CustomFiguresService');var CustomFormulas = require('./src/CustomFormulas');var CustomFormulaTemplates = require('./src/CustomFormulaTemplates');var ProcessService = require('./src/ProcessService');var Dates = require('./src/Dates');var DateService = require('./src/DateService');var DSCONST = require('./src/DSCONST');var FeatureFlagService = require('./src/FeatureFlagService');var Filters = require('./src/Filters');var FilterUtils = require('./src/FilterUtils');var HashGen = require('./src/HashGen');var HistorizedCache = require('./src/HistorizedCache');var LanguageSettings = require('./src/LanguageSettings');var LogicalCubeUtils = require('./src/LogicalCubeUtils');var Metrics = require('./src/Metrics');var Monads = require('./src/Monads');var ProposalId = require('./src/ProposalId');var QueryLimits = require('./src/QueryLimits');var QueryMetrics = require('./src/QueryMetrics');var QueryTemplates = require('./src/QueryTemplates');var QueryUtility = require('./src/QueryUtility');var ReportElementUtils = require('./src/ReportElementUtils');var ReportContainer = require('./src/ReportContainer');var Reports = require('./src/Reports');var Request = require('./src/Request');var ReportElementQuery = require('./src/ReportElementQuery');var SamplingFactor = require('./src/SamplingFactor');var Segments = require('./src/Segments');var TimesDynamic = require('./src/TimesDynamic');var TimesDynamicCache = require('./src/TimesDynamicCache');var TimeSeries = require('./src/TimeSeries');var TimeShift = require('./src/TimeShift');var TraverseFactory = require('./src/TraverseFactory');var TraverseService = require('./src/TraverseService');var UserPreferenceThreshold = require('./src/UserPreferenceThreshold');var Utils = require('./src/Utils');var Variants = require('./src/Variants');var ViewMode = require('./src/ViewMode');var ViewModeComparison = require('./src/ViewModeComparison');var ViewModePath = require('./src/ViewModePath');var LastUpdates = require('./src/LastUpdates');var wtQueryBuilder = angular.module('wtQueryBuilder', []);angular.module('wtQueryBuilder').service('AccountContainer', AccountContainer);angular.module('wtQueryBuilder').service('accountService', AccountService);angular.module('wtQueryBuilder').service('Analyses', Analyses);angular.module('wtQueryBuilder').service('analysisColumnUtils', AnalysisColumnUtils);angular.module('wtQueryBuilder').service('arrangeTypeUtils', ArrangeTypeUtils);angular.module('wtQueryBuilder').service('CalculationLayer', CalculationLayer);angular.module('wtQueryBuilder').service('campaignsAttributionService', CampaignsAttribution);angular.module('wtQueryBuilder').service('cohortUtils', CohortUtils);angular.module('wtQueryBuilder').service('ConfigPeriodColumn', ConfigPeriodColumn);angular.module('wtQueryBuilder').service('ConfigPeriodElement', ConfigPeriodElement);angular.module('wtQueryBuilder').service('Columns', Columns);angular.module('wtQueryBuilder').service('Comparison', Comparison);angular.module('wtQueryBuilder').service('ComparisonRealTime', ComparisonRealTime);angular.module('wtQueryBuilder').service('customFiguresService', CustomFiguresService);angular.module('wtQueryBuilder').service('CustomFormulas', CustomFormulas);angular.module('wtQueryBuilder').service('CustomFormulaTemplates', CustomFormulaTemplates);angular.module('wtQueryBuilder').service('processService', ProcessService);angular.module('wtQueryBuilder').service('Dates', Dates);angular.module('wtQueryBuilder').service('dateService', DateService);angular.module('wtQueryBuilder').service('DSCONST', DSCONST);angular.module('wtQueryBuilder').service('featureFlagService', FeatureFlagService);angular.module('wtQueryBuilder').service('Filters', Filters);angular.module('wtQueryBuilder').service('filterUtils', FilterUtils);angular.module('wtQueryBuilder').service('HashGen', HashGen);angular.module('wtQueryBuilder').service('historizedCacheService', HistorizedCache);angular.module('wtQueryBuilder').service('LanguageSettings', LanguageSettings);angular.module('wtQueryBuilder').service('logicalCubeUtils', LogicalCubeUtils);angular.module('wtQueryBuilder').service('metricService', Metrics);angular.module('wtQueryBuilder').service('ProposalId', ProposalId);angular.module('wtQueryBuilder').service('Monads', Monads);angular.module('wtQueryBuilder').service('QueryLimits', QueryLimits);angular.module('wtQueryBuilder').service('QueryMetrics', QueryMetrics);angular.module('wtQueryBuilder').service('QueryTemplates', QueryTemplates);angular.module('wtQueryBuilder').service('queryUtilityService', QueryUtility);angular.module('wtQueryBuilder').service('reportElementUtils', ReportElementUtils);angular.module('wtQueryBuilder').service('ReportContainer', ReportContainer);angular.module('wtQueryBuilder').service('Reports', Reports);angular.module('wtQueryBuilder').service('Request', Request);angular.module('wtQueryBuilder').service('ReportElementQuery', ReportElementQuery);angular.module('wtQueryBuilder').service('SamplingFactor', SamplingFactor);angular.module('wtQueryBuilder').service('segmentService', Segments);angular.module('wtQueryBuilder').service('TimesDynamic', TimesDynamic);angular.module('wtQueryBuilder').service('TimesDynamicCache', TimesDynamicCache);angular.module('wtQueryBuilder').service('TimeSeries', TimeSeries);angular.module('wtQueryBuilder').service('timeShiftService', TimeShift);angular.module('wtQueryBuilder').service('UserPreferenceThreshold', UserPreferenceThreshold);angular.module('wtQueryBuilder').service('utils', Utils);angular.module('wtQueryBuilder').service('Variants', Variants);angular.module('wtQueryBuilder').service('ViewMode', ViewMode);angular.module('wtQueryBuilder').factory('TraverseFactory', function () {
  return TraverseFactory;
});angular.module('wtQueryBuilder').service('traverseService', TraverseService);angular.module('wtQueryBuilder').service('viewModeComparison', ViewModeComparison);angular.module('wtQueryBuilder').service('viewModePath', ViewModePath);angular.module('wtQueryBuilder').service('LastUpdates', LastUpdates);module.exports = wtQueryBuilder;

},{"./src/AccountContainer":1,"./src/AccountService":2,"./src/Analyses":3,"./src/AnalysisColumnUtils":4,"./src/ArrangeTypeUtils":5,"./src/CalculationLayer":6,"./src/CampaignsAttribution":7,"./src/CohortUtils":8,"./src/Columns":9,"./src/Comparison":10,"./src/ComparisonRealTime":11,"./src/ConfigPeriodColumn":13,"./src/ConfigPeriodElement":14,"./src/CustomFiguresService":15,"./src/CustomFormulaTemplates":16,"./src/CustomFormulas":17,"./src/DSCONST":18,"./src/DateService":19,"./src/Dates":20,"./src/FeatureFlagService":21,"./src/FilterUtils":22,"./src/Filters":23,"./src/HashGen":24,"./src/HistorizedCache":25,"./src/LanguageSettings":26,"./src/LastUpdates":27,"./src/LogicalCubeUtils":28,"./src/Metrics":29,"./src/Monads":32,"./src/ProcessService":33,"./src/ProposalId":34,"./src/QueryLimits":35,"./src/QueryMetrics":36,"./src/QueryTemplates":37,"./src/QueryUtility":38,"./src/ReportContainer":39,"./src/ReportElementQuery":40,"./src/ReportElementUtils":41,"./src/Reports":42,"./src/Request":43,"./src/SamplingFactor":44,"./src/Segments":45,"./src/TimeSeries":46,"./src/TimeShift":47,"./src/TimesDynamic":48,"./src/TimesDynamicCache":49,"./src/TraverseFactory":50,"./src/TraverseService":51,"./src/UserPreferenceThreshold":52,"./src/Utils":53,"./src/Variants":54,"./src/ViewMode":55,"./src/ViewModeComparison":56,"./src/ViewModePath":57}]},{},[58]);
